import {jsx as $hgUW1$jsx, jsxs as $hgUW1$jsxs, Fragment as $hgUW1$Fragment} from "@emotion/react/jsx-runtime";
import {css as $hgUW1$css, keyframes as $hgUW1$keyframes} from "@emotion/react";
import {token as $hgUW1$token} from "@atlaskit/tokens";
import $hgUW1$react, {useCallback as $hgUW1$useCallback, useState as $hgUW1$useState, useRef as $hgUW1$useRef, useEffect as $hgUW1$useEffect, useMemo as $hgUW1$useMemo, Fragment as $hgUW1$Fragment1, forwardRef as $hgUW1$forwardRef, createElement as $hgUW1$createElement, memo as $hgUW1$memo, createContext as $hgUW1$createContext, useContext as $hgUW1$useContext} from "react";
import $hgUW1$atlaskitbutton, {LoadingButton as $hgUW1$LoadingButton} from "@atlaskit/button";
import $hgUW1$atlaskittooltip from "@atlaskit/tooltip";
import $hgUW1$atlaskitspinner from "@atlaskit/spinner";
import {media as $hgUW1$media, Stack as $hgUW1$Stack, Inline as $hgUW1$Inline, xcss as $hgUW1$xcss, Text as $hgUW1$Text} from "@atlaskit/primitives";
import $hgUW1$atlaskiticonglyphcross from "@atlaskit/icon/glyph/cross";
import $hgUW1$atlaskiticonglyphchevrondown from "@atlaskit/icon/glyph/chevron-down";
import $hgUW1$atlaskiticonglyphchevronup from "@atlaskit/icon/glyph/chevron-up";
import $hgUW1$atlaskiticonglyphchevronleft from "@atlaskit/icon/glyph/chevron-left";
import $hgUW1$atlaskiticonglyphchevronright from "@atlaskit/icon/glyph/chevron-right";
import $hgUW1$atlaskiticonglyphchevrondowncircle from "@atlaskit/icon/glyph/chevron-down-circle";
import $hgUW1$atlaskiticonglypharrowupcircle from "@atlaskit/icon/glyph/arrow-up-circle";
import $hgUW1$atlaskiticonglypharrowup from "@atlaskit/icon/glyph/arrow-up";
import $hgUW1$atlaskiticonglyphcheckcircleoutline from "@atlaskit/icon/glyph/check-circle-outline";
import $hgUW1$atlaskiticonglyphcheckcircle from "@atlaskit/icon/glyph/check-circle";
import $hgUW1$atlaskiticonglypharrowright from "@atlaskit/icon/glyph/arrow-right";
import $hgUW1$atlaskiticonglypheditorclose from "@atlaskit/icon/glyph/editor/close";
import $hgUW1$atlaskiticonglyphemojifrequent from "@atlaskit/icon/glyph/emoji/frequent";
import $hgUW1$atlaskiticonglyphstarfilled from "@atlaskit/icon/glyph/star-filled";
import $hgUW1$atlaskiticonglyphstar from "@atlaskit/icon/glyph/star";
import $hgUW1$atlaskiticonglyphbitbucketbuilds from "@atlaskit/icon/glyph/bitbucket/builds";
import $hgUW1$atlaskiticonglypheditormediawrapright from "@atlaskit/icon/glyph/editor/media-wrap-right";
import $hgUW1$atlaskiticonglypheditortable from "@atlaskit/icon/glyph/editor/table";
import $hgUW1$atlaskiticonglypheditoropen from "@atlaskit/icon/glyph/editor/open";
import $hgUW1$atlaskiticonglyphcopy from "@atlaskit/icon/glyph/copy";
import $hgUW1$atlaskiticonglyphwarning from "@atlaskit/icon/glyph/warning";
import $hgUW1$atlaskiticonglyphimage from "@atlaskit/icon/glyph/image";
import $hgUW1$atlaskiticonglyphdownload from "@atlaskit/icon/glyph/download";
import $hgUW1$atlaskiticonglyphmediaserviceszoomin from "@atlaskit/icon/glyph/media-services/zoom-in";
import $hgUW1$atlaskiticonglyphmediaserviceszoomout from "@atlaskit/icon/glyph/media-services/zoom-out";
import $hgUW1$atlaskiticonglyphsearch from "@atlaskit/icon/glyph/search";
import $hgUW1$atlaskiticonglyphoverview from "@atlaskit/icon/glyph/overview";
import $hgUW1$atlaskiticonglyphadd from "@atlaskit/icon/glyph/add";
import $hgUW1$atlaskiticonglyphaddcircle from "@atlaskit/icon/glyph/add-circle";
import $hgUW1$atlaskiticonglyphedit from "@atlaskit/icon/glyph/edit";
import $hgUW1$atlaskiticonglypheditfilled from "@atlaskit/icon/glyph/edit-filled";
import $hgUW1$atlaskiticonglyphsettings from "@atlaskit/icon/glyph/settings";
import $hgUW1$atlaskiticonglyphinfo from "@atlaskit/icon/glyph/info";
import $hgUW1$atlaskiticonglyphquestion from "@atlaskit/icon/glyph/question";
import $hgUW1$atlaskiticonglyphcheck from "@atlaskit/icon/glyph/check";
import $hgUW1$atlaskiticonglyphemojisymbols from "@atlaskit/icon/glyph/emoji/symbols";
import $hgUW1$atlaskiticonglyphlocation from "@atlaskit/icon/glyph/location";
import $hgUW1$atlaskiticonglyphchevronleftlarge from "@atlaskit/icon/glyph/chevron-left-large";
import $hgUW1$atlaskiticonglyphhipchatchevronup from "@atlaskit/icon/glyph/hipchat/chevron-up";
import $hgUW1$atlaskiticonglyphhipchatchevrondown from "@atlaskit/icon/glyph/hipchat/chevron-down";
import $hgUW1$atlaskiticonglyphexport from "@atlaskit/icon/glyph/export";
import $hgUW1$atlaskiticonglyphlink from "@atlaskit/icon/glyph/link";
import $hgUW1$atlaskiticonglyphshare from "@atlaskit/icon/glyph/share";
import $hgUW1$atlaskiticonglyphmenu from "@atlaskit/icon/glyph/menu";
import $hgUW1$atlaskiticonglypherror from "@atlaskit/icon/glyph/error";
import $hgUW1$atlaskiticonglypharrowleftcircle from "@atlaskit/icon/glyph/arrow-left-circle";
import $hgUW1$atlaskiticonglypharrowrightcircle from "@atlaskit/icon/glyph/arrow-right-circle";
import $hgUW1$atlaskiticonglyphrefresh from "@atlaskit/icon/glyph/refresh";
import $hgUW1$atlaskiticonglyphemojiatlassian from "@atlaskit/icon/glyph/emoji/atlassian";
import $hgUW1$atlaskiticonglyphfilter from "@atlaskit/icon/glyph/filter";
import $hgUW1$atlaskiticoncorethumbsup from "@atlaskit/icon/core/thumbs-up";
import $hgUW1$atlaskiticoncorethumbsdown from "@atlaskit/icon/core/thumbs-down";
import $hgUW1$atlaskiticoncoresidebarcollapse from "@atlaskit/icon/core/sidebar-collapse";
import $hgUW1$atlaskiticoncoresidebarexpand from "@atlaskit/icon/core/sidebar-expand";
import $hgUW1$reactindianadragscroll from "react-indiana-drag-scroll";
import {Y300 as $hgUW1$Y300, DN600 as $hgUW1$DN600, N0 as $hgUW1$N0, N800 as $hgUW1$N800, B300 as $hgUW1$B300, N60 as $hgUW1$N60, N500 as $hgUW1$N500, N70 as $hgUW1$N70, N50 as $hgUW1$N50} from "@atlaskit/theme/colors";
import $hgUW1$atlaskitbuttonnew, {IconButton as $hgUW1$IconButton} from "@atlaskit/button/new";
import $hgUW1$atlaskitavatar from "@atlaskit/avatar";
import $hgUW1$atlaskiticonutilitychevrondown from "@atlaskit/icon/utility/chevron-down";
import $hgUW1$atlaskiticonutilitychevronup from "@atlaskit/icon/utility/chevron-up";
import {AtlassianIcon as $hgUW1$AtlassianIcon, AtlassianLogo as $hgUW1$AtlassianLogo} from "@atlaskit/logo";
import {media as $hgUW1$media1} from "@atlaskit/primitives/responsive";
import $hgUW1$atlaskitlozenge from "@atlaskit/lozenge";
import $hgUW1$atlaskitdropdownmenu, {DropdownItemRadioGroup as $hgUW1$DropdownItemRadioGroup, DropdownItemRadio as $hgUW1$DropdownItemRadio, DropdownItemGroup as $hgUW1$DropdownItemGroup, DropdownItem as $hgUW1$DropdownItem} from "@atlaskit/dropdown-menu";
import {layers as $hgUW1$layers} from "@atlaskit/theme/constants";
import $hgUW1$atlaskitmodaldialog, {ModalHeader as $hgUW1$ModalHeader, ModalBody as $hgUW1$ModalBody, ModalFooter as $hgUW1$ModalFooter, ModalTransition as $hgUW1$ModalTransition} from "@atlaskit/modal-dialog";
import $hgUW1$atlaskitform, {Field as $hgUW1$Field, HelperMessage as $hgUW1$HelperMessage, ErrorMessage as $hgUW1$ErrorMessage, ValidMessage as $hgUW1$ValidMessage, Label as $hgUW1$Label, RequiredAsterisk as $hgUW1$RequiredAsterisk, FormFooter as $hgUW1$FormFooter} from "@atlaskit/form";
import $hgUW1$atlaskiticonglyphmore from "@atlaskit/icon/glyph/more";
import {Buffer as $hgUW1$Buffer} from "buffer";
import $hgUW1$plyrdistplyr from "plyr/dist/plyr";
import {CircularProgressbarWithChildren as $hgUW1$CircularProgressbarWithChildren, buildStyles as $hgUW1$buildStyles} from "react-circular-progressbar";
import $hgUW1$atlaskittextarea from "@atlaskit/textarea";
import $hgUW1$lodashshuffle from "lodash.shuffle";
import $hgUW1$atlaskitselect from "@atlaskit/select";

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
/// <reference types="./types/custom.d.ts" />
var $a69491ea5a126553$exports = {};
var $5d4509b60606b6df$exports = {};
var $660bd1c6cb41002a$exports = {};

$parcel$export($660bd1c6cb41002a$exports, "Blockquote", () => $660bd1c6cb41002a$export$29a7a275fe11687);
$parcel$export($660bd1c6cb41002a$exports, "blockquoteStyles", () => $660bd1c6cb41002a$export$7a77f8e9665fa6b2);



const $660bd1c6cb41002a$export$29a7a275fe11687 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("blockquote", {
        css: (0, $hgUW1$css)($660bd1c6cb41002a$export$7a77f8e9665fa6b2),
        children: children
    });
};
const $660bd1c6cb41002a$var$fontSizeStyles = {
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
    fontWeight: 600
};
const $660bd1c6cb41002a$export$7a77f8e9665fa6b2 = {
    paddingLeft: 0,
    fontFamily: "Inter, sans-serif",
    color: (0, $hgUW1$token)("color.text"),
    ...$660bd1c6cb41002a$var$fontSizeStyles,
    span: $660bd1c6cb41002a$var$fontSizeStyles,
    "&:before, &:after": {
        content: "''"
    }
};


var $fec02fc26c7e145d$exports = {};

$parcel$export($fec02fc26c7e145d$exports, "ButtonSize", () => $fec02fc26c7e145d$export$5dd2748b7940a2a0);
$parcel$export($fec02fc26c7e145d$exports, "ButtonAppearance", () => $fec02fc26c7e145d$export$261c9483fc4a455a);
$parcel$export($fec02fc26c7e145d$exports, "Button", () => $fec02fc26c7e145d$export$353f5b6fc5456de1);








let $fec02fc26c7e145d$export$5dd2748b7940a2a0;
(function(ButtonSize) {
    ButtonSize["MEDIUM"] = "medium";
    ButtonSize["LARGE"] = "large";
})($fec02fc26c7e145d$export$5dd2748b7940a2a0 || ($fec02fc26c7e145d$export$5dd2748b7940a2a0 = {}));
let $fec02fc26c7e145d$export$261c9483fc4a455a;
(function(ButtonAppearance) {
    ButtonAppearance["DEFAULT"] = "default";
    ButtonAppearance["DANGER"] = "danger";
    ButtonAppearance["LINK"] = "link";
    ButtonAppearance["PRIMARY"] = "primary";
    ButtonAppearance["SECONDARY"] = "secondary";
    ButtonAppearance["SUBTLE"] = "subtle";
    ButtonAppearance["WARNING"] = "warning";
    ButtonAppearance["ICON"] = "icon";
    ButtonAppearance["SUCCESS"] = "success";
})($fec02fc26c7e145d$export$261c9483fc4a455a || ($fec02fc26c7e145d$export$261c9483fc4a455a = {}));
const $fec02fc26c7e145d$export$353f5b6fc5456de1 = ({ label: label , appearance: appearance = $fec02fc26c7e145d$export$261c9483fc4a455a.DEFAULT , onClick: onClick , href: href , target: target , iconBefore: iconBefore , iconAfter: iconAfter , type: type = "button" , fullWidth: fullWidth = false , size: size = $fec02fc26c7e145d$export$5dd2748b7940a2a0.MEDIUM , disabled: disabled = false , selected: selected = false , isLoading: isLoading = false , withPadding: withPadding = true , iconType: iconType , tooltip: tooltip , isResponsive: isResponsive = false  })=>{
    const isButtonWithoutIcon = !iconBefore && !iconAfter;
    const showBeforeIcon = !isLoading && iconBefore;
    const showAfterIcon = !isLoading && iconAfter;
    const isResponsiveSpacing = isResponsive && [
        $fec02fc26c7e145d$export$261c9483fc4a455a.PRIMARY,
        $fec02fc26c7e145d$export$261c9483fc4a455a.SECONDARY
    ].includes(appearance) && size === $fec02fc26c7e145d$export$5dd2748b7940a2a0.LARGE;
    const clickHandler = (0, $hgUW1$useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    if (appearance === $fec02fc26c7e145d$export$261c9483fc4a455a.DEFAULT) return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$atlaskitbutton), {
        "aria-label": label.replaceAll("-", " "),
        type: type,
        onClick: clickHandler,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        appearance: appearance,
        testId: `button-${appearance}${selected ? "-selected" : ""}`,
        href: href,
        target: target,
        shouldFitContainer: fullWidth,
        isDisabled: disabled || isLoading,
        isSelected: selected,
        css: [
            isLoading && !label && $fec02fc26c7e145d$var$learningButtonStyles["basic"] && (0, $hgUW1$css)({
                padding: "21px 49px",
                alignItems: "center"
            }),
            $fec02fc26c7e145d$var$fullWidthStyles(fullWidth)
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    isLoading && label && (0, $hgUW1$css)({
                        marginRight: (0, $hgUW1$token)("space.100")
                    })
                ],
                children: label
            }),
            isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitspinner), {
                testId: "spinner",
                size: "small"
            })
        ]
    });
    if (appearance === $fec02fc26c7e145d$export$261c9483fc4a455a.ICON) return tooltip ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskittooltip), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
            tabIndex: 0,
            "aria-label": iconType ? iconType.replaceAll("-", " ") : "button icon",
            "data-testid": `button-${appearance}${selected ? "-selected" : ""}`,
            disabled: disabled,
            css: [
                $fec02fc26c7e145d$var$learningButtonIconStyles["base"],
                selected && $fec02fc26c7e145d$var$learningButtonIconStyles["selected"]
            ],
            onClick: clickHandler,
            children: [
                isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitspinner), {
                    testId: "spinner",
                    size: "small"
                }),
                showBeforeIcon
            ]
        })
    }) : /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
        tabIndex: 0,
        "aria-label": iconType ? iconType.replaceAll("-", " ") : "button icon",
        "data-testid": `button-${appearance}${selected ? "-selected" : ""}`,
        disabled: disabled,
        css: [
            $fec02fc26c7e145d$var$learningButtonIconStyles["base"],
            selected && $fec02fc26c7e145d$var$learningButtonIconStyles["selected"]
        ],
        onClick: clickHandler,
        children: [
            isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitspinner), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon
        ]
    });
    if (appearance === $fec02fc26c7e145d$export$261c9483fc4a455a.LINK) return /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
        "aria-label": label.replaceAll("-", " "),
        disabled: disabled,
        onClick: clickHandler,
        "data-testid": `button-${appearance}${selected ? "-selected" : ""}`,
        css: [
            $fec02fc26c7e145d$var$learningButtonLinkStyles["basic"],
            disabled && $fec02fc26c7e145d$var$learningButtonLinkStyles["disabled"],
            isButtonWithoutIcon && $fec02fc26c7e145d$var$learningButtonSpacingStyles[size],
            iconBefore && $fec02fc26c7e145d$var$learningButtonSpacingStyles[`${size}-icon-before`],
            iconAfter && $fec02fc26c7e145d$var$learningButtonSpacingStyles[`${size}-icon-after`],
            !withPadding && (0, $hgUW1$css)({
                padding: 0
            })
        ],
        children: [
            showBeforeIcon && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $fec02fc26c7e145d$var$buttonIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginRight: (0, $hgUW1$token)("space.050")
                    })
                ],
                children: iconBefore
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                target: target,
                href: !disabled ? href : undefined,
                rel: target === "_blank" ? "noreferrer" : "",
                tabIndex: 0,
                css: [
                    $fec02fc26c7e145d$var$linkStyles,
                    disabled && $fec02fc26c7e145d$var$disabledLinkStyles
                ],
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    children: label
                })
            }),
            showAfterIcon && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $fec02fc26c7e145d$var$buttonIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginLeft: (0, $hgUW1$token)("space.050")
                    }),
                    disabled && $fec02fc26c7e145d$var$disabledIconStyles
                ],
                children: iconAfter
            })
        ]
    });
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
        "aria-label": label.replaceAll("-", " "),
        type: type,
        "data-testid": `button-${appearance}${selected ? "-selected" : ""}`,
        onClick: clickHandler,
        disabled: disabled || isLoading,
        css: [
            $fec02fc26c7e145d$var$learningButtonStyles["basic"],
            $fec02fc26c7e145d$var$learningButtonStyles[appearance],
            $fec02fc26c7e145d$var$learningButtonFontStyles[size],
            selected && $fec02fc26c7e145d$var$learningButtonStyles["selected"],
            isButtonWithoutIcon && $fec02fc26c7e145d$var$learningButtonSpacingStyles[size],
            iconBefore && $fec02fc26c7e145d$var$learningButtonSpacingStyles[`${size}-icon-before`],
            iconAfter && $fec02fc26c7e145d$var$learningButtonSpacingStyles[`${size}-icon-after`],
            isResponsiveSpacing && $fec02fc26c7e145d$var$learningButtonResponsiveSpacing[size],
            isResponsiveSpacing && $fec02fc26c7e145d$var$learningButtonResponsiveFontStyles,
            iconBefore && isResponsiveSpacing && $fec02fc26c7e145d$var$learningButtonResponsiveSpacing[`${size}-icon-before`],
            iconAfter && isResponsiveSpacing && $fec02fc26c7e145d$var$learningButtonResponsiveSpacing[`${size}-icon-after`],
            $fec02fc26c7e145d$var$fullWidthStyles(fullWidth)
        ],
        children: [
            isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitspinner), {
                testId: "spinner",
                size: "small"
            }),
            showBeforeIcon && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $fec02fc26c7e145d$var$buttonIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginRight: (0, $hgUW1$token)("space.050")
                    })
                ],
                children: iconBefore
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    isLoading && (0, $hgUW1$css)({
                        marginLeft: (0, $hgUW1$token)("space.100")
                    })
                ],
                children: label
            }),
            showAfterIcon && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $fec02fc26c7e145d$var$buttonIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginLeft: (0, $hgUW1$token)("space.050")
                    })
                ],
                children: iconAfter
            })
        ]
    });
};
const $fec02fc26c7e145d$var$fullWidthStyles = (fullWidth)=>fullWidth ? (0, $hgUW1$css)({
        width: "100%",
        justifyContent: "center"
    }) : undefined;
const $fec02fc26c7e145d$var$learningButtonStyles = {
    basic: (0, $hgUW1$css)({
        fontFamily: "Charlie Text, sans-serif",
        display: "flex",
        alignItems: "center",
        borderRadius: "4px",
        borderStyle: "solid",
        borderWidth: "1px",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.hovered"),
            borderColor: (0, $hgUW1$token)("color.border.selected"),
            color: (0, $hgUW1$token)("color.text.inverse")
        },
        "&:active": {
            backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.pressed"),
            borderColor: (0, $hgUW1$token)("color.border.selected"),
            color: (0, $hgUW1$token)("color.text.inverse")
        },
        "&:disabled": {
            backgroundColor: (0, $hgUW1$token)("color.background.disabled"),
            borderColor: "transparent",
            color: (0, $hgUW1$token)("color.text.disabled"),
            cursor: "not-allowed"
        }
    }),
    primary: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.background.brand.bold"),
        borderColor: (0, $hgUW1$token)("color.border.brand"),
        color: (0, $hgUW1$token)("color.text.inverse"),
        "&:focus-visible": {
            outline: `2px solid ${(0, $hgUW1$token)("color.border.focused")}`
        }
    }),
    secondary: (0, $hgUW1$css)({
        backgroundColor: "transparent",
        borderColor: (0, $hgUW1$token)("color.border.brand"),
        color: (0, $hgUW1$token)("color.text.brand")
    }),
    selected: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.background.selected"),
        borderColor: "transparent",
        color: (0, $hgUW1$token)("color.text.brand"),
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.selected"),
            borderColor: "transparent",
            color: (0, $hgUW1$token)("color.text.brand")
        }
    })
};
const $fec02fc26c7e145d$var$learningButtonFontStyles = {
    medium: (0, $hgUW1$css)({
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600
    }),
    large: (0, $hgUW1$css)({
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: 600
    })
};
const $fec02fc26c7e145d$var$learningButtonSpacingStyles = {
    medium: (0, $hgUW1$css)({
        padding: `10px ${(0, $hgUW1$token)("space.150")}`
    }),
    "medium-icon-before": (0, $hgUW1$css)({
        padding: `10px ${(0, $hgUW1$token)("space.150")} 10px 10px`
    }),
    "medium-icon-after": (0, $hgUW1$css)({
        padding: `10px 10px 10px ${(0, $hgUW1$token)("space.150")}`
    }),
    large: (0, $hgUW1$css)({
        padding: `${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.200")}`
    }),
    "large-icon-before": (0, $hgUW1$css)({
        padding: `${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.150")}`
    }),
    "large-icon-after": (0, $hgUW1$css)({
        padding: `${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.200")}`
    })
};
const $fec02fc26c7e145d$var$learningButtonResponsiveSpacing = {
    large: (0, $hgUW1$css)({
        [(0, $hgUW1$media).below.sm]: {
            padding: `10px ${(0, $hgUW1$token)("space.150")}`
        }
    }),
    "large-icon-before": (0, $hgUW1$css)({
        [(0, $hgUW1$media).below.sm]: {
            padding: `10px ${(0, $hgUW1$token)("space.150")} 10px 10px`
        }
    }),
    "large-icon-after": (0, $hgUW1$css)({
        [(0, $hgUW1$media).below.sm]: {
            padding: `10px 10px 10px ${(0, $hgUW1$token)("space.150")}`
        }
    })
};
const $fec02fc26c7e145d$var$learningButtonResponsiveFontStyles = (0, $hgUW1$css)({
    [(0, $hgUW1$media).below.sm]: {
        fontSize: "16px",
        lineHeight: "20px"
    }
});
const $fec02fc26c7e145d$var$learningButtonLinkStyles = {
    basic: (0, $hgUW1$css)({
        display: "flex",
        width: "fit-content",
        padding: `10px ${(0, $hgUW1$token)("space.150")}`,
        border: "none",
        alignItems: "center",
        fontFamily: "Charlie Text, sans-serif",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "20px",
        color: (0, $hgUW1$token)("color.text.brand"),
        background: "transparent",
        outline: "none",
        cursor: "pointer",
        "&:hover": {
            color: (0, $hgUW1$token)("color.text.brand"),
            textDecoration: "underline",
            textUnderlineOffset: "4px"
        },
        "&:active": {
            color: (0, $hgUW1$token)("color.text.brand"),
            textDecoration: "underline"
        }
    }),
    disabled: {
        color: (0, $hgUW1$token)("color.text.disabled"),
        "&:hover": {
            textDecoration: "none"
        },
        "&:active": {
            textDecoration: "none"
        }
    }
};
const $fec02fc26c7e145d$var$linkStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.brand"),
    cursor: "pointer",
    "&:active": {
        color: (0, $hgUW1$token)("color.link.pressed")
    }
});
const $fec02fc26c7e145d$var$disabledLinkStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.disabled"),
    cursor: "not-allowed",
    "&:hover": {
        color: (0, $hgUW1$token)("color.text.disabled"),
        textDecoration: "none"
    },
    "&:active": {
        color: (0, $hgUW1$token)("color.text.disabled"),
        textDecoration: "none"
    }
});
const $fec02fc26c7e145d$var$buttonIconContainerStyles = (0, $hgUW1$css)({
    width: "24px",
    height: "24px"
});
const $fec02fc26c7e145d$var$disabledIconStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.icon.disabled"),
    cursor: "not-allowed"
});
const $fec02fc26c7e145d$var$learningButtonIconStyles = {
    base: (0, $hgUW1$css)({
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        border: "none",
        color: (0, $hgUW1$token)("color.icon"),
        backgroundColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest.hovered")
        },
        "&:active": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest.pressed")
        },
        "&:disabled": {
            backgroundColor: (0, $hgUW1$token)("color.background.disabled"),
            color: (0, $hgUW1$token)("color.icon.disabled"),
            cursor: "not-allowed"
        }
    }),
    selected: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.background.selected"),
        color: (0, $hgUW1$token)("color.icon.selected"),
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.selected.hovered"),
            color: (0, $hgUW1$token)("color.icon.selected")
        }
    })
};


var $d501466973a9f0a6$exports = {};

$parcel$export($d501466973a9f0a6$exports, "CheckboxType", () => $d501466973a9f0a6$export$138e17770a0a93a6);
$parcel$export($d501466973a9f0a6$exports, "CheckboxSize", () => $d501466973a9f0a6$export$5e435bc8b081a399);
$parcel$export($d501466973a9f0a6$exports, "Checkbox", () => $d501466973a9f0a6$export$48513f6b9f8ce62d);


var $fde9406d76ec24a9$exports = {};

$parcel$export($fde9406d76ec24a9$exports, "objectValuesToControls", () => $fde9406d76ec24a9$export$8a8918d045227e35);
$parcel$export($fde9406d76ec24a9$exports, "withFocusInteraction", () => $fde9406d76ec24a9$export$1456ddd9fbfc0a1f);
$parcel$export($fde9406d76ec24a9$exports, "inspectorProps", () => $fde9406d76ec24a9$export$1784ac302bd8ebad);
$parcel$export($fde9406d76ec24a9$exports, "formatMinutes", () => $fde9406d76ec24a9$export$30c35cbf580cab77);
$parcel$export($fde9406d76ec24a9$exports, "getRedirectUrl", () => $fde9406d76ec24a9$export$93832c3affb240d3);
$parcel$export($fde9406d76ec24a9$exports, "calculateLearningProgress", () => $fde9406d76ec24a9$export$6e67b290ed5690f6);
$parcel$export($fde9406d76ec24a9$exports, "SEARCHBAR_HISTORY_STORAGE_KEY", () => $fde9406d76ec24a9$export$1059c3e9f228d9b);
$parcel$export($fde9406d76ec24a9$exports, "getLocalStorageHistory", () => $fde9406d76ec24a9$export$7765f5b61937bda1);
$parcel$export($fde9406d76ec24a9$exports, "setLocalStorageItems", () => $fde9406d76ec24a9$export$cec0922aa1b64670);
const $3dba2111a1a6d39b$var$buildAuthQueryParams = ({ email: email , redirectUrl: redirectUrl , prompt: prompt = "none" , experience: experience = "entry-auth"  })=>{
    const queryParams = [];
    if (email) queryParams.push(`login_hint=${email}`);
    if (experience) queryParams.push(`application=community--${experience}`);
    if (redirectUrl) queryParams.push(`referer=${redirectUrl}`);
    if (prompt) queryParams.push(`prompt=${prompt}`);
    return queryParams;
};
const $3dba2111a1a6d39b$export$1db7da00354b15ed = (queryParamValues)=>{
    const queryParams = $3dba2111a1a6d39b$var$buildAuthQueryParams(queryParamValues);
    return `/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect?${queryParams.join("&")}`;
};


let $1ff01338112cd7fe$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["LOCAL"] = "local";
    Environment["DEVELOPMENT"] = "development";
    Environment["STAGING"] = "staging";
    Environment["PRODUCTION"] = "production";
})($1ff01338112cd7fe$export$7dc6752a22ab011a || ($1ff01338112cd7fe$export$7dc6752a22ab011a = {}));
const $1ff01338112cd7fe$export$1b5aa7388a6c5e6f = {
    [$1ff01338112cd7fe$export$7dc6752a22ab011a.LOCAL]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$1ff01338112cd7fe$export$7dc6752a22ab011a.DEVELOPMENT]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$1ff01338112cd7fe$export$7dc6752a22ab011a.STAGING]: {
        loggedIn: "https://id.stg.internal.atlassian.com",
        loggedOut: "https://id.stg.internal.atlassian.com"
    },
    [$1ff01338112cd7fe$export$7dc6752a22ab011a.PRODUCTION]: {
        loggedIn: "https://id.atlassian.com",
        loggedOut: "https://id.atlassian.com"
    }
};
const $1ff01338112cd7fe$export$d349399b473d7299 = {
    loggedIn: "/",
    loggedOut: "/"
};
let $1ff01338112cd7fe$export$93d048dc21eb282a;
(function(CommunityApp) {
    CommunityApp["HOME"] = "home";
    CommunityApp["LEARNING"] = "learning";
    CommunityApp["FORUMS"] = "forums";
    CommunityApp["EVENTS"] = "events";
    CommunityApp["PROFILE"] = "unified-portable-profile";
    CommunityApp["CHAMPIONS"] = "champions";
})($1ff01338112cd7fe$export$93d048dc21eb282a || ($1ff01338112cd7fe$export$93d048dc21eb282a = {}));
const $1ff01338112cd7fe$export$67e61a6fa639f224 = (email)=>[
        {
            app: $1ff01338112cd7fe$export$93d048dc21eb282a.FORUMS,
            label: "Forums",
            target: "_self",
            href: {
                loggedIn: (0, $3dba2111a1a6d39b$export$1db7da00354b15ed)({
                    email: email,
                    redirectUrl: "/forums"
                }),
                loggedOut: "/forums"
            }
        },
        {
            app: $1ff01338112cd7fe$export$93d048dc21eb282a.LEARNING,
            label: "Learning",
            href: {
                loggedIn: "/learning",
                loggedOut: "/learning"
            }
        },
        {
            app: $1ff01338112cd7fe$export$93d048dc21eb282a.EVENTS,
            label: "Events",
            target: "_self",
            href: {
                loggedIn: "/events",
                loggedOut: "/events"
            }
        },
        {
            app: $1ff01338112cd7fe$export$93d048dc21eb282a.CHAMPIONS,
            label: "Champions",
            target: "_self",
            href: {
                loggedIn: "/champions",
                loggedOut: "/champions"
            }
        }
    ];
const $1ff01338112cd7fe$export$208c68d48dfc9a12 = $1ff01338112cd7fe$export$67e61a6fa639f224();
const $1ff01338112cd7fe$export$fe0105b4860d6e11 = {
    [$1ff01338112cd7fe$export$93d048dc21eb282a.FORUMS]: "/forums",
    [$1ff01338112cd7fe$export$93d048dc21eb282a.LEARNING]: "/learning",
    [$1ff01338112cd7fe$export$93d048dc21eb282a.EVENTS]: "/events",
    [$1ff01338112cd7fe$export$93d048dc21eb282a.PROFILE]: "/user",
    [$1ff01338112cd7fe$export$93d048dc21eb282a.CHAMPIONS]: "/champions"
};
const $1ff01338112cd7fe$export$132b2bf91782e62b = {
    loggedIn: "/user",
    loggedOut: "/user"
};
const $1ff01338112cd7fe$export$b9cc8022ec117e91 = {
    loggedIn: "/user/settings",
    loggedOut: "/user/settings"
};
const $1ff01338112cd7fe$export$46dbfbdf99745111 = "Log in";
const $1ff01338112cd7fe$export$4fe37309c24221ae = "Sign up";
const $1ff01338112cd7fe$export$668d072b293d5f38 = {
    PROFILE: {
        text: "Profile",
        id: "profile"
    },
    LOG_OUT: {
        text: "Log out",
        id: "logout"
    },
    SETTINGS: {
        text: "Settings",
        id: "settings"
    }
};
let $1ff01338112cd7fe$export$3d7865934588d77e;
(function(EventType) {
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["IDENTIFY"] = "identify";
})($1ff01338112cd7fe$export$3d7865934588d77e || ($1ff01338112cd7fe$export$3d7865934588d77e = {}));
let $1ff01338112cd7fe$export$d778a884eb401313;
(function(AnalyticsActivityType) {
    AnalyticsActivityType["NAV_LOGO_CLICK"] = "NAV_LOGO_CLICK";
    AnalyticsActivityType["NAV_ITEM_CLICK"] = "NAV_ITEM_CLICK";
    AnalyticsActivityType["LOG_IN_CLICK"] = "LOG_IN_CLICK";
    AnalyticsActivityType["SIGN_UP_CLICK"] = "SIGN_UP_CLICK";
    AnalyticsActivityType["LOG_OUT_CLICK"] = "LOG_OUT_CLICK";
    AnalyticsActivityType["PROFILE_MENU_OPEN"] = "PROFILE_MENU_OPEN";
    AnalyticsActivityType["PROFILE_MENU_CLOSE"] = "PROFILE_MENU_CLOSE";
    AnalyticsActivityType["PROFILE_MENU_ITEM_CLICK"] = "PROFILE_MENU_ITEM_CLICK";
    AnalyticsActivityType["MOBILE_MENU_OPEN"] = "MOBILE_MENU_OPEN";
    AnalyticsActivityType["MOBILE_MENU_CLOSE"] = "MOBILE_MENU_CLOSE";
})($1ff01338112cd7fe$export$d778a884eb401313 || ($1ff01338112cd7fe$export$d778a884eb401313 = {}));
const $1ff01338112cd7fe$export$bc6e44c7f1ae99f6 = "https://www.atlassian.com/legal/community-platform-terms-of-use";
const $1ff01338112cd7fe$export$30786e8ac20c09d8 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";


const $fde9406d76ec24a9$export$8a8918d045227e35 = (obj, control = "select")=>({
        control: control,
        options: Object.values(obj)
    });
const $fde9406d76ec24a9$export$1456ddd9fbfc0a1f = (handler)=>(e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            handler();
        }
    };
const $fde9406d76ec24a9$export$1784ac302bd8ebad = (key, inspectMode)=>{
    if (inspectMode && inspectMode[key]) {
        const { entryId: entryId , fieldId: fieldId  } = inspectMode[key];
        return {
            "data-contentful-entry-id": entryId,
            "data-contentful-field-id": fieldId
        };
    }
};
const $fde9406d76ec24a9$export$30c35cbf580cab77 = (minutes)=>{
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    let output = "";
    if (hours > 0) {
        output += `${hours} hour`;
        if (hours > 1) output += "s";
    }
    if (remainingMinutes > 0) {
        if (hours > 0) output += " and ";
        output += `${remainingMinutes} minute`;
        if (remainingMinutes > 1) output += "s";
    }
    return output;
};
const $fde9406d76ec24a9$export$93832c3affb240d3 = (url, environment)=>{
    const idUrl = (0, $1ff01338112cd7fe$export$1b5aa7388a6c5e6f)[environment] || (0, $1ff01338112cd7fe$export$1b5aa7388a6c5e6f)[(0, $1ff01338112cd7fe$export$7dc6752a22ab011a).STAGING];
    return `${idUrl}/login?continue=${encodeURIComponent(url)}`;
};
const $fde9406d76ec24a9$export$6e67b290ed5690f6 = (completed, total)=>{
    if (total === 0) return 0;
    return completed / total * 100;
};
const $fde9406d76ec24a9$export$1059c3e9f228d9b = "searchbar_history";
const $fde9406d76ec24a9$export$7765f5b61937bda1 = ()=>{
    if (typeof window === "undefined") return [];
    const storedHistory = localStorage.getItem($fde9406d76ec24a9$export$1059c3e9f228d9b);
    return storedHistory ? JSON.parse(storedHistory) : [];
};
const $fde9406d76ec24a9$export$cec0922aa1b64670 = (items)=>{
    if (typeof window === "undefined") return;
    localStorage.setItem($fde9406d76ec24a9$export$1059c3e9f228d9b, JSON.stringify(items));
};




let $d501466973a9f0a6$export$138e17770a0a93a6;
(function(CheckboxType) {
    CheckboxType["DEFAULT"] = "DEFAULT";
    CheckboxType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    CheckboxType["DANGER"] = "DANGER";
    CheckboxType["DISABLED"] = "DISABLED";
})($d501466973a9f0a6$export$138e17770a0a93a6 || ($d501466973a9f0a6$export$138e17770a0a93a6 = {}));
let $d501466973a9f0a6$export$5e435bc8b081a399;
(function(CheckboxSize) {
    CheckboxSize["DEFAULT"] = "DEFAULT";
    CheckboxSize["LARGE"] = "LARGE";
})($d501466973a9f0a6$export$5e435bc8b081a399 || ($d501466973a9f0a6$export$5e435bc8b081a399 = {}));
const $d501466973a9f0a6$export$48513f6b9f8ce62d = ({ label: label , isChecked: isChecked , onChange: onChange , type: type = $d501466973a9f0a6$export$138e17770a0a93a6.DEFAULT , size: size = $d501466973a9f0a6$export$5e435bc8b081a399.DEFAULT , isIndeterminate: isIndeterminate = false , isRequired: isRequired = false , isBold: isBold , tabIndex: tabIndex = 0  })=>{
    const [userHasInteracted, setUserHasInteracted] = (0, $hgUW1$useState)(false);
    const checkboxRef = (0, $hgUW1$useRef)(null);
    const handleChange = (0, $hgUW1$useCallback)(()=>{
        setUserHasInteracted(true);
        if (onChange) onChange();
    }, [
        onChange
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(handleChange), [
        isChecked
    ]);
    (0, $hgUW1$useEffect)(()=>{
        if (checkboxRef.current) checkboxRef.current.indeterminate = isIndeterminate && !userHasInteracted;
    }, [
        isIndeterminate,
        userHasInteracted
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("label", {
        onKeyDown: handleKeyDown,
        css: [
            $d501466973a9f0a6$var$labelStyles,
            size === $d501466973a9f0a6$export$5e435bc8b081a399.LARGE && $d501466973a9f0a6$var$labelLargeStyles,
            type === $d501466973a9f0a6$export$138e17770a0a93a6.DISABLED && $d501466973a9f0a6$var$variants.label.DISABLED,
            isBold && (0, $hgUW1$css)({
                fontWeight: 700
            }),
            !isBold && (0, $hgUW1$css)({
                fontWeight: 400
            })
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("input", {
                ref: checkboxRef,
                tabIndex: -1,
                type: "checkbox",
                role: "checkbox",
                checked: isChecked,
                onChange: handleChange,
                css: $d501466973a9f0a6$var$inputCheckboxStyles
            }),
            label,
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                tabIndex: tabIndex,
                onKeyDown: handleKeyDown,
                css: [
                    $d501466973a9f0a6$var$variants.checkbox[type],
                    $d501466973a9f0a6$var$checkmarkStyles,
                    size === $d501466973a9f0a6$export$5e435bc8b081a399.LARGE && $d501466973a9f0a6$var$checkmarkLargeStyles,
                    isIndeterminate && !userHasInteracted && $d501466973a9f0a6$var$indeterminateCheckmarkStyles,
                    isChecked && $d501466973a9f0a6$var$checkedCheckmarkStyles,
                    isChecked && type === $d501466973a9f0a6$export$138e17770a0a93a6.DANGER && (0, $hgUW1$css)({
                        backgroundColor: (0, $hgUW1$token)("color.border.danger")
                    })
                ]
            }),
            isRequired && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $d501466973a9f0a6$var$requiredMarkStyles,
                    size === $d501466973a9f0a6$export$5e435bc8b081a399.LARGE && (0, $hgUW1$css)({
                        marginLeft: "2px"
                    })
                ],
                children: "*"
            })
        ]
    });
};
const $d501466973a9f0a6$var$requiredMarkStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtle"),
    marginLeft: "6px"
});
const $d501466973a9f0a6$var$labelStyles = (0, $hgUW1$css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    marginBottom: 0,
    userSelect: "none",
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "22px",
    "&:hover": {
        cursor: "pointer"
    }
});
const $d501466973a9f0a6$var$labelLargeStyles = (0, $hgUW1$css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $d501466973a9f0a6$var$inputCheckboxStyles = (0, $hgUW1$css)({
    position: "absolute",
    opacity: 0,
    cursor: "pointer",
    height: 0,
    width: 0
});
const $d501466973a9f0a6$var$checkmarkStyles = (0, $hgUW1$css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "3px",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    border: `1px solid ${(0, $hgUW1$token)("color.border.input")}`,
    borderRadius: "2px",
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    }
});
const $d501466973a9f0a6$var$checkedCheckmarkStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.selected.bold"),
    borderColor: (0, $hgUW1$token)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "1px",
        width: "4px",
        height: "7px",
        border: `solid ${(0, $hgUW1$token)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $d501466973a9f0a6$var$checkmarkLargeStyles = (0, $hgUW1$css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "1px",
        width: "6px !important",
        height: "10px !important",
        border: `solid ${(0, $hgUW1$token)("color.text.inverse")}`,
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)"
    }
});
const $d501466973a9f0a6$var$indeterminateCheckmarkStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.selected.bold"),
    borderColor: (0, $hgUW1$token)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "2.5px",
        top: "-1px",
        width: "9px",
        height: "7px",
        borderBottom: `2px solid ${(0, $hgUW1$token)("color.text.inverse")}`
    }
});
const $d501466973a9f0a6$var$variants = {
    label: {
        DISABLED: (0, $hgUW1$css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $hgUW1$css)({
            "&:hover": {
                borderColor: (0, $hgUW1$token)("color.border.selected")
            }
        }),
        SUCCESS: (0, $hgUW1$css)({
            "&, &:hover": {
                borderColor: (0, $hgUW1$token)("color.border.selected")
            }
        }),
        DANGER: (0, $hgUW1$css)({
            "&, &:hover": {
                borderColor: (0, $hgUW1$token)("color.border.danger")
            }
        }),
        DISABLED: (0, $hgUW1$css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};


var $c4979bfceee73878$exports = {};

$parcel$export($c4979bfceee73878$exports, "CommonModal", () => $c4979bfceee73878$export$8577c1390d697bac);





const $c4979bfceee73878$export$8577c1390d697bac = ({ isOpen: isOpen , toggleModal: toggleModal , modalDescriptionLabel: modalDescription , children: children , styles: styles  })=>{
    const closeModal = (0, $hgUW1$useCallback)((e)=>{
        e?.stopPropagation();
        toggleModal(false);
    }, []);
    const modalRef = (0, $hgUW1$useRef)(null);
    const focusOnOpen = (0, $hgUW1$useCallback)(()=>{
        if (isOpen) modalRef?.current?.focus();
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        focusOnOpen();
        const handleEsc = (event)=>{
            if (event.key === "Escape") toggleModal(false);
        };
        document.addEventListener("keyup", handleEsc, false);
        return ()=>{
            document.removeEventListener("keyup", handleEsc, false);
        };
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        focusOnOpen();
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return isOpen && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: [
            $c4979bfceee73878$var$backdropStyles,
            styles && styles
        ],
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            "aria-modal": true,
            role: "dialog",
            ref: modalRef,
            "aria-label": modalDescription,
            tabIndex: -1,
            css: $c4979bfceee73878$var$modalStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                    type: "button",
                    css: $c4979bfceee73878$var$closeButtonStyles,
                    onClick: closeModal,
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcross), {
                        label: "Close Modal",
                        size: "medium",
                        primaryColor: (0, $hgUW1$token)("color.icon")
                    })
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $c4979bfceee73878$var$modalSlotStyles,
                    children: children
                })
            ]
        })
    });
};
const $c4979bfceee73878$var$backdropStyles = (0, $hgUW1$css)({
    "&, *": {
        boxSizing: "border-box"
    },
    backgroundColor: "gray",
    position: "fixed",
    padding: "16px",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    top: 0,
    zIndex: 100000000
});
const $c4979bfceee73878$var$modalStyles = (0, $hgUW1$css)({
    position: "relative",
    padding: "16px",
    paddingTop: "48px",
    maxWidth: "100%",
    maxHeight: "100%",
    borderRadius: "8px",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    zIndex: 200000000
});
const $c4979bfceee73878$var$closeButtonStyles = (0, $hgUW1$css)({
    position: "absolute",
    top: "16px",
    right: "16px",
    border: "none",
    outline: "none",
    background: "transparent",
    padding: 0,
    cursor: "pointer",
    borderRadius: "4px",
    "&:hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.hovered")
    },
    "&:focus svg": {
        color: (0, $hgUW1$token)("color.icon.selected")
    },
    "&:active": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.pressed")
    },
    "&:disabled": {
        backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtle.hovered")
    }
});
const $c4979bfceee73878$var$modalSlotStyles = (0, $hgUW1$css)({
    minWidth: "100px",
    minHeight: "25px",
    fontSize: "16px"
});


var $0903e93de01b205a$exports = {};

$parcel$export($0903e93de01b205a$exports, "Divider", () => $0903e93de01b205a$export$2e0a83ec2e27ecbb);
/**
 * Horizontal line acting as divider with custom color and height
 * @param {DividerProps} DividerProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <Divider color={token('color.border')} />
 */ 

const $0903e93de01b205a$export$2e0a83ec2e27ecbb = ({ color: color , height: height = 1  })=>{
    const styles = {
        height: height + "px",
        border: `0 solid ${(0, $hgUW1$token)("color.border")}`,
        margin: 0,
        backgroundColor: color
    };
    return /*#__PURE__*/ (0, $hgUW1$jsx)("hr", {
        "data-testid": "divider",
        style: styles
    });
};


var $a950778dc3003c4a$exports = {};

$parcel$export($a950778dc3003c4a$exports, "Eyebrow", () => $a950778dc3003c4a$export$71f050e2efa708bb);



const $a950778dc3003c4a$export$71f050e2efa708bb = ({ fontWeight: fontWeight = "regular" , size: size = "small" , color: color = (0, $hgUW1$token)("color.text") , children: children  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("h4", {
        css: [
            $a950778dc3003c4a$var$eyebrowSmallStyles,
            size === "medium" && $a950778dc3003c4a$var$eyebrowMediumStyles,
            fontWeight === "semibold" && (0, $hgUW1$css)({
                fontWeight: 600
            }),
            color && (0, $hgUW1$css)({
                color: color
            })
        ],
        children: children
    });
};
const $a950778dc3003c4a$var$eyebrowSmallStyles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Text", sans-serif',
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    color: (0, $hgUW1$token)("color.text"),
    textTransform: "uppercase"
});
const $a950778dc3003c4a$var$eyebrowMediumStyles = (0, $hgUW1$css)({
    fontSize: "14px",
    lineHeight: "18px"
});


var $582583ec420fce57$exports = {};

$parcel$export($582583ec420fce57$exports, "Heading", () => $582583ec420fce57$export$a8a3e93435678ff9);






const $582583ec420fce57$export$a8a3e93435678ff9 = ({ children: children , level: level , inspectMode: inspectMode , id: id , color: color = (0, $hgUW1$token)("color.text") , fontWeight: fontWeight  })=>{
    const HeadingElement = $582583ec420fce57$var$levelToHeadingElementsMap[level];
    const headingStyles = $582583ec420fce57$var$levelToHeadingStylesMap[level];
    const additionalProps = inspectMode ? (0, $fde9406d76ec24a9$export$1784ac302bd8ebad)(Object.keys(inspectMode)[0], inspectMode) : {};
    return /*#__PURE__*/ (0, $hgUW1$jsx)(HeadingElement, {
        id: id,
        css: [
            headingStyles,
            fontWeight && (0, $hgUW1$css)({
                fontWeight: fontWeight
            })
        ],
        ...additionalProps,
        style: {
            color: color
        },
        children: children
    });
};
const $582583ec420fce57$var$h0Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "48px",
    lineHeight: "52px",
    letterSpacing: "-0.144px",
    margin: 0,
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "56px",
        lineHeight: "64px",
        letterSpacing: "-0.168px"
    }
});
const $582583ec420fce57$var$h1Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2.5rem",
    lineHeight: "3rem",
    margin: 0,
    letterSpacing: "-0.144px",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "3rem",
        lineHeight: "3.5rem",
        letterSpacing: "-0.168px"
    }
});
const $582583ec420fce57$var$h2Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: "2.5rem",
    margin: 0,
    letterSpacing: "-0.096px",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "2.5rem",
        lineHeight: "3rem",
        letterSpacing: "-0.12px"
    }
});
const $582583ec420fce57$var$h3Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "2rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "2rem",
        lineHeight: "2.5rem",
        letterSpacing: "normal"
    }
});
const $582583ec420fce57$var$h4Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "1.5rem",
        lineHeight: "2rem",
        letterSpacing: "normal"
    }
});
const $582583ec420fce57$var$h5Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    margin: 0,
    letterSpacing: "normal",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        letterSpacing: "normal"
    }
});
const $582583ec420fce57$var$h6Styles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.375rem",
    textTransform: "unset",
    margin: 0,
    letterSpacing: "normal",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "1rem",
        lineHeight: "1.5rem",
        letterSpacing: "normal"
    }
});
const $582583ec420fce57$var$levelToHeadingElementsMap = {
    0: "h1",
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
};
const $582583ec420fce57$var$levelToHeadingStylesMap = {
    0: $582583ec420fce57$var$h0Styles,
    1: $582583ec420fce57$var$h1Styles,
    2: $582583ec420fce57$var$h2Styles,
    3: $582583ec420fce57$var$h3Styles,
    4: $582583ec420fce57$var$h4Styles,
    5: $582583ec420fce57$var$h5Styles,
    6: $582583ec420fce57$var$h6Styles
};


var $a02a6f7de308273b$exports = {};

$parcel$export($a02a6f7de308273b$exports, "icons", () => $a02a6f7de308273b$export$df03f54e09e486fa);
$parcel$export($a02a6f7de308273b$exports, "IconSize", () => $a02a6f7de308273b$export$ff775019b5b6e7df);
$parcel$export($a02a6f7de308273b$exports, "IconRotation", () => $a02a6f7de308273b$export$b3241a99d3e47e02);
$parcel$export($a02a6f7de308273b$exports, "Icon", () => $a02a6f7de308273b$export$f04a61298a47a40f);


























































const $a02a6f7de308273b$export$df03f54e09e486fa = {
    filter: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphfilter), {
            ...props
        }),
    "chevron-down": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevrondown), {
            ...props
        }),
    "chevron-up": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevronup), {
            ...props
        }),
    "chevron-left": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevronleft), {
            ...props
        }),
    "chevron-right": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevronright), {
            ...props
        }),
    "chevron-down-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevrondowncircle), {
            ...props
        }),
    "arrow-up-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypharrowupcircle), {
            ...props
        }),
    "arrow-up": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypharrowup), {
            ...props
        }),
    "check-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcheckcircle), {
            ...props
        }),
    "check-circle-outline": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcheckcircleoutline), {
            ...props
        }),
    "arrow-right": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypharrowright), {
            ...props
        }),
    "arrow-left-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypharrowleftcircle), {
            ...props
        }),
    "arrow-right-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypharrowrightcircle), {
            ...props
        }),
    "atlassian-logo": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphemojiatlassian), {
            ...props
        }),
    cross: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcross), {
            ...props
        }),
    "dropdown-cross": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypheditorclose), {
            ...props
        }),
    "menu-icon": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphmenu), {
            ...props
        }),
    "emoji-frequent": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphemojifrequent), {
            ...props
        }),
    "star-filled": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphstarfilled), {
            ...props
        }),
    star: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphstar), {
            ...props
        }),
    "bitbucket-builds": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphbitbucketbuilds), {
            ...props
        }),
    "editor-media-wrap-right": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypheditormediawrapright), {
            ...props
        }),
    "editor-table": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypheditortable), {
            ...props
        }),
    "editor-open": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypheditoropen), {
            ...props
        }),
    copy: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcopy), {
            ...props
        }),
    warning: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphwarning), {
            ...props
        }),
    image: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphimage), {
            ...props
        }),
    download: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphdownload), {
            ...props
        }),
    "zoom-in": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphmediaserviceszoomin), {
            ...props
        }),
    "zoom-out": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphmediaserviceszoomout), {
            ...props
        }),
    search: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphsearch), {
            ...props
        }),
    overview: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphoverview), {
            ...props
        }),
    add: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphadd), {
            ...props
        }),
    refresh: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphrefresh), {
            ...props
        }),
    "add-circle": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphaddcircle), {
            ...props
        }),
    edit: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphedit), {
            ...props
        }),
    "edit-filled": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypheditfilled), {
            ...props
        }),
    error: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglypherror), {
            ...props
        }),
    settings: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphsettings), {
            ...props
        }),
    info: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphinfo), {
            ...props
        }),
    question: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphquestion), {
            ...props
        }),
    check: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcheck), {
            ...props
        }),
    "check-circle-filled": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphcheckcircle), {
            ...props
        }),
    "emoji-symbols": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphemojisymbols), {
            ...props
        }),
    location: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphlocation), {
            ...props
        }),
    "chevron-left-large": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevronleftlarge), {
            ...props
        }),
    "chevron-right-large": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphchevronleftlarge), {
            ...props
        }),
    "hipchat-chevron-up": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphhipchatchevronup), {
            ...props
        }),
    "hipchat-chevron-down": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphhipchatchevrondown), {
            ...props
        }),
    export: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphexport), {
            ...props
        }),
    link: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphlink), {
            ...props
        }),
    share: (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphshare), {
            ...props
        }),
    "sidebar-collapse": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticoncoresidebarcollapse), {
            ...props
        }),
    "sidebar-expand": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticoncoresidebarexpand), {
            ...props
        }),
    bookmark: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
            "aria-label": "bookmark",
            "data-testid": "bookmark",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                id: "Icons/bookmark_24px",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "transparent",
                    stroke: "#626F86",
                    strokeWidth: "1.5"
                })
            })
        }),
    "bookmark-filled": ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
            "aria-label": "bookmark filled",
            "data-testid": "bookmark-filled",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                id: "Icons/bookmark_24px",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                    id: "bookmark",
                    d: "M12 18L7.8 19.8C7.13333 20.0833 6.5 20.0292 5.9 19.6375C5.3 19.2458 5 18.6917 5 17.975V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V17.975C19 18.6917 18.7 19.2458 18.1 19.6375C17.5 20.0292 16.8667 20.0833 16.2 19.8L12 18Z",
                    fill: "#626F86",
                    stroke: "#626F86",
                    strokeWidth: "1.5"
                })
            })
        }),
    "gap-completed": ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
            "data-testid": "gap-completed",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                id: "Icon / <CheckCircleIcon>",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                    id: "gap",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM9.3824 11.0689C9.50441 11.1213 9.61475 11.1975 9.707 11.293L11 12.586L14.293 9.29302C14.3852 9.19751 14.4956 9.12133 14.6176 9.06892C14.7396 9.01651 14.8708 8.98892 15.0036 8.98777C15.1364 8.98662 15.2681 9.01192 15.391 9.0622C15.5138 9.11248 15.6255 9.18673 15.7194 9.28063C15.8133 9.37452 15.8875 9.48617 15.9378 9.60907C15.9881 9.73196 16.0134 9.86364 16.0122 9.99642C16.0111 10.1292 15.9835 10.2604 15.9311 10.3824C15.8787 10.5044 15.8025 10.6148 15.707 10.707L11.707 14.707C11.5195 14.8945 11.2652 14.9998 11 14.9998C10.7348 14.9998 10.4805 14.8945 10.293 14.707L8.293 12.707C8.19749 12.6148 8.1213 12.5044 8.0689 12.3824C8.01649 12.2604 7.9889 12.1292 7.98775 11.9964C7.98659 11.8636 8.0119 11.732 8.06218 11.6091C8.11246 11.4862 8.18671 11.3745 8.2806 11.2806C8.3745 11.1867 8.48615 11.1125 8.60904 11.0622C8.73194 11.0119 8.86362 10.9866 8.9964 10.9878C9.12918 10.9889 9.2604 11.0165 9.3824 11.0689Z",
                    fill: "#22A06B"
                })
            })
        }),
    "thumb-down": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticoncorethumbsdown), {
            ...props
        }),
    "thumb-up": (props)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticoncorethumbsup), {
            ...props
        }),
    "dot-default": ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#091E42",
                strokeOpacity: "0.14"
            })
        }),
    "dot-selected": ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "7",
                height: "7",
                rx: "3.5",
                stroke: "#0C66E4"
            })
        }),
    "dot-completed": ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "8",
            height: "8",
            viewBox: "0 0 8 8",
            fill: "none",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                width: "8",
                height: "8",
                rx: "4",
                fill: "#22A06B"
            })
        }),
    one: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "one",
            children: "1"
        }),
    two: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "two",
            children: "2"
        }),
    three: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "three",
            children: "3"
        }),
    four: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "four",
            children: "4"
        }),
    five: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "five",
            children: "5"
        }),
    six: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "six",
            children: "6"
        }),
    seven: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "seven",
            children: "7"
        }),
    eight: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "eight",
            children: "8"
        }),
    nine: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "nine",
            children: "9"
        }),
    zero: ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
            css: $a02a6f7de308273b$var$iconNumberStyles,
            "data-testid": "zero",
            children: "0"
        })
};
let $a02a6f7de308273b$export$ff775019b5b6e7df;
(function(IconSize) {
    IconSize["SMALL"] = "small";
    IconSize["MEDIUM"] = "medium";
    IconSize["LARGE"] = "large";
    IconSize["XLARGE"] = "xlarge";
})($a02a6f7de308273b$export$ff775019b5b6e7df || ($a02a6f7de308273b$export$ff775019b5b6e7df = {}));
let $a02a6f7de308273b$export$b3241a99d3e47e02;
(function(IconRotation) {
    IconRotation["ZERO"] = "0deg";
    IconRotation["NINETY"] = "90deg";
    IconRotation["ONE_EIGHTY"] = "180deg";
    IconRotation["TWO_SEVENTY"] = "270deg";
})($a02a6f7de308273b$export$b3241a99d3e47e02 || ($a02a6f7de308273b$export$b3241a99d3e47e02 = {}));
const $a02a6f7de308273b$export$f04a61298a47a40f = ({ type: type , size: size = $a02a6f7de308273b$export$ff775019b5b6e7df.MEDIUM , rotation: rotation = $a02a6f7de308273b$export$b3241a99d3e47e02.ZERO , alt: alt = "" , color: color , hoverColor: hoverColor , activeColor: activeColor  })=>{
    const icon = (0, $hgUW1$useMemo)(()=>$a02a6f7de308273b$export$df03f54e09e486fa[type], [
        type
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
        css: [
            $a02a6f7de308273b$var$baseStyles,
            $a02a6f7de308273b$var$rotationStyles[rotation],
            hoverColor && {
                "&:hover": {
                    color: hoverColor
                }
            },
            activeColor && {
                "&:active": {
                    color: activeColor
                }
            }
        ],
        "data-testid": `icon-${type}`,
        children: icon ? icon({
            size: size,
            label: alt,
            primaryColor: color || undefined,
            testId: type
        }) : null
    });
};
const $a02a6f7de308273b$var$baseStyles = (0, $hgUW1$css)({
    width: "fit-content",
    height: "fit-content",
    display: "inline-flex"
});
const $a02a6f7de308273b$var$rotationStyles = {
    "0deg": (0, $hgUW1$css)({
        transform: "rotate(0deg)"
    }),
    "90deg": (0, $hgUW1$css)({
        transform: "rotate(90deg)"
    }),
    "180deg": (0, $hgUW1$css)({
        transform: "rotate(180deg)"
    }),
    "270deg": (0, $hgUW1$css)({
        transform: "rotate(270deg)"
    })
};
const $a02a6f7de308273b$var$iconNumberStyles = (0, $hgUW1$css)({
    fontSize: "16px"
});


var $1298c86a7e6a9fc7$exports = {};

$parcel$export($1298c86a7e6a9fc7$exports, "Image", () => $1298c86a7e6a9fc7$export$3e431a229df88919);








/**
 * It takes a url and returns the last part of the url which is the name of the image.
 * @param {string} url - The URL of the image you want to get the name.
 * @returns name of the image file.
 */ const $1298c86a7e6a9fc7$var$getImageName = (url)=>{
    const urlSplitted = url.split("/");
    return urlSplitted[urlSplitted.length - 1];
};
/**
 * Convert bytes into KB or MB
 * @param {number} [bytes] - The number of bytes to format.
 * @returns a string with the KB o MB converted
 */ const $1298c86a7e6a9fc7$var$formatBytes = (bytes)=>{
    const marker = 1024;
    const decimal = 0;
    const kiloBytes = marker;
    const megaBytes = marker * marker;
    return bytes ? bytes < kiloBytes ? bytes + " Bytes" : bytes < megaBytes ? (bytes / kiloBytes).toFixed(decimal) + " KB" : (bytes / megaBytes).toFixed(decimal) + " MB" : undefined;
};
/**
 * Download image
 * @param {string} src - The URL of the image you want to download.
 * @param {string} name - The name of the file you want to save the image as.
 */ const $1298c86a7e6a9fc7$var$downloadImage = async (src, name)=>{
    const image = await fetch(src);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $1298c86a7e6a9fc7$export$3e431a229df88919 = ({ inspectMode: inspectMode , src: src , alt: alt , width: width , height: height , caption: caption = "" , size: size , center: center = true , preventModal: preventModal = false , onClick: onClick , ...props })=>{
    const rightToolsRef = (0, $hgUW1$useRef)(null);
    const downloadButtonRef = (0, $hgUW1$useRef)(null);
    const modalImgRef = (0, $hgUW1$useRef)(null);
    const originalImgRef = (0, $hgUW1$useRef)(null);
    const [showModal, setShowModal] = (0, $hgUW1$useState)(false);
    const [showControls, setShowControls] = (0, $hgUW1$useState)(false);
    const [totalZoom, setTotalZoom] = (0, $hgUW1$useState)(100);
    const [initialWidthModalImage, setInitialWidthModalImage] = (0, $hgUW1$useState)(0);
    const [initialHeightImage, setInitialHeightImage] = (0, $hgUW1$useState)(0);
    const [initialWidthOriginalImage, setInitialWidthOriginalImage] = (0, $hgUW1$useState)(0);
    (0, $hgUW1$useEffect)(()=>{
        if (showModal) {
            setShowControls(true);
            setTotalZoom(100);
            if (rightToolsRef.current) rightToolsRef.current.focus();
        }
    }, [
        showModal
    ]);
    (0, $hgUW1$useEffect)(()=>{
        let timer = null;
        if (showControls) timer = setTimeout(()=>setShowControls(false), 5000);
        return ()=>clearTimeout(timer);
    }, [
        showControls
    ]);
    (0, $hgUW1$useEffect)(()=>{
        const close = (e)=>{
            if (e.key === "Escape") setShowModal(false);
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, []);
    const onHoverModal = ()=>{
        setShowControls(true);
    };
    const onZoomOut = ()=>{
        if (totalZoom > 20) {
            setTotalZoom(totalZoom - 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth - initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight - initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onZoomIn = ()=>{
        if (totalZoom < 320) {
            setTotalZoom(totalZoom + 20);
            if (modalImgRef.current) {
                const widthImageModal = Math.round(modalImgRef.current?.offsetWidth + initialWidthModalImage * 0.2);
                const heightImageModal = Math.round(modalImgRef.current?.offsetHeight + initialHeightImage * 0.2);
                modalImgRef.current.style.width = `${widthImageModal}px`;
                modalImgRef.current.style.height = `${heightImageModal}px`;
            }
        }
    };
    const onBlur = ()=>{
        if (rightToolsRef.current && downloadButtonRef.current) {
            rightToolsRef.current.setAttribute("tabIndex", "-1");
            downloadButtonRef.current.focus();
        }
    };
    const onClickImage = (0, $hgUW1$useCallback)(()=>{
        if (onClick) onClick();
        if (!preventModal) setShowModal(true);
    }, [
        onClick
    ]);
    const onLoadImageModal = ()=>{
        setInitialWidthModalImage(modalImgRef.current?.offsetWidth ?? 0);
        setInitialHeightImage(modalImgRef.current?.offsetHeight ?? 0);
    };
    (0, $hgUW1$useEffect)(()=>{
        if (originalImgRef.current?.offsetWidth) setInitialWidthOriginalImage(originalImgRef.current.offsetWidth);
    }, [
        originalImgRef.current?.offsetWidth
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((e)=>{
        if (e.code === "Space") onClickImage();
    }, [
        onClickImage
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
        children: [
            showModal && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                "data-testid": "modal",
                id: "myModal",
                css: $1298c86a7e6a9fc7$var$modalStyles,
                onMouseMove: onHoverModal,
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $1298c86a7e6a9fc7$var$modalContentStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: [
                                $1298c86a7e6a9fc7$var$modalControlsStyles,
                                showControls && (0, $hgUW1$css)({
                                    opacity: 1
                                }),
                                !showControls && (0, $hgUW1$css)({
                                    opacity: 0
                                })
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $1298c86a7e6a9fc7$var$containerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: $1298c86a7e6a9fc7$var$textContainerStyles,
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                                css: $1298c86a7e6a9fc7$var$iconContainerStyles,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "image",
                                                    size: "large",
                                                    color: (0, $hgUW1$Y300)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                                css: $1298c86a7e6a9fc7$var$imageContainerStyles,
                                                children: [
                                                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                                        css: $1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: $1298c86a7e6a9fc7$var$getImageName(src)
                                                    }),
                                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                                                        css: $1298c86a7e6a9fc7$var$badgeContentStyles,
                                                        children: [
                                                            "image \xb7 ",
                                                            $1298c86a7e6a9fc7$var$formatBytes(size)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        className: "right",
                                        tabIndex: 0,
                                        ref: rightToolsRef,
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                                "data-testid": "download-button",
                                                ref: downloadButtonRef,
                                                tabIndex: 0,
                                                css: (0, $hgUW1$css)({
                                                    marginRight: "1rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "download image",
                                                onClick: ()=>{
                                                    $1298c86a7e6a9fc7$var$downloadImage(src, $1298c86a7e6a9fc7$var$getImageName(src));
                                                },
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "download",
                                                    size: "medium"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                tabIndex: 0,
                                                "data-testid": "close-modal-button",
                                                "aria-label": "close modal",
                                                onClick: ()=>{
                                                    setShowModal(false);
                                                },
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "cross",
                                                    size: "medium"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$reactindianadragscroll), {
                            css: $1298c86a7e6a9fc7$var$scrollContainerStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                                src: src,
                                alt: alt,
                                ref: modalImgRef,
                                onLoad: onLoadImageModal,
                                css: (0, $hgUW1$css)({
                                    margin: "auto"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: [
                                $1298c86a7e6a9fc7$var$modalToolsStyles,
                                (0, $hgUW1$css)({
                                    opacity: showControls ? 1 : 0
                                })
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $1298c86a7e6a9fc7$var$buttonContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                                "data-testid": "zoom-out-button",
                                                onClick: ()=>onZoomOut(),
                                                css: (0, $hgUW1$css)({
                                                    marginRight: "0.625rem",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }),
                                                "aria-label": "zoom out",
                                                tabIndex: 0,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "zoom-out"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                                css: {
                                                    border: "none",
                                                    cursor: "pointer"
                                                },
                                                "data-testid": "zoom-in-button",
                                                onClick: ()=>onZoomIn(),
                                                onBlur: onBlur,
                                                "aria-label": "zoom in",
                                                tabIndex: 0,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "zoom-in"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: (0, $hgUW1$css)({
                                            color: (0, $hgUW1$DN600)
                                        }),
                                        children: [
                                            totalZoom,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("image", inspectMode),
                css: (0, $hgUW1$css)({
                    width: "100%",
                    overflow: "hidden"
                }),
                "data-testid": "image",
                onClick: onClickImage,
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("figure", {
                    css: $1298c86a7e6a9fc7$var$figureStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                            tabIndex: 0,
                            width: width,
                            height: height,
                            ref: originalImgRef,
                            alt: alt,
                            src: src,
                            onKeyDown: handleKeyDown,
                            css: [
                                (0, $hgUW1$css)({
                                    transform: "scale(1)",
                                    objectFit: "contain",
                                    height: "auto"
                                }),
                                center && (0, $hgUW1$css)({
                                    margin: "auto"
                                }),
                                !preventModal && (0, $hgUW1$css)({
                                    cursor: "pointer"
                                }),
                                !width && (0, $hgUW1$css)({
                                    width: "100%"
                                })
                            ],
                            ...props
                        }),
                        !!initialWidthOriginalImage && !!caption && /*#__PURE__*/ (0, $hgUW1$jsx)("figcaption", {
                            style: {
                                width: `${initialWidthOriginalImage}px`
                            },
                            css: $1298c86a7e6a9fc7$var$captionContainerStyles,
                            children: caption
                        })
                    ]
                })
            })
        ]
    });
};
const $1298c86a7e6a9fc7$var$modalStyles = (0, $hgUW1$css)({
    position: "fixed",
    zIndex: 100000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    "& button": {
        background: "transparent",
        borderRadius: "3px",
        verticalAlign: "middle",
        display: "inline-flex",
        padding: "0.125rem !important",
        height: "fit-content",
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.bolder.hovered"),
            borderRadius: "3px"
        }
    }
});
const $1298c86a7e6a9fc7$var$modalContentStyles = (0, $hgUW1$css)({
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    padding: 0,
    position: "relative",
    "& img": [
        {
            maxWidth: "320%",
            width: "-moz-available"
        },
        {
            width: "-webkit-fill-available"
        }
    ]
});
const $1298c86a7e6a9fc7$var$modalControlsStyles = (0, $hgUW1$css)({
    backgroundImage: "linear-gradient(rgb(14, 22, 36), rgba(14, 22, 36, 0))",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "6.125rem",
    zIndex: 1,
    fontWeight: 500,
    padding: "1.5rem",
    transition: "opacity 0.3s ease 0s",
    "& .right:focus": {
        outline: "none"
    },
    "& .right svg": {
        color: `${(0, $hgUW1$DN600)} !important`
    }
});
const $1298c86a7e6a9fc7$var$containerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between"
});
const $1298c86a7e6a9fc7$var$textContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    color: (0, $hgUW1$DN600)
});
const $1298c86a7e6a9fc7$var$iconContainerStyles = (0, $hgUW1$css)({
    marginRight: "0.75rem",
    display: "flex",
    alignItems: "center"
});
const $1298c86a7e6a9fc7$var$imageContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    color: "filter",
    fontSize: ".875rem",
    lineHeight: "1.25rem"
});
const $1298c86a7e6a9fc7$var$badgeContentStyles = (0, $hgUW1$css)({
    margin: 0
});
const $1298c86a7e6a9fc7$var$scrollContainerStyles = (0, $hgUW1$css)({
    height: "100%",
    display: "flex",
    flexDirection: "column"
});
const $1298c86a7e6a9fc7$var$modalToolsStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "6.125rem",
    padding: "0.625rem",
    backgroundImage: "linear-gradient(rgba(14, 22, 36, 0), rgb(14, 22, 36))",
    "& svg": {
        color: `${(0, $hgUW1$DN600)} !important`
    }
});
const $1298c86a7e6a9fc7$var$buttonContainerStyles = (0, $hgUW1$css)({
    width: "50%",
    display: "flex",
    justifyContent: "space-between"
});
const $1298c86a7e6a9fc7$var$figureStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    textAlign: "center"
});
const $1298c86a7e6a9fc7$var$captionContainerStyles = (0, $hgUW1$css)({
    margin: "16px auto",
    textAlign: "center",
    fontStyle: "italic",
    fontSize: ".875rem",
    lineHeight: "1.25rem",
    color: (0, $hgUW1$token)("color.text.subtlest")
});


var $4fce8dfc4ce8f546$exports = {};

$parcel$export($4fce8dfc4ce8f546$exports, "LinkStyle", () => $4fce8dfc4ce8f546$export$2b77966d73aefa77);
$parcel$export($4fce8dfc4ce8f546$exports, "LinkSize", () => $4fce8dfc4ce8f546$export$be4c932f76c19adf);
$parcel$export($4fce8dfc4ce8f546$exports, "Link", () => $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a);






let $4fce8dfc4ce8f546$export$2b77966d73aefa77;
(function(LinkStyle) {
    LinkStyle["REGULAR"] = "regular";
    LinkStyle["SEMIBOLD"] = "semibold";
})($4fce8dfc4ce8f546$export$2b77966d73aefa77 || ($4fce8dfc4ce8f546$export$2b77966d73aefa77 = {}));
let $4fce8dfc4ce8f546$export$be4c932f76c19adf;
(function(LinkSize) {
    LinkSize["LARGE"] = "large";
    LinkSize["MEDIUM"] = "medium";
})($4fce8dfc4ce8f546$export$be4c932f76c19adf || ($4fce8dfc4ce8f546$export$be4c932f76c19adf = {}));
const $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a = ({ label: label , fontColor: fontColor = (0, $hgUW1$token)("color.text.accent.blue") , target: target = "_self" , link: link , style: style = $4fce8dfc4ce8f546$export$2b77966d73aefa77.REGULAR , icon: icon , onClick: onClick , size: size = $4fce8dfc4ce8f546$export$be4c932f76c19adf.MEDIUM , ...props })=>{
    const clickHandler = (0, $hgUW1$useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    const onKeyDown = (e)=>(handler)=>{
            if (e.key === "Enter" || e.key === " ") handler(e);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("a", {
        target: target,
        href: link,
        rel: target === "_blank" ? "noopener noreferrer" : "",
        tabIndex: 0,
        css: [
            $4fce8dfc4ce8f546$var$sizeStyles[size],
            $4fce8dfc4ce8f546$var$variantStyles[style].base,
            $4fce8dfc4ce8f546$var$baseStyles,
            $4fce8dfc4ce8f546$var$variantStyles[style].hover,
            (0, $hgUW1$css)({
                color: fontColor
            })
        ],
        style: {
            wordBreak: "break-word",
            overflowWrap: "break-word"
        },
        onClick: clickHandler,
        onKeyDown: (e)=>onKeyDown(e)(clickHandler),
        ...props,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                children: label
            }),
            icon && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: $4fce8dfc4ce8f546$var$iconContainerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: icon,
                    size: "medium"
                })
            })
        ]
    });
};
const $4fce8dfc4ce8f546$var$baseStyles = (0, $hgUW1$css)({
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "2px",
    textDecoration: "none",
    [(0, $hgUW1$media).below.sm]: {
        fontSize: "16px !important",
        lineHeight: "20px !important"
    }
});
const $4fce8dfc4ce8f546$var$sizeStyles = {
    medium: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    large: {
        fontSize: "20px",
        lineHeight: "24px"
    }
};
const $4fce8dfc4ce8f546$var$variantStyles = {
    regular: {
        base: (0, $hgUW1$css)({
            fontWeight: "normal"
        }),
        hover: (0, $hgUW1$css)({
            "&:hover": {
                color: (0, $hgUW1$token)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $hgUW1$token)("color.link")
            }
        })
    },
    semibold: {
        base: (0, $hgUW1$css)({
            fontWeight: 600
        }),
        hover: (0, $hgUW1$css)({
            "&:hover": {
                color: (0, $hgUW1$token)("color.link"),
                textDecoration: "underline",
                cursor: "pointer",
                textUnderlineOffset: "4px",
                textDecorationThickness: "2px",
                textDecorationColor: (0, $hgUW1$token)("color.link")
            }
        })
    }
};
const $4fce8dfc4ce8f546$var$iconContainerStyles = {
    display: "inline",
    verticalAlign: "middle"
};


var $800df40a54823a3f$exports = {};

$parcel$export($800df40a54823a3f$exports, "List", () => $800df40a54823a3f$export$54c2e3dc7acea9f5);
$parcel$export($800df40a54823a3f$exports, "variantsListStyles", () => $800df40a54823a3f$export$6427468642e6e9fe);




const $800df40a54823a3f$export$54c2e3dc7acea9f5 = ({ type: type = "unordered" , textStyleType: textStyleType = "regular" , children: children  })=>{
    if (type === "ordered") return /*#__PURE__*/ (0, $hgUW1$jsx)("ol", {
        "aria-label": "ordered",
        css: [
            $800df40a54823a3f$var$listStyles,
            (0, $hgUW1$css)($800df40a54823a3f$export$6427468642e6e9fe.list[type]),
            $800df40a54823a3f$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
    return /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
        "aria-label": "unordered",
        css: [
            $800df40a54823a3f$var$listStyles,
            (0, $hgUW1$css)($800df40a54823a3f$export$6427468642e6e9fe.list[type]),
            $800df40a54823a3f$export$6427468642e6e9fe.textStyle[textStyleType]
        ],
        children: children
    });
};
const $800df40a54823a3f$var$fontSizeStyles = {
    fontSize: "1.25rem",
    lineHeight: "2rem",
    [(0, $hgUW1$media).below.md]: {
        fontSize: "1rem",
        lineHeight: "1.5rem"
    }
};
const $800df40a54823a3f$var$listStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    letterSpacing: "0.3%",
    color: (0, $hgUW1$token)("color.text"),
    ...$800df40a54823a3f$var$fontSizeStyles,
    span: $800df40a54823a3f$var$fontSizeStyles
});
const $800df40a54823a3f$export$6427468642e6e9fe = {
    list: {
        unordered: {
            listStyleType: "disc",
            paddingLeft: "1.25rem",
            ul: {
                listStyleType: "circle",
                paddingLeft: "1.25rem"
            },
            "ul ul": {
                listStyleType: "square",
                paddingLeft: "1.25rem"
            },
            "ul:not(:first-child), ul li, li + li": {
                marginTop: 0
            }
        },
        ordered: {
            listStyleType: "decimal",
            paddingLeft: "1.25rem",
            ol: {
                listStyleType: "lower-alpha",
                paddingLeft: "1.25rem"
            },
            "ol ol": {
                listStyleType: "lower-roman",
                paddingLeft: "1.25rem"
            },
            "ol:not(:first-child), ol li, li + li": {
                marginTop: 0
            }
        }
    },
    textStyle: {
        regular: (0, $hgUW1$css)({
            fontWeight: 400
        }),
        italic: (0, $hgUW1$css)({
            fontStyle: "italic"
        }),
        bold: (0, $hgUW1$css)({
            fontWeight: 700
        }),
        boldItalic: (0, $hgUW1$css)({
            fontWeight: 700,
            fontStyle: "italic"
        })
    }
};


var $25cbe9fdb2d8d071$exports = {};

$parcel$export($25cbe9fdb2d8d071$exports, "NavigationBar", () => $25cbe9fdb2d8d071$export$214ae410b202e65a);
$parcel$export($25cbe9fdb2d8d071$exports, "NavBarProfileItem", () => $397a78fff494027c$export$1cba3806e1f1b01d);
$parcel$export($25cbe9fdb2d8d071$exports, "NavBarLogoItem", () => $90d3cbebafca1fdb$export$6ce3be5638d8e2a);
$parcel$export($25cbe9fdb2d8d071$exports, "MenuItem", () => $3539883ac1727dfc$export$2ce376c2cc3355c8);
$parcel$export($25cbe9fdb2d8d071$exports, "NavBarExpandableItem", () => $3b7e032fd37ae5a5$export$1229978ae51a03a8);



var $965a3cfbe886b380$exports = {};

$parcel$export($965a3cfbe886b380$exports, "useOutsideClickHandler", () => $965a3cfbe886b380$export$aa79b0abe3dfeaba);

const $965a3cfbe886b380$export$aa79b0abe3dfeaba = (refs, onOutsideClick)=>{
    (0, $hgUW1$useEffect)(()=>{
        const handleOutsideClick = (event)=>{
            // if click has occurred outside of all refs, then call onOutsideClick
            if (refs.every((ref)=>ref.current && !ref.current.contains(event.target))) onOutsideClick();
        };
        // bind the event listener
        document.addEventListener("mousedown", handleOutsideClick);
        return ()=>{
            // unbind the event listener on clean up
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [
        refs,
        onOutsideClick
    ]);
};


const $f0285f05d4d9f8a0$export$426e07cd0772984d = {
    MOBILE: {
        MAX_WIDTH: 767,
        MEDIA_QUERY: "@media (max-width: 767px)"
    },
    TABLET: {
        MIN_WIDTH: 768,
        MAX_WIDTH: 1279,
        MEDIA_QUERY: "@media (min-width: 768px) and (max-width: 1279px)"
    },
    DESKTOP: {
        MIN_WIDTH: 1280,
        MEDIA_QUERY: "@media (min-width: 1280px)"
    }
};



const $6a34d18c8d59b475$var$CloseIcon = ()=>/*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M7 7L23.9706 23.9706",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M7 24L23.9706 7.02944",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $6a34d18c8d59b475$export$2e2bcd8739ae039 = $6a34d18c8d59b475$var$CloseIcon;



const $5ba5f450ff826a14$var$HamburgerMenuIcon = ()=>/*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M4 8H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M4 16H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M4 24H28",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round"
            })
        ]
    });
var $5ba5f450ff826a14$export$2e2bcd8739ae039 = $5ba5f450ff826a14$var$HamburgerMenuIcon;






var $6e8a4d5d78071ed7$exports = {};

$parcel$export($6e8a4d5d78071ed7$exports, "useMediaQuery", () => $6e8a4d5d78071ed7$export$32d5543ab307c01);

const $6e8a4d5d78071ed7$export$32d5543ab307c01 = (mediaQuery)=>{
    const [targetReached, setTargetReached] = (0, $hgUW1$useState)(false);
    const updateTarget = (0, $hgUW1$useCallback)((e)=>{
        if (e.matches) setTargetReached(true);
        else setTargetReached(false);
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        const media = window.matchMedia(mediaQuery);
        media.addEventListener("change", updateTarget);
        // Check on mount (callback is not called until a change occurs)
        if (media.matches) setTargetReached(true);
        return ()=>media.removeEventListener("change", updateTarget);
    }, []);
    return targetReached;
};










const $3b7e032fd37ae5a5$export$1229978ae51a03a8 = ({ headerContent: headerContent , expandedHeaderContent: expandedHeaderContent , bodyContent: bodyContent , onExpandClick: onExpandClick , isNested: isNested = false  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(false);
    const onExpandClickHandler = ()=>{
        setIsOpen(!isOpen);
        if (onExpandClick) onExpandClick(isOpen);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $3b7e032fd37ae5a5$var$containerStyles,
        role: "group",
        children: bodyContent ? /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: [
                        $3b7e032fd37ae5a5$var$headerStyles,
                        isOpen && $3b7e032fd37ae5a5$var$headerSelectedStyles,
                        isNested && $3b7e032fd37ae5a5$var$nestedHeaderStyles
                    ],
                    role: "treeitem",
                    onClick: onExpandClickHandler,
                    children: [
                        isOpen && expandedHeaderContent ? expandedHeaderContent : headerContent,
                        /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: isOpen && $3b7e032fd37ae5a5$var$chevronSelectedStyles,
                            children: isOpen ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonutilitychevronup), {
                                label: "Collapse item"
                            }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonutilitychevrondown), {
                                label: "Expand item"
                            })
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
                    css: [
                        $3b7e032fd37ae5a5$var$bodyContentContainerStyles,
                        isNested && $3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles
                    ],
                    children: bodyContent
                })
            ]
        }) : /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $3b7e032fd37ae5a5$var$headerStyles,
            role: "treeitem",
            children: headerContent
        })
    });
};
const $3b7e032fd37ae5a5$var$containerStyles = (0, $hgUW1$css)({
    display: "flex",
    fontSize: "1rem",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%"
});
const $3b7e032fd37ae5a5$var$headerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: "32px",
    width: "100%",
    padding: "0 24px"
});
// when selected, header text color should appear as selected color (apply to different elements, since headerContent can vary)
const $3b7e032fd37ae5a5$var$headerSelectedStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.selected"),
    a: {
        color: (0, $hgUW1$token)("color.text.selected")
    },
    span: {
        color: (0, $hgUW1$token)("color.text.selected")
    }
});
const $3b7e032fd37ae5a5$var$nestedHeaderStyles = (0, $hgUW1$css)({
    padding: "0 40px"
});
const $3b7e032fd37ae5a5$var$bodyContentContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "8px",
    paddingTop: "8px",
    paddingLeft: "0",
    margin: 0,
    listStyle: "none"
});
const $3b7e032fd37ae5a5$var$nestedBodyContentContainerStyles = (0, $hgUW1$css)({
    li: {
        paddingLeft: "56px"
    }
});
const $3b7e032fd37ae5a5$var$chevronSelectedStyles = (0, $hgUW1$css)({
    svg: {
        color: (0, $hgUW1$token)("color.text.selected")
    }
});





const $397a78fff494027c$var$getAvatarUserHeaderForMobile = (user, isExpanded)=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: [
            $397a78fff494027c$var$headerContentStyles,
            isExpanded && $397a78fff494027c$var$avatarUserSelectedStyles
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitavatar), {
                appearance: "circle",
                src: user.avatar,
                size: "small",
                name: user.publicName
            }, user.publicName),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $397a78fff494027c$var$nameStyles,
                children: user.publicName
            })
        ]
    });
const $397a78fff494027c$export$1cba3806e1f1b01d = ({ user: user , expandableMenuContent: expandableMenuContent , profileMenuContent: profileMenuContent , onProfileMenuClick: onProfileMenuClick  })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $hgUW1$useState)(false);
    const isBreakpoint = (0, $6e8a4d5d78071ed7$export$32d5543ab307c01)(`(max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`);
    const avatarMenuRef = (0, $hgUW1$useRef)(null);
    (0, $965a3cfbe886b380$export$aa79b0abe3dfeaba)([
        avatarMenuRef
    ], ()=>setIsMenuOpen(false));
    const onProfileMenuClickHandler = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onProfileMenuClick) onProfileMenuClick(isMenuOpen);
    };
    if (isBreakpoint) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3b7e032fd37ae5a5$export$1229978ae51a03a8), {
        headerContent: $397a78fff494027c$var$getAvatarUserHeaderForMobile(user, false),
        expandedHeaderContent: $397a78fff494027c$var$getAvatarUserHeaderForMobile(user, true),
        bodyContent: expandableMenuContent,
        onExpandClick: onProfileMenuClick
    });
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
        ref: avatarMenuRef,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                css: [
                    $397a78fff494027c$var$avatarStyles,
                    isMenuOpen && $397a78fff494027c$var$avatarUserSelectedStyles
                ],
                onClick: onProfileMenuClickHandler,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitavatar), {
                    appearance: "circle",
                    src: user.avatar,
                    size: "medium",
                    name: user.publicName
                }, user.publicName)
            }),
            isMenuOpen && profileMenuContent ? /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
                css: $397a78fff494027c$var$openMenuStyles,
                "aria-label": "Profile menu",
                role: "menu",
                children: profileMenuContent
            }) : null
        ]
    });
};
const $397a78fff494027c$var$headerContentStyles = (0, $hgUW1$css)({
    display: "flex",
    gap: "8px",
    fontSize: "1rem"
});
const $397a78fff494027c$var$nameStyles = (0, $hgUW1$css)({
    alignSelf: "center"
});
const $397a78fff494027c$var$avatarStyles = (0, $hgUW1$css)({
    all: "unset",
    cursor: "pointer",
    marginTop: "3px",
    "&:focus-visible": {
        outline: `1px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $397a78fff494027c$var$avatarUserSelectedStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.selected"),
    "& > * > span": {
        outline: `2px ${(0, $hgUW1$token)("color.text.selected")} solid`
    }
});
const $397a78fff494027c$var$openMenuStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    right: 0,
    zIndex: 10,
    borderRadius: "4px",
    boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)",
    listStyle: "none",
    margin: 0,
    padding: 0
});








const $90d3cbebafca1fdb$export$6ce3be5638d8e2a = ({ subtitleHref: subtitleHref , label: label , logoSubtitle: logoSubtitle  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
        css: $90d3cbebafca1fdb$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("a", {
                href: "https://www.atlassian.com",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                        css: $90d3cbebafca1fdb$var$smallAtlassianLogoStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AtlassianIcon), {
                            testId: "mobile"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                        css: $90d3cbebafca1fdb$var$bigAtlassianLogoStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AtlassianLogo), {
                            testId: "desktop"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: $90d3cbebafca1fdb$var$dividerStyles
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                href: subtitleHref,
                css: $90d3cbebafca1fdb$var$subtitleStyles,
                "data-testid": "logoSubtitle",
                "aria-label": label,
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
                    children: [
                        " ",
                        logoSubtitle,
                        " "
                    ]
                })
            })
        ]
    });
};
const $90d3cbebafca1fdb$var$containerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    background: "none",
    fontFamily: "Charlie Display"
});
const $90d3cbebafca1fdb$var$smallAtlassianLogoStyles = (0, $hgUW1$css)({
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        svg: {
            color: (0, $hgUW1$token)("color.icon.brand"),
            transform: "scale(0.74)"
        }
    },
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $90d3cbebafca1fdb$var$bigAtlassianLogoStyles = (0, $hgUW1$css)({
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        display: "flex",
        alignItems: "center",
        span: {
            width: "148px",
            height: "24px"
        },
        svg: {
            color: (0, $hgUW1$token)("color.icon.brand")
        }
    },
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        display: "none"
    }
});
const $90d3cbebafca1fdb$var$dividerStyles = (0, $hgUW1$css)({
    width: "1px",
    height: "32px",
    backgroundColor: "#DDDEE1",
    marginLeft: "24px",
    marginRight: "16px",
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        marginLeft: "8px",
        marginRight: "16px"
    }
});
const $90d3cbebafca1fdb$var$subtitleStyles = (0, $hgUW1$css)({
    fontSize: "22px",
    fontWeight: 600,
    color: (0, $hgUW1$token)("color.text"),
    textDecoration: "none",
    padding: "6px 8px",
    "&:hover": {
        color: (0, $hgUW1$token)("color.border.brand"),
        textDecoration: "none"
    }
});






const $3539883ac1727dfc$export$2ce376c2cc3355c8 = ({ link: link , type: type  })=>{
    const { href: href , onClick: onClick , text: text  } = link;
    return /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
        css: $3539883ac1727dfc$var$menuLinkStyles,
        href: href,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("li", {
            css: [
                $3539883ac1727dfc$var$menuItemContainerBaseStyles,
                $3539883ac1727dfc$var$menuItemContainerStyles[type]
            ],
            role: "treeitem",
            children: text
        })
    });
};
const $3539883ac1727dfc$var$menuItemContainerBaseStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    width: "100%"
});
const $3539883ac1727dfc$var$menuItemContainerStyles = {
    subMenu: (0, $hgUW1$css)({
        height: "32px",
        padding: "0 40px"
    }),
    profile: (0, $hgUW1$css)({
        height: "48px",
        padding: "0 24px"
    })
};
const $3539883ac1727dfc$var$menuLinkStyles = (0, $hgUW1$css)({
    fontSize: "1rem",
    fontWeight: 400,
    color: "#172B4D",
    cursor: "pointer",
    "&:hover": {
        color: "#0C66E4",
        textDecoration: "none"
    },
    "&:active": {
        color: "#0055CC",
        li: {
            background: (0, $hgUW1$token)("color.background.accent.blue.subtlest")
        }
    }
});



const $25cbe9fdb2d8d071$var$ToggleButton = ({ isOpen: isOpen , toggleMenu: toggleMenu  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$IconButton), {
        appearance: "subtle",
        onClick: toggleMenu,
        icon: isOpen ? (0, $6a34d18c8d59b475$export$2e2bcd8739ae039) : (0, $5ba5f450ff826a14$export$2e2bcd8739ae039),
        label: isOpen ? "Close menu" : "Open menu"
    });
const $25cbe9fdb2d8d071$export$214ae410b202e65a = ({ leftItems: leftItems , rightItems: rightItems , logoItem: logoItem , isSticky: isSticky = true , onMenuToggleClick: onMenuToggleClick , onMenuOutsideClick: onMenuOutsideClick  })=>{
    // open state of mobile/tablet menu
    const [isMenuOpen, setIsMenuOpen] = (0, $hgUW1$useState)(false);
    // ref for the toggle button - necessary for the useOutsideClickHandler
    // useOutsideClickHandler will close menu IF the user clicks outside of the menu or toggle button (necessary to include toggle button prevent double-click)
    // separately, toggle button (close button) should also close the menu
    const toggleRef = (0, $hgUW1$useRef)(null);
    const handleToggle = ()=>{
        setIsMenuOpen(!isMenuOpen);
        if (onMenuToggleClick) onMenuToggleClick(isMenuOpen);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsx)("nav", {
        css: [
            $25cbe9fdb2d8d071$var$containerStyles,
            !isSticky && $25cbe9fdb2d8d071$var$stickyStyles
        ],
        "data-testid": "navbar",
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $25cbe9fdb2d8d071$var$innerContainerStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $25cbe9fdb2d8d071$var$logoWrapperStyles,
                    children: logoItem
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $25cbe9fdb2d8d071$var$navContentWrapperStyles,
                    children: [
                        leftItems || rightItems ? /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $25cbe9fdb2d8d071$var$navMenuToggleButtonStyles,
                            ref: toggleRef,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)($25cbe9fdb2d8d071$var$ToggleButton, {
                                isOpen: isMenuOpen,
                                toggleMenu: handleToggle
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $hgUW1$jsx)($25cbe9fdb2d8d071$var$DesktopNavItems, {
                            leftItems: leftItems,
                            rightItems: rightItems
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)($25cbe9fdb2d8d071$var$SmallNavItems, {
                            isMenuOpen: isMenuOpen,
                            setIsMenuOpen: setIsMenuOpen,
                            onMenuOutsideClick: onMenuOutsideClick,
                            leftItems: leftItems,
                            rightItems: rightItems,
                            toggleRef: toggleRef
                        })
                    ]
                })
            ]
        })
    });
};
const $25cbe9fdb2d8d071$var$MenuItems = ({ leftItems: leftItems , rightItems: rightItems  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
        children: [
            leftItems?.map((item, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                    css: [
                        $25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $25cbe9fdb2d8d071$var$leftItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `left-${index}`)),
            rightItems?.map((item, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                    css: [
                        $25cbe9fdb2d8d071$var$navItemWrapperStyles,
                        $25cbe9fdb2d8d071$var$rightItemStyles
                    ],
                    role: "menuitem",
                    children: item
                }, `right-${index}`))
        ]
    });
const $25cbe9fdb2d8d071$var$DesktopNavItems = ({ leftItems: leftItems , rightItems: rightItems  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
        css: $25cbe9fdb2d8d071$var$desktopNavWrapperStyles,
        role: "menubar",
        "aria-orientation": "horizontal",
        children: /*#__PURE__*/ (0, $hgUW1$jsx)($25cbe9fdb2d8d071$var$MenuItems, {
            leftItems: leftItems,
            rightItems: rightItems
        })
    });
const $25cbe9fdb2d8d071$var$SmallNavItems = ({ isMenuOpen: isMenuOpen , setIsMenuOpen: setIsMenuOpen , onMenuOutsideClick: onMenuOutsideClick , leftItems: leftItems , rightItems: rightItems , toggleRef: toggleRef  })=>{
    const menuRef = (0, $hgUW1$useRef)(null);
    // if user clicks outside of the mobile/tablet menu or toggle button, then close the menu
    (0, $965a3cfbe886b380$export$aa79b0abe3dfeaba)([
        menuRef,
        toggleRef
    ], ()=>{
        if (isMenuOpen) {
            setIsMenuOpen(false);
            if (onMenuOutsideClick) onMenuOutsideClick();
        }
    });
    return isMenuOpen ? /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $25cbe9fdb2d8d071$var$smallNavWrapperStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
            css: $25cbe9fdb2d8d071$var$smallNavUlStyles,
            ref: menuRef,
            role: "menubar",
            "aria-orientation": "vertical",
            children: /*#__PURE__*/ (0, $hgUW1$jsx)($25cbe9fdb2d8d071$var$MenuItems, {
                leftItems: leftItems,
                rightItems: rightItems
            })
        })
    }) : null;
};
const $25cbe9fdb2d8d071$var$navItemWrapperStyles = (0, $hgUW1$css)({
    height: "100%",
    alignSelf: "center",
    margin: "0 auto",
    padding: 0,
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        "& > button": {
            width: "100%",
            justifyContent: "center"
        }
    }
});
const $25cbe9fdb2d8d071$var$containerStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    position: "sticky",
    width: "100%",
    height: "68px",
    left: 0,
    top: 0,
    padding: "0 16px",
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        height: "56px",
        justifyContent: "space-between"
    }
});
const $25cbe9fdb2d8d071$var$stickyStyles = (0, $hgUW1$css)({
    position: "fixed"
});
const $25cbe9fdb2d8d071$var$innerContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "1232px",
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        width: "1232px"
    }
});
const $25cbe9fdb2d8d071$var$navContentWrapperStyles = (0, $hgUW1$css)({
    flex: 1,
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        display: "flex",
        flexDirection: "column"
    }
});
const $25cbe9fdb2d8d071$var$navMenuToggleButtonStyles = (0, $hgUW1$css)({
    flex: 0,
    alignSelf: "flex-end",
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    },
    button: {
        "&:hover, &:active": {
            backgroundColor: "transparent",
            color: (0, $hgUW1$token)("color.icon.brand")
        }
    }
});
const $25cbe9fdb2d8d071$var$desktopNavWrapperStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    listStyle: "none",
    display: "none",
    flexDirection: "column",
    width: "100%",
    padding: "16px 12px",
    margin: 0,
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        display: "block",
        position: "relative",
        gap: "8px",
        padding: 0,
        boxShadow: "none",
        height: "42px"
    }
});
// mobile/tablet open menu
const $25cbe9fdb2d8d071$var$smallNavWrapperStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    position: "absolute",
    right: 0,
    margin: 0,
    width: "100%",
    zIndex: 1000,
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).MOBILE.MAX_WIDTH}px)`]: {
        // full screen menu in mobile view
        height: "100%",
        position: "fixed",
        right: 0,
        top: 0,
        marginTop: "56px"
    },
    [`@media ((min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MIN_WIDTH}px) and (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px))`]: {
        // appearance of floating fixed-width menu in tablet view
        width: "375px",
        top: "100%",
        marginTop: "-9px",
        marginRight: "20px",
        borderRadius: "8px",
        boxShadow: "0 0 1px 0 #ccc,0 5px 20px -5px rgba(0,0,0,.1)"
    },
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        display: "none"
    }
});
const $25cbe9fdb2d8d071$var$smallNavUlStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    listStyle: "none",
    padding: "16px 0"
});
const $25cbe9fdb2d8d071$var$logoWrapperStyles = (0, $hgUW1$css)({
    margin: 0,
    padding: 0,
    paddingRight: "32px",
    flexShrink: 0,
    flexGrow: 0
});
const $25cbe9fdb2d8d071$var$leftItemStyles = (0, $hgUW1$css)({
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        alignSelf: "flex-start",
        width: "100%"
    },
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        float: "left",
        marginRight: "8px"
    }
});
const $25cbe9fdb2d8d071$var$rightItemStyles = (0, $hgUW1$css)({
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        width: "100%"
    },
    [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
        float: "right"
    }
});


var $3fbcb32390ca7008$exports = {};

$parcel$export($3fbcb32390ca7008$exports, "RadioType", () => $3fbcb32390ca7008$export$f5eff9f4cffe1e46);
$parcel$export($3fbcb32390ca7008$exports, "RadioSize", () => $3fbcb32390ca7008$export$4da24539a3bb7d98);
$parcel$export($3fbcb32390ca7008$exports, "Radio", () => $3fbcb32390ca7008$export$d7b12c4107be0d61);






let $3fbcb32390ca7008$export$f5eff9f4cffe1e46;
(function(RadioType) {
    RadioType["DEFAULT"] = "DEFAULT";
    RadioType[/** TODO: remove success styles in scope of the QUIZ component update */ "SUCCESS"] = "SUCCESS";
    RadioType["DANGER"] = "DANGER";
    RadioType["DISABLED"] = "DISABLED";
})($3fbcb32390ca7008$export$f5eff9f4cffe1e46 || ($3fbcb32390ca7008$export$f5eff9f4cffe1e46 = {}));
let $3fbcb32390ca7008$export$4da24539a3bb7d98;
(function(RadioSize) {
    RadioSize["DEFAULT"] = "DEFAULT";
    RadioSize["LARGE"] = "LARGE";
})($3fbcb32390ca7008$export$4da24539a3bb7d98 || ($3fbcb32390ca7008$export$4da24539a3bb7d98 = {}));
const $3fbcb32390ca7008$export$d7b12c4107be0d61 = ({ label: label , name: name , isChecked: isChecked , setIsChecked: setIsChecked , type: type = $3fbcb32390ca7008$export$f5eff9f4cffe1e46.DEFAULT , size: size = $3fbcb32390ca7008$export$4da24539a3bb7d98.DEFAULT , isRequired: isRequired = false , isBold: isBold , tabIndex: tabIndex = 0  })=>{
    const handleChange = (0, $hgUW1$useCallback)(()=>{
        setIsChecked(!isChecked);
    }, [
        isChecked,
        setIsChecked
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(handleChange), [
        isChecked
    ]);
    const labelAndInputConnection = name ? `${name}-${label?.toLowerCase().replace(/\s+/g, "-")}` + "-radio-input" : label?.toLowerCase().replace(/\s+/g, "-") + "-radio-input";
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: [
            $3fbcb32390ca7008$var$radioContainerStyles,
            size === $3fbcb32390ca7008$export$4da24539a3bb7d98.LARGE && (0, $hgUW1$css)({
                columnGap: "8px"
            })
        ],
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("label", {
            htmlFor: labelAndInputConnection,
            css: [
                $3fbcb32390ca7008$var$labelStyles,
                size === $3fbcb32390ca7008$export$4da24539a3bb7d98.LARGE && $3fbcb32390ca7008$var$labelLargeStyles,
                type === $3fbcb32390ca7008$export$f5eff9f4cffe1e46.DISABLED && $3fbcb32390ca7008$var$variantClasses.label.DISABLED,
                isBold && (0, $hgUW1$css)({
                    fontWeight: 700
                }),
                !isBold && (0, $hgUW1$css)({
                    fontWeight: 400
                })
            ],
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("input", {
                    "data-testid": "radio-input",
                    name: name,
                    tabIndex: -1,
                    id: labelAndInputConnection,
                    type: "radio",
                    role: "radio",
                    css: $3fbcb32390ca7008$var$inputStyles,
                    checked: isChecked,
                    onChange: (e)=>setIsChecked(e.currentTarget.checked),
                    "aria-checked": isChecked
                }),
                label,
                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    role: "radio",
                    "aria-checked": isChecked,
                    "aria-label": label,
                    tabIndex: tabIndex,
                    onKeyDown: handleKeyDown,
                    css: [
                        $3fbcb32390ca7008$var$variantClasses.checkbox[type],
                        $3fbcb32390ca7008$var$checkmarkStyles,
                        size === $3fbcb32390ca7008$export$4da24539a3bb7d98.LARGE && $3fbcb32390ca7008$var$checkmarkLargeStyles,
                        isChecked && $3fbcb32390ca7008$var$checkedCheckmarkStyles,
                        isChecked && type === $3fbcb32390ca7008$export$f5eff9f4cffe1e46.DANGER && (0, $hgUW1$css)({
                            backgroundColor: (0, $hgUW1$token)("color.border.danger")
                        })
                    ]
                }),
                isRequired && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    css: [
                        $3fbcb32390ca7008$var$requiredMarkStyles,
                        size === $3fbcb32390ca7008$export$4da24539a3bb7d98.LARGE && (0, $hgUW1$css)({
                            marginLeft: "4px"
                        })
                    ],
                    children: "*"
                })
            ]
        })
    });
};
const $3fbcb32390ca7008$var$radioContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    columnGap: "6px"
});
const $3fbcb32390ca7008$var$requiredMarkStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtle"),
    marginLeft: "2px"
});
const $3fbcb32390ca7008$var$inputStyles = (0, $hgUW1$css)({
    position: "absolute",
    height: 0,
    width: 0,
    opacity: 0,
    cursor: "pointer"
});
const $3fbcb32390ca7008$var$checkmarkStyles = (0, $hgUW1$css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "16px",
    height: "16px",
    marginTop: "2px",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "50%",
    border: `1px solid ${(0, $hgUW1$token)("color.border.input")}`,
    cursor: "pointer",
    "&:after": {
        content: '""',
        position: "absolute",
        display: "none"
    },
    [(0, $hgUW1$media1).below.xs]: {
        marginTop: "4px"
    }
});
const $3fbcb32390ca7008$var$checkmarkLargeStyles = (0, $hgUW1$css)({
    width: "20px",
    height: "20px",
    marginRight: "8px",
    marginTop: "6px",
    "&:after": {
        left: "5px !important",
        top: "5px !important",
        width: "8px !important",
        height: "8px !important"
    }
});
const $3fbcb32390ca7008$var$checkedCheckmarkStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.selected.bold"),
    borderColor: (0, $hgUW1$token)("color.border.selected"),
    "&:after": {
        display: "block",
        left: "4px",
        top: "4px",
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        backgroundColor: (0, $hgUW1$token)("color.background.input")
    }
});
const $3fbcb32390ca7008$var$labelStyles = (0, $hgUW1$css)({
    display: "flex",
    position: "relative",
    paddingLeft: "22px",
    userSelect: "none",
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px"
});
const $3fbcb32390ca7008$var$labelLargeStyles = (0, $hgUW1$css)({
    paddingLeft: "28px",
    fontSize: "20px",
    lineHeight: "32px"
});
const $3fbcb32390ca7008$var$variantClasses = {
    label: {
        DISABLED: (0, $hgUW1$css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    },
    checkbox: {
        DEFAULT: (0, $hgUW1$css)({
            ":hover": {
                borderColor: (0, $hgUW1$token)("color.border.selected")
            }
        }),
        SUCCESS: (0, $hgUW1$css)({
            ":hover": {
                borderColor: (0, $hgUW1$token)("color.border.selected")
            }
        }),
        DANGER: (0, $hgUW1$css)({
            "&, &:hover": {
                borderColor: (0, $hgUW1$token)("color.border.danger")
            }
        }),
        DISABLED: (0, $hgUW1$css)({
            pointerEvents: "none",
            opacity: "31%"
        })
    }
};


var $731a4fd527bab680$exports = {};

$parcel$export($731a4fd527bab680$exports, "TabsSize", () => $731a4fd527bab680$export$ddadc1228c8dcfa);
$parcel$export($731a4fd527bab680$exports, "Tab", () => $731a4fd527bab680$export$3e41faf802a29e71);





let $731a4fd527bab680$export$ddadc1228c8dcfa;
(function(TabsSize) {
    TabsSize["MEDIUM"] = "medium";
    TabsSize["LARGE"] = "large";
})($731a4fd527bab680$export$ddadc1228c8dcfa || ($731a4fd527bab680$export$ddadc1228c8dcfa = {}));
const $731a4fd527bab680$export$3e41faf802a29e71 = ({ label: label , onClick: onClick , iconBefore: iconBefore , iconAfter: iconAfter , size: size = $731a4fd527bab680$export$ddadc1228c8dcfa.MEDIUM , selected: selected = false , isLoading: isLoading  })=>{
    const clickHandler = (0, $hgUW1$useCallback)((e)=>{
        if (onClick) onClick(e);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
        tabIndex: 0,
        onClick: clickHandler,
        "data-testid": `tab${selected ? "-selected" : ""}`,
        css: [
            $731a4fd527bab680$var$tabStyles["basic"],
            selected && $731a4fd527bab680$var$tabStyles["selected"],
            !iconBefore && !iconAfter && $731a4fd527bab680$var$tabSpacingStyles[size],
            iconBefore && $731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-before`],
            iconAfter && $731a4fd527bab680$var$tabSpacingStyles[`${size}-icon-after`]
        ],
        children: [
            iconBefore && !isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginRight: "0.25rem"
                    })
                ],
                children: iconBefore
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    isLoading && (0, $hgUW1$css)({
                        marginRight: "0.5rem"
                    })
                ],
                children: label
            }),
            iconAfter && !isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $731a4fd527bab680$var$tabIconContainerStyles,
                    (0, $hgUW1$css)({
                        marginLeft: "0.25rem"
                    })
                ],
                children: iconAfter
            })
        ]
    });
};
const $731a4fd527bab680$var$tabStyles = {
    basic: (0, $hgUW1$css)({
        display: "flex",
        alignItems: "center",
        borderRadius: "3.125rem",
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "1.25rem",
        fontWeight: 600,
        lineHeight: "1.75rem",
        color: (0, $hgUW1$token)("color.text"),
        border: `0.125rem solid ${(0, $hgUW1$token)("color.border")}`,
        cursor: "pointer",
        outline: "none",
        background: "transparent",
        [(0, $hgUW1$media1).below.xs]: {
            fontSize: "1rem",
            lineHeight: "1.5rem",
            padding: "0.5rem 1rem"
        },
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest"),
            borderColor: (0, $hgUW1$token)("color.border"),
            color: (0, $hgUW1$token)("color.text")
        },
        "&:focus-visible": {
            border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
        }
    }),
    selected: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.bold.pressed"),
        color: (0, $hgUW1$token)("color.text.inverse"),
        border: "0.125rem solid",
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.brand.boldest"),
            color: (0, $hgUW1$token)("color.text.inverse"),
            border: "0.125rem solid"
        }
    })
};
const $731a4fd527bab680$var$tabSpacingStyles = {
    medium: (0, $hgUW1$css)({
        padding: "0.375rem 1.5rem"
    }),
    "medium-icon-before": (0, $hgUW1$css)({
        padding: "0.375rem 1.5rem 0.375rem 1rem"
    }),
    "medium-icon-after": (0, $hgUW1$css)({
        padding: "0.375rem 1rem 0.375rem 1.5rem"
    }),
    large: (0, $hgUW1$css)({
        padding: "0.625rem 1.5rem"
    }),
    "large-icon-before": (0, $hgUW1$css)({
        padding: "0.625rem 1.5rem 0.625rem 1rem"
    }),
    "large-icon-after": (0, $hgUW1$css)({
        padding: "0.625rem 1rem 0.625rem 1.5rem"
    })
};
const $731a4fd527bab680$var$tabIconContainerStyles = (0, $hgUW1$css)({
    width: "2rem",
    height: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});


var $5cf70e33bfc6ce73$exports = {};

$parcel$export($5cf70e33bfc6ce73$exports, "Tag", () => $5cf70e33bfc6ce73$export$3288d34c523a1192);
$parcel$export($5cf70e33bfc6ce73$exports, "tagListStyles", () => $5cf70e33bfc6ce73$export$f40d73b6f7f951e9);




const $5cf70e33bfc6ce73$export$3288d34c523a1192 = ({ inspectMode: inspectMode , label: label , onClick: onClick , selected: selected , iconAfter: iconAfter , iconBefore: iconBefore  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("tag", inspectMode),
        tabIndex: -1,
        css: [
            $5cf70e33bfc6ce73$var$tagStyles,
            selected && $5cf70e33bfc6ce73$var$selectedTagStyles,
            onClick && $5cf70e33bfc6ce73$var$hoverableTagStyles,
            iconBefore && $5cf70e33bfc6ce73$var$beforeIconTagStyles,
            iconAfter && $5cf70e33bfc6ce73$var$afterIconTagStyles
        ],
        onClick: onClick,
        children: [
            iconBefore && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $5cf70e33bfc6ce73$var$iconStyles,
                    $5cf70e33bfc6ce73$var$beforeIconStyles
                ],
                children: iconBefore
            }),
            label,
            iconAfter && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: [
                    $5cf70e33bfc6ce73$var$iconStyles,
                    $5cf70e33bfc6ce73$var$afterIconStyles
                ],
                children: iconAfter
            })
        ]
    });
const $5cf70e33bfc6ce73$export$f40d73b6f7f951e9 = (0, $hgUW1$css)({
    display: "flex",
    flexWrap: "wrap",
    gap: (0, $hgUW1$token)("space.100")
});
const $5cf70e33bfc6ce73$var$tagStyles = (0, $hgUW1$css)({
    display: "flex",
    height: "24px",
    padding: `4px ${(0, $hgUW1$token)("space.100")}`,
    border: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    borderRadius: "4px",
    alignItems: "center",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $hgUW1$token)("color.text"),
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    boxSizing: "border-box",
    whiteSpace: "nowrap"
});
const $5cf70e33bfc6ce73$var$hoverableTagStyles = (0, $hgUW1$css)({
    "&:hover": {
        borderColor: (0, $hgUW1$token)("color.border.accent.gray"),
        cursor: "pointer"
    }
});
const $5cf70e33bfc6ce73$var$selectedTagStyles = (0, $hgUW1$css)({
    borderColor: (0, $hgUW1$token)("color.border.selected")
});
const $5cf70e33bfc6ce73$var$iconStyles = (0, $hgUW1$css)({
    span: {
        width: "14px",
        height: "14px",
        marginBottom: "2px"
    }
});
const $5cf70e33bfc6ce73$var$beforeIconStyles = (0, $hgUW1$css)({
    marginRight: "0.125rem"
});
const $5cf70e33bfc6ce73$var$afterIconStyles = (0, $hgUW1$css)({
    marginLeft: "0.125rem"
});
const $5cf70e33bfc6ce73$var$beforeIconTagStyles = (0, $hgUW1$css)({
    paddingLeft: "0.375rem"
});
const $5cf70e33bfc6ce73$var$afterIconTagStyles = (0, $hgUW1$css)({
    paddingRight: "0.375rem"
});


var $8b54d37779d052e8$exports = {};

$parcel$export($8b54d37779d052e8$exports, "Text", () => $8b54d37779d052e8$export$5f1af8db9871e1d6);






const $8b54d37779d052e8$export$5f1af8db9871e1d6 = ({ fontWeight: fontWeight = "regular" , size: size = "regular" , color: color = (0, $hgUW1$token)("color.text.accent.gray.bolder") , children: children , backgroundColor: backgroundColor  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("span", {
        css: [
            $8b54d37779d052e8$var$textDefaultStyles,
            backgroundColor && (0, $hgUW1$css)({
                backgroundColor: backgroundColor,
                padding: "4px"
            }),
            color && (0, $hgUW1$css)({
                color: color
            }),
            $8b54d37779d052e8$var$variantsStyles.fontWeight[fontWeight],
            $8b54d37779d052e8$var$variantsStyles.size[size]
        ],
        children: children
    });
const $8b54d37779d052e8$var$textDefaultStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    blockquote: (0, $660bd1c6cb41002a$export$7a77f8e9665fa6b2),
    ul: (0, $800df40a54823a3f$export$6427468642e6e9fe).list.unordered,
    ol: (0, $800df40a54823a3f$export$6427468642e6e9fe).list.ordered
});
const $8b54d37779d052e8$var$variantsStyles = {
    size: {
        small: (0, $hgUW1$css)({
            fontSize: "14px",
            lineHeight: "20px",
            [(0, $hgUW1$media).above.sm]: {
                fontSize: "14px",
                lineHeight: "20px"
            }
        }),
        regular: (0, $hgUW1$css)({
            fontSize: "14px",
            lineHeight: "22px",
            [(0, $hgUW1$media).above.sm]: {
                fontSize: "16px",
                lineHeight: "24px"
            }
        }),
        large: (0, $hgUW1$css)({
            fontSize: "16px",
            lineHeight: "24px",
            [(0, $hgUW1$media).above.sm]: {
                fontSize: "20px",
                lineHeight: "32px"
            }
        })
    },
    fontWeight: {
        regular: (0, $hgUW1$css)({
            fontWeight: 400
        }),
        semibold: (0, $hgUW1$css)({
            fontWeight: 600
        }),
        bold: (0, $hgUW1$css)({
            fontWeight: 700
        })
    }
};


var $9cfa05d02afa3952$exports = {};

$parcel$export($9cfa05d02afa3952$exports, "AccordionSize", () => $9cfa05d02afa3952$export$8f89d78db9c8c41f);
$parcel$export($9cfa05d02afa3952$exports, "Accordion", () => $9cfa05d02afa3952$export$a766cd26d0d69044);








const $51f57eef4d47f918$var$NAVBAR_HEIGHT = 124;
const $51f57eef4d47f918$export$10e5e64ea66c812f = ({ title: title , index: index , children: children , isFirstTab: isFirstTab , isExpanded: isExpanded , shouldSingleTabBeOpen: shouldSingleTabBeOpen , setTabState: setTabState , setExpansionMap: setExpansionMap  })=>{
    const tabRef = (0, $hgUW1$useRef)(null);
    const handleExpand = (0, $hgUW1$useCallback)(()=>{
        if (!setExpansionMap) return;
        setExpansionMap((prevState)=>prevState.map((tab, i)=>{
                if (setTabState && index !== undefined && i === index) setTabState({
                    [index + 1]: !tab.isExpanded ? "expand" : "collapse"
                });
                return {
                    ...tab,
                    isExpanded: i === index ? !tab.isExpanded : shouldSingleTabBeOpen ? false : tab.isExpanded
                };
            }));
    }, [
        setExpansionMap,
        title
    ]);
    const disableClickEventBubbling = (event)=>event.stopPropagation();
    const handleKeyDown = (0, $hgUW1$useCallback)((event)=>{
        if (event.code === "Space") {
            // to handle cases when there are clickable items within accordion
            if (event.target !== event.currentTarget) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                handleExpand();
            }
        }
    }, [
        handleExpand
    ]);
    (0, $hgUW1$useEffect)(()=>{
        if (isExpanded && tabRef.current) {
            const topPosition = tabRef.current.getBoundingClientRect().top + window.scrollY - $51f57eef4d47f918$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        tabIndex: 0,
        ref: tabRef,
        onKeyDown: handleKeyDown,
        css: [
            $51f57eef4d47f918$var$accordionTabStyles,
            isFirstTab && $51f57eef4d47f918$var$firstTabStyles,
            isExpanded && $51f57eef4d47f918$var$expandedTabStyles
        ],
        onClick: handleExpand,
        "data-testid": `accordion-tab-${title}`,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    isExpanded && $51f57eef4d47f918$var$expandedTabContentStyles
                ],
                children: isExpanded ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "chevron-down",
                    alt: "Chevron down"
                }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "chevron-right",
                    alt: "Chevron right"
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $51f57eef4d47f918$var$contentContainer,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $51f57eef4d47f918$var$titleStyles,
                        children: title
                    }),
                    isExpanded && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        onClick: disableClickEventBubbling,
                        css: $51f57eef4d47f918$var$contentStyles,
                        "data-testid": "accordion-tab-content",
                        children: children
                    })
                ]
            })
        ]
    });
};
const $51f57eef4d47f918$var$accordionTabStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "100%",
    alignContent: "center",
    alignItems: "flex-start",
    padding: "24px",
    cursor: "pointer",
    borderBottom: `1px solid ${(0, $hgUW1$token)("color.border")}`
});
const $51f57eef4d47f918$var$firstTabStyles = (0, $hgUW1$css)({
    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`
});
const $51f57eef4d47f918$var$expandedTabStyles = (0, $hgUW1$css)({
    borderLeft: `${(0, $hgUW1$token)("space.100")} solid ${(0, $hgUW1$token)("color.border.accent.blue")}`
});
const $51f57eef4d47f918$var$expandedTabContentStyles = (0, $hgUW1$css)({
    marginLeft: "-0.5rem"
});
const $51f57eef4d47f918$var$contentContainer = (0, $hgUW1$css)({
    marginLeft: "0.75rem"
});
const $51f57eef4d47f918$var$titleStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    color: (0, $hgUW1$token)("color.text")
});
const $51f57eef4d47f918$var$contentStyles = (0, $hgUW1$css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "30px",
    color: (0, $hgUW1$token)("color.text"),
    ol: {
        margin: 0
    },
    ul: {
        margin: 0
    },
    a: {
        fontSize: "20px !important",
        lineHeight: "28px !important"
    }
});



let $9cfa05d02afa3952$export$8f89d78db9c8c41f;
(function(AccordionSize) {
    AccordionSize["DEFAULT"] = "default";
    AccordionSize["WIDE"] = "wide";
})($9cfa05d02afa3952$export$8f89d78db9c8c41f || ($9cfa05d02afa3952$export$8f89d78db9c8c41f = {}));
const $9cfa05d02afa3952$export$a766cd26d0d69044 = ({ tabsContent: tabsContent , size: size , shouldSingleTabBeOpen: shouldSingleTabBeOpen , onChange: onChange  })=>{
    const [expansionMap, setExpansionMap] = (0, $hgUW1$useState)([]);
    const [tabState, setTabState] = (0, $hgUW1$useState)();
    (0, $hgUW1$useEffect)(()=>{
        const initialExpansionMap = tabsContent.map((tabContent)=>({
                ...tabContent,
                isExpanded: false
            }));
        setExpansionMap(initialExpansionMap);
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        if (!tabState) return;
        onChange(tabState);
    }, [
        expansionMap,
        setExpansionMap
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: [
            $9cfa05d02afa3952$var$baseAccordionStyles,
            $9cfa05d02afa3952$export$8f89d78db9c8c41f.DEFAULT === size && $9cfa05d02afa3952$var$accordionDefaultStyles,
            $9cfa05d02afa3952$export$8f89d78db9c8c41f.WIDE === size && $9cfa05d02afa3952$var$accordionWideStyles
        ],
        "data-testid": "lesson-accordion",
        children: expansionMap.map(({ title: title , children: children , isExpanded: isExpanded  }, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $51f57eef4d47f918$export$10e5e64ea66c812f), {
                title: title,
                isFirstTab: index === 0,
                index: index,
                isExpanded: isExpanded,
                shouldSingleTabBeOpen: shouldSingleTabBeOpen,
                setTabState: setTabState,
                setExpansionMap: setExpansionMap,
                children: children
            }, title))
    });
};
const $9cfa05d02afa3952$var$baseAccordionStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    flexDirection: "column"
});
const $9cfa05d02afa3952$var$accordionDefaultStyles = (0, $hgUW1$css)({
    maxWidth: "720px"
});
const $9cfa05d02afa3952$var$accordionWideStyles = (0, $hgUW1$css)({
    maxWidth: "1020px",
    [(0, $hgUW1$media).below.md]: {
        maxWidth: "720px"
    }
});


var $7d458ed59bb9c6a8$exports = {};

$parcel$export($7d458ed59bb9c6a8$exports, "InlineCode", () => $7d458ed59bb9c6a8$export$7f1bf47c7f50a6aa);






const $7d458ed59bb9c6a8$export$7f1bf47c7f50a6aa = ({ code: code = ""  })=>{
    const lines = code ? code.split(/\r\n|\r|\n/) : null;
    const [isCopied, setIsCopied] = (0, $hgUW1$useState)(false);
    const copy = (code)=>{
        navigator.clipboard.writeText(code);
        setIsCopied(true);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("code", {
        "data-testid": "code-block",
        css: $7d458ed59bb9c6a8$var$inlineCodeStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
                css: [
                    $7d458ed59bb9c6a8$var$inlineCodeButtonStyles,
                    isCopied ? (0, $hgUW1$css)({
                        backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.pressed"),
                        border: "2px solid"
                    }) : (0, $hgUW1$css)({
                        backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest"),
                        border: `2px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
                        "&:hover": {
                            backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest.hovered"),
                            border: "2px solid transparent"
                        }
                    })
                ],
                "aria-label": "Copy",
                "aria-haspopup": "true",
                type: "button",
                tabIndex: 0,
                onClick: ()=>copy(code),
                onMouseOut: ()=>setIsCopied(false),
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                        className: "tooltipText",
                        css: $7d458ed59bb9c6a8$var$tooltipTextStyles,
                        children: isCopied ? "Copied!" : "Copy"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: "copy",
                        color: isCopied ? (0, $hgUW1$N0) : (0, $hgUW1$N800)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                children: lines?.map((line, index)=>/*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
                        css: $7d458ed59bb9c6a8$var$codeLinesStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: $7d458ed59bb9c6a8$var$lineNumberStyles,
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: $7d458ed59bb9c6a8$var$lineTextStyles,
                                children: line
                            })
                        ]
                    }, index))
            })
        ]
    });
};
const $7d458ed59bb9c6a8$var$inlineCodeStyles = (0, $hgUW1$css)({
    position: "relative",
    display: "flex",
    maxWidth: "100%",
    margin: "20px 0",
    flexDirection: "column",
    borderRadius: "3px",
    overflowWrap: "normal",
    backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest")
});
const $7d458ed59bb9c6a8$var$inlineCodeButtonStyles = (0, $hgUW1$css)({
    position: "absolute",
    right: "8px",
    top: "6px",
    display: "flex",
    padding: "2px",
    borderRadius: "4px",
    transition: "opacity 0.2s ease 0s",
    opacity: 0,
    zIndex: 1,
    cursor: "pointer",
    "&:hover .tooltipText": {
        opacity: 1
    },
    "&:hover": {
        opacity: 1
    }
});
const $7d458ed59bb9c6a8$var$tooltipTextStyles = (0, $hgUW1$css)({
    position: "absolute",
    top: "-30px",
    padding: "2px 6px",
    marginLeft: "-5px",
    borderRadius: "6px",
    backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.pressed"),
    color: (0, $hgUW1$token)("color.text.inverse"),
    textAlign: "center",
    fontSize: "11px",
    opacity: 0,
    zIndex: 1,
    transition: "opacity 0.4s ease 0s",
    "&:hover": {
        opacity: 1
    }
});
const $7d458ed59bb9c6a8$var$codeLinesStyles = (0, $hgUW1$css)({
    display: "flex",
    lineHeight: "20px",
    whiteSpace: "pre",
    fontSize: "12px"
});
const $7d458ed59bb9c6a8$var$lineNumberStyles = (0, $hgUW1$css)({
    padding: "4px 8px",
    marginRight: "8px",
    backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtler")
});
const $7d458ed59bb9c6a8$var$lineTextStyles = (0, $hgUW1$css)({
    padding: "4px 8px 4px 0"
});


var $a467abe0c2c1750b$exports = {};

$parcel$export($a467abe0c2c1750b$exports, "Lozenge", () => $a467abe0c2c1750b$export$a31cbe1bf5463979);



const $a467abe0c2c1750b$export$a31cbe1bf5463979 = ({ appearance: appearance = "default" , text: text , isBold: isBold  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitlozenge), {
        isBold: isBold,
        appearance: appearance,
        testId: "lozenge",
        children: text?.toUpperCase()
    });


var $52124b9ae1d78e04$exports = {};

$parcel$export($52124b9ae1d78e04$exports, "SectionMessageAppearance", () => $52124b9ae1d78e04$export$710836885d72543c);
$parcel$export($52124b9ae1d78e04$exports, "SectionMessage", () => $52124b9ae1d78e04$export$a36903bd214cec06);






let $52124b9ae1d78e04$export$710836885d72543c;
(function(SectionMessageAppearance) {
    SectionMessageAppearance["INFORMATION"] = "information";
    SectionMessageAppearance["INFORMATION_WHITE"] = "information_white";
})($52124b9ae1d78e04$export$710836885d72543c || ($52124b9ae1d78e04$export$710836885d72543c = {}));
const $52124b9ae1d78e04$export$a36903bd214cec06 = ({ children: children , appearance: appearance , fullWidth: fullWidth = false  })=>{
    const isInfoWhite = appearance === $52124b9ae1d78e04$export$710836885d72543c.INFORMATION_WHITE;
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: [
            $52124b9ae1d78e04$var$sectionMessageContainerStyles,
            isInfoWhite && $52124b9ae1d78e04$var$informationWhiteStyles,
            !isInfoWhite && $52124b9ae1d78e04$var$informationStyles,
            !fullWidth && (0, $hgUW1$css)({
                maxWidth: "720px"
            })
        ],
        "data-testid": `section-message${isInfoWhite ? "-white" : ""}`,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $52124b9ae1d78e04$var$iconContainerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "info",
                    alt: "info icon",
                    color: (0, $hgUW1$token)("color.icon.accent.blue")
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $52124b9ae1d78e04$var$descriptionStyles,
                children: children
            })
        ]
    });
};
const $52124b9ae1d78e04$var$sectionMessageContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "100%",
    borderRadius: "3px",
    padding: (0, $hgUW1$token)("space.300")
});
const $52124b9ae1d78e04$var$informationStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.information")
});
const $52124b9ae1d78e04$var$informationWhiteStyles = (0, $hgUW1$css)({
    border: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    backgroundColor: (0, $hgUW1$token)("elevation.surface")
});
const $52124b9ae1d78e04$var$iconContainerStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.050"),
    marginRight: (0, $hgUW1$token)("space.300"),
    [(0, $hgUW1$media).below.md]: {
        marginRight: (0, $hgUW1$token)("space.200")
    }
});
const $52124b9ae1d78e04$var$descriptionStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "32px",
    marginTop: 0,
    marginBottom: 0,
    p: {
        marginTop: 0,
        marginBottom: 0
    },
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    [(0, $hgUW1$media).below.md]: {
        fontSize: "16px",
        lineHeight: "24px"
    }
});


var $6e2eae4c8556b5b9$exports = {};

$parcel$export($6e2eae4c8556b5b9$exports, "DropdownMenuCheckbox", () => $6e2eae4c8556b5b9$export$2393c31da95977ae);





const $6e2eae4c8556b5b9$export$2393c31da95977ae = ({ items: items , placement: placement , onItemClick: onItemClick  })=>{
    const [isDropdownOpen, setIsDropdownOpen] = (0, $hgUW1$useState)(false);
    const [itemsList, setItemList] = (0, $hgUW1$useState)(items);
    const handleItemClick = (label)=>{
        setItemList((prev)=>{
            const updatedState = {
                ...prev
            };
            Object.keys(updatedState).forEach((key)=>{
                updatedState[key].isSelected = key === label;
            });
            return updatedState;
        });
        onItemClick(label);
    };
    const getFirstSelectedItem = (itemsChecked)=>{
        const selectedItem = Object.keys(itemsChecked).find((key)=>itemsChecked[key].isSelected);
        return selectedItem || Object.keys(itemsChecked)[0];
    };
    const isAnyItemSelected = Object.values(items).some(({ isSelected: isSelected  })=>isSelected);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: [
            $6e2eae4c8556b5b9$var$triggerRewriteStyles,
            isAnyItemSelected && isDropdownOpen && $6e2eae4c8556b5b9$var$triggerSelectedRewriteStyles
        ],
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitdropdownmenu), {
            onOpenChange: ({ isOpen: isOpen  })=>setIsDropdownOpen(isOpen),
            trigger: getFirstSelectedItem(itemsList),
            shouldRenderToParent: true,
            placement: placement,
            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$DropdownItemRadioGroup), {
                id: "actions",
                children: Object.entries(itemsList).map(([label, value])=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$DropdownItemRadio), {
                        testId: `dropdown-item-checkbox-${label}`,
                        isDisabled: value.isDisabled,
                        id: label,
                        onClick: ()=>handleItemClick(label),
                        isSelected: itemsList[label].isSelected,
                        children: label
                    }, label))
            })
        })
    });
};
const $6e2eae4c8556b5b9$var$triggerRewriteStyles = (0, $hgUW1$css)({
    "& > button": {
        border: `1px solid ${(0, $hgUW1$token)("color.border.brand")}`,
        padding: `${(0, $hgUW1$token)("space.100")} ${(0, $hgUW1$token)("space.100")} ${(0, $hgUW1$token)("space.100")} ${(0, $hgUW1$token)("space.150")}`,
        background: "#fff",
        alignItems: "center",
        height: "40px",
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 600,
        fontFamily: "Charlie Text, sans-serif",
        color: (0, $hgUW1$token)("color.text.brand"),
        borderRadius: "4px",
        ":hover": {
            background: (0, $hgUW1$token)("color.background.selected"),
            color: (0, $hgUW1$token)("color.text.selected")
        }
    },
    "#actions": {
        "button[disabled]": {
            background: (0, $hgUW1$token)("color.background.disabled"),
            span: {
                color: (0, $hgUW1$token)("color.text.disabled"),
                ":hover": {
                    color: (0, $hgUW1$token)("color.text.disabled")
                }
            },
            rect: {
                stroke: (0, $hgUW1$token)("color.border.disabled")
            }
        },
        ":before, :after": {
            display: "none"
        },
        button: {
            padding: `${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.200")} 24px`,
            width: "220px",
            height: "48px",
            '[aria-checked="true"]:before': {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "2px",
                height: "100%",
                background: `${(0, $hgUW1$token)("color.text.selected")}`
            },
            span: {
                gap: 0,
                span: {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "16px",
                    lineHeight: "20px"
                }
            }
        }
    },
    svg: {
        width: "30px",
        height: "30px"
    }
});
const $6e2eae4c8556b5b9$var$triggerSelectedRewriteStyles = (0, $hgUW1$css)({
    "& > button": {
        border: 0,
        background: (0, $hgUW1$token)("color.background.selected")
    }
});


var $4366d2b05f9f8f6b$exports = {};

$parcel$export($4366d2b05f9f8f6b$exports, "GreetingCard", () => $4366d2b05f9f8f6b$export$e52b3c28ffecde23);






const $7a335ab395aac0f5$export$6b53fc34987132a8 = ()=>/*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        viewBox: "0 0 406 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                clipPath: "url(#clip0_511_7308)",
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M396.155 27.8221H394.244L388.065 11.4229H391.206L396.667 26.4205L402.129 11.4229H405.269L398.818 28.3828C396.906 33.3937 395.814 35.9867 391.479 35.9867C390.011 35.9867 389.192 35.8465 388.338 35.4961V32.9031C389.328 33.2185 390.455 33.3236 391.308 33.3236C393.697 33.3236 394.756 31.6416 396.155 27.8221Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M382.705 23.5062C382.705 25.048 383.593 26.0992 385.402 26.0992C386.085 26.0992 386.733 25.9591 387.245 25.854V28.7624C386.733 28.9025 386.153 29.0427 385.265 29.0427C381.613 29.0427 379.838 26.8351 379.838 23.5763V14.2203H377.073V11.417H379.838V7.70264H382.705V11.417H387.245V14.2203H382.705V23.5062Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M370.731 6.79681C370.731 5.46524 371.585 4.69434 372.779 4.69434C373.974 4.69434 374.827 5.46524 374.827 6.79681C374.827 8.12837 373.974 8.89928 372.779 8.89928C371.585 8.89928 370.731 8.12837 370.731 6.79681ZM371.278 28.9428V11.4222H374.213V28.9428H371.278Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M367.184 18.6738V28.9408H364.248V18.3584C364.248 15.2047 363.019 13.803 360.22 13.803C357.49 13.803 355.612 15.6602 355.612 19.1994V28.9408H352.677V11.4202H355.612V14.2936C356.705 12.2262 358.718 11.0698 361.005 11.0698C364.931 11.0698 367.184 13.8381 367.184 18.6738Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M333.733 21.6899V11.4229H336.669V22.0053C336.669 25.159 337.898 26.5606 340.697 26.5606C343.427 26.5606 345.305 24.7035 345.305 21.1643V11.4229H348.24V28.9434H345.305V26.0701C344.212 28.1375 342.199 29.2938 339.912 29.2938C335.986 29.2938 333.733 26.5256 333.733 21.6899Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M318.416 19.1994V28.9408H315.48V18.3584C315.48 15.2047 314.252 13.803 311.453 13.803C308.722 13.803 306.845 15.6602 306.845 19.1994V28.9408H303.909V11.4202H306.845V14.2936C307.937 12.2262 309.951 11.0698 312.238 11.0698C315.139 11.0698 317.119 12.5766 317.972 15.3448C318.928 12.6467 321.215 11.0698 324.048 11.0698C327.871 11.0698 329.987 13.733 329.987 18.6738V28.9408H327.052V19.1994C327.052 15.5901 325.823 13.803 323.024 13.803C320.293 13.803 318.416 15.6602 318.416 19.1994Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M288.249 19.1994V28.9408H285.314V18.3584C285.314 15.2047 284.085 13.803 281.286 13.803C278.555 13.803 276.678 15.6602 276.678 19.1994V28.9408H273.742V11.4202H276.678V14.2936C277.77 12.2262 279.784 11.0698 282.071 11.0698C284.972 11.0698 286.952 12.5766 287.805 15.3448C288.761 12.6467 291.048 11.0698 293.881 11.0698C297.704 11.0698 299.82 13.733 299.82 18.6738V28.9408H296.885V19.1994C296.885 15.5901 295.656 13.803 292.857 13.803C290.126 13.803 288.249 15.6602 288.249 19.1994Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M262.275 29.2912C257.155 29.2912 254.151 25.4017 254.151 20.1455C254.151 14.8893 257.155 11.0698 262.275 11.0698C267.361 11.0698 270.331 14.8893 270.331 20.1455C270.331 25.4017 267.361 29.2912 262.275 29.2912ZM262.275 13.8731C258.623 13.8731 257.019 16.8166 257.019 20.1455C257.019 23.4744 258.623 26.4879 262.275 26.4879C265.893 26.4879 267.464 23.4744 267.464 20.1455C267.464 16.8166 265.893 13.8731 262.275 13.8731Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M251.998 24.88V27.9285C250.598 28.8746 248.38 29.2951 246.059 29.2951C238.686 29.2951 234.521 24.7398 234.521 17.4863C234.521 10.478 238.686 5.57227 245.99 5.57227C248.175 5.57227 250.36 5.99276 251.964 7.18416V10.2327C250.36 9.18151 248.585 8.62085 245.99 8.62085C240.734 8.62085 237.594 12.195 237.594 17.4863C237.594 22.7775 240.836 26.2816 246.161 26.2816C248.516 26.2816 250.36 25.7209 251.998 24.88Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M119.605 12.4499C119.605 15.8465 121.102 18.5153 127.168 19.7284C130.713 20.5371 131.501 21.1032 131.501 22.3163C131.501 23.5294 130.713 24.2572 128.192 24.2572C125.277 24.2572 121.811 23.2059 119.526 21.8311V27.3304C121.338 28.22 123.702 29.2713 128.192 29.2713C134.494 29.2713 136.936 26.3599 136.936 22.1546M136.936 22.2354C136.936 18.1918 134.888 16.3318 128.98 15.0378C125.75 14.3099 124.962 13.5821 124.962 12.5308C124.962 11.2368 126.144 10.6707 128.271 10.6707C130.87 10.6707 133.391 11.4794 135.833 12.6116V7.35493C134.1 6.46534 131.501 5.81836 128.428 5.81836C122.599 5.81836 119.605 8.40627 119.605 12.6116",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M200.274 5.979V29.0276H205.08V11.4783L207.049 16.088L213.824 29.0276H219.811V5.979H215.085V20.8595L213.273 16.4924L207.837 5.979H200.274Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M169.865 5.979H164.666V29.0276H169.865V5.979Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M158.679 22.1554C158.679 18.1117 156.631 16.2517 150.723 14.9577C147.493 14.2299 146.705 13.502 146.705 12.4507C146.705 11.1567 147.887 10.5906 150.014 10.5906C152.614 10.5906 155.134 11.3993 157.577 12.5316V7.27485C155.843 6.38526 153.244 5.73828 150.171 5.73828C144.342 5.73828 141.348 8.32619 141.348 12.5316C141.348 15.9282 142.845 18.597 148.911 19.8101C152.456 20.6188 153.244 21.1849 153.244 22.398C153.244 23.6111 152.456 24.3389 149.935 24.3389C147.02 24.3389 143.554 23.2876 141.27 21.9127V27.412C143.081 28.3016 145.445 29.353 149.935 29.353C156.159 29.353 158.679 26.4416 158.679 22.1554Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M79.1143 5.979V29.0276H89.828L91.4824 24.0135H84.3136V5.979H79.1143Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M57.9219 5.979V10.9122H63.6727V29.0276H68.9508V10.9122H75.1742V5.979H57.9219Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M50.2806 5.97412H43.4269L35.6279 29.0227H41.615L42.7179 25.1408C44.0572 25.5452 45.4752 25.7878 46.8932 25.7878C48.3112 25.7878 49.7292 25.5452 51.0684 25.1408L52.1713 29.0227H58.1584C58.0796 29.0227 50.2806 5.97412 50.2806 5.97412ZM46.8144 20.9355C45.7903 20.9355 44.8449 20.7737 43.9784 20.5311L46.8144 10.503L49.6504 20.5311C48.7838 20.7737 47.8385 20.9355 46.8144 20.9355Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M108.339 5.97363H101.485L93.6074 29.0222H99.5945L100.697 25.1404C102.037 25.5447 103.455 25.7873 104.873 25.7873C106.291 25.7873 107.709 25.5447 109.048 25.1404L110.151 29.0222H116.138L108.339 5.97363ZM104.873 20.935C103.849 20.935 102.903 20.7733 102.037 20.5306L104.873 10.5025L107.709 20.5306C106.842 20.7733 105.897 20.935 104.873 20.935Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        d: "M188.694 5.97363H181.84L174.041 29.0222H180.028L181.131 25.1404C182.47 25.5447 183.888 25.7873 185.306 25.7873C186.724 25.7873 188.142 25.5447 189.481 25.1404L190.584 29.0222H196.571L188.694 5.97363ZM185.306 20.935C184.282 20.935 183.337 20.7733 182.47 20.5306L185.306 10.5025L188.142 20.5306C187.276 20.7733 186.252 20.935 185.306 20.935Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                        clipPath: "url(#clip1_511_7308)",
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                            d: "M25.4715 28.1859L13.6868 3.70842C13.4549 3.1784 13.2229 3.08203 12.9445 3.08203C12.7125 3.08203 12.4342 3.1784 12.1558 3.66024C10.4855 6.40673 9.74318 9.58688 9.74318 12.9116C9.74318 17.5372 12.0166 21.8738 15.3571 28.8605C15.7283 29.6314 16.0067 29.776 16.6562 29.776H24.8219C25.4251 29.776 25.7498 29.5351 25.7498 29.0532C25.7498 28.8123 25.7034 28.6678 25.4715 28.1859ZM8.3513 16.6217C7.42338 15.1762 7.145 15.0799 6.91302 15.0799C6.68104 15.0799 6.54185 15.1762 6.12429 16.0435L0.231981 28.2823C0.0463961 28.6678 0 28.8123 0 29.005C0 29.3905 0.324773 29.776 1.02071 29.776H9.32562C9.88237 29.776 10.2999 29.2941 10.5319 28.3786C10.8103 27.2222 10.9031 26.2104 10.9031 25.0058C10.9031 21.6329 9.4648 18.3564 8.3513 16.6217Z",
                            fill: "#1868DB"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("clipPath", {
                        id: "clip0_511_7308",
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                            width: "406",
                            height: "37",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("clipPath", {
                        id: "clip1_511_7308",
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                            width: "25.7498",
                            height: "26.694",
                            fill: "white",
                            transform: "translate(0 3.08154)"
                        })
                    })
                ]
            })
        ]
    });






const $0467da094044eefe$export$590b8cc7d4f1d823 = ()=>/*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        viewBox: "0 0 112 113",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                id: "icon-launched-new",
                clipPath: "url(#clip0_608_7795)",
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                    id: "Clip path group",
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("mask", {
                            id: "mask0_608_7795",
                            "mask-type": "luminance",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "112",
                            height: "113",
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                                id: "clip0_10_2524",
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                    id: "Vector",
                                    d: "M112 0.5H0V112.5H112V0.5Z",
                                    fill: "white"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
                            mask: "url(#mask0_608_7795)",
                            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                                id: "Group",
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        id: "Vector_2",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.4245 80.4295C67.168 95.2604 53.3169 105.459 38.486 103.203C23.6551 100.946 13.456 87.0952 15.7126 72.2643C17.9691 57.4334 31.8202 47.2344 46.6512 49.4909C61.4821 51.7475 71.6811 65.5986 69.4245 80.4295ZM39.5994 70.0078C39.926 67.8848 38.4711 65.9103 36.3482 65.5837C34.2253 65.2571 32.2508 66.712 31.9242 68.8349C31.5976 70.9579 33.0524 72.9324 35.1754 73.259C37.2983 73.5856 39.2728 72.1307 39.5994 70.0078ZM54.9499 72.3385C55.2765 70.2156 53.8217 68.2411 51.6987 67.9145C49.5758 67.5879 47.6013 69.0428 47.2747 71.1657C46.9481 73.2887 48.403 75.2632 50.5259 75.5898C52.6488 75.9164 54.6233 74.4615 54.9499 72.3385ZM33.8541 82.7454L32.132 80.3998L27.4407 83.844L29.1628 86.1896C34.6112 93.5828 45.0181 95.1713 52.4262 89.7229L54.7718 88.0008L51.3276 83.3096L48.9819 85.0317C44.1719 88.565 37.4022 87.5406 33.869 82.7306L33.8541 82.7454Z",
                                        fill: "#1868DB"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        id: "Vector_3",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M67.8214 26.5393C53.0795 29.3006 43.3555 43.4932 46.1169 58.2499C48.8782 72.9917 63.0707 82.7157 77.8125 79.9544C92.5544 77.1931 102.293 63.0005 99.5319 48.2587C96.7706 33.5168 82.5632 23.7929 67.8214 26.5393ZM78.6588 42.2758C80.7669 41.875 82.7859 43.2705 83.1867 45.3786C83.5875 47.4867 82.1921 49.5057 80.084 49.9066C77.9759 50.3074 75.9568 48.9119 75.556 46.8038C75.1552 44.6957 76.5507 42.6767 78.6588 42.2758ZM63.3973 45.1262C65.5054 44.7254 67.5244 46.1209 67.9253 48.229C68.3261 50.3371 66.9306 52.3561 64.8225 52.7569C62.7144 53.1578 60.6954 51.7623 60.2946 49.6542C59.8937 47.5461 61.2892 45.5271 63.3973 45.1262ZM76.3428 72.0713C68.9496 73.4519 61.8534 68.5974 60.4727 61.2339L87.1802 56.2308C88.5609 63.6092 83.6915 70.6906 76.328 72.0713H76.3428Z",
                                        fill: "#82B536"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        id: "Vector_4",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        id: "Vector_5",
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M69.3206 71.522C64.8966 69.9781 61.4079 66.1776 60.4874 61.2339L64.6145 60.4619C60.5023 54.7463 54.178 50.6341 46.666 49.4909C46.4285 49.4612 46.1761 49.4167 45.9386 49.4019C45.508 52.2671 45.5526 55.2511 46.1167 58.2499C46.7996 61.8575 48.1506 65.1532 50.036 68.0481C50.5556 67.8848 51.1346 67.8403 51.7136 67.9294C53.8217 68.256 55.2914 70.2305 54.9648 72.3534C54.9054 72.7394 54.7866 73.1105 54.6382 73.4371C58.7208 77.1189 63.8871 79.5387 69.4691 80.2217C69.8996 77.2525 69.8254 74.3279 69.3206 71.522Z",
                                        fill: "#09326C"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        id: "Vector_6",
                                        d: "M37.1105 18.5589C35.4939 18.8626 33.943 19.3745 32.443 19.9453C32.443 19.9453 31.9357 20.0403 31.129 20.2877C30.3129 20.4878 29.2409 20.8857 28.0837 21.3496C25.7784 22.3248 23.3235 23.9635 22.2601 25.3038C18.8575 27.6207 15.8953 30.6524 13.728 34.2501C13.728 34.2501 13.6005 34.5506 13.3796 35.0267C13.172 35.4954 12.8711 36.1395 12.6779 36.8806C12.4487 37.5894 12.2232 38.3664 12.138 39.0812C12.0319 39.7904 11.9544 40.3955 12.0307 40.8082C12.1735 41.8321 12.4667 42.4724 12.8105 42.6457C13.1619 42.8321 13.577 42.5438 13.99 41.6956C14.1653 41.2628 14.3883 40.6978 14.6648 39.9797C14.8788 39.2444 15.2371 38.3922 15.6052 37.3413C15.6582 37.3111 15.7874 37.1677 15.863 37.1775C16.5848 34.9263 18.0622 33.0179 19.7393 31.3996C21.4298 29.7737 23.3598 28.4153 25.3445 27.0607C25.1727 26.9127 25.2076 26.665 25.3929 26.6826L25.5019 26.9363C26.7066 25.8143 27.936 25.2919 29.1048 24.7864C30.2944 24.2867 31.425 23.8377 32.7028 22.9372C32.7028 22.9372 32.4877 23.3925 32.4745 23.4001C34.8719 22.6182 37.6167 22.0775 40.4373 22.1955C43.2427 22.2869 46.1201 22.9688 48.4691 24.5119C50.8752 25.97 52.5652 28.3606 53.6246 30.9689C53.8516 31.6469 54.0785 32.3249 54.2715 33.0045C54.3962 33.6879 54.6001 34.449 54.6797 35.0528C54.8203 36.1657 54.6543 37.2947 54.118 38.2656L54.1709 38.2354L54.2011 38.2884C54.5424 38.0246 55.2229 36.9369 55.3721 35.7473C55.4646 35.1686 55.434 34.5896 55.3732 34.0806C55.3273 33.5979 55.2903 33.2857 55.2903 33.2857C55.5313 33.7102 55.7664 34.1555 55.9486 34.6309C56.0816 35.0815 56.188 35.5472 56.1791 36.0258C56.182 36.9888 55.8574 37.9623 55.2989 38.7703C54.191 40.4338 52.3157 41.2704 50.6424 41.536L50.6095 41.1688C52.0421 41.0046 52.9986 39.9706 53.223 39.5627C52.2579 40.3033 50.7995 40.8856 49.2811 40.5898C48.5361 40.4515 47.7197 40.1255 47.3784 39.7405C47.0447 39.3686 46.8665 38.8385 46.8708 38.0117C46.8985 36.3298 47.86 34.2232 48.8355 32.512C49.8283 30.7383 50.9433 29.211 51.8152 27.9971C51.4767 27.9261 50.7999 29.7309 49.8072 29.5578C50.7472 28.3402 51.6439 27.0771 52.6818 26.0321C53.0988 26.4268 52.386 26.9015 52.3552 27.0943C52.8898 26.7383 55.478 24.1295 59.4933 21.2541C63.5031 18.3996 69.0286 15.4039 74.4857 13.8324C79.9467 12.2062 85.1646 12.1912 88.1909 12.4555C91.1868 12.7897 92.2788 12.6434 89.3823 11.3409L89.7669 11.1225C86.5833 10.3337 83.8919 10.0724 80.3945 9.8125C79.908 9.91315 79.8439 9.86194 79.8865 10.1534C79.7671 10.2212 79.5682 10.334 79.6283 10.4402C79.7549 11.1575 78.6865 10.9748 78.2284 11.0944C78.351 9.91998 75.6295 10.2545 72.8735 11.3625C71.487 11.8865 70.1322 12.6203 69.0219 13.1979C67.9359 13.8492 67.1077 14.3369 66.7535 14.4854C66.0124 13.6432 64.1295 15.7642 63.1568 15.8426C63.1872 15.7728 63.4117 15.3647 63.4497 15.3081C62.9108 15.193 60.0007 17.2655 57.7814 19.2266C55.5546 21.1746 53.9377 22.899 54.9247 21.1462C53.2247 22.1988 51.4934 23.5672 49.7915 25.2347C48.1027 26.8946 46.436 28.8403 45.0442 31.2087C44.369 32.3987 43.6976 33.6567 43.277 35.1406C42.8754 36.5962 42.5394 38.2601 43.0769 40.165C43.2648 40.6195 43.4204 41.11 43.6821 41.5403C43.9836 41.9478 44.2736 42.397 44.6529 42.7255C45.038 43.0331 45.4249 43.3748 45.846 43.5916C46.2598 43.7953 46.6793 43.9782 47.1119 44.1534C48.7601 44.7088 50.6331 44.7333 52.3051 44.1876C55.7004 43.155 58.0935 39.9553 58.4079 36.5849C58.4804 35.7544 58.4471 34.8615 58.3055 34.1175C58.1656 33.4076 58.0184 32.6845 57.8785 31.9745C57.6573 31.2759 57.4569 30.5828 57.2433 29.8973C56.9823 29.2211 56.6814 28.5676 56.4072 27.8989C55.1699 25.2864 53.2694 23.0503 51.087 21.43C48.9049 19.8099 46.507 18.7681 44.2577 18.0804L44.3555 18.2528C44.2347 18.1635 43.7768 18.1603 43.679 17.9879C42.7253 18.0381 41.0604 18.071 39.6751 18.2259C38.2821 18.3675 37.1464 18.5912 37.1464 18.5912L37.1105 18.5589ZM50.547 43.0983C50.547 43.0983 50.5297 43.1608 50.5507 43.1665C50.5355 43.14 49.968 43.1289 49.3872 43.1252C48.7971 43.0743 48.2184 42.9818 48.1883 42.9288L48.2858 42.5753C48.8516 42.5523 49.5324 42.6394 50.2474 42.7248C50.6105 42.7466 50.968 42.7894 51.2971 42.813C51.6319 42.8158 51.9534 42.8262 52.2278 42.8459C52.7538 42.8456 53.1037 42.875 52.9613 43.026C52.8247 43.1561 52.1654 43.4778 50.8016 43.3924C50.6366 43.5035 50.594 43.212 50.547 43.0983ZM48.7248 28.3305C48.9904 28.0569 49.2619 27.7627 49.5787 27.4249C48.4351 29.7051 46.7257 32.0082 45.4672 34.7042C44.9032 36.0592 44.4354 37.5524 44.6239 39.0589C44.6303 39.4411 44.7788 39.7953 44.9272 40.1495C45.0283 40.5131 45.2962 40.7995 45.5166 41.0953C46.0031 41.6434 46.6452 42.0331 47.3106 42.2168C47.0285 42.3067 46.6746 42.3321 46.3172 42.2895C45.9844 42.1978 45.6066 42.0263 45.2194 41.8076C44.8968 41.5172 44.5439 41.1739 44.2898 40.7569C44.1094 40.3155 43.8119 39.853 43.8 39.3686C43.4767 37.3774 44.2801 35.6412 44.7204 34.5319C45.2518 32.0379 47.2732 29.8209 48.738 28.3229L48.7248 28.3305ZM75.3293 11.3017L75.292 11.1124L75.4605 11.0693C75.4605 11.0693 75.4734 11.1848 75.4336 11.2074C75.4222 11.249 75.3634 11.2999 75.3218 11.2885L75.3293 11.3017ZM39.9067 19.252C40.2934 18.9447 41.7287 19.2176 40.7452 19.7406C40.5072 19.6301 39.8026 19.8723 39.9067 19.252ZM52.7887 24.428C52.3491 23.9935 53.6243 22.6559 54.1751 23.2553C53.7406 23.6949 53.2325 24.0358 52.7887 24.428ZM26.807 23.1792C26.6704 23.9581 26.4775 23.2785 26.1416 22.9955C26.2853 23.0016 26.7001 22.8364 26.7504 23.1412L26.807 23.1792ZM20.0624 28.3223C20.1883 28.6368 19.9807 29.1055 19.8459 29.2696C19.2644 29.5119 19.686 28.3081 20.0624 28.3223ZM12.8127 39.961C13.1396 40.0737 13.1576 40.4142 12.8019 40.4056C12.5581 40.3159 12.4933 39.8617 12.8923 39.9158C12.8923 39.9158 12.845 39.9252 12.826 39.9535L12.8127 39.961ZM59.9658 20.1089C60.1746 21.2182 58.4067 21.5025 57.8937 22.2673C57.4082 21.3502 59.1026 20.9673 59.526 20.4464C59.7175 20.3202 59.8616 20.2033 59.9658 20.1089ZM51.5342 25.7714C51.2097 26.0959 50.8889 25.8395 50.5815 25.4527C50.2554 25.0941 49.8839 24.656 49.6192 24.5607L49.8434 24.2757C50.2098 24.4886 50.5195 24.6636 50.8161 24.8461C51.0936 25.0569 51.3198 25.3318 51.5191 25.7448L51.5342 25.7714ZM48.7068 31.8834C48.8548 32.3607 48.2335 32.6255 48.0926 32.9336C47.6072 32.6655 48.3318 31.3773 48.7068 31.8834ZM49.8278 41.2441C49.8866 41.8421 49.2689 41.5263 49.0854 41.5428C49.237 41.4392 49.4801 41.1258 49.6106 41.1394C49.6996 41.1415 49.7239 41.2154 49.8278 41.2441ZM52.2354 25.9873C52.6331 26.5333 53.1404 27.0872 53.4601 27.7125L53.1417 27.8932C52.8087 27.2754 52.3316 26.7745 51.9396 26.2077L52.2221 25.9948L52.2354 25.9873ZM54.8127 32.2588L54.4625 32.3525C53.8595 31.5372 54.7063 31.1442 54.7977 32.2324L54.8127 32.2588ZM44.6137 21.8595C44.7044 21.8958 44.8517 21.97 44.9482 21.9854C46.2715 22.3392 44.0824 23.0555 44.6137 21.8595ZM37.2998 21.7663C37.1672 21.8416 36.9889 21.9602 36.8452 21.9541C35.8442 22.0136 36.8308 21.0328 37.2998 21.7663Z",
                                        fill: "#09326C"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("defs", {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("clipPath", {
                    id: "clip0_608_7795",
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                        width: "112",
                        height: "112",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });


const $4366d2b05f9f8f6b$export$e52b3c28ffecde23 = ({ onClickLogIn: onClickLogIn , onClickContinue: onClickContinue  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $4366d2b05f9f8f6b$var$overlayStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $4366d2b05f9f8f6b$var$containerStyles,
            children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Stack), {
                alignInline: "center",
                alignBlock: "center",
                grow: "fill",
                xcss: $4366d2b05f9f8f6b$var$containerStackStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $4366d2b05f9f8f6b$var$logoStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0467da094044eefe$export$590b8cc7d4f1d823), {})
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Stack), {
                        alignInline: "center",
                        alignBlock: "center",
                        space: "space.200",
                        xcss: $4366d2b05f9f8f6b$var$middleStackStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $4366d2b05f9f8f6b$var$communityLogoStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $7a335ab395aac0f5$export$6b53fc34987132a8), {})
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                                level: 3,
                                children: "We've launched something new"
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                                children: "We’ve logged you out. Log back in to see what’s changed"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Inline), {
                        space: "space.200",
                        shouldWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).SECONDARY,
                                    label: "Continue without logging in",
                                    fullWidth: true,
                                    onClick: onClickContinue
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $4366d2b05f9f8f6b$var$buttonContainerStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                    label: "Log back in",
                                    fullWidth: true,
                                    onClick: onClickLogIn
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $4366d2b05f9f8f6b$var$overlayStyles = (0, $hgUW1$css)({
    position: "fixed",
    zIndex: (0, $hgUW1$layers).blanket(),
    inset: 0,
    backgroundColor: "white",
    overflowY: "auto",
    pointerEvents: "initial",
    fontFamily: "Charlie Display, sans-serif"
});
const $4366d2b05f9f8f6b$var$containerStackStyles = (0, $hgUW1$xcss)({
    height: "100%"
});
const $4366d2b05f9f8f6b$var$middleStackStyles = (0, $hgUW1$xcss)({
    marginBottom: "space.500"
});
const $4366d2b05f9f8f6b$var$containerStyles = (0, $hgUW1$css)({
    position: "absolute",
    width: "100%",
    marginLeft: (0, $hgUW1$token)("space.200"),
    marginRight: (0, $hgUW1$token)("space.200"),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    "@media(min-width: 1280px)": {
        width: "720px",
        height: "480px"
    },
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "656px"
    }
});
const $4366d2b05f9f8f6b$var$communityLogoStyles = (0, $hgUW1$css)({
    width: "406px",
    "@media(max-width: 767px)": {
        width: "90%"
    }
});
const $4366d2b05f9f8f6b$var$logoStyles = (0, $hgUW1$css)({
    width: "112px",
    height: "112px",
    borderRadius: "50%",
    border: "1px solid black",
    marginBottom: "24px"
});
const $4366d2b05f9f8f6b$var$buttonContainerStyles = (0, $hgUW1$css)({
    "@media(max-width: 767px)": {
        width: "100%"
    }
});


var $be203e745bcefb12$exports = {};

$parcel$defineInteropFlag($be203e745bcefb12$exports);

$parcel$export($be203e745bcefb12$exports, "Error", () => $be203e745bcefb12$export$edf27be85e5f6da0);
$parcel$export($be203e745bcefb12$exports, "default", () => $be203e745bcefb12$export$2e2bcd8739ae039);





const $72560d06a87aac8e$export$87321d307719eaf2 = (props)=>{
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
        width: "96",
        height: "89",
        viewBox: "0 0 96 89",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M0.576172 88.4576L0.628536 88.5623H95.366L95.4242 88.4576L48.0002 0.8125L0.576172 88.4576Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M48.1641 32.2012V64.207",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                d: "M50.4025 74.1797C50.4316 74.0284 50.4433 73.8655 50.4433 73.6968C50.4433 73.528 50.4316 73.3593 50.4025 73.208C50.2396 72.2946 49.6054 71.736 48.7153 71.5906C48.564 71.5673 48.4069 71.5557 48.2382 71.5557C48.0694 71.5557 47.9007 71.5673 47.7436 71.5964C46.8534 71.7418 46.2251 72.3062 46.0564 73.2138C46.0273 73.3651 46.0156 73.528 46.0156 73.7026C46.0156 73.8771 46.0273 74.0342 46.0564 74.1855C46.2193 75.0931 46.8534 75.6517 47.7436 75.8029C47.9007 75.832 48.0694 75.8437 48.2382 75.8437C48.4069 75.8437 48.564 75.832 48.7153 75.8088C49.6054 75.6633 50.2396 75.0989 50.4025 74.1913V74.1797Z",
                stroke: "white",
                strokeWidth: "7.33",
                strokeMiterlimit: "10"
            })
        ]
    });
};



const $be203e745bcefb12$export$edf27be85e5f6da0 = ({ onClickLogout: onClickLogout , errorMessage: errorMessage  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $be203e745bcefb12$var$pageStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $be203e745bcefb12$var$containerStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $72560d06a87aac8e$export$87321d307719eaf2), {}),
                /*#__PURE__*/ (0, $hgUW1$jsx)("h1", {
                    css: $be203e745bcefb12$var$headingStyles,
                    children: "Error"
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    css: $be203e745bcefb12$var$descriptionStyles,
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                    label: "Log out",
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).LINK,
                    onClick: onClickLogout
                })
            ]
        })
    });
};
var $be203e745bcefb12$export$2e2bcd8739ae039 = $be203e745bcefb12$export$edf27be85e5f6da0;
const $be203e745bcefb12$var$pageStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});
const $be203e745bcefb12$var$containerStyles = (0, $hgUW1$css)({
    maxWidth: "800px",
    minWidth: "375px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: (0, $hgUW1$token)("space.600")
});
const $be203e745bcefb12$var$headingStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.300"),
    marginBottom: (0, $hgUW1$token)("space.200"),
    fontFamily: (0, $hgUW1$token)("font.family.brand.heading"),
    fontSize: "24px",
    fontWeight: (0, $hgUW1$token)("font.weight.semibold"),
    lineHeight: "32px",
    textAlign: "center"
});
const $be203e745bcefb12$var$descriptionStyles = (0, $hgUW1$css)({
    marginBottom: (0, $hgUW1$token)("space.200"),
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter",
    fontWeight: "400",
    lineHeight: "20px",
    textAlign: "center",
    fontSize: "16px"
});


var $a0eced43682c2d75$exports = {};

$parcel$export($a0eced43682c2d75$exports, "LicenseModal", () => $a0eced43682c2d75$export$bd0c6e28f5d6b66e);









const $a0eced43682c2d75$export$bd0c6e28f5d6b66e = ({ modalTitle: modalTitle , bodyTitle: bodyTitle , bodyDescription: bodyDescription , closeModal: closeModal , licenses: licenses  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$atlaskitmodaldialog), {
        onClose: closeModal,
        shouldScrollInViewport: false,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ModalHeader), {
                children: modalTitle && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                    level: 3,
                    fontWeight: 600,
                    children: modalTitle
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$ModalBody), {
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                        css: (0, $hgUW1$css)({
                            color: (0, $hgUW1$token)("color.icon.brand")
                        }),
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AtlassianLogo), {
                            testId: "desktop"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $a0eced43682c2d75$var$spacingContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                            level: 4,
                            fontWeight: 500,
                            children: bodyTitle
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $a0eced43682c2d75$var$spacingContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Text), {
                            children: bodyDescription
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $a0eced43682c2d75$var$spacingContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                            level: 4,
                            fontWeight: 500,
                            children: "Attributions for Open Source Libraries"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $a0eced43682c2d75$var$spacingContainerStyles,
                        children: licenses?.length && licenses.map((license)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: (0, $hgUW1$css)({
                                    padding: `${(0, $hgUW1$token)("space.100")} 0`
                                }),
                                children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Text), {
                                    children: [
                                        /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                            css: $a0eced43682c2d75$var$licenseTitleStyles,
                                            href: license.link,
                                            children: `${license.packageName} ${license.version}`
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                            css: (0, $hgUW1$css)({
                                                margin: 0
                                            }),
                                            children: license.description
                                        })
                                    ]
                                }, license.packageName)
                            }))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ModalFooter), {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitbuttonnew), {
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                    onClick: closeModal,
                    children: "Close"
                })
            })
        ]
    });
};
const $a0eced43682c2d75$var$spacingContainerStyles = (0, $hgUW1$css)({
    padding: `${(0, $hgUW1$token)("space.100")} 0`
});
const $a0eced43682c2d75$var$licenseTitleStyles = (0, $hgUW1$css)({
    fontWeight: 600
});


var $1db60c687807de63$exports = {};

$parcel$export($1db60c687807de63$exports, "SUCCESS_MESSAGE", () => $1db60c687807de63$export$5620dbefc1cb6f80);
$parcel$export($1db60c687807de63$exports, "ERROR_MESSAGE", () => $1db60c687807de63$export$3f27bc10068ef877);
$parcel$export($1db60c687807de63$exports, "NewsletterSignup", () => $1db60c687807de63$export$21041608e6399292);





const $eb8aa702a3355ad4$export$260d8f4a67dc36b0 = ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
        "data-testid": "open-letter",
        width: "124",
        height: "118",
        viewBox: "0 0 124 118",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("g", {
            id: "Spot/Basics/Letter open",
            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                id: "Vector",
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_2",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_3",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_4",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_5",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_6",
                        d: "M88.2168 41.562H36.7148V43.9475H88.2168V41.562Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_7",
                        d: "M88.2168 51.1689H36.7148V53.5544H88.2168V51.1689Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_8",
                        d: "M88.2168 60.7825H36.7148V63.1679H88.2168V60.7825Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_9",
                        d: "M88.2168 70.3901H36.7148V72.7756H88.2168V70.3901Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_10",
                        d: "M88.2168 80.0034H36.7148V82.3889H88.2168V80.0034Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_11",
                        d: "M88.2168 89.6106H36.7148V91.9961H88.2168V89.6106Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_12",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_13",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_14",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_15",
                        d: "M61.8877 12.0239L11 54.5804V105.981H112.775V54.5804L61.8877 12.0239Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_16",
                        d: "M100.759 28.2393H23.0166V105.981H100.759V28.2393Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_17",
                        d: "M81.2754 28.2393H42.4938L23.0166 44.5319V105.981H100.759V44.5319L81.2754 28.2393Z",
                        fill: "#164B35"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_18",
                        d: "M94.3773 34.6199H29.3916V99.6056H94.3773V34.6199Z",
                        fill: "#DDDEE1"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_19",
                        d: "M51.0637 80.5821L49.6444 80.767C49.6444 80.767 47.1873 80.5642 46.2033 80.9041L42.5059 80.7491C42.5059 80.7491 40.9613 80.8385 40.4961 81.0532C40.2039 81.1844 40.0191 81.3454 39.9773 81.4945C39.8938 81.7927 40.4127 82.0432 41.9036 81.9478C41.9215 81.9656 41.9811 81.9835 41.9871 82.0074C43.5615 81.7987 45.0762 82.1863 46.6804 82.1446C46.6626 82.0551 46.7162 81.9895 46.7639 82.0312L46.746 82.1386C47.8135 81.9239 48.4815 82.2817 49.4595 81.912C49.4595 81.912 49.3402 82.0551 49.3462 82.0551C52.6918 82.0014 57.2241 82.1744 60.85 82.0193L60.8321 82.0014V81.9835C60.5041 81.8702 58.8999 81.7032 58.8999 81.7032C60.1106 81.1784 61.4762 81.739 62.7584 81.7211L62.7465 81.8643C62.1919 81.8583 61.6969 81.9179 61.5001 81.9776C63.4919 82.1803 67.4876 82.234 69.3959 82.0253C69.3482 81.9179 68.7578 82.1505 68.6087 81.7987C69.0978 81.7987 69.5868 81.7509 70.046 81.7569C70.046 81.9835 69.7776 81.906 69.7239 81.9478C70.5171 82.1982 86.7322 82.5441 82.8618 81.5542L82.9632 81.4349C81.9613 81.3812 81.1324 81.3335 80.0947 81.1009C79.9456 81.1188 79.9277 81.1009 79.9277 81.2142C79.886 81.2321 79.8204 81.2679 79.8383 81.3156C79.8502 81.6019 79.5281 81.4886 79.385 81.4945C79.5639 80.6059 76.1527 81.3872 75.6995 81.3514C75.616 80.928 74.8109 81.3335 74.5366 81.1486C74.5545 81.1307 74.6797 81.0413 74.6916 81.0234C74.4471 80.7491 70.4217 81.4826 71.5727 80.9638C66.8196 80.0454 58.1962 81.0771 53.0615 80.272L53.0973 80.3256C53.0556 80.3078 52.9303 80.3316 52.9005 80.272C52.3936 80.439 51.0577 80.5582 51.0577 80.5582L51.0637 80.5821ZM62.8419 81.1486C62.8419 81.1486 62.8479 81.1248 62.8419 81.1188C62.8419 81.1606 63.5039 81.1367 63.5277 81.1486V81.2917C62.8538 81.5601 61.3212 80.588 62.7763 81.0174C62.824 80.9816 62.824 81.1009 62.8359 81.1486H62.8419ZM68.7101 81.1963C68.8234 81.2083 68.9487 81.2202 69.0858 81.2321C67.5651 81.6675 65.5136 81.1069 63.8438 81.3037C64.4163 80.6775 65.77 81.0174 66.4916 81.0592C67.2132 80.922 68.072 81.095 68.7101 81.1963ZM78.5143 81.3514V81.2798H78.574C78.574 81.2977 78.568 81.3216 78.5561 81.3335C78.5501 81.3454 78.5263 81.3633 78.5143 81.3573V81.3514ZM51.8688 80.922C51.9821 80.8087 52.4055 80.8743 52.1252 81.1009C52.0537 81.0651 51.8449 81.1665 51.8688 80.922ZM70.4276 81.3752C70.4276 81.1427 70.9882 81.1009 70.9882 81.417C70.7974 81.417 70.6125 81.3991 70.4276 81.3752ZM47.7121 81.1427C47.5631 81.3872 47.6048 81.1128 47.5571 80.9578C47.5929 80.9936 47.73 81.0055 47.7002 81.1188L47.7121 81.1427ZM45.1001 81.2739C45.0643 81.3931 44.9152 81.4707 44.8436 81.4766C44.6647 81.3812 45.0166 81.1665 45.1001 81.2739ZM40.8003 81.2739C40.7943 81.411 40.6929 81.4587 40.6631 81.3216C40.6751 81.2202 40.8003 81.1427 40.8182 81.2977C40.8182 81.2918 40.8182 81.2798 40.8003 81.2739ZM73.0039 81.8881C72.8489 82.2936 72.342 81.9597 72.0676 82.067C72.1332 81.6615 72.6223 81.9656 72.831 81.8941C72.9025 81.8941 72.9622 81.8941 73.0039 81.8881ZM56.0851 81.6973C56.0851 82.0551 55.5186 81.7688 55.3277 81.8464V81.7032C55.614 81.6675 55.7869 81.578 56.0732 81.6973H56.0851ZM67.7977 81.9776C67.6903 82.1207 67.5114 81.9835 67.3981 81.9835C67.3981 81.7808 67.8692 81.751 67.7977 81.9776ZM63.0447 81.8941C63.0208 81.6734 63.2534 81.7808 63.325 81.7629C63.2772 81.8106 63.1878 81.9478 63.1341 81.9418C63.0983 81.9418 63.0864 81.912 63.0447 81.8941ZM56.2938 81.5601C56.5145 81.5601 56.753 81.5601 56.9796 81.572V81.7152C56.7411 81.7152 56.5145 81.7092 56.2879 81.7032V81.5601H56.2938ZM58.5183 81.7927V81.9358C58.1962 82.067 58.1604 81.7032 58.5123 81.7927H58.5183ZM53.4193 81.7092C53.4551 81.7152 53.5028 81.7271 53.5386 81.7271C53.9978 81.7152 53.3478 82.228 53.4193 81.7092ZM51.01 81.8344C50.9623 81.8523 50.9027 81.8941 50.855 81.8941C50.533 81.8762 50.8908 81.5363 51.01 81.8344Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_20",
                        d: "M72.2824 105.981L11.1074 54.5923L11.2088 105.981H72.2824Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_21",
                        d: "M51.4873 105.981L112.662 54.5923L112.567 105.981H51.4873Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_22",
                        d: "M51.4873 105.981H72.2825L61.8879 97.2446L51.4873 105.981Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_23",
                        d: "M51.0637 44.3943L49.6444 44.5792C49.6444 44.5792 47.1873 44.3764 46.2033 44.7164L42.5059 44.5613C42.5059 44.5613 40.9613 44.6508 40.4961 44.8655C40.2039 45.0026 40.0191 45.1577 39.9773 45.3068C39.8938 45.605 40.4127 45.8554 41.9036 45.76C41.9215 45.7779 41.9811 45.7958 41.9871 45.8196C43.5615 45.6109 45.0762 45.9986 46.6804 45.9568C46.6626 45.8674 46.7162 45.8018 46.7639 45.8435L46.746 45.9508C47.8135 45.7362 48.4815 46.094 49.4595 45.7242C49.4595 45.7242 49.3402 45.8674 49.3462 45.8674C52.6918 45.8137 57.2241 45.9866 60.85 45.8316L60.8321 45.8137V45.7958C60.5041 45.6825 58.8999 45.5155 58.8999 45.5155C60.1106 44.9907 61.4762 45.5513 62.7584 45.5334L62.7465 45.6765C62.1919 45.6706 61.6969 45.7302 61.5001 45.7898C63.4919 45.9926 67.4876 46.0463 69.3959 45.8375C69.3482 45.7302 68.7578 45.9628 68.6087 45.6109C69.0978 45.6109 69.5868 45.5632 70.046 45.5692C70.046 45.7958 69.7776 45.7183 69.7239 45.76C70.5171 46.0105 86.7322 46.3564 82.8618 45.3664L82.9632 45.2471C81.9613 45.1935 81.1324 45.1458 80.0947 44.9132C79.9456 44.9311 79.9277 44.9132 79.9277 45.0265C79.886 45.0444 79.8204 45.0802 79.8383 45.1279C79.8502 45.4141 79.5281 45.3008 79.385 45.3068C79.5639 44.4182 76.1527 45.1994 75.6995 45.1636C75.616 44.7402 74.8109 45.1458 74.5366 44.9609C74.5545 44.943 74.6797 44.8535 74.6916 44.8356C74.4471 44.5613 70.4217 45.2948 71.5727 44.776C66.8196 43.8576 58.1962 44.8893 53.0615 44.0842L53.0973 44.1379C53.0556 44.12 52.9303 44.1439 52.9005 44.0842C52.3936 44.2512 51.0577 44.3705 51.0577 44.3705L51.0637 44.3943ZM62.8419 44.9549C62.8419 44.9549 62.8479 44.9311 62.8419 44.9251C62.8419 44.9668 63.5039 44.943 63.5277 44.9549V45.098C62.8538 45.3664 61.3212 44.4003 62.7763 44.8237C62.824 44.7879 62.824 44.9072 62.8359 44.9549H62.8419ZM68.7101 45.0026C68.8234 45.0146 68.9487 45.0265 69.0858 45.0384C67.5651 45.4738 65.5136 44.9132 63.8438 45.11C64.4163 44.4838 65.77 44.8237 66.4916 44.8655C67.2132 44.7283 68.072 44.9012 68.7101 45.0026ZM78.5143 45.1577V45.0861H78.574C78.574 45.104 78.568 45.1279 78.5561 45.1398C78.5501 45.1517 78.5263 45.1696 78.5143 45.1636V45.1577ZM51.8688 44.7283C51.9821 44.615 52.4055 44.6806 52.1252 44.9072C52.0537 44.8714 51.8449 44.9728 51.8688 44.7283ZM70.4276 45.1815C70.4276 44.949 70.9882 44.9012 70.9882 45.2233C70.7974 45.2233 70.6125 45.2054 70.4276 45.1815ZM47.7121 44.949C47.5631 45.1935 47.6048 44.9191 47.5571 44.7641C47.5929 44.7999 47.73 44.8118 47.7002 44.9251L47.7121 44.949ZM45.1001 45.0802C45.0643 45.1994 44.9152 45.277 44.8436 45.2829C44.6647 45.1875 45.0166 44.9728 45.1001 45.0802ZM40.8003 45.0802C40.7943 45.2173 40.6929 45.265 40.6631 45.1279C40.6751 45.0265 40.8003 44.949 40.8182 45.104C40.8182 45.098 40.8182 45.0861 40.8003 45.0802ZM73.0039 45.6944C72.8489 46.0999 72.342 45.766 72.0676 45.8733C72.1332 45.4678 72.6223 45.7719 72.831 45.7004C72.9025 45.7004 72.9622 45.7004 73.0039 45.6944ZM56.0851 45.5036C56.0851 45.8614 55.5186 45.5751 55.3277 45.6527V45.5095C55.614 45.4738 55.7869 45.3843 56.0732 45.5036H56.0851ZM67.7977 45.7839C67.6903 45.927 67.5114 45.7898 67.3981 45.7898C67.3981 45.5871 67.8692 45.5572 67.7977 45.7839ZM63.0447 45.7004C63.0208 45.4797 63.2534 45.5871 63.325 45.5692C63.2772 45.6169 63.1878 45.754 63.1341 45.7481C63.0983 45.7481 63.0864 45.7183 63.0447 45.7004ZM56.2938 45.3664C56.5145 45.3664 56.753 45.3664 56.9796 45.3783V45.5215C56.7411 45.5215 56.5145 45.5155 56.2879 45.5095V45.3664H56.2938ZM58.5183 45.599V45.7421C58.1962 45.8733 58.1604 45.5095 58.5123 45.599H58.5183ZM53.4193 45.5155C53.4551 45.5215 53.5028 45.5334 53.5386 45.5334C53.9978 45.5215 53.3478 46.0343 53.4193 45.5155ZM51.01 45.6407C50.9623 45.6586 50.9027 45.7004 50.855 45.6944C50.533 45.6765 50.8908 45.3366 51.01 45.6407Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_24",
                        d: "M51.0637 56.4532L49.6444 56.638C49.6444 56.638 47.1873 56.4353 46.2033 56.7752L42.5059 56.6202C42.5059 56.6202 40.9613 56.7096 40.4961 56.9243C40.2039 57.0615 40.0191 57.2165 39.9773 57.3656C39.8938 57.6638 40.4127 57.9143 41.9036 57.8188C41.9215 57.8367 41.9811 57.8546 41.9871 57.8785C43.5615 57.6698 45.0762 58.0574 46.6804 58.0156C46.6626 57.9262 46.7162 57.8606 46.7639 57.9023L46.746 58.0097C47.8135 57.795 48.4815 58.1528 49.4595 57.7831C49.4595 57.7831 49.3402 57.9262 49.3462 57.9262C52.6918 57.8725 57.2241 58.0455 60.85 57.8904L60.8321 57.8725V57.8546C60.5041 57.7413 58.8999 57.5743 58.8999 57.5743C60.1106 57.0495 61.4762 57.6101 62.7584 57.5922L62.7465 57.7354C62.1919 57.7294 61.6969 57.789 61.5001 57.8487C63.4919 58.0514 67.4876 58.1051 69.3959 57.8964C69.3482 57.789 68.7578 58.0216 68.6087 57.6698C69.0978 57.6698 69.5868 57.6221 70.046 57.628C70.046 57.8546 69.7776 57.7771 69.7239 57.8188C70.5171 58.0693 86.7322 58.4152 82.8618 57.4253L82.9632 57.306C81.9613 57.2523 81.1324 57.2046 80.0947 56.972C79.9456 56.9899 79.9277 56.972 79.9277 57.0853C79.886 57.1032 79.8204 57.139 79.8383 57.1867C79.8502 57.473 79.5281 57.3597 79.385 57.3656C79.5639 56.477 76.1527 57.2583 75.6995 57.2225C75.616 56.7991 74.8109 57.2046 74.5366 57.0197C74.5545 57.0018 74.6797 56.9124 74.6916 56.8945C74.4471 56.6202 70.4217 57.3537 71.5727 56.8349C66.8196 55.9165 58.1962 56.9482 53.0615 56.1431L53.0973 56.1967C53.0556 56.1789 52.9303 56.2027 52.9005 56.1431C52.3936 56.31 51.0577 56.4293 51.0577 56.4293L51.0637 56.4532ZM62.8419 57.0197C62.8419 57.0197 62.8479 56.9959 62.8419 56.9899C62.8419 57.0316 63.5039 57.0078 63.5277 57.0197V57.1629C62.8538 57.4312 61.3212 56.4591 62.7763 56.8885C62.824 56.8527 62.824 56.972 62.8359 57.0197H62.8419ZM68.7101 57.0674C68.8234 57.0794 68.9487 57.0913 69.0858 57.1032C67.5651 57.5386 65.5136 56.978 63.8438 57.1748C64.4163 56.5486 65.77 56.8885 66.4916 56.9303C67.2132 56.7931 68.072 56.9661 68.7101 57.0674ZM78.5143 57.2225V57.1509H78.574C78.574 57.1688 78.568 57.1927 78.5561 57.2046C78.5501 57.2225 78.5263 57.2344 78.5143 57.2285V57.2225ZM51.8688 56.7931C51.9821 56.6798 52.4055 56.7454 52.1252 56.972C52.0537 56.9362 51.8449 57.0376 51.8688 56.7931ZM70.4276 57.2463C70.4276 57.0138 70.9882 56.972 70.9882 57.2941C70.7974 57.2941 70.6125 57.2762 70.4276 57.2463ZM47.7121 57.0138C47.5631 57.2583 47.6048 56.9839 47.5571 56.8289C47.5929 56.8647 47.73 56.8766 47.7002 56.9899L47.7121 57.0138ZM45.1001 57.145C45.0643 57.2642 44.9152 57.3418 44.8436 57.3477C44.6647 57.2523 45.0166 57.0376 45.1001 57.145ZM40.8003 57.145C40.7943 57.2821 40.6929 57.3298 40.6631 57.1927C40.6751 57.0913 40.8003 57.0138 40.8182 57.1688C40.8182 57.1628 40.8182 57.1509 40.8003 57.145ZM73.0039 57.7592C72.8489 58.1647 72.342 57.8308 72.0676 57.9381C72.1332 57.5326 72.6223 57.8367 72.831 57.7652C72.9025 57.7652 72.9622 57.7652 73.0039 57.7592ZM56.0851 57.5684C56.0851 57.9262 55.5186 57.6399 55.3277 57.7175V57.5743C55.614 57.5386 55.7869 57.4491 56.0732 57.5684H56.0851ZM67.7977 57.8487C67.6903 57.9918 67.5114 57.8487 67.3981 57.8546C67.3981 57.6519 67.8692 57.622 67.7977 57.8487ZM63.0447 57.7652C63.0208 57.5445 63.2534 57.6519 63.325 57.634C63.2772 57.6817 63.1878 57.8189 63.1341 57.8129C63.0983 57.8129 63.0864 57.7831 63.0447 57.7652ZM56.2938 57.4312C56.5145 57.4312 56.753 57.4312 56.9796 57.4431V57.5863C56.7411 57.5863 56.5145 57.5803 56.2879 57.5743V57.4312H56.2938ZM58.5183 57.6638V57.8069C58.1962 57.9381 58.1604 57.5743 58.5123 57.6638H58.5183ZM53.4193 57.5803C53.4551 57.5863 53.5028 57.5982 53.5386 57.5982C53.9978 57.5863 53.3478 58.0991 53.4193 57.5803ZM51.01 57.7055C50.9623 57.7234 50.9027 57.7652 50.855 57.7592C50.533 57.7413 50.8908 57.4014 51.01 57.7055Z",
                        fill: "#101214"
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                        id: "Vector_25",
                        d: "M51.0637 68.5174L49.6444 68.7022C49.6444 68.7022 47.1873 68.4995 46.2033 68.8394L42.5059 68.6844C42.5059 68.6844 40.9613 68.7738 40.4961 68.9885C40.2039 69.1257 40.0191 69.2807 39.9773 69.4298C39.8938 69.728 40.4127 69.9785 41.9036 69.8831C41.9215 69.9009 41.9811 69.9188 41.9871 69.9427C43.5615 69.734 45.0762 70.1216 46.6804 70.0799C46.6626 69.9904 46.7162 69.9248 46.7639 69.9665L46.746 70.0739C47.8135 69.8592 48.4815 70.217 49.4595 69.8473C49.4595 69.8473 49.3402 69.9904 49.3462 69.9904C52.6918 69.9367 57.2241 70.1097 60.85 69.9546L60.8321 69.9367V69.9188C60.5041 69.8055 58.8999 69.6385 58.8999 69.6385C60.1106 69.1137 61.4762 69.6743 62.7584 69.6564L62.7465 69.7996C62.1919 69.7936 61.6969 69.8532 61.5001 69.9129C63.4919 70.1156 67.4876 70.1693 69.3959 69.9606C69.3482 69.8532 68.7578 70.0858 68.6087 69.734C69.0978 69.734 69.5868 69.6863 70.046 69.6922C70.046 69.9188 69.7776 69.8413 69.7239 69.8831C70.5171 70.1335 86.7322 70.4794 82.8618 69.4895L82.9632 69.3702C81.9613 69.3165 81.1324 69.2688 80.0947 69.0362C79.9456 69.0541 79.9277 69.0362 79.9277 69.1495C79.886 69.1674 79.8204 69.2032 79.8383 69.2509C79.8502 69.5372 79.5281 69.4238 79.385 69.4298C79.5639 68.5412 76.1527 69.3225 75.6995 69.2867C75.616 68.8633 74.8109 69.2688 74.5366 69.0839C74.5545 69.066 74.6797 68.9766 74.6916 68.9587C74.4471 68.6844 70.4217 69.4179 71.5727 68.8991C66.8196 67.9807 58.1962 69.0124 53.0615 68.2073L53.0973 68.2609C53.0556 68.2431 52.9303 68.2669 52.9005 68.2073C52.3936 68.3743 51.0577 68.4935 51.0577 68.4935L51.0637 68.5174ZM62.8419 69.0839C62.8419 69.0839 62.8479 69.0601 62.8419 69.0541C62.8419 69.0959 63.5039 69.072 63.5277 69.0839V69.2271C62.8538 69.4954 61.3212 68.5233 62.7763 68.9527C62.824 68.9169 62.824 69.0362 62.8359 69.0839H62.8419ZM68.7101 69.1316C68.8234 69.1436 68.9487 69.1555 69.0858 69.1674C67.5651 69.6028 65.5136 69.0422 63.8438 69.239C64.4163 68.6128 65.77 68.9527 66.4916 68.9945C67.2132 68.8573 68.072 69.0302 68.7101 69.1316ZM78.5143 69.2867V69.2151H78.574C78.574 69.233 78.568 69.2569 78.5561 69.2688C78.5501 69.2807 78.5263 69.2986 78.5143 69.2927V69.2867ZM51.8688 68.8573C51.9821 68.744 52.4055 68.8096 52.1252 69.0362C52.0537 69.0004 51.8449 69.1018 51.8688 68.8573ZM70.4276 69.3105C70.4276 69.078 70.9882 69.0362 70.9882 69.3583C70.7974 69.3583 70.6125 69.3404 70.4276 69.3105ZM47.7121 69.078C47.5631 69.3225 47.6048 69.0481 47.5571 68.8931C47.5929 68.9289 47.73 68.9408 47.7002 69.0541L47.7121 69.078ZM45.1001 69.2092C45.0643 69.3284 44.9152 69.406 44.8436 69.4119C44.6647 69.3165 45.0166 69.1018 45.1001 69.2092ZM40.8003 69.2092C40.7943 69.3463 40.6929 69.394 40.6631 69.2569C40.6751 69.1555 40.8003 69.078 40.8182 69.233C40.8182 69.227 40.8182 69.2151 40.8003 69.2092ZM73.0039 69.8234C72.8489 70.2289 72.342 69.895 72.0676 70.0023C72.1332 69.5968 72.6223 69.9009 72.831 69.8294C72.9025 69.8294 72.9622 69.8294 73.0039 69.8234ZM56.0851 69.6326C56.0851 69.9904 55.5186 69.7041 55.3277 69.7817V69.6385C55.614 69.6028 55.7869 69.5133 56.0732 69.6326H56.0851ZM67.7977 69.9129C67.6903 70.056 67.5114 69.9129 67.3981 69.9188C67.3981 69.7161 67.8692 69.6863 67.7977 69.9129ZM63.0447 69.8294C63.0208 69.6087 63.2534 69.7161 63.325 69.6982C63.2772 69.7459 63.1878 69.883 63.1341 69.8771C63.0983 69.8771 63.0864 69.8473 63.0447 69.8294ZM56.2938 69.4954C56.5145 69.4954 56.753 69.4954 56.9796 69.5073V69.6505C56.7411 69.6505 56.5145 69.6445 56.2879 69.6385V69.4954H56.2938ZM58.5183 69.728V69.8711C58.1962 70.0023 58.1604 69.6385 58.5123 69.728H58.5183ZM53.4193 69.6445C53.4551 69.6505 53.5028 69.6624 53.5386 69.6624C53.9978 69.6505 53.3478 70.1633 53.4193 69.6445ZM51.01 69.7697C50.9623 69.7876 50.9027 69.8294 50.855 69.8234C50.533 69.8055 50.8908 69.4656 51.01 69.7697Z",
                        fill: "#101214"
                    })
                ]
            })
        })
    });











var $a6a41c835fd01d00$exports = {};
var $1ca64a7075ab6eae$exports = {};

$parcel$export($1ca64a7075ab6eae$exports, "TextField", () => $1ca64a7075ab6eae$export$2c73285ae9390cec);



const $1ca64a7075ab6eae$export$2c73285ae9390cec = ({ isInvalid: isInvalid = false , onChange: onChange = ()=>{
    return null;
} , value: value , isDisabled: isDisabled = false , isRequired: isRequired = false , ...rest })=>/*#__PURE__*/ (0, $hgUW1$jsx)("input", {
        css: [
            $1ca64a7075ab6eae$var$inputStyles,
            isInvalid && $1ca64a7075ab6eae$var$invalidStyles,
            isDisabled && $1ca64a7075ab6eae$var$disabledStyles
        ],
        onChange: onChange,
        disabled: isDisabled,
        value: value,
        required: isRequired,
        ...rest,
        role: "input"
    });
const $1ca64a7075ab6eae$var$inputStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "42px",
    fontWeight: 400,
    display: "flex",
    padding: "8px 12px",
    alignItems: "center",
    gap: "6px",
    alignSelf: "stretch",
    borderRadius: "4px",
    border: "1px solid #8590A2",
    background: "#FFFFFF",
    fontFamily: "inter",
    fontSize: "16px",
    "&:hover": {
        background: "#F7F8F9"
    },
    "&:focus": {
        borderColor: "inherit",
        boxShadow: "none",
        border: "2px solid #388BFF",
        margin: "-1px"
    }
});
const $1ca64a7075ab6eae$var$invalidStyles = (0, $hgUW1$css)({
    border: "2px solid #C9372C",
    margin: "-1px"
});
const $1ca64a7075ab6eae$var$disabledStyles = (0, $hgUW1$css)({
    color: "#091E424F",
    border: "1px solid #091E420F",
    background: "#091E4208"
});


var $60ab015507144a2b$exports = {};

$parcel$export($60ab015507144a2b$exports, "TextFieldMessage", () => $60ab015507144a2b$export$9144c5f9beecc4b7);



const $60ab015507144a2b$export$9144c5f9beecc4b7 = ({ message: message = "Example text here" , type: type = "valid"  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $60ab015507144a2b$var$spacing,
        children: [
            type === "helper" && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$HelperMessage), {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    css: $60ab015507144a2b$var$helperMessageStyle,
                    children: message
                })
            }),
            type === "error" && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ErrorMessage), {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    css: $60ab015507144a2b$var$errorMessageStyle,
                    children: message
                })
            }),
            type === "valid" && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ValidMessage), {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    css: $60ab015507144a2b$var$validMessageStyles,
                    children: message
                })
            })
        ]
    });
const $60ab015507144a2b$var$spacing = (0, $hgUW1$css)({
    marginTop: "2px"
});
const $60ab015507144a2b$var$helperMessageStyle = (0, $hgUW1$css)({
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $60ab015507144a2b$var$errorMessageStyle = (0, $hgUW1$css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    marginTop: "0.5px",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});
const $60ab015507144a2b$var$validMessageStyles = (0, $hgUW1$css)({
    paddingLeft: "6px",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
});


var $57b1d5df6b5425d4$exports = {};

$parcel$export($57b1d5df6b5425d4$exports, "TextFieldLabel", () => $57b1d5df6b5425d4$export$76375b2580d1f8ac);




const $57b1d5df6b5425d4$export$76375b2580d1f8ac = ({ labelText: labelText = "Example label" , isRequired: isRequired = true  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Label), {
        htmlFor: "basic-textfield",
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
            css: $57b1d5df6b5425d4$var$labelStyles,
            children: [
                labelText,
                isRequired && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$RequiredAsterisk), {})
            ]
        })
    });
const $57b1d5df6b5425d4$var$labelStyles = (0, $hgUW1$css)({
    fontFamily: "Inter",
    color: "#44546F",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px"
});


var $4be7278e65b71184$exports = {};

$parcel$export($4be7278e65b71184$exports, "UnifiedAccountCardContent", () => $4be7278e65b71184$export$c031b829a2452999);




var $fc6addd2061b87dd$exports = {};

$parcel$defineInteropFlag($fc6addd2061b87dd$exports);

$parcel$export($fc6addd2061b87dd$exports, "default", () => $fc6addd2061b87dd$export$2e2bcd8739ae039);





const $fc6addd2061b87dd$var$UnifiedMoreDropdownMenu = ({ actions: actions , isDisabled: isDisabled  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitdropdownmenu), {
        trigger: ({ triggerRef: triggerRef , ...props })=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $fc6addd2061b87dd$var$buttonWrapperStyle,
                "data-testid": "dropdown-trigger",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$IconButton), {
                    ...props,
                    icon: (0, $hgUW1$atlaskiticonglyphmore),
                    label: "more",
                    ref: triggerRef,
                    appearance: "default",
                    isDisabled: isDisabled
                })
            }),
        placement: "bottom-end",
        shouldRenderToParent: true,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$DropdownItemGroup), {
            children: actions.map((action, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$DropdownItem), {
                    onClick: action.onClick,
                    children: action.text
                }, index))
        })
    });
var $fc6addd2061b87dd$export$2e2bcd8739ae039 = $fc6addd2061b87dd$var$UnifiedMoreDropdownMenu;
const $fc6addd2061b87dd$var$buttonWrapperStyle = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    borderRadius: "3px"
});


const $4be7278e65b71184$export$c031b829a2452999 = ({ email: email , tags: tags , actions: actions , disableMenu: disableMenu  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $4be7278e65b71184$var$contentWrapperStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $4be7278e65b71184$var$dropdownWrapperStyles,
                children: disableMenu ? null : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fc6addd2061b87dd$export$2e2bcd8739ae039), {
                    actions: actions,
                    isDisabled: disableMenu
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $4be7278e65b71184$var$coverImageWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $4be7278e65b71184$var$coverImageStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
                        width: "350",
                        height: "82",
                        viewBox: "0 0 350 82",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                                clipPath: "url(#clip0_985_48434)",
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M167.322 38.821C177.93 34.78 184.789 30.2722 188.858 25.4255C193.11 20.3612 194.263 14.9878 193.538 9.5957C192.822 4.25652 190.271 -1.06544 187.204 -6.12471C185.194 -9.43933 182.915 -12.7134 180.746 -15.8286C179.821 -17.1581 178.915 -18.4586 178.059 -19.7211L221.313 -48.8693C222.054 -47.7618 222.787 -46.6694 223.511 -45.5908C241.665 -18.5315 254.013 -0.126895 247.42 31.5817C243.994 48.0569 230.739 60.1325 218.142 68.1357C211.864 72.1242 205.799 75.0696 201.302 77.0177C199.054 77.9913 197.201 78.7147 195.913 79.1939C195.383 79.3909 194.949 79.5465 194.622 79.6613L167.322 38.821Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M72.3053 -15.1135C82.328 -17.928 92.5012 -22.9961 101.629 -29.5552C110.755 -36.1128 118.158 -43.5947 123.819 -51.8086L166.607 8.14819C159.501 15.3002 151.561 22.0298 142.555 28.5017C133.545 34.9761 124.385 40.4509 115.146 44.9177L72.3053 -15.1135Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M145.593 48.2832L177.327 107.164L160.851 130.97L94.7005 121.821L95.1645 67.6983L145.593 48.2832Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M315.34 72.2206L315.355 72.2331L315.372 72.2449C315.778 72.5416 316.18 72.8355 316.577 73.1258C320.114 75.7149 323.269 78.0239 326.324 79.6083C329.758 81.3894 333.158 82.3068 336.975 81.7093C341.291 81.0335 344.5 78.5429 346.241 74.1008C347.949 69.7418 348.232 63.5491 346.967 55.3884L346.241 50.7055L378.755 45.6149C379.596 48.7568 380.163 52.4046 380.848 56.8254C383.982 77.0371 381.669 92.493 375.423 103.369C369.195 114.213 358.984 120.632 346.012 122.663C327.026 125.636 315.363 118.74 304.711 110.615L304.701 110.608L304.691 110.601C304.22 110.259 303.755 109.92 303.296 109.586C299.84 107.069 296.744 104.815 293.745 103.255C290.311 101.469 286.909 100.54 283.091 101.138L282.103 101.293L282.115 101.369C278.291 102.255 275.438 104.702 273.833 108.804C272.126 113.168 271.843 119.36 273.105 127.5C273.249 128.428 273.503 129.339 273.738 130.185L273.746 130.211C273.89 130.731 274.028 131.226 274.142 131.711L241.242 136.862C240.465 134.058 239.898 130.414 239.159 125.649C236.059 105.652 238.499 90.2821 244.81 79.446C251.105 68.6378 261.321 62.2203 274.06 60.2258C283.596 58.7327 291.242 59.6302 297.818 61.9301C304.407 64.2347 309.975 67.9653 315.34 72.2206Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M292.179 -56.9295L292.37 -57.2966L292.352 -57.3526L301.854 -75.6471L361.496 -44.2691L338.629 -0.241775C322.356 31.0905 300.658 42.9482 277.565 44.2706C265.48 24.4864 262.733 -0.232558 279.024 -31.6005L292.179 -56.9295Z",
                                        stroke: "#0C66E4",
                                        strokeWidth: "2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("defs", {
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("clipPath", {
                                    id: "clip0_985_48434",
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                        d: "M0 8C0 3.58172 3.58172 0 8 0H386C390.418 0 394 3.58172 394 8V96H0V8Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $4be7278e65b71184$var$textWrapperStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $4be7278e65b71184$var$emailStyles,
                        children: email
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $4be7278e65b71184$var$tagsWrapperStyles,
                        children: tags.map((tag, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $4be7278e65b71184$var$tagItemStyles,
                                children: tag
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $4be7278e65b71184$var$contentWrapperStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 0,
    margin: 0,
    height: "100%",
    borderRadius: (0, $hgUW1$token)("space.100")
});
const $4be7278e65b71184$var$coverImageWrapperStyles = (0, $hgUW1$css)({
    width: "100%",
    overflow: "hidden",
    borderTopLeftRadius: (0, $hgUW1$token)("space.100"),
    borderTopRightRadius: (0, $hgUW1$token)("space.100")
});
const $4be7278e65b71184$var$coverImageStyles = (0, $hgUW1$css)({
    background: (0, $hgUW1$token)("elevation.surface.sunken"),
    width: "100%",
    height: "82px",
    objectFit: "cover",
    margin: 0,
    padding: 0,
    display: "block"
});
const $4be7278e65b71184$var$textWrapperStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "24px",
    boxSizing: "border-box",
    width: "100%"
});
const $4be7278e65b71184$var$emailStyles = (0, $hgUW1$css)({
    fontFamily: "Inter",
    marginBottom: "12px",
    fontSize: "16px",
    color: "#44546F",
    lineHeight: "24px"
});
const $4be7278e65b71184$var$tagsWrapperStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    gap: "8px"
});
const $4be7278e65b71184$var$tagItemStyles = (0, $hgUW1$css)({
    display: "inline-block"
});
const $4be7278e65b71184$var$dropdownWrapperStyles = (0, $hgUW1$css)({
    position: "absolute",
    top: (0, $hgUW1$token)("space.150"),
    right: (0, $hgUW1$token)("space.150")
});


var $db9d361cdef36cb6$exports = {};

$parcel$export($db9d361cdef36cb6$exports, "UnifiedAccountContainerCard", () => $db9d361cdef36cb6$export$c9d2f1697787ae74);



const $db9d361cdef36cb6$export$c9d2f1697787ae74 = ({ children: children , testId: testId , onClick: onClick , isAddAccount: isAddAccount = false  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
        "data-testid": testId,
        css: [
            $db9d361cdef36cb6$var$unstyledButtonStyles,
            $db9d361cdef36cb6$var$cardContainerStyles,
            isAddAccount && $db9d361cdef36cb6$var$addAccountStyles,
            isAddAccount ? $db9d361cdef36cb6$var$hoverEffectStyles : $db9d361cdef36cb6$var$noPointerCursorStyles
        ],
        role: "button",
        onClick: isAddAccount ? onClick : undefined,
        children: children
    });
};
const $db9d361cdef36cb6$var$unstyledButtonStyles = (0, $hgUW1$css)({
    display: "flex",
    textAlign: "inherit",
    textDecoration: "none",
    background: "none",
    color: "inherit",
    border: "none",
    padding: 0,
    fontFamily: (0, $hgUW1$token)("font.family.brand.body")
});
const $db9d361cdef36cb6$var$cardContainerStyles = (0, $hgUW1$css)({
    position: "relative",
    textDecoration: "none",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    borderRadius: (0, $hgUW1$token)("space.100"),
    background: (0, $hgUW1$token)("elevation.surface"),
    alignItems: "center",
    zIndex: 1,
    justifyContent: "center",
    height: "194px",
    transition: "box-shadow 0.2s ease",
    width: "300px",
    "@media (min-width: 768px) and (max-width: 1279px)": {
        width: "290px"
    },
    "@media (min-width: 1280px)": {
        width: "290px"
    }
});
const $db9d361cdef36cb6$var$hoverEffectStyles = (0, $hgUW1$css)({
    cursor: "pointer",
    "&:hover": {
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $db9d361cdef36cb6$var$noPointerCursorStyles = (0, $hgUW1$css)({
    cursor: "default"
});
const $db9d361cdef36cb6$var$addAccountStyles = (0, $hgUW1$css)({
    border: `1px dashed ${(0, $hgUW1$token)("color.border")}`,
    boxShadow: "none"
});


var $e6da040d2ca2c72a$exports = {};

$parcel$export($e6da040d2ca2c72a$exports, "UnifiedAccountLinkAccountCard", () => $e6da040d2ca2c72a$export$fc13faf098015d3a);








const $5089616a215e9052$var$ellipseStyles = (0, $hgUW1$css)({
    width: "72px",
    height: "72px",
    backgroundColor: "#D3F1A7",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
const $5089616a215e9052$export$f21ab0717a89c77f = ()=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $5089616a215e9052$var$ellipseStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphadd), {
            label: "Add",
            size: "large",
            primaryColor: (0, $hgUW1$token)("color.icon")
        })
    });
};



const $e6da040d2ca2c72a$var$contentStyles = (0, $hgUW1$css)({
    textAlign: "center",
    padding: "17px 48px",
    fontFamily: "Inter, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
});
const $e6da040d2ca2c72a$var$textStyles = (0, $hgUW1$css)({
    marginTop: "16px",
    color: (0, $hgUW1$token)("color.icon"),
    fontSize: "16px",
    lineHeight: "24px"
});
const $e6da040d2ca2c72a$export$fc13faf098015d3a = ()=>{
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $e6da040d2ca2c72a$var$contentStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5089616a215e9052$export$f21ab0717a89c77f), {}),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $e6da040d2ca2c72a$var$textStyles,
                children: "Link account"
            })
        ]
    });
};


var $9c7edcd33b2e220b$exports = {};

$parcel$export($9c7edcd33b2e220b$exports, "UnifiedAccountTagContainer", () => $9c7edcd33b2e220b$export$b27c6704e245f018);



const $9c7edcd33b2e220b$export$b27c6704e245f018 = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $9c7edcd33b2e220b$var$containerStyles,
        children: children
    });
};
const $9c7edcd33b2e220b$var$containerStyles = (0, $hgUW1$css)({
    maxWidth: "84px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    borderRadius: "4px"
});


var $3ec1f71319ba0295$exports = {};

$parcel$export($3ec1f71319ba0295$exports, "UnifiedAccountTagLoggedIn", () => $3ec1f71319ba0295$export$8bee5cfdbbc2fc0c);




const $3ec1f71319ba0295$var$loggedInContentStyles = (0, $hgUW1$css)({
    backgroundColor: "#626F86",
    color: "#FFFFFF"
});
const $3ec1f71319ba0295$export$8bee5cfdbbc2fc0c = ()=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $9c7edcd33b2e220b$export$b27c6704e245f018), {
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: [
                $3ec1f71319ba0295$var$loggedInContentStyles,
                $3ec1f71319ba0295$var$baseContentStyles
            ],
            children: "LOGGED IN"
        })
    });
const $3ec1f71319ba0295$var$baseContentStyles = (0, $hgUW1$css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});


var $7cbc56ac0bc2e1de$exports = {};

$parcel$export($7cbc56ac0bc2e1de$exports, "UnifiedAccountTagPrimary", () => $7cbc56ac0bc2e1de$export$be7f7dedc3a0e1ad);





const $5f6e50d159d7e8e1$var$StarFilledIcon = ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
            id: "Icon / <StarFilledIcon>",
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                    width: "12",
                    height: "12",
                    rx: "6",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                    id: "Vector",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.0357 8.64198L4.0832 9.66848C4.00063 9.7119 3.90755 9.73135 3.8145 9.72463C3.72146 9.71791 3.63214 9.68529 3.55666 9.63046C3.48118 9.57563 3.42255 9.50078 3.38739 9.41437C3.35223 9.32796 3.34194 9.23344 3.3577 9.14149L3.7302 6.96698L2.1507 5.42698C2.08399 5.36186 2.03683 5.27937 2.01452 5.18886C1.99222 5.09834 1.99566 5.00338 2.02447 4.91472C2.05328 4.82605 2.10631 4.74721 2.17756 4.68709C2.24881 4.62697 2.33545 4.58797 2.4277 4.57448L4.6107 4.25698L5.5872 2.27898C5.62846 2.19525 5.69234 2.12474 5.7716 2.07544C5.85087 2.02613 5.94235 2 6.0357 2C6.12905 2 6.22053 2.02613 6.29979 2.07544C6.37906 2.12474 6.44294 2.19525 6.4842 2.27898L7.4602 4.25698L9.6432 4.57448C9.73549 4.58789 9.82219 4.62684 9.89351 4.68693C9.96482 4.74701 10.0179 4.82585 10.0468 4.91453C10.0756 5.00321 10.0791 5.09819 10.0569 5.18875C10.0346 5.2793 9.98741 5.36182 9.9207 5.42698L8.3407 6.96698L8.7137 9.14149C8.72939 9.23337 8.71908 9.32781 8.68394 9.41414C8.64879 9.50048 8.59022 9.57527 8.51482 9.63008C8.43942 9.68488 8.3502 9.71752 8.25724 9.72431C8.16427 9.7311 8.07126 9.71176 7.9887 9.66848L6.0357 8.64198Z",
                    fill: "white"
                })
            ]
        })
    });
var $5f6e50d159d7e8e1$export$2e2bcd8739ae039 = $5f6e50d159d7e8e1$var$StarFilledIcon;


const $7cbc56ac0bc2e1de$var$primaryContentStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $7cbc56ac0bc2e1de$var$iconWrapperStyles = (0, $hgUW1$css)({
    marginRight: "2px",
    display: "flex",
    alignItems: "center"
});
const $7cbc56ac0bc2e1de$export$be7f7dedc3a0e1ad = ()=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $9c7edcd33b2e220b$export$b27c6704e245f018), {
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: [
                $7cbc56ac0bc2e1de$var$primaryContentStyles,
                $7cbc56ac0bc2e1de$var$baseContentStyles
            ],
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $7cbc56ac0bc2e1de$var$iconWrapperStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5f6e50d159d7e8e1$export$2e2bcd8739ae039), {})
                }),
                "PRIMARY"
            ]
        })
    });
const $7cbc56ac0bc2e1de$var$baseContentStyles = (0, $hgUW1$css)({
    width: "84px",
    height: "28px",
    fontFamily: "Charlie Text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});



var $01ef21c48d795edb$exports = {};

$parcel$export($01ef21c48d795edb$exports, "UnifiedAccountTagLinked", () => $01ef21c48d795edb$export$446c53c437a3d14a);




const $01ef21c48d795edb$var$primaryContentStyles = (0, $hgUW1$css)({
    backgroundColor: "#FFFFFF",
    color: "#172B4D",
    border: "1px solid #091E4224"
});
const $01ef21c48d795edb$export$446c53c437a3d14a = ()=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $9c7edcd33b2e220b$export$b27c6704e245f018), {
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: [
                $01ef21c48d795edb$var$primaryContentStyles,
                $01ef21c48d795edb$var$baseContentStyles
            ],
            children: "LINKED"
        })
    });
const $01ef21c48d795edb$var$baseContentStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Text",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    boxSizing: "border-box",
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "4px"
});


var $80cd39a44f20f361$exports = {};

$parcel$defineInteropFlag($80cd39a44f20f361$exports);

$parcel$export($80cd39a44f20f361$exports, "SharedFooter", () => $80cd39a44f20f361$export$7a92b4adf6bd95bb);
$parcel$export($80cd39a44f20f361$exports, "default", () => $80cd39a44f20f361$export$2e2bcd8739ae039);







var $85d9a99cb49b730f$require$Buffer = $hgUW1$Buffer;
const $85d9a99cb49b730f$var$svgStringDesktopFooterWider = `<svg width="3597" height="220" viewBox="0 0 3597 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26831)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3507.45 240.161L3557.25 236.478L3583.87 196.676L3567.29 150.712L3519.96 133.206L3477.54 157.345L3471.98 204.936L3507.45 240.161Z" fill="#FCA700"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3604.18 274.336L3620.24 305.08C3640.49 343.822 3667.68 358.475 3696.55 359.996C3711.89 335.532 3715.4 304.987 3695.17 266.29L3666.68 211.774L3591.71 250.587L3604.11 274.315L3604.18 274.336Z" fill="#1868DB"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26831">
<rect width="3597" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $85d9a99cb49b730f$export$f3cfc44c4eba4576 = `data:image/svg+xml;base64,${$85d9a99cb49b730f$require$Buffer.from($85d9a99cb49b730f$var$svgStringDesktopFooterWider).toString("base64")}`;
const $85d9a99cb49b730f$var$svgStringDesktopFooterWide = `<svg width="3305" height="220" viewBox="0 0 3305 220" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_1461_26940)">
<path d="M2132.54 314.529C2146.63 313.033 2161.59 314.218 2177.19 318.272C2192.78 322.325 2207.65 328.995 2219.68 337.581L2245.71 236.527C2232.41 230.415 2218.06 225.333 2202.74 221.351C2187.42 217.369 2172.81 214.822 2158.49 213.604L2132.48 314.564L2132.54 314.529Z" fill="#BF63F3"/>
<path d="M1905.63 13.0095L1932.77 57.7351C1902.11 76.8306 1895.31 95.1589 1908.88 117.522C1922.45 139.884 1942.19 142.885 1973.45 124.776L2000.59 169.502C1939.18 206.46 1898.36 193.057 1867.63 142.412C1836.9 91.7667 1844.25 50.0145 1905.66 13.0565L1905.63 13.0095Z" fill="#BF63F3"/>
<path d="M2653.64 67.1608C2651.12 70.158 2648.74 73.5509 2646.59 77.2837C2644.43 81.0165 2642.62 84.8928 2641.3 88.6374C2633.3 110.896 2640.22 131.445 2658.16 146.049C2661.21 148.541 2664.61 150.872 2668.29 152.996C2671.97 155.121 2675.99 157.022 2679.83 158.505C2701.49 166.665 2722.75 162.381 2737.96 144.444C2740.54 141.43 2742.94 137.998 2745.14 134.187C2747.35 130.375 2749.05 126.695 2750.38 123.013C2758.29 100.911 2751.37 80.3628 2733.5 65.6405C2730.31 63.0181 2726.79 60.6186 2722.96 58.4028C2719.12 56.187 2715.6 54.5204 2711.88 53.1059C2690.25 44.8669 2668.94 49.1675 2653.72 67.2065L2653.64 67.1608Z" fill="#FCA700"/>
<path d="M1895.14 242.555C1892.93 245.176 1890.84 248.144 1888.96 251.41C1887.07 254.676 1885.48 258.069 1884.33 261.347C1877.35 280.834 1883.48 298.855 1899.28 311.691C1901.96 313.881 1904.95 315.93 1908.19 317.8C1911.43 319.669 1914.97 321.344 1918.34 322.652C1937.4 329.85 1956.07 326.142 1969.39 310.457C1971.66 307.822 1973.76 304.819 1975.69 301.484C1977.61 298.149 1979.1 294.929 1980.27 291.705C1987.17 272.356 1981.05 254.335 1965.3 241.396C1962.5 239.091 1959.4 236.981 1956.03 235.031C1952.65 233.081 1949.55 231.613 1946.28 230.365C1927.26 223.099 1908.54 226.821 1895.21 242.595L1895.14 242.555Z" fill="#1868DB"/>
<path d="M2377.56 187.36C2332.41 205.776 2303.33 188.768 2293.49 181.225L2286.73 268.152C2295.75 275.232 2321.35 289.599 2365.56 271.568C2407.5 254.47 2435.57 267.92 2447.25 275.96L2454 189.016C2443.32 181.668 2418.37 170.713 2377.56 187.36Z" fill="#1868DB"/>
<path d="M1956.63 392.322L2067.8 363.764L2103.25 229.834L2021.88 185.761L1956.63 392.322Z" fill="#82B536"/>
<path d="M1814.81 214.821C1777.79 204.861 1754.37 195.571 1741.02 184.518L1735.75 299.502C1749.51 304.079 1764.42 308.373 1780.76 312.342C1816.54 322.129 1838.14 331.724 1849.86 343.657L1855.25 225.91C1842.76 221.962 1829.36 218.25 1814.81 214.821Z" fill="#FCA700"/>
<path d="M1717.71 131.43L1767.34 121.105L1788.77 77.5333L1765.89 33.5097L1715.9 22.1945L1676.46 52.1123L1677.27 100.718L1717.71 131.43Z" fill="#82B536"/>
<path d="M2287.3 0.329368C2292.26 17.6796 2294.03 36.6867 2292.33 57.0839C2290.62 77.481 2285.46 97.5178 2277.28 114.391L2410.19 125.941C2414.99 107.988 2418.26 88.9353 2419.94 68.8981C2421.61 48.8609 2421.63 30.0094 2420.04 11.8036L2287.25 0.264012L2287.3 0.329368Z" fill="#82B536"/>
<path d="M2732.21 188.352C2731.07 192.109 2730.22 196.176 2729.74 200.467C2729.26 204.759 2729.16 209.049 2729.49 213.022C2731.28 236.704 2746.68 252.942 2770.15 259.359C2774.14 260.46 2778.41 261.273 2782.85 261.786C2787.29 262.299 2791.96 262.473 2796.29 262.331C2820.59 261.339 2839.19 249.028 2846.17 226.497C2847.37 222.7 2848.22 218.588 2848.72 214.207C2849.21 209.825 2849.28 205.76 2848.99 201.838C2847.18 178.337 2831.78 162.098 2808.32 155.546C2804.15 154.377 2799.74 153.548 2795.11 153.013C2790.48 152.478 2786.38 152.326 2782.2 152.484C2757.91 153.385 2739.25 165.736 2732.31 188.363L2732.21 188.352Z" fill="#82B536"/>
<path d="M2889.07 147.28C2915.86 136.154 2934.18 130.899 2947.27 131.344L2897.58 60.2224C2887.23 63.8352 2876.31 68.1465 2864.68 73.3134C2838.72 83.9714 2821.36 88.1994 2808.84 86.4762L2859.72 159.306C2869.02 155.908 2878.77 151.943 2889.07 147.28Z" fill="#BF63F3"/>
<path d="M1500.61 92.78C1499.48 96.4691 1498.65 100.462 1498.18 104.676C1497.71 108.89 1497.62 113.103 1497.94 117.004C1499.7 140.257 1514.82 156.202 1537.86 162.503C1541.78 163.584 1545.97 164.382 1550.33 164.886C1554.69 165.39 1559.28 165.56 1563.52 165.421C1587.38 164.447 1605.65 152.359 1612.51 130.235C1613.69 126.507 1614.52 122.47 1615 118.167C1615.49 113.864 1615.56 109.873 1615.27 106.022C1613.5 82.9459 1598.37 67.0012 1575.34 60.5673C1571.24 59.4199 1566.92 58.6058 1562.37 58.0804C1557.82 57.5551 1553.8 57.4053 1549.7 57.5605C1525.84 58.4455 1507.52 70.573 1500.7 92.7908L1500.61 92.78Z" fill="#FCA700"/>
<path d="M2476.23 171.901L2512.57 187.615L2580.4 132.718L2540.7 72.2981L2469.59 84.8102L2476.23 171.901Z" fill="#FCA700"/>
<path d="M1590.18 276.392C1581.18 284.413 1582.82 297.295 1599.18 315.611C1600.94 317.584 1603.22 319.181 1604.98 321.154L1565.44 356.405C1561.81 353.394 1557.79 348.885 1552.5 342.967C1511.68 297.27 1513.72 256.222 1543.27 229.879C1565.29 210.248 1585.75 208.965 1606.41 210.958C1621.55 211.808 1632.33 212.828 1640.38 205.651C1649.37 197.63 1647.78 184.796 1631.38 166.432L1625.63 159.998L1664.69 125.169C1668.74 128.65 1672.77 133.158 1677.63 138.606C1718.87 184.774 1717.35 225.357 1687.28 252.165C1665.26 271.796 1644.39 272.609 1624.1 271.038C1609.01 270.236 1598.18 269.168 1590.13 276.345L1590.18 276.392Z" fill="#BF63F3"/>
<path d="M2627.7 309.01L2674.17 285.958L2684.11 237.19L2650.04 199.408L2597.6 201.079L2566.29 240.945L2579.68 288.97L2627.7 309.01Z" fill="#1868DB"/>
<path d="M2872.12 290.73C2867.27 321.394 2860.18 348.844 2852.92 371.879L2952.23 418.074C2962.37 387.895 2972.61 350.569 2979.35 307.997C2986.08 265.424 2987.84 226.732 2987.52 194.869L2878.89 207.578C2878.69 231.751 2876.97 260.066 2872.12 290.73Z" fill="#1868DB"/>
<path d="M2029.07 76.709L2081.8 60.3305C2094.17 97.6481 2111.48 109.727 2137.85 101.538C2164.21 93.3484 2172.04 73.4588 2160.83 35.7799L2213.56 19.4014C2237.02 93.7899 2213.37 132.978 2153.67 151.525C2093.96 170.071 2052.58 151.08 2029.12 76.6918L2029.07 76.709Z" fill="#1868DB"/>
<path d="M3183.71 263.373L3218.75 257.454C3262.92 249.994 3285.29 225.656 3295.17 194.436C3275.45 168.157 3246.29 152.584 3202.18 160.035L3140.03 170.531L3156.62 268.008L3183.67 263.44L3183.71 263.373Z" fill="#82B536"/>
<path d="M3409.05 183.497L3432.31 152.723L3395.5 75.4747L3328.88 98.91L3324.57 169.298L3409.05 183.497Z" fill="#BF63F3"/>
<path d="M3096.28 193.6L3071.36 147.313L2999.69 124.541L3013.98 207.767L3075.67 265.657L3096.28 193.6Z" fill="#FCA700"/>
<path d="M3419.15 246.402C3387.51 238.086 3359.1 229.101 3335.23 220.826L3290.48 267.987C3321.77 279.173 3360.41 291.729 3404.34 303.274C3448.28 314.818 3488.09 322.876 3520.82 328.514L3504.79 265.379C3479.94 260.853 3450.8 254.717 3419.15 246.402Z" fill="#1868DB"/>
<path d="M3194.92 119.479C3224.2 117.038 3243.38 117.413 3255.57 121.325L3234.28 46.2045C3223.2 46.5499 3211.35 47.3509 3198.52 48.703C3170.19 50.9595 3152.29 49.9514 3141.1 45.084L3162.9 122.009C3172.9 121.566 3183.52 120.75 3194.92 119.479Z" fill="#1868DB"/>
<path d="M1080.67 276.053C1089.16 285.428 1102.4 283.893 1120.89 267.24C1122.88 265.447 1124.47 263.118 1126.46 261.324L1163.76 302.525C1160.75 306.228 1156.2 310.327 1150.22 315.707C1104.1 357.253 1061.73 354.658 1033.86 323.868C1013.08 300.924 1011.27 279.808 1012.82 258.521C1013.33 242.923 1014.12 231.819 1006.53 223.431C998.038 214.056 984.845 215.548 966.31 232.244L959.816 238.093L922.961 197.386C926.452 193.256 931.003 189.157 936.501 184.204C983.099 142.231 1024.98 144.284 1053.34 175.616C1074.12 198.56 1075.46 220.103 1074.33 241.006C1073.87 256.561 1073.03 267.708 1080.63 276.096L1080.67 276.053Z" fill="#82B536"/>
<path d="M625.543 193.797C639.63 192.301 654.593 193.486 670.188 197.54C685.782 201.593 700.654 208.263 712.683 216.849L738.712 115.795C725.409 109.683 711.058 104.601 695.739 100.619C680.42 96.6367 665.808 94.0903 651.489 92.8723L625.485 193.832L625.543 193.797Z" fill="#BF63F3"/>
<path d="M1266.86 164.218L1230.53 158.808L1182.68 226.256L1232.61 271.992L1293.45 242.75L1266.86 164.218Z" fill="#FCA700"/>
<path d="M399.069 336.98L422.334 306.205L385.52 228.958L318.902 252.393L314.592 322.781L399.069 336.98Z" fill="#BF63F3"/>
<path d="M388.137 121.823C385.928 124.444 383.843 127.412 381.957 130.678C380.072 133.944 378.484 137.337 377.334 140.615C370.355 160.102 376.477 178.123 392.278 190.959C394.96 193.149 397.955 195.199 401.193 197.068C404.431 198.938 407.967 200.612 411.344 201.92C430.4 209.118 449.068 205.41 462.395 189.725C464.659 187.09 466.763 184.087 468.689 180.752C470.614 177.418 472.102 174.197 473.267 170.973C480.168 151.624 474.045 133.603 458.303 120.664C455.502 118.359 452.403 116.249 449.026 114.299C445.649 112.349 442.55 110.881 439.278 109.634C420.261 102.367 401.539 106.09 388.207 121.863L388.137 121.823Z" fill="#1868DB"/>
<path d="M870.565 66.6285C825.409 85.0438 796.327 68.0356 786.485 60.4931L779.735 147.42C788.749 154.5 814.346 168.867 858.558 150.836C900.496 133.738 928.568 147.188 940.25 155.228L947.002 68.2839C936.315 60.9356 911.368 49.9809 870.565 66.6285Z" fill="#1868DB"/>
<path d="M743.463 217.247C740.532 228.564 734.449 235.337 724.723 239.407C714.173 243.821 704.241 242.98 695.082 237.49L605.16 275.114C646.399 339.254 703.508 358.315 762.522 333.623C817.497 310.622 843.195 267.293 832.726 179.9L743.381 217.282L743.463 217.247Z" fill="#1868DB"/>
<path d="M449.631 271.59L560.8 243.032L596.253 109.102L514.879 65.0287L449.631 271.59Z" fill="#82B536"/>
<path d="M307.812 94.0893C270.79 84.1287 247.365 74.8387 234.016 63.7859L228.75 178.77C242.51 183.347 257.418 187.641 273.761 191.61C309.542 201.397 331.135 210.992 342.854 222.925L348.246 105.178C335.764 101.23 322.362 97.5184 307.812 94.0893Z" fill="#FCA700"/>
<path d="M1225.21 67.6199C1224.07 71.377 1223.22 75.4437 1222.74 79.7352C1222.26 84.0267 1222.16 88.3172 1222.49 92.2903C1224.28 115.972 1239.68 132.21 1263.15 138.627C1267.14 139.728 1271.41 140.541 1275.85 141.054C1280.29 141.567 1284.96 141.741 1289.29 141.599C1313.59 140.607 1332.19 128.296 1339.17 105.765C1340.37 101.968 1341.22 97.8564 1341.72 93.4746C1342.21 89.0927 1342.28 85.0281 1341.99 81.1056C1340.18 57.6047 1324.78 41.3663 1301.32 34.8139C1297.15 33.6454 1292.74 32.8162 1288.11 32.2812C1283.48 31.7462 1279.38 31.5936 1275.2 31.7517C1250.91 32.653 1232.25 45.0039 1225.31 67.631L1225.21 67.6199Z" fill="#82B536"/>
<path d="M83.1762 155.66C74.1789 163.681 75.8177 176.563 92.1789 194.879C93.9408 196.852 96.2182 198.449 97.9802 200.422L58.4398 235.673C54.8145 232.662 50.7872 228.153 45.5013 222.235C4.68234 176.538 6.72077 135.49 36.2695 109.147C58.289 89.5158 78.7491 88.2328 99.414 90.2263C114.549 91.0758 125.328 92.0964 133.378 84.9196C142.375 76.8983 140.778 64.064 124.375 45.7004L118.628 39.2661L157.695 4.43712C161.739 7.91785 165.767 12.4265 170.633 17.8745C211.872 64.0418 210.354 104.625 180.284 131.433C158.265 151.064 137.385 151.877 117.098 150.306C102.005 149.504 91.1843 148.436 83.1342 155.613L83.1762 155.66Z" fill="#BF63F3"/>
<path d="M1120.7 188.278L1167.17 165.226L1177.11 116.458L1143.04 78.6759L1090.6 80.3475L1059.29 120.213L1072.68 168.238L1120.7 188.278Z" fill="#1868DB"/>
<path d="M1365.12 169.998C1360.27 200.662 1353.18 228.112 1345.92 251.147L1445.23 297.342C1455.37 267.164 1465.61 229.838 1472.35 187.265C1479.08 144.692 1480.84 106 1480.52 74.1372L1371.89 86.8457C1371.69 111.019 1369.97 139.334 1365.12 169.998Z" fill="#1868DB"/>
<path d="M184.943 272.962C214.22 270.521 233.398 270.896 245.587 274.808L224.294 199.687C213.221 200.033 201.37 200.834 188.539 202.186C160.208 204.442 142.304 203.434 131.116 198.567L152.92 275.492C162.921 275.048 173.542 274.233 184.943 272.962Z" fill="#1868DB"/>
</g>
<defs>
<clipPath id="clip0_1461_26940">
<rect width="3305" height="220" fill="white"/>
</clipPath>
</defs>
</svg>
`;
const $85d9a99cb49b730f$export$7d22dc8c5b0cc81c = `data:image/svg+xml;base64,${$85d9a99cb49b730f$require$Buffer.from($85d9a99cb49b730f$var$svgStringDesktopFooterWide).toString("base64")}`;
const $85d9a99cb49b730f$var$svgStringMobileFooter = `<svg width="907" height="139" viewBox="0 0 907 139" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_1421_26676" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="907" height="139">
<rect width="907" height="138.569" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_1421_26676)">
<path d="M395.637 190.948C403.967 189.968 412.814 190.744 422.035 193.4C431.255 196.056 440.048 200.427 447.161 206.052L462.551 139.842C454.685 135.837 446.2 132.507 437.142 129.898C428.085 127.289 419.445 125.62 410.979 124.822L395.603 190.971L395.637 190.948Z" fill="#BF63F3"/>
<path d="M261.469 -6.60718L277.516 22.697C259.386 35.2084 255.368 47.2171 263.392 61.8691C271.415 76.5212 283.086 78.4874 301.57 66.6224L317.617 95.9265C281.308 120.141 257.173 111.36 239.002 78.1771C220.831 44.9945 225.177 17.6384 261.486 -6.57639L261.469 -6.60718Z" fill="#BF63F3"/>
<path d="M703.749 28.8725C702.258 30.8363 700.85 33.0593 699.576 35.505C698.302 37.9507 697.228 40.4904 696.449 42.9439C691.72 57.5278 695.81 70.9912 706.42 80.56C708.221 82.1926 710.233 83.7199 712.408 85.1118C714.584 86.5037 716.96 87.7495 719.23 88.7212C732.041 94.0679 744.608 91.2609 753.601 79.5082C755.128 77.5337 756.55 75.2849 757.851 72.7877C759.152 70.2905 760.158 67.8795 760.948 65.4667C765.623 50.9859 761.533 37.5224 750.963 27.8764C749.082 26.1581 747 24.586 744.731 23.1342C742.462 21.6824 740.379 20.5905 738.179 19.6637C725.396 14.2655 712.792 17.0833 703.796 28.9024L703.749 28.8725Z" fill="#FCA700"/>
<path d="M255.266 143.791C253.96 145.508 252.727 147.453 251.612 149.593C250.497 151.733 249.559 153.956 248.879 156.104C244.752 168.871 248.372 180.679 257.715 189.089C259.3 190.524 261.071 191.867 262.985 193.092C264.9 194.316 266.991 195.414 268.987 196.271C280.255 200.986 291.293 198.557 299.172 188.28C300.511 186.554 301.755 184.587 302.894 182.402C304.032 180.217 304.912 178.106 305.601 175.994C309.681 163.316 306.061 151.509 296.753 143.031C295.097 141.521 293.265 140.139 291.268 138.861C289.271 137.584 287.439 136.622 285.504 135.804C274.26 131.044 263.19 133.482 255.307 143.817L255.266 143.791Z" fill="#1868DB"/>
<path d="M540.511 107.628C513.812 119.693 496.617 108.55 490.798 103.608L486.806 160.563C492.136 165.201 507.271 174.615 533.412 162.8C558.209 151.598 574.807 160.41 581.715 165.678L585.707 108.712C579.388 103.898 564.637 96.7202 540.511 107.628Z" fill="#1868DB"/>
<path d="M291.626 241.918L357.357 223.207L378.319 135.456L330.205 106.579L291.626 241.918Z" fill="#82B536"/>
<path d="M207.772 125.619C185.882 119.093 172.032 113.006 164.139 105.765L161.026 181.102C169.161 184.101 177.976 186.914 187.639 189.515C208.795 195.927 221.563 202.214 228.492 210.032L231.68 132.885C224.3 130.298 216.376 127.866 207.772 125.619Z" fill="#FCA700"/>
<path d="M150.358 70.9821L179.701 64.217L192.375 35.669L178.846 6.8247L149.287 -0.588974L125.967 19.0132L126.445 50.8598L150.358 70.9821Z" fill="#82B536"/>
<path d="M487.144 -14.9153C490.073 -3.54747 491.12 8.90597 490.112 22.2702C489.104 35.6344 486.055 48.7625 481.214 59.8175L559.804 67.3853C562.64 55.6224 564.574 43.1392 565.564 30.0109C566.554 16.8825 566.566 4.53097 565.627 -7.39742L487.11 -14.9582L487.144 -14.9153Z" fill="#82B536"/>
<path d="M750.205 108.277C749.527 110.739 749.028 113.403 748.743 116.215C748.458 119.027 748.402 121.838 748.596 124.441C749.655 139.957 758.761 150.597 772.638 154.801C774.997 155.523 777.517 156.055 780.143 156.391C782.77 156.727 785.533 156.841 788.088 156.748C802.457 156.099 813.458 148.032 817.586 133.27C818.296 130.782 818.798 128.088 819.089 125.217C819.38 122.346 819.421 119.683 819.252 117.113C818.181 101.715 809.075 91.0758 795.207 86.7827C792.738 86.0171 790.133 85.4738 787.394 85.1233C784.655 84.7727 782.233 84.6728 779.762 84.7763C765.4 85.3669 754.367 93.4592 750.262 108.284L750.205 108.277Z" fill="#82B536"/>
<path d="M842.951 81.367C858.788 74.077 869.621 70.6339 877.359 70.9258L847.983 24.3268C841.859 26.6939 835.405 29.5186 828.529 32.904C813.18 39.8871 802.914 42.6573 795.515 41.5283L825.596 89.2466C831.096 87.0197 836.858 84.4222 842.951 81.367Z" fill="#BF63F3"/>
<path d="M21.9939 45.6584C21.3276 48.0755 20.8378 50.6918 20.558 53.4527C20.2782 56.2137 20.2233 58.9739 20.4137 61.5301C21.454 76.7656 30.395 87.2126 44.021 91.3409C46.3368 92.0494 48.8118 92.5722 51.3906 92.9022C53.9694 93.2322 56.6827 93.3439 59.1918 93.2528C73.3009 92.6149 84.1031 84.6944 88.1561 70.199C88.853 67.7564 89.3458 65.111 89.6315 62.292C89.9171 59.4729 89.9574 56.8579 89.7918 54.3344C88.7397 39.2151 79.7987 28.7681 66.1814 24.5527C63.7577 23.8009 61.1995 23.2675 58.5098 22.9233C55.8201 22.5791 53.4424 22.4809 51.0165 22.5826C36.9134 23.1624 26.0805 31.1084 22.0493 45.6655L21.9939 45.6584Z" fill="#FCA700"/>
<path d="M598.85 97.498L620.339 107.794L660.44 71.8259L636.967 32.2385L594.924 40.4365L598.85 97.498Z" fill="#FCA700"/>
<path d="M74.9517 165.961C69.6319 171.216 70.6008 179.656 80.2747 191.657C81.3165 192.95 82.6631 193.996 83.7049 195.289L60.3258 218.385C58.1823 216.412 55.801 213.458 52.6756 209.581C28.5406 179.64 29.7458 152.746 47.2172 135.485C60.2366 122.623 72.3341 121.783 84.5526 123.089C93.5012 123.645 99.8746 124.314 104.634 119.612C109.954 114.356 109.01 105.947 99.3113 93.9154L95.9131 89.6996L119.012 66.8797C121.404 69.1603 123.785 72.1144 126.662 75.6839C151.045 105.933 150.148 132.523 132.369 150.087C119.349 162.95 107.004 163.482 95.0086 162.453C86.0848 161.927 79.6867 161.228 74.9268 165.93L74.9517 165.961Z" fill="#BF63F3"/>
<path d="M688.409 187.332L715.888 172.229L721.763 140.276L701.619 115.521L670.609 116.616L652.097 142.736L660.019 174.202L688.409 187.332Z" fill="#1868DB"/>
<path d="M832.929 175.355C830.063 195.446 825.869 213.432 821.573 228.524L880.295 258.791C886.287 239.018 892.347 214.562 896.327 186.668C900.306 158.775 901.351 133.424 901.158 112.547L836.93 120.874C836.813 136.712 835.795 155.264 832.929 175.355Z" fill="#1868DB"/>
<path d="M334.456 35.1284L365.632 24.3972C372.95 48.8477 383.184 56.7618 398.772 51.3962C414.36 46.0306 418.993 32.9989 412.363 8.3117L443.539 -2.41947C457.409 46.3198 443.431 71.9961 408.128 84.1476C372.826 96.2991 348.359 83.8565 334.489 35.1171L334.456 35.1284Z" fill="#1868DB"/>
</g>
</svg>
`;
const $85d9a99cb49b730f$export$eca0cf64e1927e60 = `data:image/svg+xml;base64,${$85d9a99cb49b730f$require$Buffer.from($85d9a99cb49b730f$var$svgStringMobileFooter).toString("base64")}`;






const $80cd39a44f20f361$var$TABLET_MEDIA_QUERY = "@media (min-width: 768px) and (max-width: 1279px)";
const $80cd39a44f20f361$var$MOBILE_MEDIA_QUERY = "@media (max-width: 767px)";
const $80cd39a44f20f361$var$DESKTOP_MEDIA_QUERY = "@media (min-width: 1280px)";
const $80cd39a44f20f361$var$YEAR = new Date().getFullYear();
const $80cd39a44f20f361$var$COPYRIGHT = `Copyright © ${$80cd39a44f20f361$var$YEAR} Atlassian`;
const $80cd39a44f20f361$var$FooterLink = ({ href: href , onClick: onClick , text: text , styles: styles = []  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("a", {
        href: href,
        onClick: onClick,
        css: [
            $80cd39a44f20f361$var$linkStyle,
            ...styles
        ],
        children: text
    });
const $80cd39a44f20f361$var$FORUMS_URL = (0, $1ff01338112cd7fe$export$fe0105b4860d6e11)[(0, $1ff01338112cd7fe$export$93d048dc21eb282a).FORUMS];
const $80cd39a44f20f361$var$getForumsUrl = (url, isLoggedIn, email)=>isLoggedIn ? (0, $3dba2111a1a6d39b$export$1db7da00354b15ed)({
        email: email,
        redirectUrl: url
    }) : url;
const $80cd39a44f20f361$export$7a92b4adf6bd95bb = ({ reportAProblemCallback: reportAProblemCallback , isLoggedIn: isLoggedIn = false , showChampions: showChampions = false , email: email , licenseData: licenseData  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(false);
    const openModal = (0, $hgUW1$useCallback)(()=>setIsOpen(true), []);
    const closeModal = (0, $hgUW1$useCallback)(()=>setIsOpen(false), []);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $80cd39a44f20f361$var$footerBackgroundStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $80cd39a44f20f361$var$footerWrapperStyles,
            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $80cd39a44f20f361$var$footerStyle,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $80cd39a44f20f361$var$innerDivStyle,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $80cd39a44f20f361$var$logoContainerStyle,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $80cd39a44f20f361$var$logoStyle,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AtlassianIcon), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $80cd39a44f20f361$var$columnsContainerStyle,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $80cd39a44f20f361$var$columnStyle,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                            css: $80cd39a44f20f361$var$headerStyle,
                                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                                href: "/",
                                                css: $80cd39a44f20f361$var$linkStyle,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a950778dc3003c4a$export$71f050e2efa708bb), {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Community"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: $80cd39a44f20f361$var$columnStyle,
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                                css: $80cd39a44f20f361$var$headerStyle,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                                    href: $80cd39a44f20f361$var$getForumsUrl($80cd39a44f20f361$var$FORUMS_URL, isLoggedIn, email),
                                                    css: $80cd39a44f20f361$var$linkStyle,
                                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a950778dc3003c4a$export$71f050e2efa708bb), {
                                                        size: "medium",
                                                        fontWeight: "semibold",
                                                        children: "Forums"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                                href: $80cd39a44f20f361$var$getForumsUrl(`${$80cd39a44f20f361$var$FORUMS_URL}/help/faqpage`, isLoggedIn, email),
                                                text: "FAQs"
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                                href: $80cd39a44f20f361$var$getForumsUrl(`${$80cd39a44f20f361$var$FORUMS_URL}/custom/page/page-id/rules-of-engagement`, isLoggedIn, email),
                                                text: "Forums guidelines"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: $80cd39a44f20f361$var$columnStyle,
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                                css: $80cd39a44f20f361$var$headerStyle,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                                    href: (0, $1ff01338112cd7fe$export$fe0105b4860d6e11)[(0, $1ff01338112cd7fe$export$93d048dc21eb282a).LEARNING],
                                                    css: $80cd39a44f20f361$var$linkStyle,
                                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a950778dc3003c4a$export$71f050e2efa708bb), {
                                                        size: "medium",
                                                        fontWeight: "semibold",
                                                        children: "Learning"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                                href: "https://university.atlassian.com/student/activity/836764-about-us",
                                                text: "About learning"
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                                href: "https://university.atlassian.com/student/activity/1938006-resources-and-support",
                                                text: "Resources"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $80cd39a44f20f361$var$columnStyle,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                            css: $80cd39a44f20f361$var$headerStyle,
                                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                                href: (0, $1ff01338112cd7fe$export$fe0105b4860d6e11)[(0, $1ff01338112cd7fe$export$93d048dc21eb282a).EVENTS],
                                                css: $80cd39a44f20f361$var$linkStyle,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a950778dc3003c4a$export$71f050e2efa708bb), {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Events"
                                                })
                                            })
                                        })
                                    }),
                                    showChampions && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $80cd39a44f20f361$var$columnStyle,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                            css: $80cd39a44f20f361$var$headerStyle,
                                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                                href: (0, $1ff01338112cd7fe$export$fe0105b4860d6e11)[(0, $1ff01338112cd7fe$export$93d048dc21eb282a).CHAMPIONS],
                                                css: $80cd39a44f20f361$var$linkStyle,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a950778dc3003c4a$export$71f050e2efa708bb), {
                                                    size: "medium",
                                                    fontWeight: "semibold",
                                                    children: "Champions"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $80cd39a44f20f361$var$bottomDivStyle,
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: $80cd39a44f20f361$var$bottomContentStyle,
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: $80cd39a44f20f361$var$copyrightText,
                                    children: $80cd39a44f20f361$var$COPYRIGHT
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                    css: $80cd39a44f20f361$var$bottomLinksContainerStyle,
                                    children: [
                                        reportAProblemCallback && /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                            onClick: reportAProblemCallback,
                                            text: "Report a problem",
                                            styles: [
                                                $80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                            text: "Privacy Policy",
                                            styles: [
                                                $80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/legal/community-platform-terms-of-use",
                                            text: "Terms",
                                            styles: [
                                                $80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                            href: "https://www.atlassian.com/trust/data-protection",
                                            text: "Security",
                                            styles: [
                                                $80cd39a44f20f361$var$bottomLinkStyle
                                            ]
                                        }),
                                        licenseData && /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $hgUW1$jsx)($80cd39a44f20f361$var$FooterLink, {
                                                    onClick: openModal,
                                                    text: "About",
                                                    styles: [
                                                        $80cd39a44f20f361$var$bottomLinkStyle
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ModalTransition), {
                                                    children: isOpen && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a0eced43682c2d75$export$bd0c6e28f5d6b66e), {
                                                        ...licenseData,
                                                        closeModal: closeModal
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $80cd39a44f20f361$var$footerBackgroundStyles = (0, $hgUW1$css)({
    width: "100%",
    backgroundImage: `url(${(0, $85d9a99cb49b730f$export$f3cfc44c4eba4576)})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingTop: (0, $hgUW1$token)("space.200"),
    paddingBottom: (0, $hgUW1$token)("space.200"),
    boxSizing: "border-box",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        backgroundImage: `url(${(0, $85d9a99cb49b730f$export$7d22dc8c5b0cc81c)})`
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        backgroundImage: `url(${(0, $85d9a99cb49b730f$export$eca0cf64e1927e60)})`
    }
});
const $80cd39a44f20f361$var$footerWrapperStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "100%",
    fontFamily: "Inter, sans-serif",
    [$80cd39a44f20f361$var$DESKTOP_MEDIA_QUERY]: {
        maxWidth: "1234px"
    },
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        maxWidth: "720px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        paddingLeft: "20px",
        paddingRight: "20px"
    }
});
const $80cd39a44f20f361$var$footerStyle = (0, $hgUW1$css)({
    borderRadius: "0px 0px 24px 24px",
    width: "100%",
    margin: "0 auto",
    backgroundColor: "#F8F8F8",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        padding: "0 16px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "24px",
        textAlign: "left"
    }
});
const $80cd39a44f20f361$var$linkStyle = (0, $hgUW1$css)({
    display: "inline",
    fontSize: "12px",
    fontWeight: 400,
    color: (0, $hgUW1$token)("color.text"),
    textDecoration: "none",
    "&:hover": {
        textDecoration: "underline",
        textDecorationColor: (0, $hgUW1$token)("color.text"),
        color: (0, $hgUW1$token)("color.text"),
        cursor: "pointer"
    }
});
const $80cd39a44f20f361$var$innerDivStyle = (0, $hgUW1$css)({
    padding: "24px 24px",
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        flexDirection: "column",
        alignItems: "flex-start"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: "0px",
        paddingBottom: "8px"
    }
});
const $80cd39a44f20f361$var$logoContainerStyle = (0, $hgUW1$css)({
    width: "420px",
    display: "flex",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        justifyContent: "flex-start",
        width: "120px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginBottom: "16px",
        width: "120px"
    }
});
const $80cd39a44f20f361$var$logoStyle = (0, $hgUW1$css)({
    svg: {
        color: (0, $hgUW1$token)("color.icon.brand"),
        transform: `scale(0.9)`
    },
    marginLeft: "24px",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        marginLeft: "0",
        marginBottom: "8px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginLeft: "0",
        paddingLeft: "0"
    }
});
const $80cd39a44f20f361$var$columnsContainerStyle = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        gap: "16px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        width: "100%",
        flexDirection: "column",
        gap: "0"
    }
});
const $80cd39a44f20f361$var$columnStyle = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "120px",
    textAlign: "left",
    gap: "12px",
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        width: "100%",
        marginBottom: "16px"
    }
});
const $80cd39a44f20f361$var$headerStyle = (0, $hgUW1$css)({
    marginBottom: "4px"
});
const $80cd39a44f20f361$var$bottomDivStyle = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        padding: "0 0px"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        justifyContent: "flex-start",
        width: "100%",
        paddingLeft: "0",
        paddingRight: "0"
    }
});
const $80cd39a44f20f361$var$copyrightText = (0, $hgUW1$css)({
    marginLeft: "0px",
    fontSize: "12px",
    color: (0, $hgUW1$token)("color.text.subtle")
});
const $80cd39a44f20f361$var$bottomContentStyle = (0, $hgUW1$css)({
    width: "100%",
    maxWidth: "calc(100% - 48px)",
    paddingTop: "16px",
    paddingBottom: "24px",
    paddingLeft: "24px",
    paddingRight: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    [$80cd39a44f20f361$var$TABLET_MEDIA_QUERY]: {
        paddingLeft: "0",
        paddingRight: "0"
    },
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        maxWidth: "100%",
        justifyContent: "flex-start",
        flexDirection: "column-reverse",
        alignItems: "flex-start",
        paddingLeft: "24px",
        paddingRight: "0"
    }
});
const $80cd39a44f20f361$var$bottomLinkStyle = (0, $hgUW1$css)({
    display: "inline",
    marginLeft: "32px",
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        marginLeft: "0"
    }
});
const $80cd39a44f20f361$var$bottomLinksContainerStyle = (0, $hgUW1$css)({
    [$80cd39a44f20f361$var$MOBILE_MEDIA_QUERY]: {
        // match columnStyle
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        textAlign: "left",
        marginTop: "0",
        marginBottom: "32px",
        gap: "12px"
    }
});
var $80cd39a44f20f361$export$2e2bcd8739ae039 = $80cd39a44f20f361$export$7a92b4adf6bd95bb;


var $fff41b96fcd62262$exports = {};

$parcel$export($fff41b96fcd62262$exports, "WelcomeModal", () => $fff41b96fcd62262$export$9d12d42929c3fcf);






const $fff41b96fcd62262$export$9d12d42929c3fcf = ({ onAccept: onAccept , onCancel: onCancel , coverImageSrc: coverImageSrc  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitmodaldialog), {
        onClose: onCancel,
        width: "auto",
        shouldCloseOnEscapePress: false,
        shouldCloseOnOverlayClick: false,
        shouldScrollInViewport: true,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $fff41b96fcd62262$var$modalContainerStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $fff41b96fcd62262$var$modalImageContainerStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                        src: coverImageSrc,
                        alt: "cover",
                        css: $fff41b96fcd62262$var$coverImageStyles
                    })
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $fff41b96fcd62262$var$modalBodyStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("h1", {
                            css: $fff41b96fcd62262$var$modalHeadingContainerStyles,
                            children: "Welcome to the new Atlassian Community"
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            css: $fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: "Online forums and learning are now in one easy-to-use experience."
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                            css: $fff41b96fcd62262$var$modalSubheadingContainerStyles,
                            children: [
                                "By continuing, you accept the updated",
                                " ",
                                /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                    href: (0, $1ff01338112cd7fe$export$bc6e44c7f1ae99f6),
                                    target: "_blank",
                                    children: "Community Terms of Use"
                                }),
                                " ",
                                "and acknowledge the",
                                " ",
                                /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                    href: (0, $1ff01338112cd7fe$export$30786e8ac20c09d8),
                                    target: "_blank",
                                    children: "Privacy Policy"
                                }),
                                ". Your public name, photo, and achievements may be publicly visible and available in search engines."
                            ]
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: $fff41b96fcd62262$var$modalButtonContainerStyles,
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $fff41b96fcd62262$var$buttonStyle,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$atlaskitbuttonnew), {
                                        appearance: "subtle",
                                        onClick: onCancel,
                                        children: [
                                            " ",
                                            "Cancel and logout"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $fff41b96fcd62262$var$buttonStyle,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitbuttonnew), {
                                        appearance: "primary",
                                        onClick: onAccept,
                                        children: "Accept and continue"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $fff41b96fcd62262$var$buttonStyle = (0, $hgUW1$css)({
    fontSize: "16px",
    "& span": {
        fontWeight: "600"
    }
});
const $fff41b96fcd62262$var$coverImageStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "auto",
    display: "block"
});
const $fff41b96fcd62262$var$modalContainerStyles = (0, $hgUW1$css)({
    maxWidth: "600px",
    margin: "0 auto"
});
const $fff41b96fcd62262$var$modalImageContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    overflow: "hidden"
});
const $fff41b96fcd62262$var$modalBodyStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px"
});
const $fff41b96fcd62262$var$modalHeadingContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    paddingTop: "24px",
    fontWeight: 700,
    textAlign: "center"
});
const $fff41b96fcd62262$var$modalSubheadingContainerStyles = (0, $hgUW1$css)({
    fontSize: "16px",
    marginTop: "16px",
    fontFamily: "Inter",
    textAlign: "center",
    marginBottom: "24px"
});
const $fff41b96fcd62262$var$modalButtonContainerStyles = (0, $hgUW1$css)({
    paddingTop: "16px",
    display: "flex",
    justifyContent: "center",
    gap: "8px"
});


$parcel$exportWildcard($a6a41c835fd01d00$exports, $1ca64a7075ab6eae$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $60ab015507144a2b$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $57b1d5df6b5425d4$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $4be7278e65b71184$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $db9d361cdef36cb6$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $e6da040d2ca2c72a$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $9c7edcd33b2e220b$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $3ec1f71319ba0295$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $7cbc56ac0bc2e1de$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $fc6addd2061b87dd$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $01ef21c48d795edb$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $80cd39a44f20f361$exports);
$parcel$exportWildcard($a6a41c835fd01d00$exports, $fff41b96fcd62262$exports);







const $2db63308c0b2527b$export$b56677d67e73c7be = ({ response: response , isLoading: isLoading  })=>{
    const { message: message , isError: responseError  } = response;
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $2db63308c0b2527b$var$inputStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Field), {
            name: "email",
            label: "Email address",
            defaultValue: "",
            children: ({ fieldProps: fieldProps , error: error  })=>{
                const displayMessage = error || message;
                const displayType = error || responseError ? "error" : "valid";
                return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment1), {
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: $2db63308c0b2527b$var$inputButtonFlex,
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1ca64a7075ab6eae$export$2c73285ae9390cec), {
                                    ...fieldProps,
                                    required: true,
                                    type: "email",
                                    autoComplete: "off",
                                    placeholder: "yourname@email.com"
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $2db63308c0b2527b$export$a3b9b213fa74e4fd,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Sign up",
                                        type: "submit",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        isLoading: isLoading,
                                        fullWidth: true
                                    })
                                })
                            ]
                        }),
                        displayMessage ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $60ab015507144a2b$export$9144c5f9beecc4b7), {
                            type: displayType,
                            message: displayMessage
                        }) : null
                    ]
                });
            }
        })
    });
};
const $2db63308c0b2527b$var$inputStyles = (0, $hgUW1$css)({
    "& label": {
        fontWeight: 400
    }
});
const $2db63308c0b2527b$var$inputButtonFlex = (0, $hgUW1$css)({
    display: "flex",
    alignContent: "center",
    gap: (0, $hgUW1$token)("space.100")
});
const $2db63308c0b2527b$export$a3b9b213fa74e4fd = ({ isMobile: isMobile  })=>(0, $hgUW1$css)({
        minWidth: "fit-content",
        display: isMobile ? "none" : "block",
        marginTop: isMobile ? (0, $hgUW1$token)("space.200") : 0,
        [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).MOBILE.MEDIA_QUERY]: {
            minWidth: "100%",
            display: isMobile ? "block" : "none"
        }
    });


const $d51a9a1c56c91a16$export$eefa3b352a86957 = "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers";
const $d51a9a1c56c91a16$export$ecf6508459835aaf = "By signing up, you agree to receive promotional emails including product news, events, and more from Atlassian and its affiliates, and acknowledge and accept the ";
const $d51a9a1c56c91a16$export$ec00f1754868e2a2 = ({ response: response , onSubmit: onSubmit  })=>{
    const handleSubmit = async (data)=>{
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const errors = {
            email: !emailPattern.test(data.email) ? "Enter a valid email address." : undefined
        };
        if (!errors.email) await onSubmit(data);
        return errors;
    };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitform), {
        onSubmit: handleSubmit,
        children: ({ formProps: formProps , submitting: submitting  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("form", {
                ...formProps,
                css: $d51a9a1c56c91a16$var$formWrapperStyles,
                "data-testid": "signup-form",
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $d51a9a1c56c91a16$var$formActionStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $2db63308c0b2527b$export$b56677d67e73c7be), {
                                response: response,
                                isLoading: submitting
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: (0, $2db63308c0b2527b$export$a3b9b213fa74e4fd)({
                                    isMobile: true
                                }),
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    label: "Sign up",
                                    type: "submit",
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                    isLoading: submitting,
                                    fullWidth: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                        css: $d51a9a1c56c91a16$var$acknowledgeStyle,
                        children: [
                            $d51a9a1c56c91a16$export$ecf6508459835aaf,
                            /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                href: $d51a9a1c56c91a16$export$eefa3b352a86957,
                                target: "_blank",
                                children: "Atlassian Privacy Policy"
                            }),
                            "."
                        ]
                    })
                ]
            })
    });
};
const $d51a9a1c56c91a16$var$formWrapperStyles = (0, $hgUW1$css)({
    width: "100%",
    paddingLeft: (0, $hgUW1$token)("space.800"),
    paddingRight: (0, $hgUW1$token)("space.800"),
    [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).MOBILE.MEDIA_QUERY]: {
        padding: 0
    },
    [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MEDIA_QUERY]: {
        marginTop: (0, $hgUW1$token)("space.300")
    },
    [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MEDIA_QUERY]: {
        marginTop: (0, $hgUW1$token)("space.400")
    }
});
const $d51a9a1c56c91a16$var$formActionStyles = (0, $hgUW1$css)({
    [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).MOBILE.MEDIA_QUERY]: {
        flexDirection: "column",
        gap: (0, $hgUW1$token)("space.200")
    }
});
const $d51a9a1c56c91a16$var$acknowledgeStyle = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    maxWidth: "405px",
    color: (0, $hgUW1$token)("color.text.subtlest"),
    fontWeight: "400",
    fontSize: "12px",
    marginTop: (0, $hgUW1$token)("space.100"),
    "& a": {
        color: (0, $hgUW1$token)("color.text.selected")
    },
    [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).MOBILE.MEDIA_QUERY]: {
        maxWidth: "unset"
    }
});


var $ca43fe01b6155439$exports = {};
var $3ced3ef7e9864bf1$exports = {};

$parcel$export($3ced3ef7e9864bf1$exports, "DESKTOP_SCREEN_WIDTH", () => $3ced3ef7e9864bf1$export$27ed77542911fb0e);
$parcel$export($3ced3ef7e9864bf1$exports, "useDeviceSize", () => $3ced3ef7e9864bf1$export$4616d33c54ae5baf);

// Default to a common desktop device width (is used to handle window object not being available during SSR)
const $3ced3ef7e9864bf1$var$DEFAULT_WIDTH = 1440;
const $3ced3ef7e9864bf1$export$27ed77542911fb0e = 1024;
const $3ced3ef7e9864bf1$export$4616d33c54ae5baf = ()=>{
    const [width, setWidth] = (0, $hgUW1$useState)(typeof window !== "undefined" ? window.innerWidth : $3ced3ef7e9864bf1$var$DEFAULT_WIDTH);
    const handleWindowResize = ()=>{
        setWidth(window.innerWidth);
    };
    (0, $hgUW1$useEffect)(()=>{
        if (typeof window === "undefined") return;
        if (width === $3ced3ef7e9864bf1$var$DEFAULT_WIDTH && width !== window.innerWidth) handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    }, []);
    return width;
};




var $cbd57b1b072c1da3$exports = {};

$parcel$export($cbd57b1b072c1da3$exports, "usePostNewsletterSignup", () => $cbd57b1b072c1da3$export$ea96d97e8873ca7f);


const $cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE = "community_learning_signup";
const $cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF = "pointALead";
const $cbd57b1b072c1da3$var$WAC_BASE_URL = {
    [(0, $1ff01338112cd7fe$export$7dc6752a22ab011a).LOCAL]: "/api/wac",
    [(0, $1ff01338112cd7fe$export$7dc6752a22ab011a).DEVELOPMENT]: "https://wac.stg.internal.atlassian.com",
    [(0, $1ff01338112cd7fe$export$7dc6752a22ab011a).STAGING]: "https://wac.stg.internal.atlassian.com",
    [(0, $1ff01338112cd7fe$export$7dc6752a22ab011a).PRODUCTION]: "https://www.atlassian.com"
};
// Initiates POST to /streamhub/wacformlead
// Endpoint in: https://bitbucket.org/atlassian/bxp-express/src/routes/streamhubSubmission.ts
const $cbd57b1b072c1da3$var$postNewsletterSignup = async (formValues, environment)=>{
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...formValues,
            formType: $cbd57b1b072c1da3$var$NEWSLETTER_FORM_TYPE,
            formDef: $cbd57b1b072c1da3$var$NEWSLETTER_FORM_DEF
        })
    };
    return fetch($cbd57b1b072c1da3$var$WAC_BASE_URL[environment] + "/endpoint/streamhub/wacformlead", requestOptions);
};
const $cbd57b1b072c1da3$export$ea96d97e8873ca7f = (environment = (0, $1ff01338112cd7fe$export$7dc6752a22ab011a).DEVELOPMENT)=>{
    const [loading, setLoading] = (0, $hgUW1$useState)(false);
    const [error, setError] = (0, $hgUW1$useState)(null);
    const [success, setSuccess] = (0, $hgUW1$useState)(false);
    const handleNewsletterSignup = async (formValues)=>{
        setLoading(true);
        setError(null);
        setSuccess(false);
        try {
            const response = await $cbd57b1b072c1da3$var$postNewsletterSignup(formValues, environment);
            if (!response.ok || response.status !== 200) throw new Error(`Error with status: ${response.status}`);
            setSuccess(true);
        } catch (err) {
            setError(err.message);
        } finally{
            setLoading(false);
        }
    };
    return {
        handleNewsletterSignup: handleNewsletterSignup,
        loading: loading,
        error: error,
        success: success
    };
};


$parcel$exportWildcard($ca43fe01b6155439$exports, $3ced3ef7e9864bf1$exports);
$parcel$exportWildcard($ca43fe01b6155439$exports, $965a3cfbe886b380$exports);
$parcel$exportWildcard($ca43fe01b6155439$exports, $6e8a4d5d78071ed7$exports);
$parcel$exportWildcard($ca43fe01b6155439$exports, $cbd57b1b072c1da3$exports);


const $1db60c687807de63$export$5620dbefc1cb6f80 = "You’re on the list! Thanks for signing up.";
const $1db60c687807de63$export$3f27bc10068ef877 = "Something went wrong. Try again.";
const $1db60c687807de63$export$21041608e6399292 = ({ environment: environment , ...rest })=>{
    const { handleNewsletterSignup: handleNewsletterSignup , error: error , success: success  } = (0, $cbd57b1b072c1da3$export$ea96d97e8873ca7f)(environment);
    const onSubmit = async ({ email: email  })=>{
        await handleNewsletterSignup({
            email: email,
            ...rest
        });
    };
    const successMessage = success ? $1db60c687807de63$export$5620dbefc1cb6f80 : undefined;
    const responseMessage = error ? $1db60c687807de63$export$3f27bc10068ef877 : successMessage;
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $1db60c687807de63$var$signUpWrapper,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $1db60c687807de63$var$stack,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $eb8aa702a3355ad4$export$260d8f4a67dc36b0), {}),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("h2", {
                        css: $1db60c687807de63$var$headingStyles,
                        children: [
                            "Sign up for the community ",
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                children: "newsletter"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $1db60c687807de63$var$descriptionStyles,
                        children: "Get the latest resources, tips, and trends to help you grow."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d51a9a1c56c91a16$export$ec00f1754868e2a2), {
                response: {
                    message: responseMessage,
                    isError: Boolean(error)
                },
                onSubmit: onSubmit
            })
        ]
    });
};
const $1db60c687807de63$var$signUpWrapper = (0, $hgUW1$css)({
    margin: "0 auto",
    maxWidth: "624px"
});
const $1db60c687807de63$var$stack = (0, $hgUW1$css)({
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: (0, $hgUW1$token)("space.100")
});
const $1db60c687807de63$var$headingStyles = (0, $hgUW1$css)({
    fontFamily: '"Charlie Display", sans-serif',
    color: (0, $hgUW1$token)("color.text"),
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    "& span": {
        display: "block",
        [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).MOBILE.MEDIA_QUERY]: {
            display: "inline-block"
        }
    },
    [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MEDIA_QUERY]: {
        fontSize: "32px"
    },
    [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).MOBILE.MEDIA_QUERY]: {
        width: "340px",
        fontSize: "32px"
    }
});
const $1db60c687807de63$var$descriptionStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    color: (0, $hgUW1$token)("color.text"),
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "32px",
    marginTop: 0,
    [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MEDIA_QUERY]: {
        fontSize: "20px"
    },
    [(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).MOBILE.MEDIA_QUERY]: {
        fontSize: "16px",
        lineHeight: "24px"
    }
});


$parcel$exportWildcard($5d4509b60606b6df$exports, $660bd1c6cb41002a$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $fec02fc26c7e145d$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $d501466973a9f0a6$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $c4979bfceee73878$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $0903e93de01b205a$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $a950778dc3003c4a$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $582583ec420fce57$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $a02a6f7de308273b$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $1298c86a7e6a9fc7$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $4fce8dfc4ce8f546$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $800df40a54823a3f$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $25cbe9fdb2d8d071$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $3fbcb32390ca7008$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $731a4fd527bab680$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $5cf70e33bfc6ce73$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $8b54d37779d052e8$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $9cfa05d02afa3952$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $7d458ed59bb9c6a8$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $a467abe0c2c1750b$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $52124b9ae1d78e04$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $6e2eae4c8556b5b9$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $4366d2b05f9f8f6b$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $be203e745bcefb12$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $a0eced43682c2d75$exports);
$parcel$exportWildcard($5d4509b60606b6df$exports, $1db60c687807de63$exports);


var $6e379ec2eca3d7d3$exports = {};
var $83fc18f8199a12ff$exports = {};

$parcel$export($83fc18f8199a12ff$exports, "AudioPlayer", () => $83fc18f8199a12ff$export$832cc5475f11d8b4);







const $83fc18f8199a12ff$export$832cc5475f11d8b4 = ({ source: source , isOpened: isOpened , onClose: onClose , onControlClick: onControlClick , onProgressUpdate: onProgressUpdate , onError: onError  })=>{
    const audioRef = (0, $hgUW1$useRef)(null);
    const focusRef = (0, $hgUW1$useRef)(null);
    const playerSource = {
        type: "audio",
        sources: [
            {
                src: source
            }
        ]
    };
    const playerOptions = {
        hideControls: true,
        controls: [
            "play",
            "progress",
            "current-time"
        ]
    };
    const addEvents = (0, $hgUW1$useCallback)((instance)=>{
        addEvent(instance, "play");
        addEvent(instance, "pause");
        if (onError) instance.on("error", onError);
    }, [
        onControlClick,
        onError
    ]);
    const addEvent = (0, $hgUW1$useCallback)((instance, event)=>{
        instance.on(event, ()=>onControlClick && onControlClick(event));
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2));
        });
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        const player = new (0, $hgUW1$plyrdistplyr)(audioRef.current, playerOptions);
        player.source = playerSource;
        addEvents(player);
        //To avoid: aria-label attribute is not well supported on a div with no valid role attribute.
        const plyrTimer = document.getElementsByClassName("plyr__time")[0];
        if (plyrTimer) plyrTimer.removeAttribute("aria-label");
        if (isOpened) focusRef.current?.focus();
        const plyrAudioContainer = document.getElementsByClassName("plyr--audio")[0];
        if (plyrAudioContainer) plyrAudioContainer.role = "presentation";
    }, [
        isOpened
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClose();
        }
    }, [
        onClose
    ]);
    return isOpened && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        ref: focusRef,
        tabIndex: 0,
        css: $83fc18f8199a12ff$var$audioPlayerStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("figure", {
            "data-testid": "audio-player",
            css: $83fc18f8199a12ff$var$figureStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("audio", {
                    tabIndex: 0,
                    role: "presentation",
                    ref: audioRef
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    onClick: onClose,
                    css: $83fc18f8199a12ff$var$closeIconStyles,
                    "data-testid": "close-audio",
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: "cross",
                        color: (0, $hgUW1$token)("color.icon.subtle"),
                        alt: "close-audio"
                    })
                })
            ]
        })
    });
};
const $83fc18f8199a12ff$var$audioPlayerStyles = (0, $hgUW1$css)({
    borderRadius: "8px",
    maxWidth: "340px",
    padding: "24px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay"),
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    ".plyr--audio": {
        width: "100%",
        "--plyr-color-main": (0, $hgUW1$B300),
        "--plyr-audio-control-color": (0, $hgUW1$N0),
        "--plyr-control-icon-size": "16px",
        "--plyr-range-thumb-height": "8px",
        "--plyr-range-track-height": "8px",
        "--plyr-range-thumb-shadow": "none",
        "--plyr-audio-progress-buffered-background": (0, $hgUW1$N60),
        "--plyr-font-family": "Charlie Text",
        "--plyr-tooltip-background": (0, $hgUW1$N500),
        "--plyr-tooltip-color": (0, $hgUW1$N0),
        "--plyr-tooltip-radius": "8px",
        "--plyr-control-spacing": "16px",
        "--plyr-range-thumb-background": (0, $hgUW1$B300)
    },
    ".plyr--audio > .plyr__controls": {
        padding: 0
    },
    ".plyr--audio > .plyr__controls > .plyr__control": {
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "16px",
        backgroundColor: (0, $hgUW1$token)("color.background.information.bold"),
        borderRadius: "50%"
    },
    ".plyr__progress": {
        marginRight: "16px"
    },
    ".icon--not-pressed": {
        marginRight: "-3px"
    },
    ".plyr__time": {
        fontFamily: "Inter, sans-serif",
        color: (0, $hgUW1$token)("color.text.subtlest"),
        fontSize: "14px",
        fontWeight: 600
    },
    ".plyr--audio:focus, .plyr--audio:focus-visible": {
        border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $83fc18f8199a12ff$var$figureStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0
});
const $83fc18f8199a12ff$var$closeIconStyles = (0, $hgUW1$css)({
    display: "flex",
    cursor: "pointer",
    marginLeft: "4px"
});


var $389dbaf1c04dd698$exports = {};

$parcel$export($389dbaf1c04dd698$exports, "BadgeCard", () => $389dbaf1c04dd698$export$22da447a4012011);






const $389dbaf1c04dd698$export$22da447a4012011 = ({ image: image , badgeTitle: badgeTitle , earnedDate: earnedDate , link: link , onClick: onClick  })=>{
    const clickHandler = (0, $hgUW1$useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(clickHandler), []);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $389dbaf1c04dd698$var$containerStyles,
        tabIndex: 0,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "badge-card",
        children: [
            image && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1298c86a7e6a9fc7$export$3e431a229df88919), {
                    ...image,
                    width: 64,
                    height: 64,
                    preventModal: true,
                    style: {
                        height: "64px",
                        objectFit: "contain"
                    }
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $389dbaf1c04dd698$var$contentContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $389dbaf1c04dd698$var$badgeTitleStyles,
                        children: badgeTitle
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                        css: $389dbaf1c04dd698$var$earnedDateStyles,
                        children: [
                            "Earned: ",
                            earnedDate
                        ]
                    })
                ]
            })
        ]
    });
};
const $389dbaf1c04dd698$var$containerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: (0, $hgUW1$token)("color.background.input"),
    border: `0 solid ${(0, $hgUW1$token)("color.border")}`,
    borderRadius: "4px",
    padding: "16px 12px",
    transition: "all 0.2s ease-in-out",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
    }
});
const $389dbaf1c04dd698$var$contentContainerStyles = (0, $hgUW1$css)({
    marginLeft: "16px"
});
const $389dbaf1c04dd698$var$badgeTitleStyles = (0, $hgUW1$css)({
    paddingBottom: "4px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    lineHeight: "20px",
    color: (0, $hgUW1$token)("color.text"),
    wordBreak: "break-word",
    margin: 0
});
const $389dbaf1c04dd698$var$earnedDateStyles = (0, $hgUW1$css)({
    fontSize: "14px",
    lineHeight: "20px",
    color: (0, $hgUW1$token)("color.text.subtlest"),
    fontFamily: "system-ui",
    fontWeight: "normal",
    wordBreak: "break-word",
    margin: 0
});


var $c18917e553fd2737$exports = {};

$parcel$export($c18917e553fd2737$exports, "CertificateCard", () => $c18917e553fd2737$export$c572aa3e2aa38d2);






const $c18917e553fd2737$export$c572aa3e2aa38d2 = ({ image: image , backgroundColor: backgroundColor , title: title , link: link , onClick: onClick  })=>{
    const clickHandler = (0, $hgUW1$useCallback)(()=>{
        if (onClick) onClick(link, "_self");
    }, [
        onClick,
        link
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(clickHandler), []);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        tabIndex: 0,
        css: $c18917e553fd2737$var$containerStyles,
        onClick: clickHandler,
        onKeyDown: handleKeyDown,
        "data-testid": "certificate-card",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    $c18917e553fd2737$var$cardHeaderStyles,
                    (0, $hgUW1$css)({
                        backgroundColor: backgroundColor
                    })
                ],
                "data-testid": "certificate-card-background",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $c18917e553fd2737$var$imageContainerStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1298c86a7e6a9fc7$export$3e431a229df88919), {
                        ...image,
                        width: 112,
                        height: 112,
                        preventModal: true,
                        style: {
                            objectFit: "contain"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $c18917e553fd2737$var$cardTitleStyles,
                children: title
            })
        ]
    });
};
const $c18917e553fd2737$var$containerStyles = (0, $hgUW1$css)({
    maxWidth: "280px",
    background: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "5px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    transition: "box-shadow 0.2s ease",
    "&:hover": {
        cursor: "pointer",
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
    }
});
const $c18917e553fd2737$var$cardHeaderStyles = (0, $hgUW1$css)({
    height: "66px",
    padding: "14px 16px 0",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px"
});
const $c18917e553fd2737$var$imageContainerStyles = (0, $hgUW1$css)({
    height: "112px",
    width: "112px"
});
const $c18917e553fd2737$var$cardTitleStyles = (0, $hgUW1$css)({
    padding: "0 16px 24px",
    marginTop: "76px",
    color: "N800",
    lineHeight: "20px",
    fontSize: "16px",
    fontFamily: "system-ui",
    fontWeight: 600,
    wordBreak: "break-word"
});


var $3ca3d702a74367ba$exports = {};

$parcel$export($3ca3d702a74367ba$exports, "ContentOverviewCardState", () => $3ca3d702a74367ba$export$84c408eab3fc01b3);
$parcel$export($3ca3d702a74367ba$exports, "ContentOverviewCard", () => $3ca3d702a74367ba$export$cb86f63bb5e77777);







var $ed20910b93d89c3f$exports = {};

$parcel$export($ed20910b93d89c3f$exports, "ContentType", () => $ed20910b93d89c3f$export$e2e108cbe2e4f865);
let $ed20910b93d89c3f$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType["LEARNING_PATH"] = "LEARNING_PATH";
    ContentType["COURSE"] = "COURSE";
    ContentType["LESSON"] = "LESSON";
})($ed20910b93d89c3f$export$e2e108cbe2e4f865 || ($ed20910b93d89c3f$export$e2e108cbe2e4f865 = {}));


let $3ca3d702a74367ba$export$84c408eab3fc01b3;
(function(ContentOverviewCardState) {
    ContentOverviewCardState["LOADING"] = "loading";
    ContentOverviewCardState["DEFAULT"] = "default";
    ContentOverviewCardState["IN_PROGRESS"] = "in_progress";
    ContentOverviewCardState["FINISHED"] = "finished";
})($3ca3d702a74367ba$export$84c408eab3fc01b3 || ($3ca3d702a74367ba$export$84c408eab3fc01b3 = {}));
const $3ca3d702a74367ba$export$cb86f63bb5e77777 = ({ inspectMode: inspectMode , state: state = $3ca3d702a74367ba$export$84c408eab3fc01b3.DEFAULT , heading: heading , subheading: subheading , tags: tags = [] , collapsedSectionItems: itemsSectionCollapsed = [] , collapsedSectionContent: infoSectionCollapsed = "" , collapsedSectionTitle: titleSectionCollapsed , contentType: contentType , onClickButton: onClickButton  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(false);
    const handleClickButton = (0, $hgUW1$useCallback)(()=>{
        if (onClickButton) onClickButton();
    }, [
        onClickButton
    ]);
    const handleToggleVisibility = (0, $hgUW1$useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
    }, []);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("article", {
        "aria-label": heading,
        css: [
            $3ca3d702a74367ba$var$articleContainerStyles,
            state === $3ca3d702a74367ba$export$84c408eab3fc01b3.FINISHED && (0, $hgUW1$css)({
                borderLeftColor: (0, $hgUW1$token)("color.border.success")
            })
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $3ca3d702a74367ba$var$containerStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                        "data-testid": "toggle-visibility",
                        "aria-label": isOpen ? "collapse" : "expand",
                        onClick: handleToggleVisibility,
                        css: $3ca3d702a74367ba$var$buttonStyles,
                        children: isOpen ? /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                type: "chevron-down"
                            })
                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $3ca3d702a74367ba$var$buttonIconSpanStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                type: "chevron-right"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $3ca3d702a74367ba$var$gridContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $3ca3d702a74367ba$var$gridItemStyles,
                                children: [
                                    tags.length > 0 && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $3ca3d702a74367ba$var$tagContainerStyles,
                                        children: tags?.map((tag, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                                css: $3ca3d702a74367ba$var$tagStyles,
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                                                    inspectMode: tag.inspectMode && {
                                                        tag: tag.inspectMode.duration
                                                    },
                                                    label: tag.label
                                                })
                                            }, `tag-${index}`))
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                                        css: $3ca3d702a74367ba$var$titleContainerStyles,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                                            level: 5,
                                            children: heading
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                        ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("description", inspectMode),
                                        css: $3ca3d702a74367ba$var$descriptionStyles,
                                        children: subheading
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $3ca3d702a74367ba$var$gridSideItemStyles,
                                children: [
                                    state === $3ca3d702a74367ba$export$84c408eab3fc01b3.LOADING && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "",
                                        isLoading: true
                                    }),
                                    state === $3ca3d702a74367ba$export$84c408eab3fc01b3.DEFAULT && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Get started",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        onClick: handleClickButton
                                    }),
                                    state === $3ca3d702a74367ba$export$84c408eab3fc01b3.IN_PROGRESS && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Continue",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).SECONDARY,
                                        onClick: handleClickButton
                                    }),
                                    state === $3ca3d702a74367ba$export$84c408eab3fc01b3.FINISHED && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: $3ca3d702a74367ba$var$finishedStateContainerStyles,
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                                css: (0, $hgUW1$css)({
                                                    marginRight: (0, $hgUW1$token)("space.100")
                                                }),
                                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a), {
                                                    link: "#",
                                                    label: `Review ${(0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).COURSE === contentType ? "lesson" : "course"}`,
                                                    onClick: handleClickButton
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                type: "check-circle",
                                                color: (0, $hgUW1$token)("color.icon.success")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                "data-testid": "section-expanded",
                css: [
                    $3ca3d702a74367ba$var$sectionExpandedStyles,
                    (0, $hgUW1$css)({
                        display: isOpen ? "block" : "none"
                    })
                ],
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $3ca3d702a74367ba$var$sectionContentStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                            color: (0, $hgUW1$token)("color.border"),
                            height: 1
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("sectionList", inspectMode),
                        css: $3ca3d702a74367ba$var$sectionListStyles,
                        children: [
                            titleSectionCollapsed && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $3ca3d702a74367ba$var$sectionTitleStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                                    level: 6,
                                    children: titleSectionCollapsed
                                })
                            }),
                            itemsSectionCollapsed.length > 0 && /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
                                css: $3ca3d702a74367ba$var$listStyles,
                                "aria-label": "collapsed section items",
                                children: itemsSectionCollapsed?.map((item, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                                        css: $3ca3d702a74367ba$var$itemStyles,
                                        children: item
                                    }, `item-${index}`))
                            }),
                            infoSectionCollapsed && infoSectionCollapsed
                        ]
                    })
                ]
            })
        ]
    });
};
const $3ca3d702a74367ba$var$articleContainerStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderLeft: `8px solid ${(0, $hgUW1$token)("color.border.brand")}`,
    borderRadius: "8px",
    padding: "16px 24px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised")
});
const $3ca3d702a74367ba$var$containerStyles = (0, $hgUW1$css)({
    padding: "16px 0",
    display: "flex",
    alignItems: "flex-start"
});
const $3ca3d702a74367ba$var$buttonStyles = (0, $hgUW1$css)({
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer"
});
const $3ca3d702a74367ba$var$buttonIconSpanStyles = (0, $hgUW1$css)({
    marginRight: "16px"
});
const $3ca3d702a74367ba$var$gridContainerStyles = (0, $hgUW1$css)({
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(12, minmax(0, 1fr))",
    [(0, $hgUW1$media).above.sm]: {
        columnGap: "16px",
        alignItems: "center"
    }
});
const $3ca3d702a74367ba$var$gridItemStyles = (0, $hgUW1$css)({
    gridColumn: "span 12",
    color: (0, $hgUW1$token)("color.text"),
    [(0, $hgUW1$media).above.sm]: {
        gridColumn: "span 9",
        color: (0, $hgUW1$token)("color.text")
    }
});
const $3ca3d702a74367ba$var$tagContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexWrap: "wrap"
});
const $3ca3d702a74367ba$var$tagStyles = (0, $hgUW1$css)({
    marginRight: "12px",
    "&:last-of-type": {
        marginRight: 0
    }
});
const $3ca3d702a74367ba$var$titleContainerStyles = (0, $hgUW1$css)({
    margin: "16px auto",
    [(0, $hgUW1$media).above.sm]: {
        marginRight: "1px"
    }
});
const $3ca3d702a74367ba$var$descriptionStyles = (0, $hgUW1$css)({
    display: "none",
    fontSize: "16px",
    margin: 0,
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter, sans-serif",
    [(0, $hgUW1$media).above.sm]: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        lineHeight: "1.5",
        color: (0, $hgUW1$token)("color.text")
    }
});
const $3ca3d702a74367ba$var$gridSideItemStyles = (0, $hgUW1$css)({
    gridColumn: "span 12",
    [(0, $hgUW1$media).above.sm]: {
        gridColumn: "span 3",
        justifySelf: "end"
    }
});
const $3ca3d702a74367ba$var$finishedStateContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    marginRight: "4px"
});
const $3ca3d702a74367ba$var$sectionExpandedStyles = (0, $hgUW1$css)({
    overflow: "hidden",
    transition: "ease-in-out 1000ms",
    paddingLeft: "40px"
});
const $3ca3d702a74367ba$var$sectionContentStyles = (0, $hgUW1$css)({
    margin: "8px 0"
});
const $3ca3d702a74367ba$var$sectionListStyles = (0, $hgUW1$css)({
    padding: "24px 0"
});
const $3ca3d702a74367ba$var$sectionTitleStyles = (0, $hgUW1$css)({
    marginBottom: "8px",
    textTransform: "uppercase"
});
const $3ca3d702a74367ba$var$listStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text"),
    fontSize: "14px",
    lineHeight: "20px",
    listStyleType: "disc",
    listStylePosition: "inside",
    paddingLeft: "4px",
    marginTop: 0,
    fontFamily: "Inter, sans-serif",
    [(0, $hgUW1$media).above.sm]: {
        fontSize: "16px",
        lineHeight: "1.714"
    }
});
const $3ca3d702a74367ba$var$itemStyles = (0, $hgUW1$css)({
    marginTop: 0,
    marginLeft: "20px",
    textIndent: "-20px"
});


var $e018ab7ed2648ae8$exports = {};

$parcel$export($e018ab7ed2648ae8$exports, "EmptyState", () => $e018ab7ed2648ae8$export$fddf379e22a74b00);







const $e018ab7ed2648ae8$export$fddf379e22a74b00 = ({ image: image , description: description , redirectLink: redirectLink  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        tabIndex: 0,
        css: $e018ab7ed2648ae8$var$containerStyles,
        "data-testid": "empty-state",
        children: [
            image && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $e018ab7ed2648ae8$var$imageContainerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1298c86a7e6a9fc7$export$3e431a229df88919), {
                    src: image.src,
                    alt: image.alt,
                    preventModal: true,
                    height: 96
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $e018ab7ed2648ae8$var$descriptionContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $e018ab7ed2648ae8$var$descriptionStyles,
                        children: description
                    }),
                    redirectLink && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a), {
                        label: redirectLink.label,
                        link: redirectLink.link,
                        style: (0, $4fce8dfc4ce8f546$export$2b77966d73aefa77).SEMIBOLD,
                        fontColor: (0, $hgUW1$token)("color.link"),
                        css: (0, $hgUW1$css)({
                            fontFamily: "system-ui"
                        })
                    })
                ]
            })
        ]
    });
const $e018ab7ed2648ae8$var$containerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    padding: "24px",
    border: "1px dashed",
    borderColor: (0, $hgUW1$N70),
    borderRadius: "4px",
    alignItems: "center"
});
const $e018ab7ed2648ae8$var$imageContainerStyles = (0, $hgUW1$css)({
    width: "64px",
    [(0, $hgUW1$media).above.sm]: {
        width: "96px"
    }
});
const $e018ab7ed2648ae8$var$descriptionContainerStyles = (0, $hgUW1$css)({
    marginLeft: "16px",
    lineHeight: "23px"
});
const $e018ab7ed2648ae8$var$descriptionStyles = (0, $hgUW1$css)({
    paddingBottom: "2px",
    margin: 0,
    fontFamily: "system-ui",
    fontSize: "16px",
    color: (0, $hgUW1$token)("color.text"),
    fontWeight: "normal",
    wordBreak: "break-word",
    lineHeight: 1.714
});


var $81dd635d83decaee$exports = {};

$parcel$export($81dd635d83decaee$exports, "InlineFeedbackMessageAppearance", () => $81dd635d83decaee$export$f9292ef28b7b429a);
$parcel$export($81dd635d83decaee$exports, "InlineFeedbackMessage", () => $81dd635d83decaee$export$f23c56ac9ab316f);






let $81dd635d83decaee$export$f9292ef28b7b429a;
(function(InlineFeedbackMessageAppearance) {
    InlineFeedbackMessageAppearance["INCORRECT"] = "INCORRECT";
    InlineFeedbackMessageAppearance["CORRECT"] = "CORRECT";
})($81dd635d83decaee$export$f9292ef28b7b429a || ($81dd635d83decaee$export$f9292ef28b7b429a = {}));
const $81dd635d83decaee$export$f23c56ac9ab316f = ({ title: title , description: description , appearance: appearance = $81dd635d83decaee$export$f9292ef28b7b429a.CORRECT  })=>{
    const isIncorrectAppearance = appearance === $81dd635d83decaee$export$f9292ef28b7b429a.INCORRECT;
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $81dd635d83decaee$var$feedbackMessageContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    $81dd635d83decaee$var$feedbackMessageLeftBorderStyles,
                    (0, $hgUW1$css)({
                        backgroundColor: `${isIncorrectAppearance ? (0, $hgUW1$token)("color.border.danger") : (0, $hgUW1$token)("color.border.success")}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                "data-testid": `feedback-message-${appearance}`,
                css: $81dd635d83decaee$var$feedbackMessageContentContainerStyles,
                children: [
                    isIncorrectAppearance ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: "error",
                        color: (0, $hgUW1$token)("color.border.danger")
                    }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: "check-circle",
                        color: (0, $hgUW1$token)("color.border.success")
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $81dd635d83decaee$var$feedbackMessageContentStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                css: $81dd635d83decaee$var$feedbackMessageTitleStyles,
                                children: title
                            }),
                            description && /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                css: $81dd635d83decaee$var$feedbackMessageDescriptionStyles,
                                children: description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $81dd635d83decaee$var$feedbackMessageContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    backgroundColor: (0, $hgUW1$token)("color.background.input")
});
const $81dd635d83decaee$var$feedbackMessageContentContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    padding: "24px 24px 24px 16px",
    display: "flex",
    border: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    borderRadius: "0 3px 3px 0",
    borderLeft: "none",
    [(0, $hgUW1$media).below.xs]: {
        padding: "16px 16px 16px 8px"
    }
});
const $81dd635d83decaee$var$feedbackMessageLeftBorderStyles = (0, $hgUW1$css)({
    maxHeight: "100%",
    width: "8px",
    borderRadius: "3px 0 0 3px"
});
const $81dd635d83decaee$var$feedbackMessageContentStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "16px",
    [(0, $hgUW1$media).below.xs]: {
        marginLeft: "8px"
    }
});
const $81dd635d83decaee$var$feedbackMessageTitleStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    color: (0, $hgUW1$token)("color.text"),
    margin: 0,
    [(0, $hgUW1$media).below.xs]: {
        fontSize: "16px"
    }
});
const $81dd635d83decaee$var$feedbackMessageDescriptionStyles = (0, $hgUW1$css)({
    marginTop: "16px",
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $hgUW1$token)("color.text"),
    marginBottom: 0,
    p: {
        margin: 0
    },
    [(0, $hgUW1$media).below.xs]: {
        marginTop: "8px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});


var $8d99d7c025746ac9$exports = {};

$parcel$export($8d99d7c025746ac9$exports, "LearningContentCard", () => $8d99d7c025746ac9$export$c01be50dd5c433fe);






var $2cfa64583f556289$exports = {};

$parcel$export($2cfa64583f556289$exports, "PopupShare", () => $2cfa64583f556289$export$477c64ffaba52edf);






const $2cfa64583f556289$export$477c64ffaba52edf = ({ showCopyLink: showCopyLink = true , shareOnFb: shareOnFb = true , shareOnLinkedin: shareOnLinkedin = true , shareOnPdf: shareOnPdf = false , onGeneratePdf: onGeneratePdf , backgroundColor: backgroundColor = "#FFFFFF" , urlToShare: urlToShare , alignToLeft: alignToLeft = false  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(false);
    const [isCopied, setIsCopied] = (0, $hgUW1$useState)(false);
    const dropdownRef = (0, $hgUW1$useRef)(null);
    const handleButtonClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setIsOpen(!isOpen);
    };
    const handleOnGeneratePDF = (event)=>{
        if (onGeneratePdf) {
            event.stopPropagation();
            event.preventDefault();
            onGeneratePdf();
            setIsOpen(!isOpen);
        }
    };
    const handleShare = (url)=>{
        window.open(url, "_blank");
    };
    const shareOnFacebook = ()=>{
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlToShare)}`;
        handleShare(facebookUrl);
    };
    const shareOnLinkedIn = ()=>{
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(urlToShare)}`;
        handleShare(linkedinUrl);
    };
    const copyToClipboard = (0, $hgUW1$useCallback)(()=>{
        navigator.clipboard.writeText(urlToShare).then(()=>{
            setIsCopied(true);
            setTimeout(()=>{
                setIsCopied(false);
            }, 2000);
        });
    }, [
        urlToShare
    ]);
    const onKeyDownLinkedIn = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(shareOnLinkedIn), []);
    const onKeyDownFacebook = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(shareOnFacebook), []);
    const onKeyDownGeneratePdf = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(()=>{
        if (onGeneratePdf) onGeneratePdf();
    }), [
        onGeneratePdf
    ]);
    (0, $hgUW1$useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: (0, $hgUW1$css)({
            width: "fit-content",
            position: "relative"
        }),
        "data-testid": "popup-share",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                label: "Share",
                appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                onClick: handleButtonClick,
                selected: isOpen,
                iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "share"
                }),
                iconType: "share"
            }),
            isOpen && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                "data-testid": "popup-share-dropdown",
                css: [
                    $2cfa64583f556289$var$popupShareDropdownStyles,
                    [
                        alignToLeft && (0, $hgUW1$css)({
                            width: "176px",
                            right: 0
                        }),
                        shareOnPdf && (0, $hgUW1$css)({
                            width: "220px"
                        })
                    ]
                ],
                style: {
                    backgroundColor: backgroundColor
                },
                children: [
                    showCopyLink && /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
                        onClick: copyToClipboard,
                        css: $2cfa64583f556289$var$copyToClipboardOptionStyles,
                        "aria-label": "copy to clipboard",
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                type: "link",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: (0, $hgUW1$css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem",
                                    fontFamily: "Charlie Text, sans-serif",
                                    color: (0, $hgUW1$token)("color.text")
                                }),
                                children: "Copy Link"
                            }),
                            isCopied && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: $2cfa64583f556289$var$isCopiedStyles,
                                children: "Copied!"
                            })
                        ]
                    }),
                    shareOnLinkedin && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        tabIndex: 0,
                        css: $2cfa64583f556289$var$shareOnLinkedInOptionStyles,
                        onClick: shareOnLinkedIn,
                        onKeyDown: onKeyDownLinkedIn,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                                    id: "g5891",
                                    children: [
                                        /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                            d: "M512,64c0,-35.323 -28.677,-64 -64,-64l-384,0c-35.323,0 -64,28.677 -64,64l0,384c0,35.323 28.677,64 64,64l384,0c35.323,0 64,-28.677 64,-64l0,-384Z",
                                            id: "background",
                                            style: {
                                                fill: "#2867b2"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                                            id: "shapes",
                                            children: [
                                                /*#__PURE__*/ (0, $hgUW1$jsx)("rect", {
                                                    height: "257.962",
                                                    id: "rect11",
                                                    style: {
                                                        fill: "#fff"
                                                    },
                                                    width: "85.76",
                                                    x: "61.053",
                                                    y: "178.667"
                                                }),
                                                /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                                    d: "M104.512,54.28c-29.341,0 -48.512,19.29 -48.512,44.573c0,24.752 18.588,44.574 47.377,44.574l0.554,0c29.903,0 48.516,-19.822 48.516,-44.574c-0.555,-25.283 -18.611,-44.573 -47.935,-44.573Z",
                                                    id: "path13-0",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                                    d: "M357.278,172.601c-45.49,0 -65.866,25.017 -77.276,42.589l0,-36.523l-85.738,0c1.137,24.197 0,257.961 0,257.961l85.737,0l0,-144.064c0,-7.711 0.554,-15.42 2.827,-20.931c6.188,-15.4 20.305,-31.352 43.993,-31.352c31.012,0 43.436,23.664 43.436,58.327l0,138.02l85.741,0l0,-147.93c0,-79.237 -42.305,-116.097 -98.72,-116.097Z",
                                                    id: "path15",
                                                    style: {
                                                        fill: "#fff",
                                                        fillRule: "nonzero"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: (0, $hgUW1$css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on Linkedin"
                            })
                        ]
                    }),
                    shareOnFb && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        tabIndex: 0,
                        css: $2cfa64583f556289$var$shareOnFacebookOptionStyles,
                        onClick: shareOnFacebook,
                        onKeyDown: onKeyDownFacebook,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                xmlnsXlink: "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: "0 0 512 512",
                                style: {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: "2",
                                    width: "1rem",
                                    height: "1rem"
                                },
                                xmlSpace: "preserve",
                                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("g", {
                                    children: [
                                        /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                            d: "M512,256c0,-141.385 -114.615,-256 -256,-256c-141.385,0 -256,114.615 -256,256c0,127.777 93.616,233.685 216,252.89l0,-178.89l-65,0l0,-74l65,0l0,-56.4c0,-64.16 38.219,-99.6 96.695,-99.6c28.009,0 57.305,5 57.305,5l0,63l-32.281,0c-31.801,0 -41.719,19.733 -41.719,39.978l0,48.022l71,0l-11.35,74l-59.65,0l0,178.89c122.385,-19.205 216,-125.113 216,-252.89Z",
                                            fill: "#1877f2",
                                            fillRule: "nonzero"
                                        }),
                                        /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                            d: "M355.65,330l11.35,-74l-71,0l0,-48.022c0,-20.245 9.917,-39.978 41.719,-39.978l32.281,0l0,-63c0,0 -29.297,-5 -57.305,-5c-58.476,0 -96.695,35.44 -96.695,99.6l0,56.4l-65,0l0,74l65,0l0,178.89c13.033,2.045 26.392,3.11 40,3.11c13.608,0 26.966,-1.065 40,-3.11l0,-178.89l59.65,0Z",
                                            fill: "#fff",
                                            fillRule: "nonzero"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: (0, $hgUW1$css)({
                                    marginLeft: "0.5rem",
                                    fontSize: "0.875rem",
                                    lineHeight: "1.25rem"
                                }),
                                children: "Share on Facebook"
                            })
                        ]
                    }),
                    shareOnPdf && onGeneratePdf && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        tabIndex: 0,
                        css: $2cfa64583f556289$var$shareOnPdfOptionStyles,
                        onClick: handleOnGeneratePDF,
                        onKeyDown: onKeyDownGeneratePdf,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $2cfa64583f556289$var$shareOnPdfTextStyles,
                            children: "Export to PDF"
                        })
                    })
                ]
            })
        ]
    });
};
const $2cfa64583f556289$var$popupShareDropdownStyles = (0, $hgUW1$css)({
    position: "absolute",
    marginTop: "0.5rem",
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.25rem",
    zIndex: 2,
    color: (0, $hgUW1$token)("color.text"),
    boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
});
const $2cfa64583f556289$var$copyToClipboardOptionStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.hovered")
    }
});
const $2cfa64583f556289$var$isCopiedStyles = (0, $hgUW1$css)({
    position: "absolute",
    backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtle.pressed"),
    color: (0, $hgUW1$token)("color.text"),
    fontSize: "0.688rem",
    lineHeight: "0.875rem",
    padding: "0.25rem",
    borderRadius: "0.25rem",
    marginTop: "0.25rem",
    right: "1rem"
});
const $2cfa64583f556289$var$shareOnLinkedInOptionStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.hovered")
    }
});
const $2cfa64583f556289$var$shareOnFacebookOptionStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "0.75rem",
    paddingRight: "1rem",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    ":hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.hovered")
    }
});
const $2cfa64583f556289$var$shareOnPdfOptionStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: `${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.200")} 24px`,
    gap: "8px",
    width: "220px",
    border: "none",
    transition: "background",
    transitionDuration: "300ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
    cursor: "pointer",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    ":hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.neutral.subtle.hovered")
    }
});
const $2cfa64583f556289$var$shareOnPdfTextStyles = (0, $hgUW1$css)({
    fontSize: "16px",
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    fontWeight: "400"
});


var $d8ee29df49af8811$exports = {};

$parcel$export($d8ee29df49af8811$exports, "LearningProgressBar", () => $d8ee29df49af8811$export$184a993f673fc83f);








const $d8ee29df49af8811$export$184a993f673fc83f = ({ completedResources: completedResources , resourceCount: resourceCount , completionDate: completionDate , contentType: contentType  })=>{
    const getProgressText = ()=>{
        switch(contentType){
            case (0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).COURSE:
                return `${completedResources} of ${resourceCount} lessons`;
            case (0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).LEARNING_PATH:
                return `${completedResources} of ${resourceCount} courses`;
            default:
                return `${Math.round((0, $fde9406d76ec24a9$export$6e67b290ed5690f6)(completedResources, resourceCount))}%`;
        }
    };
    if (completedResources === resourceCount) return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $d8ee29df49af8811$var$progressBarStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "gap-completed"
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                css: [
                    $d8ee29df49af8811$var$progressTitleStyles,
                    (0, $hgUW1$css)({
                        color: (0, $hgUW1$token)("color.text.success")
                    })
                ],
                children: [
                    "Completed ",
                    completionDate
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "learning-progress-bar-container",
        css: $d8ee29df49af8811$var$progressBarContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $d8ee29df49af8811$var$progressBarStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$CircularProgressbarWithChildren), {
                    strokeWidth: 10,
                    value: (0, $fde9406d76ec24a9$export$6e67b290ed5690f6)(completedResources, resourceCount),
                    styles: (0, $hgUW1$buildStyles)({
                        pathColor: completedResources === 0 ? (0, $hgUW1$token)("color.border") : (0, $hgUW1$token)("color.text.success")
                    })
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                css: $d8ee29df49af8811$var$progressTitleStyles,
                children: getProgressText()
            })
        ]
    });
};
const $d8ee29df49af8811$var$progressBarContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    gap: (0, $hgUW1$token)("space.100")
});
const $d8ee29df49af8811$var$progressBarStyles = (0, $hgUW1$css)({
    display: "flex",
    maxWidth: "20px",
    width: "100%"
});
const $d8ee29df49af8811$var$progressTitleStyles = (0, $hgUW1$css)({
    marginTop: 0,
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    fontFamily: "Inter, sans-serif",
    color: (0, $hgUW1$token)("color.text.subtle")
});







const $94fa590b0c9d9421$export$64ef9b8c11710c47 = ({ title: title , description: description , isLearningProgress: isLearningProgress , inspectMode: inspectMode  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "card-content",
        css: $94fa590b0c9d9421$var$titleAndDetailsContainerStyles,
        children: [
            isLearningProgress ? /*#__PURE__*/ (0, $hgUW1$jsx)("h4", {
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                css: $94fa590b0c9d9421$var$withProgressTitleStyles,
                children: title
            }) : /*#__PURE__*/ (0, $hgUW1$jsx)("h5", {
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                css: $94fa590b0c9d9421$var$catalogTitleStyles,
                children: title
            }),
            description && /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                "data-testid": "description",
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("description", inspectMode),
                css: $94fa590b0c9d9421$var$descriptionStyles,
                children: description
            })
        ]
    });
const $94fa590b0c9d9421$var$titleAndDetailsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $hgUW1$token)("space.300")} ${(0, $hgUW1$token)("space.300")}`,
    marginBottom: "-2px"
});
const $94fa590b0c9d9421$var$baseTitleStyles = (0, $hgUW1$css)({
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    color: (0, $hgUW1$token)("color.text")
});
const $94fa590b0c9d9421$var$learningProgressTitleStyles = (0, $hgUW1$css)({
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    marginTop: "20px !important",
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px",
    color: (0, $hgUW1$token)("color.text"),
    height: "64px"
});
const $94fa590b0c9d9421$var$withProgressTitleStyles = (0, $hgUW1$css)([
    $94fa590b0c9d9421$var$learningProgressTitleStyles,
    {
        fontSize: "24px",
        lineHeight: "32px",
        marginTop: "0 !important"
    }
]);
const $94fa590b0c9d9421$var$catalogTitleStyles = (0, $hgUW1$css)([
    $94fa590b0c9d9421$var$baseTitleStyles,
    {
        fontSize: "20px",
        lineHeight: "28px",
        marginTop: `${(0, $hgUW1$token)("space.150")} !important`
    }
]);
const $94fa590b0c9d9421$var$descriptionStyles = (0, $hgUW1$css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    marginTop: (0, $hgUW1$token)("space.250"),
    marginBottom: 0,
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: (0, $hgUW1$token)("color.text.subtle")
});






const $70542fe329d53412$export$ce572121d239fe86 = 4;
const $70542fe329d53412$export$3b38c99bd0870716 = 290;
const $70542fe329d53412$export$bb4069a5b1582edc = 24;
const $70542fe329d53412$export$9c6eb1f46b993412 = 3;


const $fb345954107134f9$export$331084b24da1eef5 = ({ tags: tags , lastLabelWidth: lastLabelWidth  })=>tags.length > 0 && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $fb345954107134f9$var$labelContainerStyles,
        id: "tabs-container",
        children: tags.slice(0, (0, $70542fe329d53412$export$9c6eb1f46b993412)).map((tag, index, arr)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: index === arr.length - 1 && (0, $hgUW1$css)([
                    {
                        "& > div": {
                            width: lastLabelWidth
                        }
                    },
                    $fb345954107134f9$var$truncatedLabelStyles
                ]),
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                    ...tag
                })
            }, tag.label + index))
    });
const $fb345954107134f9$var$labelContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${(0, $70542fe329d53412$export$ce572121d239fe86)}px`,
    padding: `0 ${(0, $70542fe329d53412$export$bb4069a5b1582edc)}px`,
    overflow: "hidden"
});
const $fb345954107134f9$var$truncatedLabelStyles = (0, $hgUW1$css)({
    "& > div": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block"
    }
});






const $f73a4551a9d8a3b1$export$8a8c015277a3d77a = ({ imageUrl: imageUrl , backgroundColor: backgroundColor , productIcon: productIcon , isLearningProgress: isLearningProgress  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: [
            $f73a4551a9d8a3b1$var$imageBaseStyles,
            !imageUrl && $f73a4551a9d8a3b1$var$noImageStyles,
            (0, $hgUW1$css)({
                backgroundColor: backgroundColor
            }, isLearningProgress && {
                height: "96px"
            }, !isLearningProgress && {
                height: "80px"
            })
        ],
        style: {
            backgroundImage: `url(${imageUrl})`
        },
        "data-testid": "card-image",
        children: productIcon && /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
            css: (0, $hgUW1$css)({
                marginLeft: "26px"
            }),
            src: productIcon,
            alt: "product icon"
        })
    });
const $f73a4551a9d8a3b1$var$imageBaseStyles = (0, $hgUW1$css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0 0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
});
const $f73a4551a9d8a3b1$var$noImageStyles = (0, $hgUW1$css)({
    background: (0, $hgUW1$token)("color.background.accent.gray.subtlest")
});




const $8d99d7c025746ac9$export$c01be50dd5c433fe = ({ inspectMode: inspectMode , title: title , description: description , onClick: onClick , target: target , link: link , tags: tags , minHeight: minHeight = 248 , isLoading: isLoading = false , learningProgress: learningProgress , onGeneratePdf: onGeneratePdf , shouldDisplayShareButton: shouldDisplayShareButton = false , shouldDisplayBookmark: shouldDisplayBookmark = false , productIcon: productIcon , imageUrl: imageUrl , backgroundColor: backgroundColor  })=>{
    const cardRef = (0, $hgUW1$useRef)(null);
    const [lastLabelWidth, setLastLabelWidth] = (0, $hgUW1$useState)("auto");
    const clickHandler = (0, $hgUW1$useCallback)(()=>{
        onClick && onClick();
    }, [
        link,
        target,
        onClick
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(clickHandler), [
        clickHandler
    ]);
    const handleOnSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    (0, $hgUW1$useEffect)(()=>{
        // truncating the last label if it doesn't fit in the card
        if (tags.length && cardRef.current) {
            const card = cardRef.current;
            const tagsContainer = card.querySelector("#tabs-container");
            const maxTagsContainerWidth = (card?.offsetWidth || (0, $70542fe329d53412$export$3b38c99bd0870716)) - (0, $70542fe329d53412$export$bb4069a5b1582edc) * 2;
            let firstTagsWidth = 0;
            let totalTagsWidth = 0;
            if (tagsContainer) {
                Array.from(tagsContainer.children).slice(0, (0, $70542fe329d53412$export$9c6eb1f46b993412)).forEach((tag, i, arr)=>{
                    if (i < arr.length - 1) firstTagsWidth += tag.clientWidth + (0, $70542fe329d53412$export$ce572121d239fe86);
                    totalTagsWidth += tag.clientWidth;
                });
                const shouldTruncate = totalTagsWidth + ((0, $70542fe329d53412$export$ce572121d239fe86) * tagsContainer.children.length - 1) + (0, $70542fe329d53412$export$bb4069a5b1582edc) * 2 > card?.offsetWidth;
                if (shouldTruncate) setLastLabelWidth(maxTagsContainerWidth - firstTagsWidth - 2);
            }
        }
    }, [
        cardRef.current
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: [
            $8d99d7c025746ac9$var$learningContentCardContainerStyles,
            $8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles
        ],
        "data-testid": "loading-learning-content-card",
        style: {
            minHeight: `${minHeight}px`
        },
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    $8d99d7c025746ac9$var$imageBaseStyles,
                    $8d99d7c025746ac9$var$noImageStyles
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $8d99d7c025746ac9$var$bodyContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $8d99d7c025746ac9$var$labelContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $8d99d7c025746ac9$var$smallPillStyles
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: [
                                        $8d99d7c025746ac9$var$smallPillStyles,
                                        (0, $hgUW1$css)({
                                            marginLeft: "24px"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $8d99d7c025746ac9$var$titleAndDetailsContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: (0, $hgUW1$css)({
                                marginTop: "12px"
                            }),
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: [
                                        $8d99d7c025746ac9$var$bigPillStyles,
                                        (0, $hgUW1$css)({
                                            width: "212px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $8d99d7c025746ac9$var$bigPillStyles
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
        href: link,
        target: target,
        rel: "noopener noreferrer",
        css: $8d99d7c025746ac9$var$linkContainerStyles,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            ref: cardRef,
            role: "link",
            css: $8d99d7c025746ac9$var$learningContentCardContainerStyles,
            onClick: clickHandler,
            onKeyDown: handleKeyDown,
            tabIndex: 0,
            "data-testid": "learning-content-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $f73a4551a9d8a3b1$export$8a8c015277a3d77a), {
                    imageUrl: imageUrl,
                    backgroundColor: backgroundColor,
                    productIcon: productIcon,
                    isLearningProgress: !!learningProgress
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: [
                        $8d99d7c025746ac9$var$bodyContainerStyles,
                        learningProgress && $8d99d7c025746ac9$var$progressBodyContainerStyles
                    ],
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fb345954107134f9$export$331084b24da1eef5), {
                            tags: tags,
                            lastLabelWidth: lastLabelWidth
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $94fa590b0c9d9421$export$64ef9b8c11710c47), {
                            title: title,
                            description: description,
                            inspectMode: inspectMode,
                            isLearningProgress: !!learningProgress
                        }),
                        learningProgress && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $8d99d7c025746ac9$var$learningContentCardProgressContainerStyles,
                            "data-testid": "learning-progress-content",
                            children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d8ee29df49af8811$export$184a993f673fc83f), {
                                        completedResources: learningProgress.completedResources,
                                        resourceCount: learningProgress.resourceCount,
                                        completionDate: learningProgress.completionDate,
                                        contentType: (0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).LEARNING_PATH
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                        css: $8d99d7c025746ac9$var$learningContentCardIconsContainerStyles,
                                        children: [
                                            shouldDisplayShareButton && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $2cfa64583f556289$export$477c64ffaba52edf), {
                                                urlToShare: link,
                                                alignToLeft: true,
                                                shareOnFb: false,
                                                shareOnLinkedin: false,
                                                showCopyLink: false,
                                                shareOnPdf: true,
                                                onGeneratePdf: onGeneratePdf
                                            }),
                                            shouldDisplayBookmark && /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                                "data-testid": "save-content",
                                                css: $8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles,
                                                onClick: handleOnSave,
                                                children: learningProgress.isSaved ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "bookmark-filled"
                                                }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                                    type: "bookmark"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $8d99d7c025746ac9$var$imageBaseStyles = (0, $hgUW1$css)({
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px 7px 0px 0px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "80px"
});
const $8d99d7c025746ac9$var$noImageStyles = (0, $hgUW1$css)({
    background: (0, $hgUW1$token)("color.background.accent.gray.subtlest")
});
const $8d99d7c025746ac9$var$bodyContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: `${(0, $70542fe329d53412$export$bb4069a5b1582edc)}px 0 0`
});
const $8d99d7c025746ac9$var$progressBodyContainerStyles = (0, $hgUW1$css)({
    padding: `21px 0 0`
});
const $8d99d7c025746ac9$var$labelContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: `${(0, $70542fe329d53412$export$ce572121d239fe86)}px`,
    padding: `0 ${(0, $70542fe329d53412$export$bb4069a5b1582edc)}px`,
    overflow: "hidden"
});
const $8d99d7c025746ac9$var$linkContainerStyles = (0, $hgUW1$css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $8d99d7c025746ac9$var$titleAndDetailsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `0 ${(0, $hgUW1$token)("space.300")} ${(0, $hgUW1$token)("space.300")}`
});
const $8d99d7c025746ac9$var$learningContentCardProgressContainerStyles = (0, $hgUW1$css)({
    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`
});
const $8d99d7c025746ac9$var$learningContentCardProgressItemsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `18px ${(0, $hgUW1$token)("space.300")}`
});
const $8d99d7c025746ac9$var$learningContentCardIconsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    gap: (0, $hgUW1$token)("space.300")
});
const $8d99d7c025746ac9$var$learningContentCardBookmarkContainerStyles = (0, $hgUW1$css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $8d99d7c025746ac9$var$learningContentCardContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    minWidth: `${(0, $70542fe329d53412$export$3b38c99bd0870716)}px`,
    "&:hover": {
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $hgUW1$token)("color.border.focused")}`,
        border: `1px solid ${(0, $hgUW1$token)("color.border.focused")}`
    }
});
const $8d99d7c025746ac9$var$loadingLearningContentCardContainerStyles = (0, $hgUW1$css)({
    boxShadow: "none",
    border: `1px solid ${(0, $hgUW1$token)("color.background.disabled")}`,
    cursor: "initial",
    "&:hover": {
        boxShadow: "none"
    },
    "&:active": {
        outline: "none",
        border: `1px solid ${(0, $hgUW1$token)("color.background.disabled")}`
    }
});
const $8d99d7c025746ac9$var$smallPillStyles = (0, $hgUW1$css)({
    width: "52px",
    height: "10.5px",
    backgroundColor: (0, $hgUW1$token)("color.background.neutral"),
    borderRadius: "15px",
    marginLeft: (0, $hgUW1$token)("space.100"),
    display: "inline-block"
});
const $8d99d7c025746ac9$var$bigPillStyles = (0, $hgUW1$css)({
    maxWidth: "227px",
    height: "17.5px",
    backgroundColor: (0, $hgUW1$token)("color.background.neutral"),
    borderRadius: "25px",
    marginTop: (0, $hgUW1$token)("space.100")
});


var $1f7c4876f10b107b$exports = {};

$parcel$export($1f7c4876f10b107b$exports, "Modal", () => $1f7c4876f10b107b$export$2b77a92f1a5ad772);







let $1f7c4876f10b107b$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($1f7c4876f10b107b$var$DialogWidth || ($1f7c4876f10b107b$var$DialogWidth = {}));
const $1f7c4876f10b107b$export$2b77a92f1a5ad772 = ({ closeModal: closeModal , width: width = $1f7c4876f10b107b$var$DialogWidth.LARGE , imageLink: imageLink , actionButton: actionButton , heading: heading , subheading: subheading , surveyText: surveyText  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitmodaldialog), {
        onClose: closeModal,
        width: width,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $1f7c4876f10b107b$var$modalContainerStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    css: $1f7c4876f10b107b$var$modalCloseButtonStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                        label: "close modal button",
                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                        iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "cross"
                        }),
                        onClick: closeModal
                    })
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $1f7c4876f10b107b$var$modalBodyStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $1f7c4876f10b107b$var$modalImageContainerStyles,
                            children: imageLink && /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                                src: imageLink,
                                alt: "modal-image",
                                width: 120,
                                height: 120,
                                css: $1f7c4876f10b107b$var$imageStyles
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            "data-testid": "modal-heading",
                            css: $1f7c4876f10b107b$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            "data-testid": "modal-subheading",
                            css: $1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                            children: subheading
                        }),
                        surveyText && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            "data-testid": "modal-survey-text",
                            css: [
                                $1f7c4876f10b107b$var$modalSubheadingContainerStyles,
                                $1f7c4876f10b107b$var$surveyTextStyles
                            ],
                            children: surveyText
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $1f7c4876f10b107b$var$modalActionButtonContainerStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                size: (0, $fec02fc26c7e145d$export$5dd2748b7940a2a0).LARGE,
                                onClick: actionButton.onClick,
                                label: actionButton.label,
                                iconBefore: actionButton.iconBefore,
                                iconAfter: actionButton.iconAfter
                            })
                        })
                    ]
                })
            ]
        })
    });
const $1f7c4876f10b107b$var$imageStyles = (0, $hgUW1$css)({
    borderRadius: "50%"
});
const $1f7c4876f10b107b$var$modalContainerStyles = (0, $hgUW1$css)({
    padding: `${(0, $hgUW1$token)("space.400")} ${(0, $hgUW1$token)("space.500")}`,
    [(0, $hgUW1$media1).below.sm]: {
        padding: "16px"
    }
});
const $1f7c4876f10b107b$var$modalCloseButtonStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    [(0, $hgUW1$media1).below.sm]: {
        padding: "8px"
    }
});
const $1f7c4876f10b107b$var$modalImageContainerStyles = (0, $hgUW1$css)({
    marginBottom: "24px",
    [(0, $hgUW1$media1).below.sm]: {
        marginBottom: "16px"
    }
});
const $1f7c4876f10b107b$var$modalBodyStyles = (0, $hgUW1$css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: `${(0, $hgUW1$token)("space.200")} auto 0`,
    [(0, $hgUW1$media1).below.sm]: {
        marginTop: 0
    }
});
const $1f7c4876f10b107b$var$modalHeadingContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "32px",
    fontWeight: 600,
    lineHeight: "40px",
    marginTop: 0,
    marginBottom: "24px",
    textAlign: "center",
    [(0, $hgUW1$media1).below.sm]: {
        marginTop: 0,
        marginBottom: "16px",
        fontSize: "24px",
        lineHeight: "32px"
    }
});
const $1f7c4876f10b107b$var$modalSubheadingContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    color: (0, $hgUW1$token)("color.text"),
    textAlign: "center",
    [(0, $hgUW1$media1).below.sm]: {
        marginBottom: "32px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});
const $1f7c4876f10b107b$var$surveyTextStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.200"),
    a: {
        fontSize: "20px"
    }
});
const $1f7c4876f10b107b$var$modalActionButtonContainerStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.400"),
    [(0, $hgUW1$media1).below.sm]: {
        margin: 0
    }
});


var $c5616d3f1657fc84$exports = {};

$parcel$export($c5616d3f1657fc84$exports, "LessonsTabContentSize", () => $c5616d3f1657fc84$export$415b2bdf1346d2d4);
$parcel$export($c5616d3f1657fc84$exports, "LessonsTabContent", () => $c5616d3f1657fc84$export$ce96f190f5d3ee14);






let $c5616d3f1657fc84$export$415b2bdf1346d2d4;
(function(LessonsTabContentSize) {
    LessonsTabContentSize["DEFAULT"] = "default";
    LessonsTabContentSize["WIDE"] = "wide";
})($c5616d3f1657fc84$export$415b2bdf1346d2d4 || ($c5616d3f1657fc84$export$415b2bdf1346d2d4 = {}));
const $c5616d3f1657fc84$export$ce96f190f5d3ee14 = ({ tabLinks: tabLinks , activeTab: activeTab = 0 , onClickTab: onClickTab , children: children , size: size = $c5616d3f1657fc84$export$415b2bdf1346d2d4.DEFAULT  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: [
            $c5616d3f1657fc84$var$tabsContainerStyles["base"],
            $c5616d3f1657fc84$var$tabsContainerStyles[`${size}-size`]
        ],
        "data-testid": "navtab",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("ul", {
                css: $c5616d3f1657fc84$var$tabsButtonGroupContainerStyles,
                children: tabLinks.map((tab, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                        "data-testid": `button-${tab}${index === activeTab ? "-selected" : ""}`,
                        css: $c5616d3f1657fc84$var$tabsButtonContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $731a4fd527bab680$export$3e41faf802a29e71), {
                            size: (0, $fec02fc26c7e145d$export$5dd2748b7940a2a0).LARGE,
                            label: tab,
                            onClick: ()=>onClickTab(index),
                            selected: index === activeTab
                        })
                    }, `li-navtab-${tab}-${index}`))
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $c5616d3f1657fc84$var$tabsContentContainerStyles,
                children: children
            })
        ]
    });
const $c5616d3f1657fc84$var$tabsContainerStyles = {
    base: (0, $hgUW1$css)({
        width: "100%",
        borderRadius: "8px",
        boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
        [(0, $hgUW1$media1).below.md]: {
            maxWidth: "720px"
        }
    }),
    "default-size": (0, $hgUW1$css)({
        maxWidth: "720px"
    }),
    "wide-size": (0, $hgUW1$css)({
        maxWidth: "1020px"
    })
};
const $c5616d3f1657fc84$var$tabsButtonGroupContainerStyles = (0, $hgUW1$css)({
    padding: "18px",
    overflowX: "auto",
    listStyleType: "none",
    borderBottom: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    [(0, $hgUW1$media1).below.xs]: {
        padding: "12px"
    }
});
const $c5616d3f1657fc84$var$tabsButtonContainerStyles = (0, $hgUW1$css)({
    margin: "6px",
    [(0, $hgUW1$media1).below.xs]: {
        margin: "4px"
    }
});
const $c5616d3f1657fc84$var$tabsContentContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px",
    letterSpacing: "-0.06px",
    padding: "24px",
    color: (0, $hgUW1$token)("color.text"),
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    [(0, $hgUW1$media1).below.xs]: {
        padding: "16px",
        fontSize: "16px",
        lineHeight: "24px"
    }
});


var $eb6f767c51421421$exports = {};

$parcel$export($eb6f767c51421421$exports, "Metadata", () => $eb6f767c51421421$export$e7adebdc1ebd2fed);




const $eb6f767c51421421$export$e7adebdc1ebd2fed = ({ fields: fields  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $eb6f767c51421421$var$metadataContainerStyles,
        "data-testid": "metadata",
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $eb6f767c51421421$var$metadataListStyles,
            children: fields.map((field)=>field.value && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $eb6f767c51421421$var$metadataItemsStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            css: $eb6f767c51421421$var$metadataTitleStyles,
                            children: field.name
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $eb6f767c51421421$var$metadataValueStyles,
                            children: field.value
                        })
                    ]
                }, field.name))
        })
    });
const $eb6f767c51421421$var$metadataContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    padding: (0, $hgUW1$token)("space.400"),
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised")
});
const $eb6f767c51421421$var$metadataListStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: (0, $hgUW1$token)("space.200")
});
const $eb6f767c51421421$var$metadataItemsStyles = (0, $hgUW1$css)({
    display: "flex",
    minHeight: "24px",
    gap: (0, $hgUW1$token)("space.300"),
    alignItems: "center"
});
const $eb6f767c51421421$var$metadataTitleStyles = (0, $hgUW1$css)({
    margin: 0,
    minWidth: "88px",
    color: "#000",
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    textTransform: "uppercase"
});
const $eb6f767c51421421$var$metadataValueStyles = (0, $hgUW1$css)({
    margin: 0,
    color: "#000",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});


var $7fe7e19d380f3d34$exports = {};

$parcel$export($7fe7e19d380f3d34$exports, "ArrowPosition", () => $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9);
$parcel$export($7fe7e19d380f3d34$exports, "Popup", () => $7fe7e19d380f3d34$export$129a32eedafa97c5);









let $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9;
(function(ArrowPosition) {
    ArrowPosition["LEFT_START"] = "leftStart";
    ArrowPosition["LEFT_CENTER"] = "leftCenter";
    ArrowPosition["LEFT_END"] = "leftEnd";
    ArrowPosition["TOP_START"] = "topStart";
    ArrowPosition["TOP_CENTER"] = "topCenter";
    ArrowPosition["TOP_END"] = "topEnd";
    ArrowPosition["RIGHT_START"] = "rightStart";
    ArrowPosition["RIGHT_CENTER"] = "rightCenter";
    ArrowPosition["RIGHT_END"] = "rightEnd";
    ArrowPosition["BOTTOM_START"] = "bottomStart";
    ArrowPosition["BOTTOM_CENTER"] = "bottomCenter";
    ArrowPosition["BOTTOM_END"] = "bottomEnd";
})($7fe7e19d380f3d34$export$2d4c84fdfce6f2a9 || ($7fe7e19d380f3d34$export$2d4c84fdfce6f2a9 = {}));
const $7fe7e19d380f3d34$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ popupHeight: popupHeight , title: title , children: children , step: step , totalSteps: totalSteps , arrowPosition: arrowPosition , onClose: onClose , onPrevious: onPrevious , onNext: onNext , popupStyle: popupStyle  }, popoverRef)=>{
    const CONTAINER_SIZE_PX = 88;
    const handlePrevious = ()=>{
        if (onPrevious) onPrevious();
    };
    const handleNext = ()=>{
        if (onNext) onNext();
    };
    const handleClose = ()=>{
        if (onClose) onClose();
    };
    (0, $hgUW1$useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (popoverRef && !popoverRef.current.contains(event.target)) handleClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        "data-testid": `popup-${arrowPosition}`,
        css: $7fe7e19d380f3d34$var$popupContainerStyles,
        style: popupStyle,
        ref: popoverRef,
        tabIndex: 0,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: [
                $7fe7e19d380f3d34$var$popupContentStyles["base"],
                $7fe7e19d380f3d34$var$popupContentStyles[arrowPosition]
            ],
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $7fe7e19d380f3d34$var$contentHeaderStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                            css: $7fe7e19d380f3d34$var$counterContainerStyles,
                            children: [
                                step,
                                "/",
                                totalSteps
                            ]
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: $7fe7e19d380f3d34$var$buttonsContainerStyles,
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    disabled: step === 1,
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                    label: "Previous",
                                    iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: "chevron-left",
                                        alt: "next icon"
                                    }),
                                    onClick: handlePrevious
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    disabled: step === totalSteps,
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                    label: "Next",
                                    iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: "chevron-right",
                                        alt: "previous icon"
                                    }),
                                    onClick: handleNext
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: (0, $hgUW1$css)({
                        overflow: "auto",
                        maxHeight: `calc(${popupHeight}px - ${CONTAINER_SIZE_PX}px)`,
                        padding: "0 16px"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            css: $7fe7e19d380f3d34$var$titleContainerStyles,
                            children: title
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                            css: $7fe7e19d380f3d34$var$descriptionContainerStyles,
                            children: [
                                " ",
                                children
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const $7fe7e19d380f3d34$var$popupContainerStyles = (0, $hgUW1$css)({
    width: "340px",
    position: "absolute",
    zIndex: 10,
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "8px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay"),
    [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
        top: "0 !important",
        left: "0 !important"
    },
    [(0, $hgUW1$media1).below.xs]: {
        height: "100%",
        width: "100%",
        border: "1px solid",
        borderColor: (0, $hgUW1$token)("color.border"),
        borderRadius: 0
    }
});
const $7fe7e19d380f3d34$var$popupContentStyles = {
    base: (0, $hgUW1$css)({
        position: "relative",
        padding: "24px 8px",
        color: (0, $hgUW1$token)("color.text"),
        display: "flex",
        flexDirection: "column",
        "&:after": {
            content: '""',
            display: "block",
            position: "absolute",
            border: "16px solid transparent",
            width: 0,
            height: 0,
            marginTop: "-10px"
        },
        [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
            "&:after": {
                display: "none"
            }
        }
    }),
    leftStart: (0, $hgUW1$css)({
        "&::after": {
            top: "35px",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $hgUW1$token)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftCenter: (0, $hgUW1$css)({
        "&::after": {
            top: "calc(50%)",
            left: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $hgUW1$token)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    leftEnd: (0, $hgUW1$css)({
        "&::after": {
            left: "-5px",
            bottom: "35px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: 0,
            borderRightColor: (0, $hgUW1$token)("color.border.inverse"),
            marginLeft: "-10px",
            filter: "drop-shadow(-2px 1px 1px rgb(178, 176, 176))"
        }
    }),
    topStart: (0, $hgUW1$css)({
        "&::after": {
            top: "-21px",
            left: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topCenter: (0, $hgUW1$css)({
        "&::after": {
            top: "-5px",
            left: "calc(50% - 16px)",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    topEnd: (0, $hgUW1$css)({
        "&::after": {
            top: "-5px",
            right: "35px",
            borderRight: "12px solid transparent",
            borderLeft: "12px solid transparent",
            borderBottom: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderTop: 0,
            marginRight: "-10px",
            filter: "drop-shadow(0 -1px 0.4px rgb(178, 176, 176))"
        }
    }),
    rightStart: (0, $hgUW1$css)({
        "&::after": {
            top: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightCenter: (0, $hgUW1$css)({
        "&::after": {
            top: "calc(50% - 10px)",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    rightEnd: (0, $hgUW1$css)({
        "&::after": {
            bottom: "35px",
            right: "-5px",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderRight: 0,
            marginRight: "-10px",
            filter: "drop-shadow(2px 0 1px #939393)"
        }
    }),
    bottomStart: (0, $hgUW1$css)({
        "&::after": {
            left: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomCenter: (0, $hgUW1$css)({
        "&::after": {
            left: "calc(50% - 16px)",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    }),
    bottomEnd: (0, $hgUW1$css)({
        "&::after": {
            right: "35px",
            bottom: "-14px",
            borderLeft: "12px solid transparent",
            borderRight: "12px solid transparent",
            borderTop: `16px solid ${(0, $hgUW1$token)("color.border.inverse")}`,
            borderBottom: 0,
            filter: "drop-shadow(0 4px 2px #939393)"
        }
    })
};
const $7fe7e19d380f3d34$var$contentHeaderStyles = (0, $hgUW1$css)({
    padding: "0 16px",
    marginBottom: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $7fe7e19d380f3d34$var$titleContainerStyles = (0, $hgUW1$css)({
    marginBottom: "16px",
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px"
});
const $7fe7e19d380f3d34$var$descriptionContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $7fe7e19d380f3d34$var$counterContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    color: (0, $hgUW1$token)("color.text.subtlest")
});
const $7fe7e19d380f3d34$var$buttonsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center"
});


var $915f5687b3b07750$exports = {};

$parcel$export($915f5687b3b07750$exports, "ProgressBar", () => $915f5687b3b07750$export$c17561cb55d4db30);



const $915f5687b3b07750$export$c17561cb55d4db30 = ({ progress: progress  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        "data-testid": "progress-bar",
        css: $915f5687b3b07750$var$progressBarContainerStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            "data-testid": `progress-${progress}`,
            css: [
                $915f5687b3b07750$var$progressBarContentStyles,
                (0, $hgUW1$css)({
                    width: `${progress}%`
                })
            ]
        })
    });
const $915f5687b3b07750$var$progressBarContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "8px",
    backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtler"),
    borderRadius: "100px",
    overflow: "hidden"
});
const $915f5687b3b07750$var$progressBarContentStyles = (0, $hgUW1$css)({
    height: "8px",
    backgroundColor: (0, $hgUW1$token)("color.text.success"),
    borderRadius: "100px"
});


var $579f9ef2424e0bd8$exports = {};

$parcel$export($579f9ef2424e0bd8$exports, "ProgressStatus", () => $579f9ef2424e0bd8$export$fad76899145ca0c7);
$parcel$export($579f9ef2424e0bd8$exports, "defineProgressStatus", () => $579f9ef2424e0bd8$export$aa03ab7e1a208875);
$parcel$export($579f9ef2424e0bd8$exports, "LearningHeader", () => $579f9ef2424e0bd8$export$86f07cccb119409d);









let $579f9ef2424e0bd8$export$fad76899145ca0c7;
(function(ProgressStatus) {
    ProgressStatus["NOT_STARTED"] = "not_started";
    ProgressStatus["IN_PROGRESS"] = "in_progress";
    ProgressStatus["FINISHED"] = "finished";
})($579f9ef2424e0bd8$export$fad76899145ca0c7 || ($579f9ef2424e0bd8$export$fad76899145ca0c7 = {}));
const $579f9ef2424e0bd8$export$aa03ab7e1a208875 = (progressStatus, contentTypeLabel)=>{
    switch(progressStatus){
        case $579f9ef2424e0bd8$export$fad76899145ca0c7.NOT_STARTED:
            return `Start ${contentTypeLabel}`;
        case $579f9ef2424e0bd8$export$fad76899145ca0c7.IN_PROGRESS:
            return `Continue ${contentTypeLabel}`;
        case $579f9ef2424e0bd8$export$fad76899145ca0c7.FINISHED:
            return `Review ${contentTypeLabel}`;
        default:
            return `Start ${contentTypeLabel}`;
    }
};
const $579f9ef2424e0bd8$export$86f07cccb119409d = ({ inspectMode: inspectMode , heading: heading , anonymousView: anonymousView = true , urlToShare: urlToShare , onSignIn: onSignIn , onStartCourse: onStartCourse , isLoading: isLoading , contentType: contentType , progressStatus: progressStatus , tagLine: tagLine , isSaved: isSaved , onSave: onSave , shouldShowFeedback: shouldShowFeedback , onStartFeedback: onStartFeedback  })=>{
    const handleSignIn = ()=>{
        if (onSignIn) onSignIn();
    };
    const handleStartCourse = ()=>{
        if (onStartCourse) onStartCourse();
    };
    const handleOnSave = ()=>{
        if (onSave) onSave();
    };
    const contentTypeLabel = contentType === (0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).COURSE ? "course" : "learning path";
    const status = $579f9ef2424e0bd8$export$aa03ab7e1a208875(progressStatus, contentTypeLabel);
    const renderActionButtons = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
            label: "",
            isLoading: isLoading
        });
        if (anonymousView) return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: (0, $hgUW1$css)({
                display: "flex"
            }),
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                    label: "Sign in",
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                    onClick: handleSignIn,
                    isLoading: isLoading
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: (0, $hgUW1$css)({
                        marginLeft: (0, $hgUW1$token)("space.200")
                    }),
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                        label: status,
                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).SECONDARY,
                        onClick: handleStartCourse,
                        isLoading: isLoading
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: (0, $hgUW1$css)({
                display: "flex"
            }),
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                    label: status,
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                    onClick: handleStartCourse,
                    isLoading: isLoading
                }),
                shouldShowFeedback && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: (0, $hgUW1$css)({
                        marginLeft: (0, $hgUW1$token)("space.200")
                    }),
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                        label: "Take survey",
                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).SECONDARY,
                        onClick: onStartFeedback,
                        isLoading: isLoading
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("section", {
        "data-testid": "learning-header",
        css: $579f9ef2424e0bd8$var$learningHeaderContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    (0, $5cf70e33bfc6ce73$export$f40d73b6f7f951e9)
                ],
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                    label: contentTypeLabel
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: (0, $hgUW1$css)({
                    margin: `${(0, $hgUW1$token)("space.300")} 0`
                }),
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                    level: 1,
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    css: $579f9ef2424e0bd8$var$tagLineStyles,
                    children: tagLine
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: (0, $hgUW1$css)({
                    marginTop: (0, $hgUW1$token)("space.300"),
                    marginBottom: (0, $hgUW1$token)("space.400")
                }),
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                    color: (0, $hgUW1$N50)
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: (0, $hgUW1$css)({
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }),
                children: [
                    renderActionButtons(),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: (0, $hgUW1$css)({
                            display: "flex"
                        }),
                        children: [
                            !anonymousView && /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                css: $579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles,
                                onClick: handleOnSave,
                                "aria-label": isSaved ? "unsave" : "save",
                                children: isSaved ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                    type: "bookmark-filled"
                                }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                    type: "bookmark"
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $2cfa64583f556289$export$477c64ffaba52edf), {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $579f9ef2424e0bd8$var$learningHeaderContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    paddingTop: `${(0, $hgUW1$token)("space.600")}`,
    paddingBottom: `${(0, $hgUW1$token)("space.400")}`,
    [(0, $hgUW1$media1).above.lg]: {
        paddingTop: (0, $hgUW1$token)("space.1000"),
        paddingBottom: `${(0, $hgUW1$token)("space.400")}`
    }
});
const $579f9ef2424e0bd8$var$tagLineStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "32px"
});
const $579f9ef2424e0bd8$var$learningCourseCardBookmarkContainerStyles = (0, $hgUW1$css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none"
});


var $d559b1cc82536c49$exports = {};

$parcel$export($d559b1cc82536c49$exports, "Footer", () => $d559b1cc82536c49$export$a06f1c675e846f6f);





const $d559b1cc82536c49$export$a06f1c675e846f6f = ({ onOpenReportProblemModal: onOpenReportProblemModal  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("footer", {
        "data-testid": "footer",
        css: $d559b1cc82536c49$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                href: "https://www.atlassian.com",
                css: [
                    $d559b1cc82536c49$var$paddingRightStyles,
                    $d559b1cc82536c49$var$logoLinkStyles
                ],
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AtlassianLogo), {
                    appearance: "neutral",
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("ul", {
                    css: $d559b1cc82536c49$var$listStyles,
                    "aria-label": "footer navigation",
                    children: [
                        onOpenReportProblemModal && /*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                            css: [
                                $d559b1cc82536c49$var$listItemStyles,
                                $d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: [
                                    $d559b1cc82536c49$var$listItemLinkStyles,
                                    (0, $hgUW1$css)({
                                        cursor: "pointer"
                                    })
                                ],
                                onClick: onOpenReportProblemModal,
                                children: "Report problem"
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                            css: [
                                $d559b1cc82536c49$var$listItemStyles,
                                $d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                css: $d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                children: "Privacy Policy"
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                            css: [
                                $d559b1cc82536c49$var$listItemStyles,
                                $d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                css: $d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://community.atlassian.com/t5/user/termsofservicepage",
                                children: "Terms of Use"
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("li", {
                            css: [
                                $d559b1cc82536c49$var$listItemStyles,
                                $d559b1cc82536c49$var$paddingRightStyles
                            ],
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                                css: $d559b1cc82536c49$var$listItemLinkStyles,
                                href: "https://www.atlassian.com/security",
                                children: "Security"
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("li", {
                            css: $d559b1cc82536c49$var$listItemStyles,
                            children: [
                                "\xa9 ",
                                new Date().getUTCFullYear(),
                                " Atlassian"
                            ]
                        })
                    ]
                })
            })
        ]
    });
const $d559b1cc82536c49$var$footerContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    maxWidth: "1440px",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    zIndex: 4,
    padding: "48px 104px",
    boxSizing: "border-box",
    margin: "0 auto",
    width: "100%",
    [(0, $hgUW1$media1).below.md]: {
        padding: "48px 60px"
    },
    [(0, $hgUW1$media1).below.sm]: {
        padding: "72px 32px",
        flexDirection: "column",
        alignItems: "flex-start"
    }
});
const $d559b1cc82536c49$var$listStyles = (0, $hgUW1$css)({
    display: "flex",
    paddingLeft: 0,
    margin: 0,
    flexDirection: "row",
    justifyContent: "flex-end",
    listStyle: "none",
    [(0, $hgUW1$media1).below.sm]: {
        flexDirection: "column"
    }
});
const $d559b1cc82536c49$var$listItemStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    marginTop: 0,
    color: (0, $hgUW1$token)("color.text.subtlest"),
    [(0, $hgUW1$media1).below.sm]: {
        paddingTop: "24px"
    }
});
const $d559b1cc82536c49$var$paddingRightStyles = (0, $hgUW1$css)({
    paddingRight: "24px"
});
const $d559b1cc82536c49$var$logoLinkStyles = (0, $hgUW1$css)({
    lineHeight: "24px"
});
const $d559b1cc82536c49$var$listItemLinkStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtlest"),
    textDecoration: "none",
    "&:hover": {
        color: (0, $hgUW1$token)("color.text.subtlest"),
        textDecoration: "none"
    }
});


var $fa53e9c0a1746730$exports = {};

$parcel$export($fa53e9c0a1746730$exports, "LabelledGraphic", () => $fa53e9c0a1746730$export$12b5e3eab33f219b);






const $fa53e9c0a1746730$export$12b5e3eab33f219b = ({ image: image , markers: markers , onClickMarker: onClickMarker , onClickNext: onClickNext , onClickPrevious: onClickPrevious , onClickDismiss: onClickDismiss , pulseAnimationColor: pulseAnimationColor = (0, $hgUW1$token)("color.background.input")  })=>{
    const [activeId, setActiveId] = (0, $hgUW1$useState)(null);
    const [popoverPosX, setPopoverPosX] = (0, $hgUW1$useState)(null);
    const [popoverPosY, setPopoverPosY] = (0, $hgUW1$useState)(null);
    const [clickedMarkers, setClickedMarkers] = (0, $hgUW1$useState)([]);
    const containerDivRef = (0, $hgUW1$useRef)(null);
    const popupRef = (0, $hgUW1$useRef)(null);
    const imageContainerRef = (0, $hgUW1$useRef)(null);
    const maxPopupHeight = 540;
    const maxPopupWidth = 340;
    const defaultDesktopWidth = 1040;
    const iconNumbers = [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "zero"
    ];
    const handleNextStep = (idx)=>{
        if (onClickNext) onClickNext();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx + 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId + 1 : null;
        });
    };
    const handlePreviousStep = (idx)=>{
        if (onClickPrevious) onClickPrevious();
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx - 1
            ]);
        setActiveId((prevId)=>{
            return prevId !== null ? prevId - 1 : null;
        });
    };
    const handleDismiss = (0, $hgUW1$useCallback)(()=>{
        if (onClickDismiss) onClickDismiss();
        setActiveId(null);
    }, []);
    const handleClickMarker = (0, $hgUW1$useCallback)((idx)=>{
        if (onClickMarker) onClickMarker(idx + 1);
        setClickedMarkers((prevState)=>[
                ...prevState,
                idx
            ]);
        setActiveId(idx);
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        if (containerDivRef.current && activeId != null) {
            const parentWidth = containerDivRef.current.clientWidth;
            const parentHeight = containerDivRef.current.clientHeight;
            const popoverHeight = popupRef?.current?.clientHeight ?? 0;
            let posX = parentWidth * markers[activeId].posX / 100;
            let posY = parentHeight * markers[activeId].posY / 100;
            switch(markers[activeId].arrowPosition){
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).LEFT_START:
                    posX = posX + 70;
                    posY = posY - 15;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).LEFT_CENTER:
                    posX = posX + 70;
                    posY = posY - Math.ceil(popoverHeight / 2.5) - 15;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).LEFT_END:
                    posX = posX + 70;
                    posY = posY - popoverHeight + 70;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).TOP_START:
                    posX = posX - 24;
                    posY = posY + 70;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).TOP_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 27;
                    posY = posY + 70;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).TOP_END:
                    posX = posX - maxPopupWidth + 60;
                    posY = posY + 70;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).RIGHT_START:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - 13;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).RIGHT_CENTER:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - Math.ceil(popoverHeight / 2) + 32;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).RIGHT_END:
                    posX = posX - maxPopupWidth - 24;
                    posY = posY - popoverHeight + 70;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).BOTTOM_START:
                    posX = posX - 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).BOTTOM_CENTER:
                    posX = posX - Math.ceil(maxPopupWidth / 2) + 25;
                    posY = posY - popoverHeight - 20;
                    break;
                case (0, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9).BOTTOM_END:
                    posX = posX - maxPopupWidth + 70;
                    posY = posY - popoverHeight - 18;
                    break;
                default:
                    break;
            }
            setPopoverPosX(posX / parentWidth * 100);
            setPopoverPosY(posY / parentHeight * 100);
            // Focus the popup when it is opened
            popupRef.current?.focus();
        }
    }, [
        activeId,
        markers,
        imageContainerRef.current?.clientHeight
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            handleClickMarker(Number(event.currentTarget.getAttribute("data-marker-index")));
        }
    }, [
        handleClickMarker
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $fa53e9c0a1746730$var$labelledGraphicContainerStyles,
        ref: containerDivRef,
        children: [
            markers?.map((marker, idx)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    "data-testid": "graphic-marker",
                    css: [
                        $fa53e9c0a1746730$var$markerPulseStyles,
                        clickedMarkers.includes(idx) && "none",
                        !clickedMarkers.includes(idx) && pulseAnimationColor === "#FFFFFF" && (0, $hgUW1$css)({
                            animation: `${$fa53e9c0a1746730$var$pulseWhiteAnimationStyles} 3000ms cubic-bezier(0.55, 0.06, 0.68, 0.19) infinite`
                        }),
                        !clickedMarkers.includes(idx) && pulseAnimationColor !== "#FFFFFF" && (0, $hgUW1$css)({
                            animation: `${$fa53e9c0a1746730$var$pulsePurpleAnimationStyles} 3000ms cubic-bezier(0.55, 0.06, 0.68, 0.19) infinite`
                        })
                    ],
                    style: {
                        left: marker.posX + "%",
                        top: marker.posY + "%"
                    },
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            handleClickMarker(idx);
                        },
                        draggable: true,
                        css: [
                            $fa53e9c0a1746730$var$graphicMarkerContainerStyles["base"],
                            activeId === idx && $fa53e9c0a1746730$var$graphicMarkerContainerStyles["selected"],
                            (0, $hgUW1$css)({
                                border: `2px solid ${pulseAnimationColor}`
                            })
                        ],
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
                            children: [
                                marker.icon && iconNumbers.includes(marker.icon) && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: [
                                        activeId === idx && (0, $hgUW1$css)({
                                            color: (0, $hgUW1$token)("color.text.inverse")
                                        }),
                                        activeId !== idx && (0, $hgUW1$css)({
                                            color: (0, $hgUW1$token)("color.text")
                                        })
                                    ],
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: marker.icon
                                    })
                                }),
                                marker.icon && !iconNumbers.includes(marker.icon) && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: (0, $hgUW1$css)({
                                        display: "flex",
                                        alignItems: "center"
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        size: "small",
                                        color: `${activeId === idx ? (0, $hgUW1$token)("color.icon.inverse") : (0, $hgUW1$token)("color.icon.warning.inverse")}`,
                                        type: marker.icon
                                    })
                                })
                            ]
                        })
                    })
                }, `marker-${idx}`)),
            activeId != null && imageContainerRef.current && containerDivRef.current && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $7fe7e19d380f3d34$export$129a32eedafa97c5), {
                popupHeight: imageContainerRef.current.clientHeight > 540 ? 540 : imageContainerRef.current.clientHeight,
                title: markers[activeId].title,
                totalSteps: markers.length,
                step: activeId + 1,
                popupStyle: {
                    position: "absolute",
                    left: popoverPosX + "%",
                    top: popoverPosY + "%",
                    maxHeight: `${maxPopupHeight}px`,
                    maxWidth: `${maxPopupWidth}px`
                },
                arrowPosition: markers[activeId].arrowPosition,
                onNext: ()=>handleNextStep(activeId),
                onPrevious: ()=>handlePreviousStep(activeId),
                onClose: handleDismiss,
                ref: popupRef,
                children: markers[activeId].children
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                ref: imageContainerRef,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1298c86a7e6a9fc7$export$3e431a229df88919), {
                    ...image,
                    css: [
                        $fa53e9c0a1746730$var$imageStyles,
                        (0, $hgUW1$css)({
                            maxWidth: `${defaultDesktopWidth}px`
                        })
                    ],
                    preventModal: true
                })
            })
        ]
    });
};
const $fa53e9c0a1746730$var$labelledGraphicContainerStyles = (0, $hgUW1$css)({
    position: "relative",
    cursor: "default"
});
const $fa53e9c0a1746730$var$pulseWhiteAnimationStyles = (0, $hgUW1$keyframes)({
    "0%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.border.inverse")}, 0 0 0 ${(0, $hgUW1$token)("color.border.inverse")}`
    },
    "33%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.border.inverse")}, 0 0 0 ${(0, $hgUW1$token)("color.border.inverse")}`
    },
    "66%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.border.inverse")}, 0 0 0 10px ${(0, $hgUW1$token)("color.border.inverse")}`
    },
    "100%": {
        transform: `0 0 0 2px ${(0, $hgUW1$token)("color.border.inverse")}, 0 0 0 10px ${(0, $hgUW1$token)("color.border.inverse")}`
    }
});
const $fa53e9c0a1746730$var$pulsePurpleAnimationStyles = (0, $hgUW1$keyframes)({
    "0%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.text.discovery")}, 0 0 0 ${(0, $hgUW1$token)("color.text.discovery")}`
    },
    "33%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.text.discovery")}, 0 0 0 ${(0, $hgUW1$token)("color.text.discovery")}`
    },
    "66%": {
        boxShadow: `0 0 0 2px ${(0, $hgUW1$token)("color.text.discovery")}, 0 0 0 10px ${(0, $hgUW1$token)("color.text.discovery")}`
    },
    "100%": {
        transform: `0 0 0 2px ${(0, $hgUW1$token)("color.text.discovery")}, 0 0 0 10px ${(0, $hgUW1$token)("color.text.discovery")}`
    }
});
const $fa53e9c0a1746730$var$markerPulseStyles = (0, $hgUW1$css)({
    height: "46px",
    width: "46px",
    padding: "6px 12px",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    borderRadius: "50%",
    zIndex: 2,
    cursor: "pointer"
});
const $fa53e9c0a1746730$var$graphicMarkerContainerStyles = {
    base: (0, $hgUW1$css)({
        height: "40px",
        width: "40px",
        padding: "6px 12px",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: (0, $hgUW1$token)("color.background.accent.yellow.subtle"),
        fontFamily: "Charlie Display, sans-serif",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "24px",
        color: (0, $hgUW1$token)("color.text"),
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay"),
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.yellow.subtle.hovered")
        },
        "&:active": {
            backgroundColor: (0, $hgUW1$token)("color.background.accent.yellow.subtle.pressed")
        }
    }),
    selected: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.text"),
        "&:hover": {
            backgroundColor: (0, $hgUW1$token)("color.text")
        },
        "&:active": {
            backgroundColor: (0, $hgUW1$token)("color.text")
        }
    })
};
const $fa53e9c0a1746730$var$imageStyles = (0, $hgUW1$css)({
    height: "auto",
    width: "100%"
});


var $9225344cd5d1f99b$exports = {};

$parcel$export($9225344cd5d1f99b$exports, "LessonHeader", () => $9225344cd5d1f99b$export$7bee7638d150bc04);






const $9225344cd5d1f99b$export$7bee7638d150bc04 = ({ heading: heading , tags: tags , description: description , urlToShare: urlToShare , onListenClick: onListenClick  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $9225344cd5d1f99b$var$headingWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                    level: 1,
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $9225344cd5d1f99b$var$metadataStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $9225344cd5d1f99b$var$flexContainerStyles,
                        children: tags.map((tag, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $9225344cd5d1f99b$var$tagStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                                    ...tag
                                })
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $9225344cd5d1f99b$var$flexContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
                                css: $9225344cd5d1f99b$var$listenButtonStyles,
                                onClick: ()=>onListenClick && onListenClick(),
                                "data-testid": "listen-button",
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M8.5 17.3333V13.5C8.5 12.9477 8.05228 12.5 7.5 12.5C6.94772 12.5 6.5 12.9477 6.5 13.5V15.6667C6.5 16.6792 7.32081 17.5 8.33333 17.5C8.42538 17.5 8.5 17.4254 8.5 17.3333ZM7.5 11C6.11929 11 5 12.1193 5 13.5V15.6667C5 17.5076 6.49238 19 8.33333 19C9.25381 19 10 18.2538 10 17.3333V13.5C10 12.1193 8.88071 11 7.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M15.5 17.3333V13.5C15.5 12.9477 15.9477 12.5 16.5 12.5C17.0523 12.5 17.5 12.9477 17.5 13.5V15.6667C17.5 16.6792 16.6792 17.5 15.6667 17.5C15.5746 17.5 15.5 17.4254 15.5 17.3333ZM16.5 11C17.8807 11 19 12.1193 19 13.5V15.6667C19 17.5076 17.5076 19 15.6667 19C14.7462 19 14 18.2538 14 17.3333V13.5C14 12.1193 15.1193 11 16.5 11Z",
                                                fill: "#44546F"
                                            }),
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M12 5.5C8.96243 5.5 6.5 7.96243 6.5 11V14.25H5V11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11V14.25H17.5V11C17.5 7.96243 15.0376 5.5 12 5.5Z",
                                                fill: "#44546F"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                        css: $9225344cd5d1f99b$var$listenTextWrapperStyles,
                                        children: "Listen"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $2cfa64583f556289$export$477c64ffaba52edf), {
                                urlToShare: urlToShare,
                                alignToLeft: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $9225344cd5d1f99b$var$lineWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                    color: (0, $hgUW1$token)("color.border")
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $9225344cd5d1f99b$var$descriptionStyles,
                children: description
            })
        ]
    });
const $9225344cd5d1f99b$var$metadataStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $9225344cd5d1f99b$var$flexContainerStyles = (0, $hgUW1$css)({
    display: "flex"
});
const $9225344cd5d1f99b$var$listenButtonStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    marginRight: "1.5rem",
    cursor: "pointer",
    padding: 0,
    border: "none",
    background: "transparent"
});
const $9225344cd5d1f99b$var$listenTextWrapperStyles = (0, $hgUW1$css)({
    marginLeft: "0.25rem",
    color: (0, $hgUW1$token)("color.text.subtle"),
    fontSize: "16px",
    fontFamily: "Charlie Text, sans-serif"
});
const $9225344cd5d1f99b$var$tagStyles = (0, $hgUW1$css)({
    marginRight: "0.5rem"
});
const $9225344cd5d1f99b$var$lineWrapperStyles = (0, $hgUW1$css)({
    padding: "1.5rem 0 2.5rem 0"
});
const $9225344cd5d1f99b$var$headingWrapperStyles = (0, $hgUW1$css)({
    padding: "5rem 0 1.5rem 0"
});
const $9225344cd5d1f99b$var$descriptionStyles = (0, $hgUW1$css)({
    paddingBottom: (0, $hgUW1$token)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $hgUW1$token)("color.text"),
    p: {
        margin: 0
    },
    a: {
        fontSize: "20px",
        lineHeight: "32px"
    },
    ul: {
        paddingLeft: "20px",
        marginTop: 0,
        marginBottom: 0,
        li: {
            marginTop: "16px"
        },
        "li + li": {
            marginTop: "16px !important"
        }
    }
});


var $3b9afd8fe4435353$exports = {};

$parcel$export($3b9afd8fe4435353$exports, "LessonList", () => $3b9afd8fe4435353$export$962a95c44e73eb25);











const $057799a99c9f255f$export$b7cafc9b9fbb48b2 = ({ isCompleted: isCompleted , size: size  })=>isCompleted ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
        type: "check-circle-filled",
        size: size,
        color: (0, $hgUW1$token)("color.icon.success")
    }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
        type: "check-circle-outline",
        size: size,
        color: (0, $hgUW1$token)("color.background.accent.gray.subtler.pressed")
    });








const $7e5a668c3a5a9ea8$export$2c301aad86da9f9a = ({ sectionTitle: sectionTitle , slug: slug , lessonSlug: lessonSlug , isCompleted: isCompleted , onNavigation: onNavigation  })=>{
    const handleKeyDown = (0, $hgUW1$useCallback)((event, onNavigation, slug, lessonSlug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                sectionSlug: slug,
                lessonSlug: lessonSlug
            });
        }
    }, [
        onNavigation,
        slug,
        lessonSlug
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $7e5a668c3a5a9ea8$var$sectionStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $057799a99c9f255f$export$b7cafc9b9fbb48b2), {
                isCompleted: isCompleted,
                size: (0, $a02a6f7de308273b$export$ff775019b5b6e7df).SMALL
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $7e5a668c3a5a9ea8$var$sectionLinkStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    role: "link",
                    tabIndex: 0,
                    onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug, lessonSlug),
                    onClick: ()=>onNavigation({
                            sectionSlug: slug,
                            lessonSlug: lessonSlug
                        }),
                    children: sectionTitle
                })
            })
        ]
    });
};
const $7e5a668c3a5a9ea8$var$sectionStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    marginBottom: "0.75rem"
});
const $7e5a668c3a5a9ea8$var$sectionLinkStyles = (0, $hgUW1$css)({
    marginLeft: "11px",
    span: {
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
        lineHeight: "1.5rem",
        fontWeight: 400,
        color: (0, $hgUW1$token)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $hgUW1$token)("color.text.selected"),
            textDecoration: "none"
        }
    }
});




const $fc302bf0bdbf0587$export$e4e5e6361d1b89e2 = ({ lessonTitle: lessonTitle , slug: slug , duration: duration , isCompleted: isCompleted , isCurrentLesson: isCurrentLesson , hasDivider: hasDivider , sections: sections , onNavigation: onNavigation  })=>{
    const [isExpanded, setIsExpanded] = (0, $hgUW1$useState)(isCurrentLesson);
    const expandByCard = (event)=>{
        if (event.target === event.currentTarget) setIsExpanded(!isExpanded);
    };
    const expandByButton = ()=>{
        setIsExpanded(!isExpanded);
    };
    (0, $hgUW1$useEffect)(()=>{
        setIsExpanded(isCurrentLesson);
    }, [
        isCurrentLesson
    ]);
    const handleKeyDown = (0, $hgUW1$useCallback)((event, onNavigation, slug)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onNavigation({
                lessonSlug: slug
            });
        }
    }, [
        onNavigation,
        slug
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("section", {
        tabIndex: 0,
        css: [
            $fc302bf0bdbf0587$var$lessonCardContainerStyles,
            !hasDivider && (0, $hgUW1$css)({
                marginBottom: "16px"
            })
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: [
                    $fc302bf0bdbf0587$var$lessonCardStyles,
                    isCurrentLesson && $fc302bf0bdbf0587$var$currentLessonStyles,
                    !isCurrentLesson && $fc302bf0bdbf0587$var$hoverLessonStyles
                ],
                onClick: expandByCard,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                        tabIndex: 0,
                        "aria-label": "expand lesson button",
                        css: [
                            $fc302bf0bdbf0587$var$expandButtonStyles,
                            !isCurrentLesson && (0, $hgUW1$css)({
                                borderColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest.hovered")
                            })
                        ],
                        "data-testid": "expand-button",
                        onClick: expandByButton,
                        children: isExpanded ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "chevron-down",
                            size: (0, $a02a6f7de308273b$export$ff775019b5b6e7df).MEDIUM,
                            color: isCurrentLesson ? (0, $hgUW1$token)("color.icon.selected") : (0, $hgUW1$token)("color.icon.subtle")
                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "chevron-right",
                            size: (0, $a02a6f7de308273b$export$ff775019b5b6e7df).MEDIUM,
                            color: isCurrentLesson ? (0, $hgUW1$token)("color.icon.selected") : (0, $hgUW1$token)("color.icon.subtle")
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $fc302bf0bdbf0587$var$mainContentColumnStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                css: [
                                    $fc302bf0bdbf0587$var$durationStyles,
                                    !isCurrentLesson && (0, $hgUW1$css)({
                                        color: (0, $hgUW1$token)("color.text.subtlest")
                                    })
                                ],
                                children: duration.toUpperCase()
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $fc302bf0bdbf0587$var$lessonContainer,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $fc302bf0bdbf0587$var$lessonTitleStyles,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                            role: "button",
                                            tabIndex: 0,
                                            onKeyDown: (event)=>handleKeyDown(event, onNavigation, slug),
                                            onClick: ()=>onNavigation({
                                                    lessonSlug: slug
                                                }),
                                            children: lessonTitle
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: (0, $hgUW1$css)({
                                            marginLeft: "1.5rem",
                                            display: "flex"
                                        }),
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $057799a99c9f255f$export$b7cafc9b9fbb48b2), {
                                            isCompleted: isCompleted,
                                            size: (0, $a02a6f7de308273b$export$ff775019b5b6e7df).MEDIUM
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: (0, $hgUW1$css)({
                                    marginTop: "0.75rem"
                                }),
                                children: isExpanded && sections.map((section)=>/*#__PURE__*/ (0, $hgUW1$createElement)((0, $7e5a668c3a5a9ea8$export$2c301aad86da9f9a), {
                                        ...section,
                                        lessonSlug: slug,
                                        onNavigation: onNavigation,
                                        key: `section-${section.slug}`
                                    }))
                            })
                        ]
                    })
                ]
            }),
            hasDivider && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: (0, $hgUW1$css)({
                    marginTop: "16px",
                    marginBottom: "16px"
                }),
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                    height: 2,
                    color: (0, $hgUW1$token)("color.border")
                })
            })
        ]
    }, slug);
};
const $fc302bf0bdbf0587$var$lessonCardContainerStyles = (0, $hgUW1$css)({
    maxWidth: "25.25rem",
    [(0, $hgUW1$media).below.sm]: {
        maxWidth: "100%",
        paddingRight: "16px"
    }
});
const $fc302bf0bdbf0587$var$lessonCardStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    padding: "16px",
    borderRadius: "0.25rem",
    cursor: "pointer"
});
const $fc302bf0bdbf0587$var$currentLessonStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.selected"),
    borderLeft: `4px solid ${(0, $hgUW1$token)("color.text.brand")}`
});
const $fc302bf0bdbf0587$var$hoverLessonStyles = (0, $hgUW1$css)({
    ":hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest")
    },
    ":hover button": {
        borderColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest.pressed")
    }
});
const $fc302bf0bdbf0587$var$mainContentColumnStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginLeft: "0.75rem"
});
const $fc302bf0bdbf0587$var$expandButtonStyles = (0, $hgUW1$css)({
    width: "1.5rem",
    height: "1.5rem",
    padding: 0,
    border: `1px solid ${(0, $hgUW1$token)("color.background.accent.blue.subtlest.pressed")}`,
    borderRadius: "0.25rem",
    boxSizing: "content-box",
    background: "transparent",
    outline: "none",
    cursor: "pointer",
    ":focus-visible": {
        border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $fc302bf0bdbf0587$var$durationStyles = (0, $hgUW1$css)({
    width: "100%",
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1.125rem",
    color: (0, $hgUW1$token)("color.text.selected"),
    marginTop: 0,
    marginBottom: (0, $hgUW1$token)("space.075")
});
const $fc302bf0bdbf0587$var$lessonContainer = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center"
});
const $fc302bf0bdbf0587$var$lessonTitleStyles = (0, $hgUW1$css)({
    width: "100%",
    fontFamily: "Charlie Display",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "1.5rem",
    span: {
        color: (0, $hgUW1$token)("color.text")
    },
    ":hover": {
        span: {
            color: (0, $hgUW1$token)("color.text.selected"),
            textDecoration: "none"
        }
    }
});


const $3b9afd8fe4435353$export$962a95c44e73eb25 = ({ lessons: lessons  })=>{
    const currentLessonIndx = lessons.findIndex((lesson)=>lesson.isCurrentLesson);
    const updatedLessons = lessons.map((lesson, indx)=>({
            ...lesson,
            hasDivider: !(indx === currentLessonIndx || indx === currentLessonIndx - 1)
        }));
    return updatedLessons.map((lesson)=>/*#__PURE__*/ (0, $hgUW1$createElement)((0, $fc302bf0bdbf0587$export$e4e5e6361d1b89e2), {
            ...lesson,
            key: `lesson-${lesson.slug}`
        }));
};


var $65703ff0bcd12648$exports = {};

$parcel$export($65703ff0bcd12648$exports, "LessonSidebar", () => $65703ff0bcd12648$export$c2bf8d11366d1eb0);









const $bae5a7f2c1ae6bce$export$7ded8628b71ba75 = ({ progress: progress , pathColor: pathColor , trailColor: trailColor = (0, $hgUW1$token)("color.border") , image: image , title: title , onCourseNavigation: onCourseNavigation  })=>{
    const handleKeyDown = (0, $hgUW1$useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onCourseNavigation && onCourseNavigation();
        }
    }, [
        onCourseNavigation
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $bae5a7f2c1ae6bce$var$progressBadgeContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: (0, $hgUW1$css)({
                    maxWidth: "64px",
                    [(0, $hgUW1$media1).above.sm]: {
                        maxWidth: "85px"
                    }
                }),
                "data-testid": "progress-circle",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$CircularProgressbarWithChildren), {
                    strokeWidth: 4,
                    value: progress,
                    styles: (0, $hgUW1$buildStyles)({
                        pathColor: pathColor,
                        trailColor: trailColor
                    }),
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $bae5a7f2c1ae6bce$var$imageBadgeContainerStyles,
                        children: image ? /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                            css: $bae5a7f2c1ae6bce$var$imageStyles,
                            "data-testid": "badge-image",
                            src: image.src,
                            alt: image.alt
                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: [
                                (0, $hgUW1$css)({
                                    backgroundColor: trailColor
                                }),
                                $bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                    tabIndex: 0,
                    onKeyDown: handleKeyDown,
                    css: $bae5a7f2c1ae6bce$var$titleStyles,
                    onClick: onCourseNavigation,
                    children: title
                })
            })
        ]
    });
};
const $bae5a7f2c1ae6bce$var$progressBadgeContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    gap: "16px"
});
const $bae5a7f2c1ae6bce$var$imageBadgeContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "100%",
    padding: "8px"
});
const $bae5a7f2c1ae6bce$var$imageStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $bae5a7f2c1ae6bce$var$innerCircleBackgroundStyles = (0, $hgUW1$css)({
    borderRadius: "9999px",
    width: "100%",
    height: "100%"
});
const $bae5a7f2c1ae6bce$var$titleStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text"),
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "28px",
    fontFamily: "Charlie Display, sans-serif",
    paddingRight: "16px",
    margin: 0,
    "&:hover": {
        cursor: "pointer",
        color: (0, $hgUW1$token)("color.text.selected")
    }
});



const $65703ff0bcd12648$export$c2bf8d11366d1eb0 = ({ lessons: lessons , progress: progress , pathColor: pathColor , title: title , image: image , isVisible: isVisible , onChangeMenuVisibility: onChangeMenuVisibility , onCourseNavigation: onCourseNavigation  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)((0, $9c3f769544bb2079$export$1ba59dacbcbf90fe), {
        isVisible: isVisible,
        onChangeMenuVisibility: onChangeMenuVisibility,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: (0, $hgUW1$css)({
                    marginLeft: "16px"
                }),
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: (0, $hgUW1$css)({
                            marginBottom: "16px",
                            lineHeight: "24px"
                        }),
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: [
                                $65703ff0bcd12648$var$subheadingStyles,
                                (0, $hgUW1$css)({
                                    marginBottom: "24px",
                                    marginTop: "24px"
                                })
                            ],
                            children: "Current course"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $bae5a7f2c1ae6bce$export$7ded8628b71ba75), {
                        progress: progress,
                        pathColor: pathColor,
                        title: title,
                        image: image,
                        onCourseNavigation: onCourseNavigation
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: (0, $hgUW1$css)({
                            marginBottom: "24px",
                            marginTop: "24px",
                            lineHeight: "24px"
                        }),
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $65703ff0bcd12648$var$subheadingStyles,
                            children: "Lessons in this course"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3b9afd8fe4435353$export$962a95c44e73eb25), {
                lessons: lessons
            })
        ]
    });
const $65703ff0bcd12648$var$subheadingStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Text, sens-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    textTransform: "uppercase",
    color: (0, $hgUW1$token)("color.text")
});


var $dbb9d5792c296a49$exports = {};

$parcel$export($dbb9d5792c296a49$exports, "SubmitFeedback", () => $dbb9d5792c296a49$export$f6dc54b55657f29f);








const $dbb9d5792c296a49$export$f6dc54b55657f29f = ({ onSubmit: onSubmit , onChange: onChange , isLoading: isLoading , isSubmitted: isSubmitted , hasError: hasError , opinion: opinion  })=>{
    const [isOpen, setIsOpen] = (0, $hgUW1$useState)(false);
    const [isYesSelected, setIsYesSelected] = (0, $hgUW1$useState)(false);
    const [isNoSelected, setIsNoSelected] = (0, $hgUW1$useState)(false);
    const handleChange = (0, $hgUW1$useCallback)((e)=>{
        e.preventDefault();
        if (onChange) onChange(e);
    }, [
        onChange
    ]);
    const handleYes = (0, $hgUW1$useCallback)(()=>{
        setIsOpen(true);
        setIsYesSelected(true);
        setIsNoSelected(false);
    }, []);
    const handleNo = (0, $hgUW1$useCallback)(()=>{
        setIsOpen(true);
        setIsNoSelected(true);
        setIsYesSelected(false);
    }, []);
    const handleCancel = (0, $hgUW1$useCallback)(()=>{
        setIsOpen(false);
        setIsYesSelected(false);
        setIsNoSelected(false);
    }, []);
    const renderButtons = ()=>{
        if (isLoading && !isSubmitted) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$LoadingButton), {
            appearance: "primary",
            isLoading: true,
            children: "Submit"
        });
        if (isSubmitted) return null;
        return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                    type: "submit",
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                    label: "Submit",
                    onClick: onSubmit
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).LINK,
                    label: "Cancel",
                    onClick: handleCancel
                })
            ]
        });
    };
    const renderFeedbackBox = ()=>{
        if (!isOpen) return null;
        if (!isSubmitted) return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: {
                label: {
                    fontSize: "13.7143px",
                    color: (0, $hgUW1$token)("color.text.subtlest")
                },
                textArea: {
                    borderColor: `${(0, $hgUW1$token)("color.border")} !important`,
                    "&:focus": {
                        borderColor: `${(0, $hgUW1$token)("color.border.focused")} !important`
                    }
                }
            },
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Label), {
                    htmlFor: "area",
                    children: "Send us your opinion"
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskittextarea), {
                    placeholder: "Begin typing in here...",
                    defaultValue: opinion,
                    onChange: handleChange
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$FormFooter), {
                    children: renderButtons()
                })
            ]
        });
        if (!hasError) return /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
            css: $dbb9d5792c296a49$var$feedbackStyles,
            children: "Thanks for your feedback!"
        });
        return /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
            css: $dbb9d5792c296a49$var$feedbackStyles,
            children: "Error submitting feedback. Try again later."
        });
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
        children: [
            !isSubmitted && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: (0, $hgUW1$css)({
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            css: $dbb9d5792c296a49$var$labelStyles,
                            children: "Was this content helpful?"
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: (0, $hgUW1$css)({
                                marginLeft: "1rem",
                                display: "flex"
                            }),
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: (0, $hgUW1$css)({
                                        marginRight: "0.5rem"
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Yes",
                                        onClick: handleYes,
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        disabled: isYesSelected
                                    })
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    label: "No",
                                    onClick: handleNo,
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                    disabled: isNoSelected
                                })
                            ]
                        })
                    ]
                })
            }),
            renderFeedbackBox()
        ]
    });
};
const $dbb9d5792c296a49$var$labelStyles = (0, $hgUW1$css)({
    marginTop: 0,
    marginBottom: 0,
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "1.25rem",
    fontWeight: 600,
    lineHeight: "1.75rem",
    color: (0, $hgUW1$token)("color.text")
});
const $dbb9d5792c296a49$var$feedbackStyles = (0, $hgUW1$css)({
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    width: "13.813rem",
    height: "1.563rem"
});



var $44303f6c3c81eeac$exports = {};

$parcel$export($44303f6c3c81eeac$exports, "QuestionType", () => $44303f6c3c81eeac$export$51940fbbacba35d4);
$parcel$export($44303f6c3c81eeac$exports, "QuizStatus", () => $44303f6c3c81eeac$export$bf1c1ed72daa392b);
$parcel$export($44303f6c3c81eeac$exports, "QuestionStatus", () => $44303f6c3c81eeac$export$602daccbd963b20);
$parcel$export($44303f6c3c81eeac$exports, "MatchingAnswerStatus", () => $44303f6c3c81eeac$export$85e3e62cc743c830);
$parcel$export($44303f6c3c81eeac$exports, "ActionDescription", () => $44303f6c3c81eeac$export$cb9c858407602327);
$parcel$export($44303f6c3c81eeac$exports, "Quiz", () => $44303f6c3c81eeac$export$76709845c4fea6cd);














let $b55544cdfa85935b$export$1bd2035254432789;
(function(InputStatus) {
    InputStatus["CORRECT"] = "CORRECT";
    InputStatus["INCORRECT"] = "INCORRECT";
    InputStatus["SELECTED"] = "SELECTED";
    InputStatus["DEFAULT"] = "DEFAULT";
    InputStatus["DISABLED"] = "DISABLED";
})($b55544cdfa85935b$export$1bd2035254432789 || ($b55544cdfa85935b$export$1bd2035254432789 = {}));
const $b55544cdfa85935b$export$56e6c05354470c53 = ({ inspectMode: inspectMode , text: text , elementId: elementId , inputStatus: inputStatus = $b55544cdfa85935b$export$1bd2035254432789.DEFAULT , onClick: onClick  })=>{
    const handleKeyDown = (0, $hgUW1$useCallback)((event)=>{
        if (event.code === "Space") {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        css: [
            $b55544cdfa85935b$var$quizInputsContainerStyles,
            $b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    $b55544cdfa85935b$var$quizInputBorderStyles["DEFAULT"],
                    $b55544cdfa85935b$var$quizInputBorderStyles[inputStatus],
                    $b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                id: elementId ? elementId + "-quiz-input" : "",
                css: [
                    $b55544cdfa85935b$var$quizInputsContentStyles,
                    $b55544cdfa85935b$var$quizInputsVariantStyles[inputStatus]
                ],
                onClick: onClick,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                    css: $b55544cdfa85935b$var$quizInputsTextStyles,
                    children: text
                })
            })
        ]
    });
};
const $b55544cdfa85935b$var$quizInputsContainerStyles = (0, $hgUW1$css)({
    width: "50%",
    display: "flex",
    cursor: "pointer",
    borderRadius: "8px",
    boxShadow: "0px 1px 1px 0px rgba(9, 30, 66, 0.25), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",
    justifyContent: "center"
});
const $b55544cdfa85935b$var$quizInputsContentStyles = (0, $hgUW1$css)({
    maxWidth: "300px",
    width: "100%",
    padding: "16px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    border: "1px solid rgba(9, 30, 66, 0.14)",
    borderLeft: "none",
    borderRadius: "0 8px 8px 0"
});
const $b55544cdfa85935b$var$quizInputsTextStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    width: "100%",
    [(0, $hgUW1$media1).below.xs]: {
        fontSize: "14px",
        lineHeight: "20px"
    }
});
const $b55544cdfa85935b$var$quizInputBorderStyles = {
    DEFAULT: (0, $hgUW1$css)({
        maxHeight: "100%",
        width: "8px",
        borderRadius: "8px 0 0 8px",
        border: "1px solid rgba(9, 30, 66, 0.14)",
        borderRight: "none",
        backgroundColor: (0, $hgUW1$N0),
        [(0, $hgUW1$media1).below.xs]: {
            width: "4px"
        }
    }),
    CORRECT: (0, $hgUW1$css)({
        backgroundColor: "#22A06B",
        border: "1px solid #22A06B"
    }),
    INCORRECT: (0, $hgUW1$css)({
        backgroundColor: "#E2483D",
        border: "1px solid #E2483D"
    }),
    SELECTED: (0, $hgUW1$css)({
        backgroundColor: "#0C66E4",
        border: "1px solid #0C66E4"
    })
};
const $b55544cdfa85935b$var$quizInputsVariantStyles = {
    DEFAULT: (0, $hgUW1$css)({
        color: "#000000",
        backgroundColor: (0, $hgUW1$N0),
        fontWeight: 400
    }),
    CORRECT: (0, $hgUW1$css)({
        fontWeight: 700
    }),
    INCORRECT: (0, $hgUW1$css)({
        fontWeight: 700
    }),
    SELECTED: (0, $hgUW1$css)({
        fontWeight: 700
    }),
    DISABLED: (0, $hgUW1$css)({
        color: "#626F86",
        fontWeight: 400,
        backgroundColor: "#F7F8F9",
        border: "1px solid #F7F8F9",
        boxShadow: "none",
        transition: "all",
        transitionDuration: "500ms",
        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        pointerEvents: "none"
    })
};



let $44303f6c3c81eeac$export$51940fbbacba35d4;
(function(QuestionType) {
    QuestionType["SINGLE_SELECT"] = "SINGLE_SELECT";
    QuestionType["MULTI_SELECT"] = "MULTI_SELECT";
    QuestionType["MATCHING"] = "MATCHING";
})($44303f6c3c81eeac$export$51940fbbacba35d4 || ($44303f6c3c81eeac$export$51940fbbacba35d4 = {}));
let $44303f6c3c81eeac$export$bf1c1ed72daa392b;
(function(QuizStatus) {
    QuizStatus["DEFAULT"] = "DEFAULT";
    QuizStatus["ERROR"] = "ERROR";
    QuizStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuizStatus["SUCCESS"] = "SUCCESS";
})($44303f6c3c81eeac$export$bf1c1ed72daa392b || ($44303f6c3c81eeac$export$bf1c1ed72daa392b = {}));
let $44303f6c3c81eeac$export$602daccbd963b20;
(function(QuestionStatus) {
    QuestionStatus["INCORRECT"] = "INCORRECT";
    QuestionStatus["PARTLY_CORRECT"] = "PARTLY_CORRECT";
    QuestionStatus["CORRECT"] = "CORRECT";
})($44303f6c3c81eeac$export$602daccbd963b20 || ($44303f6c3c81eeac$export$602daccbd963b20 = {}));
let $44303f6c3c81eeac$export$85e3e62cc743c830;
(function(MatchingAnswerStatus) {
    MatchingAnswerStatus["DEFAULT"] = "DEFAULT";
    MatchingAnswerStatus["INCORRECT"] = "INCORRECT";
    MatchingAnswerStatus["CORRECT"] = "CORRECT";
})($44303f6c3c81eeac$export$85e3e62cc743c830 || ($44303f6c3c81eeac$export$85e3e62cc743c830 = {}));
let $44303f6c3c81eeac$export$cb9c858407602327;
(function(ActionDescription) {
    ActionDescription["SINGLE_SELECT"] = "Select the correct answer.";
    ActionDescription["MULTI_SELECT"] = "Select all correct answers.";
    ActionDescription["MATCHING"] = "Select the matching pairs.";
})($44303f6c3c81eeac$export$cb9c858407602327 || ($44303f6c3c81eeac$export$cb9c858407602327 = {}));
const $44303f6c3c81eeac$var$QuizStatusToCheckboxType = {
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $44303f6c3c81eeac$var$QuizStatusToRadioType = {
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT]: "DEFAULT",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS]: "SUCCESS",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR]: "DANGER",
    [$44303f6c3c81eeac$export$bf1c1ed72daa392b.PARTLY_CORRECT]: "DANGER"
};
const $44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH = 480;
const $44303f6c3c81eeac$var$NAVBAR_HEIGHT = 124;
const $44303f6c3c81eeac$export$76709845c4fea6cd = ({ inspectMode: inspectMode , title: title , questions: questions = [] , onCompletion: onCompletion , step: step = 0 , setStep: setStep , onInteraction: onInteraction , isCompleted: isCompleted = false , setIsCompleted: setIsCompleted , isLoggedInUser: isLoggedInUser , handleUserLogin: handleUserLogin , lessonId: lessonId , onAnswerSubmit: onAnswerSubmit  })=>{
    const [questionAnswers, setQuestionAnswers] = (0, $hgUW1$useState)([]);
    const [selectedAnswers, setSelectedAnswers] = (0, $hgUW1$useState)([]);
    const [status, setStatus] = (0, $hgUW1$useState)($44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT);
    const [answersStatus, setAnswersStatus] = (0, $hgUW1$useState)({});
    const [matchingAnswersStatus, setMatchingAnswersStatus] = (0, $hgUW1$useState)($44303f6c3c81eeac$export$85e3e62cc743c830.DEFAULT);
    const [correctAnswersArray, setCorrectAnswersArray] = (0, $hgUW1$useState)([]);
    const [incorrectAnswersArray, setIncorrectAnswersArray] = (0, $hgUW1$useState)([]);
    const [lastSubmittedQuestion, setLastSubmittedQuestion] = (0, $hgUW1$useState)({
        lessonId: "",
        step: 0
    });
    const width = (0, $3ced3ef7e9864bf1$export$4616d33c54ae5baf)();
    const isNextButtonDisabled = step + 1 !== questions.length ? !isCompleted && status !== $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS : true;
    const isMatchingFeedbackVisible = questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING && matchingAnswersStatus !== $44303f6c3c81eeac$export$85e3e62cc743c830.DEFAULT && !isCompleted;
    //set quiz status after initialization
    (0, $hgUW1$useEffect)(()=>{
        if (lastSubmittedQuestion.lessonId !== lessonId) setLastSubmittedQuestion({
            lessonId: lessonId,
            step: 0
        });
        if (isCompleted && lessonId && questions.length) {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS);
            onSubmittedQuestionsRecheck(questions.length - 1);
        } else {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
        }
    }, [
        lessonId,
        isCompleted
    ]);
    //set quiz last submitted question step after initialization
    (0, $hgUW1$useEffect)(()=>{
        setLastSubmittedQuestion((prevState)=>{
            if (prevState.lessonId === lessonId && !prevState.step) return {
                ...prevState,
                step: step
            };
            else return {
                ...prevState
            };
        });
    }, [
        step,
        lastSubmittedQuestion.lessonId
    ]);
    (0, $hgUW1$useEffect)(()=>{
        checkMatchingQuestionCompleted();
    }, [
        correctAnswersArray
    ]);
    (0, $hgUW1$useEffect)(()=>{
        const isLastCompletedQuestion = status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS && lastSubmittedQuestion.step === questions.length;
        if (questions.length && !isLastCompletedQuestion) setQuestionAnswers(questions[step]?.answers);
    }, [
        step,
        questions
    ]);
    const handleOnAnswerSubmit = (type, status)=>{
        if (onAnswerSubmit) onAnswerSubmit(type, status);
    };
    const toggleAnswer = (answer)=>{
        onInteraction();
        if (status !== $44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT) return;
        if (questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.SINGLE_SELECT) setSelectedAnswers([
            answer
        ]);
        if (questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MULTI_SELECT) {
            if (selectedAnswers.includes(answer)) setSelectedAnswers((a)=>a.filter((ans)=>ans !== answer));
            else setSelectedAnswers((a)=>[
                    ...a,
                    answer
                ]);
        }
        if (questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING) {
            if (isLoggedInUser) toggleMatchingQuestion(answer);
            else handleUserLogin();
        }
    };
    const toggleMatchingQuestion = (answer)=>{
        if (selectedAnswers.length && selectedAnswers[0].title !== answer.title && selectedAnswers[0].isLeftMatchingAnswer !== answer.isLeftMatchingAnswer) {
            if (selectedAnswers[0].matchingAnswer?.title === answer.title && !correctAnswersArray.includes(answer)) {
                const correctAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING, $44303f6c3c81eeac$export$602daccbd963b20.CORRECT);
                setMatchingAnswersStatus($44303f6c3c81eeac$export$85e3e62cc743c830.CORRECT);
                setSelectedAnswers([
                    ...correctAnswers
                ]);
                setCorrectAnswersArray((a)=>[
                        ...a,
                        ...correctAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($44303f6c3c81eeac$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            } else {
                const incorrectAnswers = [
                    ...selectedAnswers,
                    answer
                ];
                handleOnAnswerSubmit($44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING, $44303f6c3c81eeac$export$602daccbd963b20.INCORRECT);
                setMatchingAnswersStatus($44303f6c3c81eeac$export$85e3e62cc743c830.INCORRECT);
                setSelectedAnswers([
                    ...incorrectAnswers
                ]);
                setIncorrectAnswersArray((a)=>[
                        ...a,
                        ...incorrectAnswers
                    ]);
                setTimeout(()=>{
                    setSelectedAnswers([]);
                    setMatchingAnswersStatus($44303f6c3c81eeac$export$85e3e62cc743c830.DEFAULT);
                }, 500);
            }
        } else {
            setSelectedAnswers([
                answer
            ]);
            setIncorrectAnswersArray([]);
        }
    };
    const checkMatchingQuestionCompleted = ()=>{
        const leftAnswers = questions[step]?.leftAnswers;
        const rightAnswers = questions[step]?.rightAnswers;
        if (correctAnswersArray.length === leftAnswers?.length + rightAnswers?.length) {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
            const questionOnCompletion = questions[step]?.onCompletion;
            if (questionOnCompletion) questionOnCompletion();
            if (onCompletion && step + 1 === questions.length) {
                onCompletion();
                setIsCompleted(true);
            }
        }
    };
    const handleAnswerSubmit = ()=>{
        if (isLoggedInUser) onSubmit();
        else handleUserLogin();
    };
    const onSubmit = ()=>{
        const answers = questions[step]?.answers;
        const correctAnswers = answers.filter((ans)=>ans.correct);
        const totalSteps = questions.length;
        const questionOnCompletion = questions[step]?.onCompletion;
        const atLeastOneCorrectAnswer = !!correctAnswers.filter((ans)=>selectedAnswers.includes(ans)).length;
        if (correctAnswers.length === selectedAnswers.length && correctAnswers.every((ans)=>selectedAnswers.includes(ans))) {
            if (step + 1 === totalSteps) {
                /** completed quiz */ setIsCompleted(true);
                if (questionOnCompletion) questionOnCompletion();
                if (onCompletion) onCompletion();
            } else /** unfinished quiz */ if (questionOnCompletion) questionOnCompletion();
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS);
            handleOnAnswerSubmit(questions[step]?.type, $44303f6c3c81eeac$export$602daccbd963b20.CORRECT);
            setLastSubmittedQuestion((prevState)=>{
                return {
                    ...prevState,
                    step: step + 1
                };
            });
        } else if (atLeastOneCorrectAnswer) {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.PARTLY_CORRECT);
            handleOnAnswerSubmit(questions[step]?.type, $44303f6c3c81eeac$export$602daccbd963b20.PARTLY_CORRECT);
        } else {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR);
            handleOnAnswerSubmit(questions[step]?.type, $44303f6c3c81eeac$export$602daccbd963b20.INCORRECT);
        }
        setAnswersStatus(selectedAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: answers.find((a)=>a.title === curr.title)?.correct ? $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS : $44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onTryAgain = ()=>{
        const element = document.getElementById("quiz-question-container");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT);
        setSelectedAnswers([]);
        setAnswersStatus({});
        setQuestionAnswers((prevState)=>(0, $hgUW1$lodashshuffle)(prevState));
    };
    const onSubmittedQuestionsRecheck = (step)=>{
        const prevQuestionAnswers = questions[step].answers;
        const correctAnswers = prevQuestionAnswers.filter((answer)=>answer.correct);
        setStep(step);
        setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS);
        setSelectedAnswers(correctAnswers);
        setAnswersStatus(correctAnswers.reduce((prev, curr)=>({
                ...prev,
                [curr.title]: questions[step].answers.find((a)=>a.title === curr.title)?.correct ? $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS : $44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR
            }), {}));
    };
    const onNextQuestionClick = ()=>{
        const nextQuestionStep = step + 1;
        const element = document.getElementById("quiz-question-container");
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY - $44303f6c3c81eeac$var$NAVBAR_HEIGHT;
            window.scrollTo({
                top: topPosition,
                behavior: "smooth"
            });
        }
        if (nextQuestionStep < lastSubmittedQuestion.step || isCompleted) onSubmittedQuestionsRecheck(step + 1);
        else {
            setStatus($44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT);
            setSelectedAnswers([]);
            setCorrectAnswersArray([]);
            setStep(step + 1);
            setAnswersStatus({});
        }
    };
    const onPrevQuestionClick = ()=>{
        onInteraction();
        onSubmittedQuestionsRecheck(step - 1);
    };
    const getQuizProgress = ()=>{
        const progress = isCompleted ? questions.length : lastSubmittedQuestion.step;
        return progress / questions.length * 100;
    };
    const getInputStatus = (answer)=>{
        if (correctAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return (0, $b55544cdfa85935b$export$1bd2035254432789).CORRECT;
        if (incorrectAnswersArray.includes(answer) && selectedAnswers.includes(answer)) return (0, $b55544cdfa85935b$export$1bd2035254432789).INCORRECT;
        if (correctAnswersArray.includes(answer) || status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS) return (0, $b55544cdfa85935b$export$1bd2035254432789).DISABLED;
        if (selectedAnswers.includes(answer)) return (0, $b55544cdfa85935b$export$1bd2035254432789).SELECTED;
        return (0, $b55544cdfa85935b$export$1bd2035254432789).DEFAULT;
    };
    const getAnswerStatus = (answer)=>!!selectedAnswers.find((a)=>a.title === answer.title);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $44303f6c3c81eeac$var$quizContainerStyles,
        id: "quiz",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                css: $44303f6c3c81eeac$var$quizTitleStyles,
                children: title
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $44303f6c3c81eeac$var$quizContentContainerStyles,
                id: "quiz-question-container",
                "data-testid": "quiz-question-container",
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $44303f6c3c81eeac$var$quizHeaderContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $44303f6c3c81eeac$var$quizActionPanelContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "back-button",
                                        disabled: !step,
                                        iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "arrow-left-circle"
                                        }),
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                        onClick: onPrevQuestionClick,
                                        iconType: "arrow-left-circle"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
                                        css: $44303f6c3c81eeac$var$questionsStepStyles,
                                        children: [
                                            "QUESTION ",
                                            step + 1,
                                            " 0F ",
                                            questions.length
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                        css: $44303f6c3c81eeac$var$desktopScreenProgressContainerStyles,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $915f5687b3b07750$export$c17561cb55d4db30), {
                                            progress: getQuizProgress()
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "next-button",
                                        disabled: isNextButtonDisabled,
                                        iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "arrow-right-circle"
                                        }),
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                        onClick: onNextQuestionClick,
                                        iconType: "arrow-right-circle"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                css: $44303f6c3c81eeac$var$mobileScreenProgressContainerStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $915f5687b3b07750$export$c17561cb55d4db30), {
                                    progress: getQuizProgress()
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", questions[step]?.inspectMode),
                        css: $44303f6c3c81eeac$var$questionTitleStyles,
                        children: questions[step]?.title
                    }),
                    questions[step] && questions[step].imageUrl && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $44303f6c3c81eeac$var$questionImageStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1298c86a7e6a9fc7$export$3e431a229df88919), {
                            src: questions[step].imageUrl,
                            alt: questions[step]?.title.props.children
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $44303f6c3c81eeac$var$chooseCorrectAnswerStyles,
                        children: $44303f6c3c81eeac$export$cb9c858407602327[questions[step]?.type]
                    }),
                    questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        children: questions[step]?.leftAnswers?.map((leftAnswer, index)=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $44303f6c3c81eeac$var$quizInputsContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $b55544cdfa85935b$export$56e6c05354470c53), {
                                        inspectMode: leftAnswer?.inspectMode,
                                        elementId: leftAnswer.title,
                                        text: leftAnswer.title,
                                        onClick: ()=>toggleAnswer(leftAnswer),
                                        inputStatus: getInputStatus(leftAnswer)
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $b55544cdfa85935b$export$56e6c05354470c53), {
                                        inspectMode: questions[step]?.rightAnswers?.[index]?.inspectMode,
                                        elementId: questions[step]?.rightAnswers?.[index]?.title,
                                        text: questions[step]?.rightAnswers?.[index]?.title,
                                        onClick: ()=>toggleAnswer(questions[step]?.rightAnswers?.[index]),
                                        inputStatus: getInputStatus(questions[step]?.rightAnswers?.[index])
                                    })
                                ]
                            }, leftAnswer.title + questions[step]?.rightAnswers?.[index]?.title))
                    }),
                    (questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.SINGLE_SELECT || questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MULTI_SELECT) && questionAnswers?.map((answer)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $44303f6c3c81eeac$var$answerContainerStyles,
                            ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", answer?.inspectMode),
                            children: questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.SINGLE_SELECT ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3fbcb32390ca7008$export$d7b12c4107be0d61), {
                                size: width >= $44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? (0, $3fbcb32390ca7008$export$4da24539a3bb7d98).LARGE : (0, $3fbcb32390ca7008$export$4da24539a3bb7d98).DEFAULT,
                                label: answer.title,
                                isChecked: getAnswerStatus(answer),
                                setIsChecked: ()=>toggleAnswer(answer),
                                type: $44303f6c3c81eeac$var$QuizStatusToRadioType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d501466973a9f0a6$export$48513f6b9f8ce62d), {
                                size: width >= $44303f6c3c81eeac$var$MOBILE_SCREEN_WIDTH ? (0, $d501466973a9f0a6$export$5e435bc8b081a399).LARGE : (0, $d501466973a9f0a6$export$5e435bc8b081a399).DEFAULT,
                                label: answer.title,
                                onChange: ()=>toggleAnswer(answer),
                                isChecked: getAnswerStatus(answer),
                                type: $44303f6c3c81eeac$var$QuizStatusToCheckboxType[answersStatus[answer.title]],
                                isBold: getAnswerStatus(answer)
                            })
                        }, answer.title)),
                    !isCompleted && status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.DEFAULT && questions[step]?.type !== $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: [
                            $44303f6c3c81eeac$var$buttonContainerStyles,
                            (0, $hgUW1$css)({
                                borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`,
                                paddingTop: "32px"
                            })
                        ],
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                            label: "Submit answer",
                            appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                            onClick: handleAnswerSubmit,
                            disabled: selectedAnswers.length === 0 || questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING
                        })
                    }),
                    (status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS || questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING) && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $44303f6c3c81eeac$var$buttonContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: [
                                $44303f6c3c81eeac$var$feedbackContainerStyles,
                                status !== $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS && (0, $hgUW1$css)({
                                    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`
                                })
                            ],
                            children: [
                                status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $81dd635d83decaee$export$f23c56ac9ab316f), {
                                    title: questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING ? "Correct" : "That’s correct",
                                    appearance: (0, $81dd635d83decaee$export$f9292ef28b7b429a).CORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                (!isCompleted || questions[step]?.type === $44303f6c3c81eeac$export$51940fbbacba35d4.MATCHING && !isCompleted) && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: (0, $hgUW1$css)({
                                        marginTop: "32px"
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        disabled: status !== $44303f6c3c81eeac$export$bf1c1ed72daa392b.SUCCESS,
                                        label: "Next question",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        onClick: onNextQuestionClick,
                                        iconAfter: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "arrow-right"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    (status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.ERROR || status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.PARTLY_CORRECT) && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $44303f6c3c81eeac$var$buttonContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                            css: $44303f6c3c81eeac$var$feedbackContainerStyles,
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $81dd635d83decaee$export$f23c56ac9ab316f), {
                                    title: status === $44303f6c3c81eeac$export$bf1c1ed72daa392b.PARTLY_CORRECT ? "That’s partly correct" : "That’s not correct",
                                    appearance: (0, $81dd635d83decaee$export$f9292ef28b7b429a).INCORRECT,
                                    description: questions[step]?.feedbackMessage
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: (0, $hgUW1$css)({
                                        marginTop: "32px"
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Try again",
                                        iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "refresh"
                                        }),
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        onClick: onTryAgain
                                    })
                                })
                            ]
                        })
                    }),
                    isCompleted && /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                        css: $44303f6c3c81eeac$var$completionMessageStyles,
                        children: "\uD83C\uDF89 Quiz complete! Great work."
                    })
                ]
            }),
            isMatchingFeedbackVisible && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: $44303f6c3c81eeac$var$matchingFeedbackContainerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $81dd635d83decaee$export$f23c56ac9ab316f), {
                    title: matchingAnswersStatus === $44303f6c3c81eeac$export$85e3e62cc743c830.INCORRECT ? "That’s incorrect" : "That’s correct",
                    appearance: matchingAnswersStatus === $44303f6c3c81eeac$export$85e3e62cc743c830.INCORRECT ? (0, $81dd635d83decaee$export$f9292ef28b7b429a).INCORRECT : (0, $81dd635d83decaee$export$f9292ef28b7b429a).CORRECT
                })
            })
        ]
    });
};
const $44303f6c3c81eeac$var$quizContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});
const $44303f6c3c81eeac$var$quizContentContainerStyles = (0, $hgUW1$css)({
    padding: "32px 48px",
    borderRadius: "8px",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    maxWidth: "720px",
    width: "100%",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    [(0, $hgUW1$media1).below.md]: {
        maxWidth: "720px",
        width: "100%"
    },
    [(0, $hgUW1$media1).below.xs]: {
        padding: "24px 16px"
    }
});
const $44303f6c3c81eeac$var$quizHeaderContainerStyles = (0, $hgUW1$css)({
    marginBottom: "32px",
    paddingBottom: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    flexDirection: "row",
    [(0, $hgUW1$media1).below.sm]: {
        flexDirection: "column"
    },
    [(0, $hgUW1$media1).below.xs]: {
        marginBottom: "24px",
        paddingBottom: "24px"
    }
});
const $44303f6c3c81eeac$var$quizActionPanelContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
const $44303f6c3c81eeac$var$quizTitleStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "48px",
    letterSpacing: "-0.12px",
    marginTop: 0,
    marginBottom: "32px",
    textAlign: "center",
    [(0, $hgUW1$media1).below.xs]: {
        display: "none"
    }
});
const $44303f6c3c81eeac$var$questionTitleStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    color: (0, $hgUW1$token)("color.text"),
    marginTop: 0,
    marginBottom: "32px",
    [(0, $hgUW1$media1).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px",
        marginBottom: "24px"
    }
});
const $44303f6c3c81eeac$var$questionImageStyles = (0, $hgUW1$css)({
    padding: "24px 0"
});
const $44303f6c3c81eeac$var$desktopScreenProgressContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    margin: "0 24px 0 13px",
    [(0, $hgUW1$media1).below.sm]: {
        display: "none"
    }
});
const $44303f6c3c81eeac$var$mobileScreenProgressContainerStyles = (0, $hgUW1$css)({
    [(0, $hgUW1$media1).below.sm]: {
        width: "100%",
        margin: 0,
        marginTop: "12px"
    }
});
const $44303f6c3c81eeac$var$chooseCorrectAnswerStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (0, $hgUW1$token)("color.text.subtlest"),
    marginTop: 0,
    marginBottom: "24px",
    [(0, $hgUW1$media1).below.xs]: {
        fontSize: "14px",
        lineHeight: "22px",
        marginBottom: "16px"
    }
});
const $44303f6c3c81eeac$var$answerContainerStyles = (0, $hgUW1$css)({
    marginBottom: "24px",
    [(0, $hgUW1$media1).below.xs]: {
        marginBottom: "20px"
    }
});
const $44303f6c3c81eeac$var$quizInputsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    gap: "24px",
    marginTop: "24px"
});
const $44303f6c3c81eeac$var$buttonContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    marginTop: "32px",
    [(0, $hgUW1$media1).below.xs]: {
        marginTop: "24px"
    }
});
const $44303f6c3c81eeac$var$feedbackContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    width: "100%"
});
const $44303f6c3c81eeac$var$questionsStepStyles = (0, $hgUW1$css)({
    minWidth: "115px",
    marginLeft: "24px",
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Charlie Text, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px"
});
const $44303f6c3c81eeac$var$completionMessageStyles = (0, $hgUW1$css)({
    marginTop: "40px",
    marginBottom: 0,
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    textAlign: "center"
});
const $44303f6c3c81eeac$var$matchingFeedbackContainerStyles = (0, $hgUW1$css)({
    marginTop: "40px",
    maxWidth: "624px",
    width: "100%",
    [(0, $hgUW1$media1).below.xs]: {
        display: "none"
    }
});


var $9c3f769544bb2079$exports = {};

$parcel$export($9c3f769544bb2079$exports, "Sidebar", () => $9c3f769544bb2079$export$1ba59dacbcbf90fe);





const $9c3f769544bb2079$export$1ba59dacbcbf90fe = ({ onChangeMenuVisibility: onChangeMenuVisibility , isVisible: isVisible = true , children: children  })=>{
    const toggleMenu = ()=>{
        if (onChangeMenuVisibility) onChangeMenuVisibility(!isVisible);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $9c3f769544bb2079$var$sidebarNavContainerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                "data-testid": "button-toggle-menu-toggle",
                css: [
                    $9c3f769544bb2079$var$buttonToggleMenuStyles,
                    !isVisible && $9c3f769544bb2079$var$buttonToggleMenuClosedStyles,
                    isVisible && $9c3f769544bb2079$var$buttonToggleMenuOpenStyles
                ],
                onClick: toggleMenu,
                "aria-label": "toggle menu",
                children: isVisible ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "chevron-left",
                    color: (0, $hgUW1$token)("color.icon")
                }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: "chevron-right",
                    color: (0, $hgUW1$token)("color.icon")
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
                    "data-testid": "button-toggle-menu-show",
                    css: $9c3f769544bb2079$var$mobileButtonToggleMenuStyles,
                    onClick: toggleMenu,
                    "aria-label": "show menu",
                    children: [
                        isVisible ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "dropdown-cross",
                            color: (0, $hgUW1$token)("color.icon")
                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "menu-icon",
                            color: (0, $hgUW1$token)("color.icon")
                        }),
                        isVisible ? /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: (0, $hgUW1$css)({
                                span: {
                                    color: (0, $hgUW1$token)("color.icon")
                                }
                            }),
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                                children: "Close"
                            })
                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: (0, $hgUW1$css)({
                                span: {
                                    color: (0, $hgUW1$token)("color.icon")
                                }
                            }),
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                                children: "Menu"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: [
                    isVisible && $9c3f769544bb2079$var$sidebarOpenStyles,
                    !isVisible && $9c3f769544bb2079$var$sidebarClosedStyles,
                    $9c3f769544bb2079$var$sidebarStyles
                ],
                "data-testid": "sidebar",
                children: isVisible && children
            })
        ]
    });
};
const $9c3f769544bb2079$var$sidebarNavContainerStyles = (0, $hgUW1$css)({
    position: "absolute",
    height: "100%",
    opacity: 1,
    display: "block",
    transform: "translateX(0px)",
    [(0, $hgUW1$media1).below.sm]: {
        width: "100%",
        position: "absolute"
    }
});
const $9c3f769544bb2079$var$sidebarStyles = (0, $hgUW1$css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    height: "100%",
    paddingTop: "1.75rem",
    paddingRight: "7px",
    paddingLeft: "0.5rem",
    top: 0,
    bottom: 0,
    left: 0,
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderColor: (0, $hgUW1$token)("color.border"),
    borderTop: "none",
    borderLeft: "none",
    backgroundColor: (0, $hgUW1$token)("elevation.surface.sunken"),
    overflowY: "auto",
    overflowX: "hidden"
});
const $9c3f769544bb2079$var$sidebarClosedStyles = (0, $hgUW1$css)({
    width: "1.25rem",
    [(0, $hgUW1$media1).below.sm]: {
        top: 0,
        borderRightWidth: 0,
        paddingTop: 0,
        height: 0,
        width: "100%",
        position: "absolute"
    }
});
const $9c3f769544bb2079$var$sidebarOpenStyles = (0, $hgUW1$css)({
    display: "block",
    transform: "translateX(0px)",
    paddingTop: "1.75rem",
    position: "fixed",
    [(0, $hgUW1$media1).below.sm]: {
        width: "100vw",
        marginTop: "3rem",
        position: "absolute"
    },
    [(0, $hgUW1$media1).above.sm]: {
        width: "26.25rem",
        position: "absolute"
    },
    [(0, $hgUW1$media1).below.md]: {
        boxShadow: `0 0 0 10000px ${(0, $hgUW1$token)("color.blanket")}`
    },
    [(0, $hgUW1$media1).above.lg]: {
        position: "relative",
        boxShadow: "none"
    }
});
const $9c3f769544bb2079$var$mobileButtonToggleMenuContainerStyles = (0, $hgUW1$css)({
    display: "none",
    alignItems: "center",
    justifyContent: "align-start",
    width: "100vw",
    paddingLeft: "1rem",
    height: "3rem",
    borderBottom: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    borderLeft: "none",
    borderRight: "none",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    position: "relative",
    zIndex: 200,
    [(0, $hgUW1$media1).below.sm]: {
        display: "flex"
    }
});
const $9c3f769544bb2079$var$mobileButtonToggleMenuStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    border: "none",
    background: "transparent",
    outline: "none"
});
const $9c3f769544bb2079$var$buttonToggleMenuStyles = (0, $hgUW1$css)({
    transition: "all",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    transitionDuration: "300ms",
    border: "none",
    borderRadius: "9999px",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    width: "1.5rem",
    height: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay"),
    position: "absolute",
    top: "1.75rem",
    zIndex: 200,
    cursor: "pointer",
    [(0, $hgUW1$media1).below.sm]: {
        display: "none"
    }
});
const $9c3f769544bb2079$var$buttonToggleMenuOpenStyles = (0, $hgUW1$css)({
    marginLeft: "25.5rem"
});
const $9c3f769544bb2079$var$buttonToggleMenuClosedStyles = (0, $hgUW1$css)({
    marginLeft: "0.5rem"
});


var $3d76652bb6362040$exports = {};

$parcel$export($3d76652bb6362040$exports, "LearningSidebar", () => $3d76652bb6362040$export$4ff69a78d3a65d6f);












let $035f8a623e403361$export$23d03d0b3065d061;
(function(LearningProgressStatus) {
    LearningProgressStatus["NOT_STARTED"] = "NOT_STARTED";
    LearningProgressStatus["IN_PROGRESS"] = "IN_PROGRESS";
    LearningProgressStatus["COMPLETED"] = "COMPLETED";
})($035f8a623e403361$export$23d03d0b3065d061 || ($035f8a623e403361$export$23d03d0b3065d061 = {}));
let $035f8a623e403361$export$490c7ce941281ba8;
(function(CardStatus) {
    CardStatus["COMPLETED"] = "completed";
    CardStatus["DEFAULT"] = "default";
})($035f8a623e403361$export$490c7ce941281ba8 || ($035f8a623e403361$export$490c7ce941281ba8 = {}));
const $035f8a623e403361$export$780035d9fe48eb32 = 420;




const $32c02b5652036d7a$var$SidebarContext = /*#__PURE__*/ (0, $hgUW1$createContext)(undefined);
const $32c02b5652036d7a$export$861cd542ff836f0d = ()=>{
    const context = (0, $hgUW1$useContext)($32c02b5652036d7a$var$SidebarContext);
    if (!context) throw new Error("useSidebarContext must be used within a SidebarContextProvider");
    return context;
};
const $32c02b5652036d7a$export$d8355e8edbcacbe8 = ({ children: children  })=>{
    const [hoverInfo, setHoverInfo] = (0, $hgUW1$useState)(null);
    const contextValue = (0, $hgUW1$useMemo)(()=>({
            hoverInfo: hoverInfo,
            setHoverInfo: setHoverInfo
        }), [
        hoverInfo,
        setHoverInfo
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsx)($32c02b5652036d7a$var$SidebarContext.Provider, {
        value: contextValue,
        children: children
    });
};
















let $47b694880a211b2b$export$40bdb27f2137fcf;
(function(Appearance) {
    Appearance["COURSE"] = "course";
    Appearance["LESSON"] = "lesson";
    Appearance["SECTION"] = "section";
})($47b694880a211b2b$export$40bdb27f2137fcf || ($47b694880a211b2b$export$40bdb27f2137fcf = {}));
/**
 * Props for the TextTooltip component
 * @param {string} text - Text to display in the tooltip
 * @param {CardStatus} status - Current status of the item (completed, or default)
 * @param {Appearance} appearance - Whether the item is a course card or lesson card
 * @param {boolean} isSelected - Whether the item is selected
 */ const $47b694880a211b2b$var$MOBILE_SCREEN_WIDTH = 650;
const $47b694880a211b2b$export$c0d3d8bfa41e2e2a = ({ text: text , status: status , appearance: appearance , isSelected: isSelected  })=>{
    const [isTruncated, setIsTruncated] = (0, $hgUW1$useState)(false);
    const textRef = (0, $hgUW1$useRef)(null);
    const deviceSize = (0, $3ced3ef7e9864bf1$export$4616d33c54ae5baf)();
    (0, $hgUW1$useEffect)(()=>{
        const checkTruncation = ()=>{
            if (textRef.current) // Check if the text is truncated by comparing scrollWidth to clientWidth
            setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
        };
        checkTruncation();
        window.addEventListener("resize", checkTruncation);
        return ()=>{
            window.removeEventListener("resize", checkTruncation);
        };
    }, [
        text
    ]);
    const isLesson = appearance === $47b694880a211b2b$export$40bdb27f2137fcf.LESSON;
    const isCourse = appearance === $47b694880a211b2b$export$40bdb27f2137fcf.COURSE;
    const isSection = appearance === $47b694880a211b2b$export$40bdb27f2137fcf.SECTION;
    const textElement = /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
        "data-testid": "sidebar-text-tooltip",
        ref: textRef,
        css: [
            isCourse && $47b694880a211b2b$var$courseTitleStyles,
            isCourse && isSelected && $47b694880a211b2b$var$titleSelectedStyles,
            isLesson && $47b694880a211b2b$var$lessonTitleStyles,
            isLesson && isSelected && $47b694880a211b2b$var$titleSelectedStyles,
            $47b694880a211b2b$var$sectionTitleStyles,
            isCourse && $47b694880a211b2b$var$courseMaxWidth,
            isLesson && $47b694880a211b2b$var$lessonMaxWidth,
            status === (0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED && $47b694880a211b2b$var$sectionTitleCompletedStyles,
            status === (0, $035f8a623e403361$export$490c7ce941281ba8).DEFAULT && $47b694880a211b2b$var$sectionTitleDefaultStyles,
            isSection && isSelected && $47b694880a211b2b$var$sectionTitleSelectedStyles
        ],
        children: text
    });
    const isMobile = deviceSize <= $47b694880a211b2b$var$MOBILE_SCREEN_WIDTH;
    return isTruncated ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskittooltip), {
        content: text,
        position: isMobile ? "bottom" : "right",
        children: textElement
    }) : textElement;
};
const $47b694880a211b2b$var$sectionTitleStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    marginTop: 0,
    marginLeft: "10px",
    maxWidth: "330px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [(0, $hgUW1$media).below.xs]: {
        maxWidth: "290px"
    }
});
const $47b694880a211b2b$var$sectionTitleSelectedStyles = (0, $hgUW1$css)({
    fontWeight: 600,
    color: (0, $hgUW1$token)("color.text.selected")
});
const $47b694880a211b2b$var$sectionTitleCompletedStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtlest")
});
const $47b694880a211b2b$var$sectionTitleDefaultStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtle")
});
const $47b694880a211b2b$var$lessonTitleStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    fontSize: "16px",
    color: (0, $hgUW1$token)("color.text.subtle"),
    marginTop: 0,
    marginRight: "auto",
    marginLeft: (0, $hgUW1$token)("space.025")
});
const $47b694880a211b2b$var$titleSelectedStyles = (0, $hgUW1$css)({
    fontWeight: "500 !important",
    color: (0, $hgUW1$token)("color.text")
});
const $47b694880a211b2b$var$courseTitleStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    marginTop: 0
});
const $47b694880a211b2b$var$courseMaxWidth = (0, $hgUW1$css)({
    marginLeft: 0,
    maxWidth: "320px"
});
const $47b694880a211b2b$var$lessonMaxWidth = (0, $hgUW1$css)({
    marginLeft: 0,
    marginRight: "auto",
    maxWidth: "290px",
    [(0, $hgUW1$media).below.xs]: {
        maxWidth: "270px"
    }
});










const $4baed82dabfd5555$var$loadingFlash = (0, $hgUW1$keyframes)`
  0% {
    background-position: -10px;
  }
  100% {
    background-position: calc(100% + 250px);
  }
`;
const $4baed82dabfd5555$var$skeletonStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(241, 242, 244, 1)",
    borderRadius: "4px",
    position: "relative",
    "&::before": {
        content: '""',
        display: "block",
        width: "100%",
        height: "100%",
        borderRadius: "4px",
        background: `linear-gradient(
      90deg,
      rgba(241, 242, 244, 1) 0,
      #f9f9f9 calc(50% - 25px),
      #f9f9f9 calc(50% + 25px),
      rgba(241, 242, 244, 1) 100%
    )`,
        backgroundSize: "35%",
        backgroundPosition: 0,
        backgroundRepeat: "no-repeat",
        animation: `${$4baed82dabfd5555$var$loadingFlash} 2.5s infinite linear`
    }
});
const $4baed82dabfd5555$export$27a22c945b52f415 = ()=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $4baed82dabfd5555$var$skeletonStyles,
        "data-testid": "skeleton-loader"
    });




const $193bb26965d10640$export$9794789a1567361c = /*#__PURE__*/ (0, $hgUW1$memo)(()=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $193bb26965d10640$var$loaderContainerStyles,
        children: [
            [
                ...Array(4)
            ].map((_, index)=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $193bb26965d10640$var$sectionBarStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: (0, $0ca1c0d89e77a13d$export$a3b47b9708ebe4f0)[(0, $035f8a623e403361$export$490c7ce941281ba8).DEFAULT],
                            color: (0, $hgUW1$token)("color.icon")
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $193bb26965d10640$var$skeletonLoaderBarStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4baed82dabfd5555$export$27a22c945b52f415), {})
                        })
                    ]
                }, index)),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $193bb26965d10640$var$sectionBarStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: (0, $0ca1c0d89e77a13d$export$a3b47b9708ebe4f0)[(0, $035f8a623e403361$export$490c7ce941281ba8).DEFAULT],
                        color: (0, $hgUW1$token)("color.icon")
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $47b694880a211b2b$export$c0d3d8bfa41e2e2a), {
                        text: "Quiz",
                        status: (0, $035f8a623e403361$export$490c7ce941281ba8).DEFAULT,
                        isSelected: false
                    })
                ]
            })
        ]
    }));
const $193bb26965d10640$var$loaderContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $hgUW1$token)("space.100"),
    padding: (0, $hgUW1$token)("space.100")
});
const $193bb26965d10640$var$skeletonLoaderBarStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "20px",
    marginLeft: "10px"
});
const $193bb26965d10640$var$sectionBarStyles = (0, $hgUW1$css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $hgUW1$token)("color.background.neutral")
        }
    }
});









const $0efd93166e145c77$export$a3b47b9708ebe4f0 = {
    [(0, $035f8a623e403361$export$490c7ce941281ba8).DEFAULT]: "dot-default",
    [(0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED]: "dot-completed"
};
const $0efd93166e145c77$export$411533295806dc51 = (sectionContentfulId, seenSectionObserver)=>{
    const element = document.getElementById(`${sectionContentfulId}`);
    if (element) seenSectionObserver.unobserve(element);
};
const $0efd93166e145c77$export$a1fd357e7aacc4df = /*#__PURE__*/ (0, $hgUW1$memo)(({ section: { title: title , id: id  } , status: status , courseSlug: courseSlug , lessonSlug: lessonSlug , onSelect: onSelect , isSelected: isSelected  })=>{
    const handleSectionClick = (e)=>{
        e.stopPropagation();
        onSelect(courseSlug || "", lessonSlug, id);
    };
    const getIconType = ()=>{
        if (isSelected && status === (0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED) return $0efd93166e145c77$export$a3b47b9708ebe4f0[status];
        if (isSelected) return "dot-selected";
        return $0efd93166e145c77$export$a3b47b9708ebe4f0[status];
    };
    const type = getIconType();
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "sidebar-section-item",
        css: [
            $0efd93166e145c77$var$sectionBarStyles,
            isSelected && $0efd93166e145c77$var$sectionBarSelectedStyles
        ],
        onClick: handleSectionClick,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                type: type,
                color: (0, $hgUW1$token)("color.icon")
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $47b694880a211b2b$export$c0d3d8bfa41e2e2a), {
                text: title,
                status: status,
                isSelected: isSelected,
                appearance: (0, $47b694880a211b2b$export$40bdb27f2137fcf).SECTION
            })
        ]
    });
});
const $0efd93166e145c77$var$sectionBarStyles = (0, $hgUW1$css)({
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0 4px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:active": {
        background: `${(0, $hgUW1$token)("color.background.accent.gray.subtlest.hovered")} !important`
    },
    "&:hover": {
        background: "rgba(220, 223, 228, 0.50)",
        "&::before": {
            content: '""',
            display: "block",
            width: "2px",
            height: "12px",
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            background: (0, $hgUW1$token)("color.background.neutral")
        }
    }
});
const $0efd93166e145c77$var$sectionBarSelectedStyles = (0, $hgUW1$css)({
    "&::before": {
        content: '""',
        display: "block",
        width: "2px",
        height: "12px",
        position: "absolute",
        left: 0,
        top: "50%",
        transform: "translateY(-50%)",
        background: `${(0, $hgUW1$token)("color.text.selected")} !important`
    }
});



const $48630d5962798e4a$export$272e7ef3ea22070d = (status)=>{
    switch(status){
        case (0, $035f8a623e403361$export$23d03d0b3065d061).COMPLETED:
            return (0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED;
        case (0, $035f8a623e403361$export$23d03d0b3065d061).IN_PROGRESS:
        case (0, $035f8a623e403361$export$23d03d0b3065d061).NOT_STARTED:
        default:
            return (0, $035f8a623e403361$export$490c7ce941281ba8).DEFAULT;
    }
};
const $48630d5962798e4a$export$15379570ba48f04d = (courseSlug, lessonSlug, sectionSlug)=>{
    const currentPath = globalThis.location.pathname;
    const currentHash = globalThis.location.hash;
    if (courseSlug) return currentPath.includes(`/course/${courseSlug}`);
    if (sectionSlug === "quiz") return currentPath.includes(`lesson/${lessonSlug}`) && currentHash === "#quiz";
    if (sectionSlug) return currentPath.includes(`/lesson/${lessonSlug}`) && currentHash === `#${sectionSlug}`;
    if (lessonSlug) {
        const lessonPath = `/lesson/${lessonSlug}`;
        return currentPath.endsWith(lessonPath) || currentPath.includes(lessonPath + "/");
    }
    return currentHash === `#${sectionSlug}`;
};


const $d1d0f9af78cf2050$export$5496f515fa03c54e = (totalMinutes)=>{
    if (totalMinutes > 59) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (minutes === 0) return `${hours} h`;
        return `${hours} h ${minutes} min`;
    }
    return `${totalMinutes} min`;
};


const $0ca1c0d89e77a13d$export$a3b47b9708ebe4f0 = {
    [(0, $035f8a623e403361$export$490c7ce941281ba8).DEFAULT]: "dot-default",
    [(0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED]: "dot-completed"
};
const $0ca1c0d89e77a13d$export$951debaed2d5c034 = /*#__PURE__*/ (0, $hgUW1$memo)((props)=>{
    const { lesson: { sys: sys , slug: slug , title: title , sectionListCollection: sectionListCollection , duration: duration  } , courseSlug: courseSlug , isLoading: isLoading , progressForLesson: progressForLesson , onSelect: onSelect , expandedLessonIds: expandedLessonIds , selectedSectionId: selectedSectionId , currentLessonSlug: currentLessonSlug  } = props;
    const isSelected = (0, $48630d5962798e4a$export$15379570ba48f04d)("", slug);
    const status = (0, $48630d5962798e4a$export$272e7ef3ea22070d)(progressForLesson?.status);
    const [isLessonCardExpanded, setIsLessonCardExpanded] = (0, $hgUW1$useState)(false);
    (0, $hgUW1$useEffect)(()=>{
        const isExpanded = expandedLessonIds?.includes(sys.id);
        setIsLessonCardExpanded(isExpanded || false);
    }, [
        expandedLessonIds
    ]);
    const handleExpandClick = (e)=>{
        e.stopPropagation();
        setIsLessonCardExpanded(!isLessonCardExpanded);
    };
    const handleCardClick = ()=>{
        setIsLessonCardExpanded(true);
        onSelect(courseSlug || "", slug);
    };
    const renderStatusIndicator = ()=>{
        if (status === (0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
            type: "check-circle-outline",
            color: (0, $hgUW1$token)("color.icon.success")
        });
        return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: [
                $0ca1c0d89e77a13d$var$lessonTimeBadgeStyles,
                isSelected && $0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles
            ],
            children: (0, $d1d0f9af78cf2050$export$5496f515fa03c54e)(duration)
        });
    };
    const renderSections = ()=>{
        if (isLoading && isLessonCardExpanded) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $193bb26965d10640$export$9794789a1567361c), {});
        if (!isLessonCardExpanded) return null;
        return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $0ca1c0d89e77a13d$var$sectionContainerStyles,
            children: sectionListCollection.items.map((section)=>{
                const sectionStatus = section.id === "quiz" && status === (0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED ? (0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED : (0, $48630d5962798e4a$export$272e7ef3ea22070d)(progressForLesson?.section.find((sectionProgress)=>sectionProgress.sectionId === section.sys.id)?.status);
                return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0efd93166e145c77$export$a1fd357e7aacc4df), {
                    section: section,
                    status: sectionStatus,
                    onSelect: onSelect,
                    lessonSlug: slug,
                    courseSlug: courseSlug,
                    isSelected: currentLessonSlug === slug && section.sys.id === selectedSectionId
                }, section.id);
            })
        });
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "sidebar-lesson-card",
        css: [
            $0ca1c0d89e77a13d$var$lessonCardStyles,
            isSelected && $0ca1c0d89e77a13d$var$lessonCardSelectedStyles
        ],
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $0ca1c0d89e77a13d$var$lessonCardHeaderStyles,
                onClick: handleCardClick,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $0ca1c0d89e77a13d$var$lessonExpanderStyles,
                        onClick: handleExpandClick,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: isLessonCardExpanded ? "chevron-down" : "chevron-right",
                            color: (0, $hgUW1$token)("color.icon")
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $47b694880a211b2b$export$c0d3d8bfa41e2e2a), {
                        text: title,
                        isSelected: isSelected,
                        appearance: (0, $47b694880a211b2b$export$40bdb27f2137fcf).LESSON
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles,
                        children: renderStatusIndicator()
                    })
                ]
            }),
            renderSections()
        ]
    });
});
const $0ca1c0d89e77a13d$var$lessonCardStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $hgUW1$token)("space.100"),
    paddingBottom: (0, $hgUW1$token)("space.100"),
    paddingLeft: (0, $hgUW1$token)("space.250"),
    paddingRight: (0, $hgUW1$token)("space.100"),
    "&:active": {
        background: "#F1F2F4 !important"
    },
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $0ca1c0d89e77a13d$var$lessonCardSelectedStyles = (0, $hgUW1$css)({
    background: (0, $hgUW1$token)("color.background.input.hovered"),
    "&:active": {
        background: `${(0, $hgUW1$token)("color.background.input.hovered")} !important`
    }
});
const $0ca1c0d89e77a13d$var$lessonCardHeaderStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    cursor: "pointer"
});
const $0ca1c0d89e77a13d$var$lessonExpanderStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    cursor: "pointer",
    marginRight: (0, $hgUW1$token)("space.025")
});
const $0ca1c0d89e77a13d$var$lessonTimeBadgeStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    color: (0, $hgUW1$token)("color.text"),
    padding: `${(0, $hgUW1$token)("space.025")} ${(0, $hgUW1$token)("space.075")}`,
    borderRadius: "8px",
    background: (0, $hgUW1$token)("color.background.neutral"),
    marginLeft: "auto"
});
const $0ca1c0d89e77a13d$var$lessonTimeBadgeSelectedStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.brand"),
    background: (0, $hgUW1$token)("color.background.brand.subtlest")
});
const $0ca1c0d89e77a13d$var$sectionContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginLeft: (0, $hgUW1$token)("space.200"),
    marginTop: (0, $hgUW1$token)("space.100")
});
const $0ca1c0d89e77a13d$var$lessonTimeBadgeContainerStyles = (0, $hgUW1$css)({
    marginLeft: "auto"
});








const $11732cc088354996$export$748c6b3a71d1e268 = /*#__PURE__*/ (0, $hgUW1$memo)(()=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Fragment), {
        children: [
            ...Array(4)
        ].map((_, index)=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $11732cc088354996$var$lessonCardHeaderStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $11732cc088354996$var$lessonExpanderStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "chevron-right",
                            color: (0, $hgUW1$token)("color.icon")
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $11732cc088354996$var$skeletonLoaderBarStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4baed82dabfd5555$export$27a22c945b52f415), {}),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $11732cc088354996$var$skeletonTimeLoaderBarStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4baed82dabfd5555$export$27a22c945b52f415), {})
                            })
                        ]
                    })
                ]
            }, index))
    }));
const $11732cc088354996$var$lessonCardHeaderStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: (0, $hgUW1$token)("space.100"),
    paddingBottom: (0, $hgUW1$token)("space.100"),
    paddingLeft: (0, $hgUW1$token)("space.250"),
    paddingRight: (0, $hgUW1$token)("space.100")
});
const $11732cc088354996$var$lessonExpanderStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px"
});
const $11732cc088354996$var$skeletonTimeLoaderBarStyles = (0, $hgUW1$css)({
    width: "50px",
    height: "20px",
    marginLeft: (0, $hgUW1$token)("space.300")
});
const $11732cc088354996$var$skeletonLoaderBarStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "20px",
    marginLeft: (0, $hgUW1$token)("space.025")
});





var $ef44b01e6346ac17$require$Buffer = $hgUW1$Buffer;
const $ef44b01e6346ac17$var$badge = `<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_2407_668" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="120" height="120">
<path d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z" fill="#FCA700"/>
</mask>
<g mask="url(#mask0_2407_668)">
<path d="M59.9919 120.001C93.129 120.001 119.992 93.1381 119.992 60.001C119.992 26.8639 93.129 0.00100708 59.9919 0.00100708C26.8549 0.00100708 -0.00805664 26.8639 -0.00805664 60.001C-0.00805664 93.1381 26.8549 120.001 59.9919 120.001Z" fill="#F0F1F2"/>
<path d="M114.195 48.5778C139.041 82.736 131.616 130.479 97.5729 155.447L75.6838 125.554C93.1971 112.63 97.0229 88.0317 84.2648 70.3823L114.195 48.5778Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M61.381 -11.1668L61.381 -11.1667L61.3875 -11.1713C66.9496 -15.1726 72.2687 -18.6935 77.3965 -21.8258L116.987 15.9668C109.215 16.5818 99.355 21.2346 85.3825 30.54L85.3825 30.5399L85.3765 30.5441C79.0802 35.0076 73.098 38.8783 67.3602 42.2665L28.6585 5.32281C36.6192 3.90769 46.9288 -1.45355 61.381 -11.1668Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M-4.01227 93.1467L46.5982 80.1918L59.4265 130.835L8.81594 143.79L-4.01227 93.1467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M3.67239 23.827L3.68518 23.7211L3.66478 23.6962C4.43632 16.9412 1.0124 10.0403 -2.57376 4.84886C-4.3803 2.23367 -6.23694 0.0395466 -7.64175 -1.5007C-8.34432 -2.27099 -8.93428 -2.8782 -9.34902 -3.29322C-9.39083 -3.33506 -9.43086 -3.37495 -9.46905 -3.41285L13.9267 -0.587166C22.5213 4.49206 28.577 10.8772 32.2178 18.2212C35.8649 25.5781 37.096 33.9122 36.0121 42.8863C34.4107 56.146 27.9882 65.8687 18.1125 72.3709C8.28951 78.8384 -4.96514 82.1287 -20.3194 82.5128L-15.6409 43.7758C-9.8996 42.5993 -5.41093 40.3431 -2.18767 37.026C1.06994 33.6736 3.01663 29.2565 3.67239 23.827Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M98.1255 59.8467C98.1255 81.1403 81.101 98.3963 60.1074 98.3963C39.1139 98.3963 22.0894 81.1403 22.0894 59.8467C22.0894 38.5531 39.1139 21.2971 60.1074 21.2971C81.101 21.2971 98.1255 38.5531 98.1255 59.8467Z" stroke="#1868DB" stroke-width="0.5"/>
<path d="M35.4794 65.1887C35.2675 65.5337 35.0269 65.9381 34.84 66.2562C34.66 66.5631 34.7569 66.9575 35.06 67.1444L39.3062 69.765C39.6175 69.9569 40.025 69.8581 40.2106 69.5431C40.3794 69.2575 40.5981 68.89 40.8369 68.495C42.52 65.7175 44.2125 66.0562 47.2619 67.5056L51.4731 69.5075C51.805 69.6656 52.2019 69.5181 52.3512 69.1819L54.3737 64.6156C54.5175 64.2906 54.3762 63.9112 54.055 63.76C53.1656 63.3419 51.3981 62.5075 49.8156 61.7412C44.0656 58.9569 39.2 59.1406 35.48 65.1887H35.4794Z" fill="url(#paint0_linear_2407_668)"/>
<path d="M54.5206 54.8113C54.7325 54.4663 54.9731 54.0619 55.16 53.7438C55.34 53.4369 55.2431 53.0425 54.94 52.8556L50.6938 50.235C50.3825 50.0431 49.975 50.1419 49.7894 50.4569C49.6206 50.7425 49.4019 51.11 49.1631 51.505C47.48 54.2825 45.7875 53.9438 42.7381 52.4944L38.5269 50.4925C38.195 50.3344 37.7981 50.4819 37.6488 50.8181L35.6263 55.3844C35.4825 55.7094 35.6238 56.0888 35.945 56.24C36.8344 56.6581 38.6019 57.4925 40.1844 58.2588C45.9344 61.0431 50.8 60.8594 54.52 54.8113H54.5206Z" fill="url(#paint1_linear_2407_668)"/>
<path d="M85.1263 49.5188H73.8275C73.8275 52.335 76.1106 54.6175 78.9263 54.6175H81.0069V56.6256C81.0069 59.4419 83.29 61.7244 86.1056 61.7244V50.4988C86.1056 49.9575 85.6669 49.5188 85.1256 49.5188H85.1263Z" fill="#1D7AFC"/>
<path d="M79.5345 55.1475H68.2357C68.2357 57.9638 70.5188 60.2463 73.3345 60.2463H75.4151V62.2544C75.4151 65.0706 77.6982 67.3531 80.5138 67.3531V56.1275C80.5138 55.5863 80.0751 55.1475 79.5338 55.1475H79.5345Z" fill="url(#paint2_linear_2407_668)"/>
<path d="M73.9425 60.7756H62.6438C62.6438 63.5919 64.9269 65.8744 67.7425 65.8744H69.8232V67.8825C69.8232 70.6988 72.1063 72.9813 74.9219 72.9813V61.7556C74.9219 61.2144 74.4832 60.7756 73.9419 60.7756H73.9425Z" fill="url(#paint3_linear_2407_668)"/>
</g>
<defs>
<linearGradient id="paint0_linear_2407_668" x1="54.2475" y1="71.11" x2="41.3981" y2="63.7263" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint1_linear_2407_668" x1="35.7519" y1="48.89" x2="48.6019" y2="56.2738" gradientUnits="userSpaceOnUse">
<stop stop-color="#0055CC"/>
<stop offset="0.972" stop-color="#1C78FA"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint2_linear_2407_668" x1="80.2745" y1="55.1663" x2="75.4682" y2="60.1225" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
<linearGradient id="paint3_linear_2407_668" x1="75.0019" y1="60.8281" x2="69.445" y2="66.2344" gradientUnits="userSpaceOnUse">
<stop offset="0.176" stop-color="#0055CC"/>
<stop offset="1" stop-color="#1D7AFC"/>
</linearGradient>
</defs>
</svg>`;
const $ef44b01e6346ac17$export$44f5f766f3f98994 = `data:image/svg+xml;base64,${$ef44b01e6346ac17$require$Buffer.from($ef44b01e6346ac17$var$badge).toString("base64")}`;


const $aefb4e9d0a694068$export$bb61bd2f4f2a772c = (props)=>{
    const { setHoverInfo: setHoverInfo  } = (0, $32c02b5652036d7a$export$861cd542ff836f0d)();
    return /*#__PURE__*/ (0, $hgUW1$jsx)($aefb4e9d0a694068$export$7b8f328152f30a2c, {
        ...props,
        onHover: setHoverInfo
    });
};
const $aefb4e9d0a694068$export$7b8f328152f30a2c = /*#__PURE__*/ (0, $hgUW1$memo)(({ course: { sys: sys , title: title , reward: reward , slug: slug , lessonsCollection: lessonsCollection  } , status: status , isLoading: isLoading , selectedLessonRef: selectedLessonRef , progressForLessons: progressForLessons , onHover: onHover , onSelect: onSelect , expandedLessonIds: expandedLessonIds = [] , expandedCourseIds: expandedCourseIds = [] , selectedSectionId: selectedSectionId , currentLessonSlug: currentLessonSlug  })=>{
    const courseCardRef = (0, $hgUW1$useRef)(null);
    const isSelected = (0, $48630d5962798e4a$export$15379570ba48f04d)(slug);
    const [isCourseExpanded, setIsCourseExpanded] = (0, $hgUW1$useState)(false);
    (0, $hgUW1$useEffect)(()=>{
        const isExpanded = expandedCourseIds.includes(sys.id);
        setIsCourseExpanded(isExpanded || false);
    }, [
        expandedCourseIds
    ]);
    const courseCardTitle = {
        [(0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED]: "Completed",
        [(0, $035f8a623e403361$export$490c7ce941281ba8).DEFAULT]: "Course"
    };
    const numberOfCompletedLessons = lessonsCollection.items.filter(({ sys: { id: id  }  })=>(0, $48630d5962798e4a$export$272e7ef3ea22070d)(progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status) === (0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED).length;
    const numberOfTotalLessons = lessonsCollection.items.length;
    const progress = numberOfCompletedLessons / numberOfTotalLessons * 100;
    const isStatusCompleted = progress === 100;
    const handleCourseCardExpand = (0, $hgUW1$useCallback)(()=>{
        setIsCourseExpanded(!isCourseExpanded);
        onSelect(slug);
    }, [
        isCourseExpanded,
        onSelect,
        slug
    ]);
    const showCoursePopup = (0, $hgUW1$useCallback)(()=>{
        if (courseCardRef.current) onHover({
            courseId: sys.id,
            courseCardPosition: courseCardRef.current.getBoundingClientRect()
        });
    }, [
        sys.id,
        onHover
    ]);
    const hideCoursePopup = (0, $hgUW1$useCallback)(()=>{
        onHover(null);
    }, [
        onHover
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "sidebar-course-card",
        css: [
            $aefb4e9d0a694068$var$courseCardStyles,
            isCourseExpanded && $aefb4e9d0a694068$var$courseCardOpenedStyles
        ],
        ref: courseCardRef,
        onMouseEnter: showCoursePopup,
        onMouseLeave: hideCoursePopup,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: [
                    $aefb4e9d0a694068$var$courseCardHeaderStyles,
                    isCourseExpanded && $aefb4e9d0a694068$var$courseCardHeaderOpenedStyles
                ],
                onClick: handleCourseCardExpand,
                onMouseEnter: showCoursePopup,
                "data-testid": "course-card-header",
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: [
                            $aefb4e9d0a694068$var$courseExpanderStyles,
                            isCourseExpanded && $aefb4e9d0a694068$var$courseExpanderSelectedStyles
                        ],
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: isCourseExpanded ? "chevron-down" : "chevron-right",
                            color: isCourseExpanded ? (0, $hgUW1$token)("color.icon.selected") : (0, $hgUW1$token)("color.icon")
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $aefb4e9d0a694068$var$courseTitleContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                css: [
                                    $aefb4e9d0a694068$var$courseCardTitleStyles,
                                    status === (0, $035f8a623e403361$export$490c7ce941281ba8).COMPLETED && $aefb4e9d0a694068$var$courseCardTitleCompletedStyles,
                                    status === (0, $035f8a623e403361$export$490c7ce941281ba8).DEFAULT && $aefb4e9d0a694068$var$courseCardTitleDefaultStyles,
                                    isSelected && $aefb4e9d0a694068$var$courseCardTitleSelectedStyles
                                ],
                                children: isSelected ? "Current course".toUpperCase() : courseCardTitle[status].toUpperCase()
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $47b694880a211b2b$export$c0d3d8bfa41e2e2a), {
                                text: title,
                                isSelected: isSelected,
                                appearance: (0, $47b694880a211b2b$export$40bdb27f2137fcf).COURSE
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $aefb4e9d0a694068$var$progressCircleContainerStyles,
                        "data-testid": "course-progress-circle",
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$CircularProgressbarWithChildren), {
                                strokeWidth: 8,
                                value: progress,
                                styles: (0, $hgUW1$buildStyles)({
                                    pathColor: (0, $hgUW1$token)("color.border.success"),
                                    trailColor: "rgba(9, 30, 66, 0.14)"
                                }),
                                css: [
                                    isStatusCompleted && $aefb4e9d0a694068$var$completedCourseProgressStyles
                                ],
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: [
                                        $aefb4e9d0a694068$var$imageBadgeContainerStyles,
                                        isStatusCompleted && $aefb4e9d0a694068$var$completedCourseProgressStyles
                                    ],
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                                        css: $aefb4e9d0a694068$var$imageStyles,
                                        "data-testid": "course-badge-image",
                                        src: reward?.badgeCdnUrl || reward?.badge?.[0]?.cdn_url || (0, $ef44b01e6346ac17$export$44f5f766f3f98994),
                                        alt: title
                                    })
                                })
                            }),
                            isStatusCompleted && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                type: "check",
                                color: (0, $hgUW1$token)("color.icon.success")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $aefb4e9d0a694068$var$lessonContainerStyles,
                onMouseEnter: hideCoursePopup,
                children: isLoading && isCourseExpanded ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $11732cc088354996$export$748c6b3a71d1e268), {}) : isCourseExpanded && lessonsCollection.items.map((lesson)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        ref: (0, $48630d5962798e4a$export$15379570ba48f04d)("", lesson.slug) ? selectedLessonRef : null,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0ca1c0d89e77a13d$export$951debaed2d5c034), {
                            lesson: lesson,
                            courseSlug: slug,
                            progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                            onSelect: onSelect,
                            isLoading: isLoading,
                            expandedLessonIds: expandedLessonIds,
                            selectedSectionId: selectedSectionId,
                            currentLessonSlug: currentLessonSlug
                        })
                    }, lesson.sys.id))
            })
        ]
    });
});
const $aefb4e9d0a694068$var$courseCardStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    paddingTop: (0, $hgUW1$token)("space.300"),
    paddingBottom: (0, $hgUW1$token)("space.300"),
    borderBottom: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    "&:hover": {
        background: "#F7F8F9"
    }
});
const $aefb4e9d0a694068$var$courseCardOpenedStyles = (0, $hgUW1$css)({
    paddingBottom: 0,
    "&:hover": {
        background: "none"
    }
});
const $aefb4e9d0a694068$var$courseCardHeaderStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    paddingLeft: (0, $hgUW1$token)("space.100"),
    paddingRight: (0, $hgUW1$token)("space.100")
});
const $aefb4e9d0a694068$var$courseCardHeaderOpenedStyles = (0, $hgUW1$css)({
    marginBottom: (0, $hgUW1$token)("space.100")
});
const $aefb4e9d0a694068$var$courseExpanderStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "4px",
    border: `1px solid ${(0, $hgUW1$token)("color.background.accent.gray.subtlest")}`,
    cursor: "pointer"
});
const $aefb4e9d0a694068$var$courseExpanderSelectedStyles = (0, $hgUW1$css)({
    border: `1px solid ${(0, $hgUW1$token)("color.background.accent.blue.subtler")}`
});
const $aefb4e9d0a694068$var$courseTitleContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    marginLeft: (0, $hgUW1$token)("space.100"),
    marginRight: "auto"
});
const $aefb4e9d0a694068$var$courseCardTitleStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px"
});
const $aefb4e9d0a694068$var$courseCardTitleSelectedStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.selected")
});
const $aefb4e9d0a694068$var$courseCardTitleCompletedStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.success")
});
const $aefb4e9d0a694068$var$courseCardTitleDefaultStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtlest")
});
const $aefb4e9d0a694068$var$completedCourseProgressStyles = (0, $hgUW1$css)({
    opacity: "0.2"
});
const $aefb4e9d0a694068$var$progressCircleContainerStyles = (0, $hgUW1$css)({
    position: "relative",
    maxWidth: "32px",
    span: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }
});
const $aefb4e9d0a694068$var$imageBadgeContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "100%",
    padding: (0, $hgUW1$token)("space.100")
});
const $aefb4e9d0a694068$var$imageStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "50%"
});
const $aefb4e9d0a694068$var$lessonContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $hgUW1$token)("space.100")
});








var $e48fba9cf5395297$require$Buffer = $hgUW1$Buffer;
const $e48fba9cf5395297$var$courseBg = `<svg width="419" height="16" viewBox="0 0 419 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_550_14457)">
<rect width="419" height="16" fill="#CCE0FF"/>
<g clipPath="url(#clip1_550_14457)">
<path d="M419.987 -18.5349C419.996 -18.6007 420.003 -18.6684 420.014 -18.7323C420.032 -18.7947 420.048 -18.8548 420.064 -18.915C420.099 -19.0356 420.114 -19.1585 420.159 -19.2632C420.248 -19.4786 420.309 -19.6895 420.416 -19.8625C420.463 -19.9546 420.508 -20.0404 420.551 -20.1238C420.603 -20.2039 420.653 -20.2775 420.702 -20.3488C420.75 -20.4201 420.79 -20.4949 420.836 -20.5598C420.888 -20.6209 420.931 -20.6813 420.974 -20.7375C421.14 -20.9764 421.288 -21.1424 421.37 -21.2817C421.452 -21.421 421.479 -21.522 421.443 -21.5797C421.407 -21.6374 421.307 -21.6518 421.142 -21.6124C420.978 -21.5729 420.733 -21.4929 420.458 -21.2992C420.387 -21.251 420.313 -21.2006 420.234 -21.1476C420.159 -21.0907 420.086 -21.0172 420.006 -20.9452C419.928 -20.8714 419.847 -20.793 419.762 -20.7101C419.686 -20.6195 419.613 -20.5188 419.533 -20.4154C419.364 -20.214 419.244 -19.956 419.102 -19.6814C419.032 -19.5431 418.992 -19.3907 418.936 -19.2369C418.91 -19.159 418.885 -19.0793 418.86 -18.9995C418.838 -18.9178 418.826 -18.835 418.809 -18.7495C418.615 -17.7843 418.69 -16.8131 418.876 -15.8955C419.059 -14.9692 419.392 -14.1022 419.756 -13.244C419.947 -12.82 420.142 -12.3941 420.364 -11.9832C420.574 -11.563 420.81 -11.1596 421.049 -10.7501L421.231 -10.4386C421.302 -10.321 421.379 -10.2101 421.453 -10.1053C421.527 -10.0006 421.606 -9.89614 421.681 -9.80195L421.834 -9.60333C421.861 -9.56574 421.887 -9.52816 421.909 -9.49438C421.917 -9.47618 421.939 -9.45715 421.93 -9.44167L421.87 -9.4071L421.756 -9.34475C421.555 -9.2203 421.349 -9.09548 421.146 -8.96877C420.732 -8.71463 420.314 -8.45596 419.889 -8.19466C419.043 -7.67017 418.178 -7.13781 417.292 -6.58888C415.522 -5.48495 413.666 -4.32951 411.701 -3.10375C411.569 -3.02103 411.438 -2.9383 411.311 -2.85594L411.263 -2.82245C411.247 -2.81267 411.23 -2.79231 411.213 -2.79503L411.176 -2.83796L411.129 -2.89683C411.053 -2.99935 410.979 -3.09997 410.908 -3.19868C410.748 -3.42193 410.595 -3.64364 410.445 -3.8657C409.853 -4.75016 409.317 -5.59122 408.833 -6.35712C407.867 -7.87642 407.139 -9.19183 406.523 -10.4477C405.911 -11.704 405.395 -12.8909 404.961 -14.1983C404.532 -15.5018 404.156 -16.9191 403.941 -18.6294C403.764 -20.0724 403.734 -21.6582 403.948 -23.2902C404.067 -24.102 404.224 -24.9319 404.485 -25.7435C404.596 -26.156 404.761 -26.5543 404.909 -26.9594C405.08 -27.3562 405.245 -27.7586 405.453 -28.1438C405.847 -28.925 406.311 -29.6786 406.85 -30.3841C407.385 -31.0935 407.973 -31.7656 408.624 -32.3738C408.936 -32.6905 409.287 -32.9706 409.619 -33.2637C409.969 -33.5374 410.311 -33.821 410.678 -34.0689C411.033 -34.3347 411.41 -34.5667 411.777 -34.8021C412.152 -35.0318 412.539 -35.2437 412.914 -35.465C414.436 -36.3062 415.99 -36.9507 417.497 -37.3604C419.003 -37.7742 420.458 -37.9529 421.776 -37.9727C423.096 -37.9948 424.276 -37.8642 425.269 -37.709C426.262 -37.5579 427.07 -37.3657 427.646 -37.233L428.69 -36.9731C429.045 -36.8906 429.419 -36.816 429.771 -36.7438C430.378 -36.6242 431.227 -36.4356 432.428 -36.2523C433.028 -36.1615 433.721 -36.0769 434.532 -36.0632C435.339 -36.0534 436.29 -36.1149 437.298 -36.4729C437.804 -36.6385 438.302 -36.8957 438.794 -37.2048C439.033 -37.3787 439.288 -37.5351 439.516 -37.7605C439.63 -37.869 439.756 -37.968 439.863 -38.0906C439.969 -38.2173 440.076 -38.3441 440.183 -38.4708C440.585 -39.0093 440.922 -39.6533 441.087 -40.36C441.245 -41.0619 441.295 -41.8006 441.211 -42.5236C441.061 -43.9793 440.534 -45.3835 439.853 -46.7869C439.509 -47.4894 439.114 -48.1853 438.684 -48.8866C438.47 -49.2437 438.255 -49.5754 438.036 -49.9299C437.987 -50.0054 437.941 -50.0791 437.892 -50.1546L437.861 -50.2043C437.876 -50.2183 437.894 -50.2303 437.914 -50.2446C437.836 -50.198 438.202 -50.4311 438.461 -50.5962C439.016 -50.9486 439.658 -51.3547 440.372 -51.809C441.803 -52.7114 443.524 -53.7985 445.425 -54.9977C446.336 -55.5719 447.291 -56.1709 448.275 -56.789L448.326 -56.8229C448.342 -56.8285 448.363 -56.8575 448.374 -56.8291L448.412 -56.782L448.504 -56.6579C448.854 -56.1741 449.194 -55.6643 449.531 -55.1417C449.866 -54.6085 450.202 -54.0711 450.54 -53.5318C450.86 -52.9887 451.204 -52.4562 451.506 -51.9012C452.14 -50.8042 452.697 -49.6712 453.218 -48.5372C454.609 -45.4748 455.414 -42.5189 455.622 -39.8407C455.835 -37.1587 455.451 -34.7733 454.708 -32.833C453.969 -30.8848 452.931 -29.3702 451.906 -28.2006C450.869 -27.0365 449.854 -26.1974 448.994 -25.5647C448.74 -25.3769 448.489 -25.1936 448.225 -25.0259C447.964 -24.8543 447.711 -24.6813 447.441 -24.5299C447.177 -24.3728 446.912 -24.2175 446.652 -24.0608C446.391 -23.9059 446.118 -23.7795 445.858 -23.6394C445.335 -23.3486 444.792 -23.1336 444.267 -22.8909C444.001 -22.7819 443.73 -22.6891 443.467 -22.5865L443.07 -22.4368L442.67 -22.3139C441.607 -21.9637 440.54 -21.7558 439.49 -21.6187C438.439 -21.4751 437.397 -21.4582 436.377 -21.4936C435.354 -21.5266 434.349 -21.6452 433.361 -21.7966C432.866 -21.869 432.377 -21.9631 431.889 -22.0529C431.396 -22.1508 430.914 -22.258 430.418 -22.3472C429.434 -22.5326 428.468 -22.7237 427.477 -22.8686C426.491 -23.014 425.476 -23.1064 424.439 -23.0396C423.318 -22.955 422.489 -22.6083 422.02 -22.2885C421.775 -22.1351 421.62 -21.979 421.526 -21.8617C421.431 -21.7444 421.396 -21.6575 421.422 -21.6051L421.393 -21.4788C421.408 -21.4697 421.421 -21.4749 421.419 -21.4957L421.417 -21.6089L421.441 -21.5816C421.478 -21.5345 421.572 -21.5216 421.717 -21.5384C421.86 -21.5571 422.053 -21.6116 422.306 -21.665C422.804 -21.7878 423.52 -21.9506 424.501 -21.9791C426.333 -22.0036 428.217 -21.4933 430.151 -21.0651C432.069 -20.5956 434.122 -20.121 436.309 -19.9979C437.401 -19.9331 438.53 -19.9303 439.679 -20.0655C440.824 -20.1921 441.997 -20.4071 443.155 -20.7739L443.593 -20.9042L444.026 -21.0614C444.313 -21.168 444.608 -21.2671 444.896 -21.3844C445.464 -21.6371 446.054 -21.8709 446.616 -22.1755C446.899 -22.3238 447.191 -22.4604 447.471 -22.6231C447.751 -22.7858 448.03 -22.9527 448.316 -23.1181C448.602 -23.2793 448.877 -23.4647 449.157 -23.6505C449.44 -23.8303 449.714 -24.0282 449.988 -24.2304C450.841 -24.8582 451.905 -25.7016 453.021 -26.8957C453.309 -27.1871 453.571 -27.5225 453.863 -27.8605C454.004 -28.0321 454.137 -28.2178 454.276 -28.4019C454.418 -28.5841 454.554 -28.7744 454.686 -28.9767C455.233 -29.7648 455.74 -30.6669 456.174 -31.6739C457.054 -33.6806 457.614 -36.1379 457.566 -38.8279C457.534 -41.5171 456.936 -44.407 455.846 -47.313C455.131 -49.2086 454.232 -51.0191 453.22 -52.7275C453 -53.1092 452.768 -53.4857 452.531 -53.8595C452.294 -54.2398 452.058 -54.6159 451.817 -54.9852C451.333 -55.728 450.844 -56.4872 450.306 -57.24C450.171 -57.4276 450.035 -57.6151 449.893 -57.8043C449.653 -58.1255 449.383 -58.4567 449.123 -58.7678L448.927 -59.0067L448.828 -59.1241L448.779 -59.1849L448.713 -59.1435L448.187 -58.821L447.222 -58.2106C446.463 -57.721 445.702 -57.2332 444.944 -56.7458C443.425 -55.7748 441.918 -54.8133 440.448 -53.8739C438.753 -52.7996 437.104 -51.7523 435.527 -50.7531C435.991 -50.0108 436.451 -49.2806 436.903 -48.5602C437.066 -48.3037 437.217 -48.0566 437.362 -47.8111C437.505 -47.5633 437.664 -47.3253 437.793 -47.0784C438.349 -46.1047 438.792 -45.1297 439.105 -44.1938C439.417 -43.2556 439.58 -42.3464 439.535 -41.5453C439.493 -40.7422 439.25 -40.0623 438.851 -39.5598C438.46 -39.0496 437.954 -38.691 437.475 -38.4375C436.995 -38.1882 436.554 -38.0451 436.181 -37.9645C435.996 -37.9233 435.825 -37.9043 435.679 -37.8769C435.529 -37.8639 435.404 -37.8531 435.302 -37.8421C435.2 -37.8312 435.122 -37.8308 435.068 -37.8302C435.013 -37.8297 434.988 -37.8275 434.988 -37.8275C434.988 -37.8275 434.871 -37.8258 434.651 -37.8214C434.54 -37.8264 434.399 -37.8289 434.237 -37.8337C434.073 -37.8405 433.88 -37.8594 433.667 -37.8766C432.801 -37.959 431.531 -38.193 429.936 -38.5373C429.151 -38.6875 428.292 -38.9299 427.33 -39.1213C426.369 -39.3108 425.335 -39.5003 424.228 -39.5889C423.123 -39.684 421.952 -39.7105 420.741 -39.6161C419.533 -39.5114 418.291 -39.2883 417.058 -38.9422C415.82 -38.5999 414.613 -38.0966 413.43 -37.5304C412.848 -37.2281 412.256 -36.9335 411.697 -36.5849C411.125 -36.2584 410.565 -35.8951 410.019 -35.512C407.837 -33.9779 405.925 -31.9888 404.62 -29.7209C403.3 -27.462 402.621 -24.9776 402.422 -22.6921C402.327 -21.5467 402.342 -20.4485 402.416 -19.4205C402.469 -18.9089 402.508 -18.4129 402.588 -17.9394C402.625 -17.7034 402.656 -17.469 402.697 -17.2417C402.742 -17.0148 402.786 -16.792 402.83 -16.5776C403.106 -15.2754 403.444 -14.0752 403.836 -12.9845C404.024 -12.4364 404.237 -11.9177 404.431 -11.4142C404.65 -10.9212 404.839 -10.434 405.058 -9.98298C405.906 -8.16173 406.754 -6.6679 407.532 -5.40717C408.303 -4.16047 408.956 -3.11338 409.589 -2.21778C409.677 -2.09742 409.763 -1.97896 409.846 -1.8624C409.972 -1.69494 410.097 -1.53165 410.231 -1.36908C410.364 -1.21067 410.493 -1.0519 410.619 -0.899205C410.683 -0.822855 410.748 -0.748768 410.811 -0.672419C410.838 -0.607579 410.885 -0.664166 410.925 -0.684437L411.049 -0.758101C411.375 -0.947891 411.688 -1.14077 411.994 -1.33518C412.199 -1.46416 412.396 -1.58825 412.583 -1.70518C414.541 -2.94081 416.392 -4.10837 418.154 -5.22217C419.034 -5.78098 419.891 -6.32738 420.73 -6.86175C421.15 -7.13101 421.563 -7.39348 421.975 -7.65786C422.182 -7.7891 422.388 -7.9245 422.593 -8.05348L423.1 -8.37651L423.351 -8.53671L423.58 -8.69928L424.035 -9.02403L424.063 -9.04323L424.074 -9.05681C424.074 -9.05681 424.071 -9.06287 424.069 -9.06894L424.03 -9.12852L423.95 -9.24961L423.794 -9.48571C423.591 -9.79544 423.369 -10.1056 423.118 -10.405L422.846 -10.7381L422.646 -10.9914C422.584 -11.0742 422.525 -11.1592 422.472 -11.2385L422.296 -11.5213C422.062 -11.9038 421.823 -12.2818 421.616 -12.6688C421.392 -13.0502 421.203 -13.4408 421.015 -13.8274C420.658 -14.6063 420.324 -15.3894 420.137 -16.1874C419.943 -16.9804 419.861 -17.7833 419.977 -18.536L419.987 -18.5349Z" fill="#0055CC"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#0055CC"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#0055CC"/>
<path d="M384.78 4.00317C387.938 3.20902 387.727 2.24328 384.526 2.8355C382.254 3.25484 379.932 3.70159 377.414 4.2115C376.157 4.47157 374.85 4.74014 373.477 5.02282C372.791 5.16832 372.086 5.31754 371.367 5.47009L371.218 5.49975C371.197 5.50156 371.166 5.52111 371.163 5.48779C371.092 5.3198 371.022 5.14955 370.951 4.97739C369.623 1.76683 368.946 -0.312608 368.381 -2.12056C367.842 -3.9371 367.411 -5.50071 367.051 -7.83206C366.893 -8.815 366.773 -9.88939 366.688 -11.0193C366.622 -12.1487 366.576 -13.3344 366.64 -14.536C366.704 -15.7375 366.819 -16.9582 367.064 -18.1397C367.308 -19.3212 367.637 -20.4743 368.076 -21.5384C368.18 -21.8056 368.312 -22.0583 368.428 -22.3159C368.488 -22.4429 368.547 -22.5717 368.605 -22.6964C368.676 -22.8221 368.743 -22.9475 368.812 -23.071C369.086 -23.5669 369.355 -24.0518 369.614 -24.5212C369.889 -24.9814 370.184 -25.4057 370.452 -25.8255C370.59 -26.0304 370.716 -26.2407 370.855 -26.4332C371 -26.62 371.14 -26.8041 371.278 -26.9818C371.556 -27.3353 371.803 -27.6799 372.06 -27.9813C372.327 -28.2708 372.576 -28.5442 372.802 -28.7905C373.238 -29.3046 373.671 -29.64 373.952 -29.9099L374.459 -30.3798L375.001 -30.8128C375.161 -30.9442 375.356 -31.1016 375.579 -31.2847C375.688 -31.3822 375.817 -31.471 375.954 -31.5606C376.091 -31.6542 376.237 -31.7509 376.39 -31.8543C376.986 -32.2879 377.767 -32.7207 378.666 -33.1973C380.483 -34.1269 382.926 -34.9702 385.749 -35.687C386.452 -35.8718 387.182 -36.0463 387.929 -36.2181C388.673 -36.3959 389.442 -36.5611 390.222 -36.7357C390.745 -36.8524 391.276 -36.9698 391.811 -37.0875C391.827 -37.0973 391.829 -37.0806 391.834 -37.0685L391.843 -37.0295L391.877 -36.8813C391.965 -36.4755 392.052 -36.0698 392.138 -35.6618C392.826 -32.3978 393.535 -29.0517 394.215 -25.8333C394.699 -23.5608 395.138 -21.507 395.533 -19.657C395.709 -18.833 395.874 -18.0563 396.03 -17.3228L396.047 -17.2508C396.046 -17.2319 396.008 -17.237 395.99 -17.2291C395.759 -17.1839 395.532 -17.139 395.315 -17.0972C393.858 -16.8198 392.563 -16.5564 391.456 -16.2549C390.349 -15.9574 389.427 -15.6237 388.695 -15.2811C387.829 -14.8809 387.014 -14.3843 386.312 -13.7653C385.606 -13.1501 385.025 -12.4137 384.602 -11.6258C384.182 -10.8319 383.945 -10.0036 383.788 -9.19684C383.737 -8.79165 383.662 -8.39072 383.656 -7.99783C383.648 -7.79989 383.64 -7.60612 383.631 -7.41235C383.631 -7.2193 383.643 -7.02734 383.649 -6.83691C383.805 -3.79328 384.714 -1.22835 385.709 1.20748C386.262 2.50247 386.762 3.06972 386.983 3.0044L386.993 2.90906C386.995 2.92988 387.006 2.93939 387.029 2.93532L387.023 2.9883C387.233 2.86729 387.157 2.12695 386.709 0.831265C385.907 -1.60452 385.185 -4.13535 385.149 -6.8662C385.149 -7.03616 385.145 -7.20576 385.149 -7.37608C385.164 -7.54521 385.174 -7.71399 385.187 -7.88504C385.199 -8.2302 385.278 -8.56223 385.326 -8.90422C385.476 -9.57396 385.682 -10.2423 386.022 -10.8571C386.365 -11.4682 386.82 -12.0321 387.389 -12.52C387.957 -13.0078 388.635 -13.4232 389.39 -13.7698C389.972 -14.0448 390.76 -14.3208 391.748 -14.5722C392.735 -14.8236 393.919 -15.0374 395.292 -15.2697C395.66 -15.3352 396.039 -15.3995 396.429 -15.469C396.772 -15.5364 397.118 -15.6043 397.469 -15.6724C397.646 -15.7088 397.826 -15.7432 398.003 -15.7796L398.137 -15.8059L398.206 -15.8181C398.206 -15.8181 398.218 -15.8192 398.222 -15.8237L398.22 -15.8404L398.213 -15.8733L398.161 -16.1416C397.961 -17.1481 397.754 -18.2066 397.532 -19.3163C397.2 -21.0059 396.833 -22.8478 396.421 -24.8327C396.152 -26.1249 395.86 -27.4132 395.553 -28.6874C394.886 -31.4349 394.198 -34.3926 393.546 -37.2862L393.341 -38.2231L393.235 -38.7028L393.183 -38.9396L393.156 -39.0589C393.152 -39.0775 393.15 -39.1025 393.141 -39.1143L393.079 -39.1005C392.467 -38.9657 391.858 -38.8289 391.251 -38.6944C390.541 -38.5343 389.839 -38.3748 389.149 -38.2206C387.771 -37.9081 386.435 -37.6014 385.194 -37.2777C382.705 -36.6507 380.584 -35.9233 379.116 -35.303C378.753 -35.1373 378.426 -34.9872 378.141 -34.8597C377.997 -34.7948 377.866 -34.7352 377.745 -34.6785C377.627 -34.6158 377.521 -34.5583 377.422 -34.5058C377.038 -34.2962 376.829 -34.1816 376.829 -34.1816C376.829 -34.1816 376.751 -34.1391 376.605 -34.0572C376.459 -33.9712 376.233 -33.8676 375.972 -33.6855C375.704 -33.5091 375.379 -33.2921 374.999 -33.0431C374.904 -32.9803 374.807 -32.9152 374.705 -32.8498C374.611 -32.7744 374.511 -32.6965 374.413 -32.6167C374.213 -32.4566 373.998 -32.2891 373.775 -32.1102C373.313 -31.7722 372.875 -31.3252 372.39 -30.8677C371.887 -30.4254 371.447 -29.8606 370.947 -29.3074C370.689 -29.0333 370.468 -28.7245 370.238 -28.4087C370.006 -28.097 369.77 -27.7743 369.529 -27.4513C369.295 -27.1226 369.093 -26.7673 368.869 -26.4185C368.652 -26.0639 368.416 -25.714 368.211 -25.3458C368.012 -24.9719 367.81 -24.5935 367.61 -24.2131C367.412 -23.8267 367.19 -23.4612 367.018 -23.0414C366.838 -22.6334 366.644 -22.2242 366.501 -21.7963L366.27 -21.1595C366.194 -20.9452 366.142 -20.7266 366.076 -20.5111C365.569 -18.7781 365.306 -16.9907 365.209 -15.2722C365.017 -11.8291 365.44 -8.6765 365.857 -6.37103C366.505 -2.89797 367.285 -0.399449 367.899 1.48819C368.53 3.37439 369.032 4.64646 369.43 5.61072C369.519 5.81702 369.604 6.02368 369.693 6.2258C369.821 6.52311 369.954 6.82006 370.092 7.11438L370.193 7.33434L370.219 7.39085C370.227 7.40905 370.255 7.38986 370.274 7.39032L370.391 7.36545L370.861 7.27014C371.154 7.20702 371.444 7.142 371.732 7.07923C372.451 6.91835 373.155 6.76081 373.838 6.60923C375.206 6.2955 376.507 5.99813 377.757 5.70926C380.258 5.1232 382.558 4.56506 384.799 4.00364L384.78 4.00317Z" fill="#0055CC"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#0055CC"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#0055CC"/>
<path d="M334.463 4.55043C336.378 5.19855 337.423 5.25896 337.511 5.00382C337.601 4.73999 336.74 4.16631 334.878 3.42756C332.352 2.4169 329.793 1.33152 327.049 0.0860085C325.677 -0.537881 324.262 -1.20208 322.786 -1.9218C322.048 -2.27958 321.294 -2.65483 320.524 -3.0434C320.14 -3.23882 319.751 -3.43804 319.356 -3.63881C318.73 -3.96432 318.098 -4.29136 317.454 -4.62376C317.2 -4.26182 316.851 -3.76363 316.498 -3.26091C311.509 3.94463 310.444 5.82257 307.026 10.6636C306.168 11.8815 305.22 13.2247 304.201 14.6706C303.026 16.3251 301.771 18.0936 300.448 19.9519C301.609 20.5878 302.784 21.2287 303.958 21.8718C304.893 22.372 305.832 22.8676 306.756 23.3477C308.612 24.3052 310.431 25.205 312.103 26.0043C315.451 27.6025 318.222 28.8038 319.543 29.3586C320.099 29.5979 320.659 29.8221 321.228 30.0372C323.093 30.7483 327.879 32.5744 334.242 34.4547C337.42 35.4003 340.99 36.3582 344.761 37.2378C346.647 37.6765 348.582 38.0984 350.545 38.4927C351.525 38.691 352.513 38.8802 353.502 39.0631L354.99 39.3328L357.469 39.7599C357.512 39.07 357.618 37.3781 357.721 35.7073C358.398 24.2427 358.818 17.1478 359.038 13.4422C359.115 12.0821 359.191 10.7663 359.248 9.79823C358.525 9.66157 357.813 9.53027 357.113 9.39788C356.669 9.31047 356.23 9.22686 355.799 9.14253C354.934 8.97197 354.095 8.79926 353.278 8.62663C351.643 8.27947 350.096 7.92473 348.607 7.5691C345.63 6.85142 342.892 6.12149 340.191 5.33379C338.504 4.8422 337.595 4.76987 337.515 5.00346C337.437 5.2242 338.192 5.75466 339.861 6.35065C342.533 7.3025 345.259 8.16562 348.242 8.98554C349.733 9.39341 351.289 9.78944 352.935 10.1692C353.757 10.3623 354.602 10.5471 355.474 10.7317C356.136 10.8674 356.819 11.0054 357.52 11.1503C357.485 11.7346 357.434 12.53 357.383 13.3486C357.181 16.7484 356.524 23.8218 355.888 33.8225C355.843 34.6301 355.797 35.4335 355.753 36.2389L355.697 37.4438C355.695 37.5154 355.695 37.4881 355.696 37.4965L355.7 37.5003L355.703 37.5147L355.713 37.5495C355.713 37.5495 355.699 37.557 355.686 37.5581C355.653 37.5568 355.753 37.5796 355.443 37.531C355.007 37.4618 354.566 37.3929 354.124 37.3222C353.241 37.1784 352.344 37.0274 351.449 36.8616C349.654 36.5388 347.844 36.1754 346.062 35.7822C342.497 35.0064 339.05 34.105 336.046 33.2324C333.043 32.3575 330.487 31.5175 328.681 30.8914C327.778 30.573 327.064 30.3202 326.573 30.1467C326.083 29.9667 325.818 29.8679 325.818 29.8679C321.699 28.3744 317.646 26.7051 313.653 24.9006C311.657 23.9951 309.679 23.0545 307.719 22.0746C306.741 21.5844 305.762 21.086 304.793 20.5804L303.34 19.8146L302.638 19.4369L309.085 10.2354C314.014 3.19241 316.386 -0.198335 317.845 -2.28244C317.896 -2.35604 317.946 -2.42965 317.981 -2.48098C318.602 -2.1676 319.205 -1.86528 319.791 -1.56985C320.573 -1.18236 321.337 -0.814252 322.09 -0.459821C323.592 0.247136 325.035 0.892152 326.437 1.484C329.24 2.67411 331.869 3.66742 334.463 4.55459L334.463 4.55043Z" fill="#0055CC"/>
<path d="M266.148 11.4376C265.904 11.2409 261.607 11.6971 262.767 12.4216C263.152 12.7387 263.531 12.7338 263.685 12.3129C263.756 13.1539 264.635 12.0998 265.004 12.398C264.83 12.9693 266.069 11.8381 265.807 12.4269C270.358 13.3708 279.961 8.37317 268.469 10.984C269.573 11.3221 268.502 11.4792 268.006 11.3161C268.775 10.623 266.63 11.1225 266.225 11.3523C266.878 11.3825 265.768 11.8563 266.15 11.4397L266.148 11.4376Z" fill="#101214"/>
<path d="M272.605 3.22316C273.458 2.36056 274.245 3.76267 275.035 3.06913C276.28 1.68993 267.453 -0.414982 267.475 1.23096C267.685 2.6437 272.067 2.52666 272.605 3.22316Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_550_14457)">
<path d="M13.0459 7.94648C13.2244 7.80301 13.375 7.65148 13.5135 7.50519C13.6519 7.3589 13.7767 7.22429 13.8912 7.09266C14.1165 6.83394 14.2962 6.60644 14.4242 6.41279C14.6826 6.0274 14.7534 5.77787 14.657 5.68132C14.5605 5.58477 14.2987 5.63893 13.898 5.85831C13.6977 5.968 13.4612 6.12069 13.1927 6.31602C13.0586 6.41577 12.9146 6.52266 12.7657 6.64468C12.6168 6.7667 12.4583 6.90004 12.2783 7.02685C11.7797 7.3995 11.2791 7.7744 10.7705 8.1542C10.2398 8.49606 9.70493 8.83827 9.16244 9.18954C8.60947 9.51654 8.02636 9.81049 7.44957 10.1291C7.15404 10.2785 6.84575 10.4017 6.5389 10.5416C6.23133 10.6732 5.92782 10.8275 5.60858 10.9454C5.28898 11.0591 4.96332 11.1755 4.63765 11.2918C4.47464 11.3479 4.31044 11.4146 4.1448 11.4646C3.97464 11.5109 3.80449 11.5571 3.63433 11.6033C3.29175 11.6939 2.94835 11.7992 2.59636 11.8779C2.24139 11.9465 1.88225 12.0154 1.51931 12.0888C0.0606176 12.3264 -1.49813 12.4259 -3.12925 12.2945C-3.56103 12.2753 -3.97141 12.2123 -4.35537 12.1637C-4.54794 12.1447 -4.73171 12.1061 -4.90643 12.0751C-4.9938 12.0596 -5.08116 12.0441 -5.16436 12.0282C-5.22411 12.0166 -5.28576 12.0072 -5.34551 11.9956C-5.43287 11.9801 -5.5081 11.9594 -5.58713 11.9432C-6.21656 11.7732 -6.77491 11.6244 -7.25162 11.4978C-7.70977 11.3676 -8.08591 11.2638 -8.36563 11.1831C-8.05452 12.2599 -7.73595 13.2771 -7.45896 14.2015C-7.28585 14.7489 -7.12621 15.2617 -6.97515 15.748C-6.68674 16.6588 -6.42815 17.4673 -6.18005 18.2515C-5.68384 19.8199 -5.22994 21.2871 -4.66961 23.2339C-4.04204 25.3764 -3.32537 27.8951 -2.58721 30.5168C-2.22004 31.83 -1.84428 33.1696 -1.4715 34.4991C-1.25363 35.2733 -1.04029 36.0438 -0.825398 36.8078C-0.802628 36.8772 -0.789367 36.9578 -0.758627 37.0223L-0.551516 37.0883L-0.137285 37.2202L0.276945 37.3522L0.53893 37.4218C0.71283 37.4676 0.884474 37.5114 1.05837 37.5572C1.23346 37.5924 1.40628 37.6257 1.57946 37.6631C4.36235 38.2066 7.04848 37.8962 9.14027 37.3602C9.66062 37.2144 10.1485 37.0567 10.6086 36.9182C11.0609 36.7615 11.4697 36.5876 11.8496 36.4434C12.2341 36.3031 12.5622 36.1425 12.8562 35.9995C13.1502 35.8565 13.4062 35.7357 13.6198 35.6332C13.8785 35.5185 14.1157 35.3742 14.3552 35.2317L15.0752 34.7979C15.254 34.6817 15.4828 34.5611 15.7156 34.3899C15.9507 34.2205 16.2176 34.0316 16.5119 33.8194C16.8017 33.6033 17.1399 33.3894 17.4667 33.1155C17.7957 32.8436 18.1502 32.5506 18.5283 32.2388C18.716 32.0798 18.9169 31.9281 19.1073 31.7521C19.2955 31.5743 19.4897 31.3938 19.6897 31.2065C20.0835 30.8345 20.499 30.446 20.9358 30.0368C21.3513 29.6482 21.7823 29.2458 22.2305 28.8229C22.6881 28.4119 23.1922 28.0283 23.6952 27.6091C23.943 27.3925 24.219 27.2112 24.4958 27.0152C24.7708 26.8214 25.0517 26.625 25.3346 26.4263C25.4725 26.322 25.6221 26.2314 25.772 26.145C25.9215 26.0544 26.0733 25.9657 26.2248 25.8728C26.5303 25.6932 26.8325 25.4991 27.1493 25.329C28.4302 24.6598 29.8119 24.0406 31.3018 23.6052C32.7947 23.1799 34.3762 22.9064 36.0024 22.8599C36.8156 22.8251 37.6359 22.8736 38.4607 22.9489L39.0913 23.0348L39.4056 23.0789L40.0042 23.2075C40.8225 23.3779 41.6365 23.5717 42.4509 23.7697C42.1544 22.74 41.401 20.1363 40.667 17.5876C37.7264 7.53183 35.9053 1.30688 34.9535 -1.94261C34.9552 -2.23861 34.6651 -2.19668 34.4682 -2.26564C34.2584 -2.3146 34.0485 -2.36355 33.8387 -2.41251L33.6803 -2.44913C33.6311 -2.45956 33.6141 -2.46227 33.5778 -2.46961L33.3902 -2.50372L33.0173 -2.57001C32.7696 -2.61988 32.5206 -2.63607 32.2744 -2.66928L31.9055 -2.71284L31.5408 -2.73367C30.5668 -2.81081 29.6218 -2.74779 28.7074 -2.67062C26.8858 -2.45607 25.2051 -1.99564 23.6927 -1.35886C23.3041 -1.21817 22.9496 -1.02168 22.5817 -0.859698C22.4004 -0.772642 22.2187 -0.689742 22.0393 -0.604949C21.8648 -0.512183 21.6929 -0.413354 21.5206 -0.318686C21.1787 -0.123287 20.8406 0.0675779 20.5024 0.258452C20.1809 0.47097 19.8612 0.681234 19.5415 0.89149C19.3828 0.99757 19.226 1.10138 19.0692 1.20519C18.9128 1.31317 18.7677 1.43066 18.618 1.54435C18.321 1.77363 18.0236 1.99874 17.7304 2.22349C17.4281 2.44063 17.165 2.69844 16.8834 2.93687C16.6064 3.1791 16.3335 3.42097 16.0565 3.6632C14.9003 4.78106 14.4954 5.51069 14.6627 5.67453C14.8371 5.84825 15.5686 5.4743 16.7575 4.469C17.0367 4.25176 17.3182 4.03643 17.6015 3.81883C17.8853 3.60539 18.1547 3.37221 18.455 3.18042C18.7503 2.98066 19.0435 2.77901 19.3427 2.57472C19.4915 2.47579 19.6354 2.36889 19.7888 2.27377C19.9425 2.18281 20.0981 2.08959 20.256 1.99827C20.5672 1.81183 20.8807 1.62728 21.1938 1.43857C21.5194 1.27187 21.8468 1.10292 22.1765 0.935855C22.3434 0.852145 22.5062 0.768783 22.675 0.682808C22.8449 0.60933 23.0189 0.535501 23.193 0.461662C23.5419 0.322314 23.8814 0.148096 24.2446 0.0284898C25.6722 -0.5212 27.2231 -0.905332 28.8787 -1.07402C29.7068 -1.13111 30.5609 -1.17788 31.436 -1.10266L31.7652 -1.08084L32.0939 -1.04009C32.3148 -1.00888 32.5385 -0.994695 32.7585 -0.948727C32.959 -0.911546 33.1636 -0.874721 33.3663 -0.835639L33.4906 -0.804459C33.5296 -0.791045 33.5901 -0.794202 33.5831 -0.753728C33.7626 -0.108343 33.9886 0.711361 34.2604 1.69705C34.563 2.82065 34.9173 4.13071 35.3166 5.62151C36.1212 8.60049 37.1258 12.2923 38.3635 16.5934C38.7677 17.9957 39.1924 19.3919 39.6324 20.7701L39.7103 21.0172L39.7503 21.1397C39.7503 21.1397 39.7548 21.1435 39.757 21.1454C39.7661 21.153 39.7713 21.1651 39.7789 21.1792C39.7935 21.2031 39.816 21.2452 39.8321 21.2858C39.8094 21.2898 39.7776 21.2863 39.7337 21.288L39.7 21.2867L39.6811 21.2863L39.5858 21.2756L39.0005 21.2047C38.6159 21.1478 38.1999 21.1419 37.8004 21.1073C37.3951 21.0795 36.9912 21.0914 36.5855 21.0825C34.9651 21.0992 33.3478 21.3233 31.8071 21.7044C28.7091 22.4451 25.9889 23.9167 23.8329 25.4108C23.5617 25.6001 23.2986 25.7845 23.0374 25.9666C22.7852 26.1563 22.5484 26.3552 22.3129 26.5434C22.0774 26.7317 21.8479 26.9174 21.6222 27.0985C21.5105 27.19 21.3985 27.2773 21.2906 27.3643C21.1876 27.4593 21.0865 27.552 20.9873 27.6424C20.2001 28.3674 19.5102 29.0042 18.937 29.5344C18.6591 29.7914 18.4082 30.0209 18.1904 30.2202C18.0817 30.3219 17.9806 30.4146 17.8871 30.4983C17.7891 30.5781 17.6987 30.6489 17.6204 30.7144C17.3005 30.9709 17.13 31.1094 17.13 31.1094C17.13 31.1094 16.8416 31.3422 16.3261 31.7624C16.0647 31.9676 15.7272 32.1899 15.3418 32.4646C15.15 32.6009 14.9442 32.7446 14.7266 32.8977C14.509 33.0509 14.2624 33.1835 14.0092 33.3376C13.758 33.4895 13.4926 33.6489 13.2175 33.8154C12.9446 33.9838 12.637 34.1154 12.3319 34.2761C12.0216 34.4247 11.7142 34.6066 11.3733 34.7411C11.037 34.8794 10.6885 35.0229 10.3339 35.169C8.89465 35.705 7.25528 36.1346 5.51244 36.2647C4.64192 36.3402 3.74838 36.319 2.85551 36.2327L2.18746 36.1501L1.52224 36.0273C1.30062 35.9877 1.08518 35.9225 0.864745 35.8723L0.70406 35.8338L0.64585 35.8158L0.529429 35.7797C0.476824 35.778 0.495606 35.7281 0.478692 35.7023L0.439583 35.5651L0.23949 34.8753C0.105343 34.4149 -0.0284482 33.9585 -0.162235 33.5022C-0.429811 32.5896 -0.692493 31.685 -0.951844 30.7947C-1.99079 27.2401 -2.95224 23.9516 -3.66507 21.5018L-5.03013 16.8425L-5.71171 14.5117L-5.92228 13.7977L-5.96736 13.64L-5.99086 13.5623L-6.00278 13.5214C-6.00278 13.5214 -6.02077 13.4831 -6.00077 13.496C-5.91685 13.5202 -5.83258 13.5486 -5.74485 13.5683L-5.6163 13.5991L-5.29637 13.6595C-5.12807 13.689 -4.95906 13.7268 -4.78886 13.754L-4.27933 13.8231L-3.7698 13.8922L-3.25864 13.9319C-1.47352 14.073 0.223859 13.951 1.8069 13.6711C2.20054 13.5887 2.59002 13.5067 2.97117 13.4254C3.3535 13.3335 3.71855 13.2116 4.08731 13.1083C4.27151 13.0546 4.45344 12.999 4.63347 12.9456C4.81315 12.8881 4.98721 12.8142 5.162 12.7487C5.51122 12.6135 5.85438 12.481 6.19753 12.3484C6.53616 12.212 6.85488 12.0396 7.17958 11.8877C7.49939 11.7278 7.82481 11.5842 8.13331 11.4148C8.73565 11.052 9.34051 10.7184 9.90882 10.3502C10.4625 9.95811 11.0127 9.57471 11.5478 9.18631C12.0546 8.7626 12.5558 8.34566 13.0547 7.92683L13.0459 7.94648Z" fill="#0055CC"/>
<path d="M114.495 32.3233C112.222 31.5594 111.865 32.4842 114.065 33.4412C115.623 34.1181 117.228 34.7952 118.977 35.5123C119.855 35.8642 120.766 36.2322 121.724 36.617C122.269 36.8321 122.83 37.0521 123.405 37.2771C123.642 37.3719 123.882 37.4581 124.118 37.5446L124.298 37.6109L124.387 37.6431L124.432 37.658C124.448 37.6672 124.451 37.6354 124.461 37.6282L124.677 37.3074C124.82 37.0915 124.962 36.8714 125.107 36.6532C125.214 36.4803 125.323 36.3051 125.431 36.1299C126.78 33.8413 127.434 32.3201 127.986 30.9923C128.522 29.6576 128.956 28.5121 129.531 26.8088C130.002 25.3663 130.481 23.6442 130.752 21.7826C131.029 19.9289 131.072 17.9297 130.72 16.0614C130.685 15.8273 130.618 15.6003 130.566 15.3718L130.485 15.0327C130.452 14.9243 130.42 14.8201 130.388 14.7117C130.257 14.2887 130.129 13.8759 130.004 13.4734C129.871 13.0758 129.708 12.6954 129.569 12.3277C129.497 12.143 129.427 11.9644 129.357 11.79C129.273 11.619 129.194 11.4517 129.115 11.2886C128.956 10.9624 128.812 10.6518 128.666 10.3665C128.501 10.0891 128.349 9.82956 128.209 9.59201C127.945 9.10715 127.656 8.75656 127.474 8.4912L127.134 8.0276L126.744 7.59974C126.627 7.47357 126.483 7.32232 126.319 7.14562C126.159 6.96439 125.94 6.79237 125.717 6.58514C125.273 6.16197 124.688 5.71968 124.013 5.24104C122.649 4.29127 120.829 3.37894 118.787 2.5467C117.766 2.12111 116.69 1.71915 115.586 1.30078C115.27 1.18135 114.951 1.06003 114.628 0.93906C114.367 0.83993 114.105 0.738895 113.84 0.640126L113.446 0.4897L113.246 0.41467L113.146 0.37717L113.096 0.35841C113.096 0.35841 113.082 0.389005 113.075 0.406389C112.755 1.2378 112.429 2.08018 112.103 2.92671C111.218 5.21915 110.304 7.56446 109.412 9.8156C108.794 11.4093 108.234 12.851 107.732 14.1514C107.421 14.9526 107.128 15.7103 106.85 16.4268C106.745 16.6982 106.644 16.965 106.543 17.2276L106.506 17.3274C106.489 17.3478 106.52 17.3471 106.533 17.3544L106.583 17.3731L106.78 17.4463C106.91 17.4938 107.038 17.5435 107.168 17.591C107.634 17.7625 108.085 17.9291 108.525 18.0903C109.559 18.458 110.424 18.7754 111.129 19.0899C111.836 19.4021 112.382 19.7072 112.788 19.9826C113.763 20.6283 114.417 21.4256 114.721 22.3225C115.031 23.2209 115.01 24.211 114.85 25.1627C114.514 27.0782 113.723 28.8274 112.888 30.5008C112.427 31.3926 112.339 31.952 112.53 32.0971L112.524 32.1921C112.543 32.1967 112.555 32.1914 112.562 32.174L112.566 32.1192C112.77 32.2253 113.25 31.9025 113.813 31.0312C114.839 29.3874 115.819 27.6386 116.32 25.4445C116.554 24.3541 116.654 23.1054 116.251 21.8205C116.047 21.1856 115.719 20.5657 115.278 20.0207C114.838 19.4734 114.298 19.004 113.712 18.6079C113.257 18.2948 112.658 17.946 111.931 17.5894C111.201 17.2309 110.34 16.8775 109.378 16.5014C109.259 16.4551 109.137 16.4069 109.015 16.3587L108.972 16.3415L108.965 16.3358L108.952 16.3285L108.932 16.3114L108.894 16.2874C108.885 16.2798 108.864 16.2774 108.883 16.2548C108.905 16.2235 108.922 16.1989 108.937 16.1767C109.05 15.9046 109.164 15.6303 109.285 15.345C109.769 14.1721 110.29 12.891 110.842 11.5045C111.2 10.6006 111.535 9.68824 111.85 8.77542C112.189 7.78926 112.548 6.77404 112.917 5.74334C113.278 4.74895 113.644 3.73943 114.005 2.74504L114.061 2.56814C114.061 2.56814 114.066 2.54885 114.07 2.54849L114.092 2.555L114.135 2.56806L114.223 2.59607L114.268 2.61102L114.292 2.61945L114.381 2.65161L114.756 2.78908C115.003 2.88097 115.248 2.97094 115.491 3.06319C115.976 3.24351 116.451 3.42266 116.91 3.60324C117.372 3.77931 117.813 3.96134 118.238 4.13648C119.943 4.84051 121.328 5.56817 122.259 6.15047C122.71 6.45973 123.088 6.68503 123.314 6.87524C123.546 7.05866 123.675 7.15875 123.675 7.15875C123.675 7.15875 123.72 7.1968 123.812 7.26645C123.898 7.33873 124.044 7.43095 124.196 7.58148C124.355 7.72712 124.549 7.90546 124.772 8.1127C124.829 8.16442 124.886 8.21615 124.948 8.27167C125.001 8.33208 125.059 8.39212 125.117 8.45634C125.233 8.58477 125.355 8.7189 125.483 8.861C126.504 9.99784 127.669 11.8 128.462 14.0309C128.555 14.3103 128.651 14.5957 128.747 14.8812C128.839 15.167 128.95 15.4574 129.012 15.7415C129.087 16.0288 129.164 16.3138 129.211 16.6119L129.291 17.0539C129.312 17.2032 129.325 17.3531 129.347 17.5023C129.488 18.7029 129.464 19.9345 129.335 21.1165C129.074 23.485 128.427 25.6372 127.869 27.2046C127.024 29.5691 126.192 31.2486 125.546 32.5173C124.889 33.7808 124.393 34.6273 124.007 35.2609C123.939 35.3738 123.871 35.4825 123.805 35.589L123.775 35.6377C123.775 35.6377 123.741 35.6281 123.724 35.6254L123.618 35.5863C123.167 35.4156 122.729 35.2521 122.3 35.0921C121.329 34.7356 120.408 34.3979 119.52 34.072C117.742 33.4309 116.096 32.8581 114.486 32.3157L114.495 32.3233Z" fill="#0055CC"/>
<path d="M63.2213 -4.91981C64.3036 -4.55832 64.931 -4.50988 65.0627 -4.7584C65.1871 -4.9937 64.7809 -5.5439 63.6473 -6.03733C62.8457 -6.3791 62.0109 -6.66763 61.1289 -6.89542C60.2473 -7.11905 59.3135 -7.2899 58.3289 -7.34513C57.8413 -7.40358 57.3321 -7.37202 56.8151 -7.38176C56.558 -7.36997 56.296 -7.34306 56.0313 -7.32222C55.898 -7.31066 55.7647 -7.29911 55.6314 -7.28755C55.497 -7.2654 55.3648 -7.24136 55.2303 -7.21921C54.1508 -7.06059 53.0339 -6.72876 51.9327 -6.21366C51.7776 -6.13937 51.624 -6.0715 51.4775 -5.99376C51.3356 -5.91221 51.1978 -5.83104 51.0597 -5.75402C50.7857 -5.59808 50.528 -5.44774 50.2994 -5.27685C50.0662 -5.10976 49.8377 -4.96196 49.6378 -4.79776C49.4383 -4.6294 49.2487 -4.46819 49.0667 -4.31603C48.7053 -4.00564 48.4124 -3.68019 48.1181 -3.3945C47.8555 -3.08218 47.5991 -2.79557 47.3722 -2.50733C46.4759 -1.34485 45.8317 -0.275565 45.0325 1.33172C44.3767 2.70416 43.7657 4.37696 43.3437 6.17395C42.9124 7.95917 42.6876 9.9258 42.8109 11.7679C42.9178 13.6155 43.3565 15.3442 43.9484 16.684C44.5304 18.031 45.2423 18.9618 45.621 19.485C45.8706 19.776 46.1183 20.0692 46.3915 20.3414C46.8871 20.8083 47.8267 21.6795 49.2654 22.4989C49.6286 22.6962 50.0023 22.9177 50.4196 23.1102C50.8332 23.3072 51.2794 23.4931 51.7434 23.6669C52.6774 24.0119 53.698 24.3137 54.8094 24.5258C57.0183 24.9575 59.6288 24.962 62.1114 24.1404C63.3524 23.7391 64.5396 23.1263 65.6002 22.3608C66.6654 21.5991 67.6064 20.6867 68.4118 19.7104C69.54 18.318 70.3115 16.8999 70.9125 15.5972C71.4954 14.2794 71.8779 13.0712 72.1641 11.9868C72.4458 10.8986 72.6224 9.93065 72.7077 9.09447C72.8141 8.26064 72.8305 7.55211 72.8419 6.97831C72.8528 4.26015 72.1712 1.85591 71.051 -0.0633815C70.4777 -1.01665 69.8234 -1.86426 69.0796 -2.58242C68.3284 -3.28736 67.5418 -3.9179 66.6795 -4.40338C66.2508 -4.67885 65.8679 -4.78834 65.5987 -4.84473C65.3256 -4.8966 65.1518 -4.86894 65.0821 -4.77687L65.145 -4.63126C65.1232 -4.66504 65.0952 -4.67311 65.0588 -4.65736L65.0431 -4.69376C65.0108 -4.58185 65.0816 -4.41803 65.2604 -4.21742C65.4355 -4.01228 65.7286 -3.80058 66.0982 -3.50529C66.8482 -2.98281 67.5077 -2.34335 68.1348 -1.66543C68.7505 -0.973925 69.282 -0.187015 69.7486 0.672685C70.2113 1.53691 70.5551 2.50588 70.8114 3.55585C71.0594 4.60655 71.2063 5.74994 71.1886 6.97894C71.1966 7.21745 71.1654 7.48872 71.1497 7.79223C71.1381 8.09539 71.0911 8.42678 71.0364 8.79032C70.948 9.51559 70.767 10.3601 70.5057 11.2954C69.9645 13.1699 69.1073 15.4663 67.5012 17.7163L67.3088 17.9911L67.1005 18.2525L66.6908 18.7811C66.3873 19.1054 66.1203 19.4642 65.8002 19.7668C65.6299 19.9327 65.4716 20.1164 65.2858 20.273C65.1023 20.4316 64.9187 20.5902 64.7333 20.7511C64.3409 21.0432 63.9478 21.35 63.5114 21.5935C62.6552 22.102 61.7221 22.5228 60.7441 22.7629C58.7947 23.2718 56.7658 23.2231 55.0396 22.865C53.3077 22.5136 51.8735 21.9413 50.9288 21.4483C50.4595 21.1889 50.0869 20.9799 49.8427 20.8249C49.602 20.6611 49.4726 20.5716 49.4726 20.5716C49.4726 20.5716 49.4235 20.5381 49.3322 20.4768C49.2405 20.4113 49.0971 20.3293 48.9364 20.1942C48.772 20.0637 48.5714 19.9027 48.3372 19.7174C48.1201 19.5117 47.8736 19.2813 47.5996 19.0239C47.0988 18.4714 46.5061 17.8031 46.0168 16.9475C45.52 16.1009 45.0877 15.1039 44.7938 14.0068C44.1804 11.8107 44.2512 9.25102 44.7058 6.95602C45.1626 4.63984 45.9616 2.59194 46.736 1.18404C47.8904 -0.951311 49.1258 -2.26907 50.1581 -3.12021C51.1942 -3.97588 52.0123 -4.41609 52.6484 -4.70413C53.6061 -5.15434 54.5704 -5.45614 55.5178 -5.6138C55.6356 -5.6345 55.753 -5.65937 55.8686 -5.68198C55.9871 -5.69435 56.1034 -5.70862 56.2219 -5.72099C56.4548 -5.74538 56.6851 -5.77583 56.9142 -5.79569C57.3752 -5.80208 57.8243 -5.8494 58.2681 -5.81234C60.0484 -5.77572 61.691 -5.41453 63.2383 -4.91709L63.2213 -4.91981Z" fill="#0055CC"/>
<path d="M149.643 41.1462C149.707 41.1386 149.772 41.135 149.834 41.1296C149.897 41.1284 149.958 41.1335 150.017 41.1368C150.136 41.1434 150.255 41.1393 150.367 41.1485C150.584 41.1884 150.799 41.195 150.983 41.2609C151.077 41.2863 151.167 41.3078 151.257 41.3294C151.342 41.3619 151.422 41.3948 151.5 41.4216C151.58 41.4504 151.654 41.4776 151.725 41.5028C151.793 41.5368 151.859 41.5689 151.92 41.5972C152.179 41.7027 152.367 41.8102 152.516 41.8582C152.665 41.9103 152.768 41.9119 152.818 41.8655C152.869 41.8192 152.863 41.7211 152.795 41.5675C152.727 41.4139 152.604 41.2022 152.364 40.9733C152.304 40.9155 152.242 40.8517 152.176 40.7882C152.104 40.7315 152.021 40.6736 151.936 40.6138C151.851 40.554 151.758 40.4908 151.66 40.4279C151.555 40.3783 151.444 40.3271 151.328 40.2721C151.099 40.1534 150.826 40.0974 150.536 40.0197C150.391 39.9903 150.237 39.9806 150.078 39.9629C149.999 39.955 149.919 39.9452 149.837 39.9418C149.757 39.9445 149.674 39.9476 149.59 39.9506C148.636 39.9788 147.736 40.254 146.905 40.6177C146.068 40.9798 145.315 41.471 144.572 41.9823C144.209 42.2488 143.842 42.5115 143.498 42.8057C143.142 43.0862 142.801 43.3864 142.46 43.695L142.203 43.9229C142.117 43.9975 142.015 44.1008 141.928 44.1902C141.84 44.2818 141.755 44.373 141.675 44.4639L141.463 44.7068L141.37 44.8029C141.341 44.8285 141.308 44.8776 141.28 44.8192L141.196 44.7216L141.177 44.698L141.059 44.5718L140.819 44.3157C140.497 43.9722 140.173 43.6226 139.843 43.2714C139.187 42.5688 138.512 41.8509 137.823 41.1133C136.438 39.6471 134.985 38.105 133.447 36.4758C133.366 36.3925 133.286 36.3093 133.205 36.2261L133.16 36.188C133.113 36.1606 133.152 36.1278 133.173 36.0987L133.224 36.0376C133.316 35.9373 133.407 35.8393 133.497 35.7413C133.679 35.5471 133.86 35.3593 134.04 35.1738C134.763 34.4418 135.456 33.7649 136.09 33.1581C137.34 31.9418 138.448 30.9918 139.511 30.1548C140.576 29.3197 141.597 28.587 142.741 27.9067C143.884 27.2263 145.144 26.5737 146.712 25.9993C147.041 25.8701 147.387 25.775 147.733 25.6568C148.083 25.5489 148.444 25.4588 148.809 25.36C149.549 25.1973 150.314 25.0408 151.105 24.9722C152.687 24.8036 154.367 24.8909 156.008 25.2858C157.649 25.6806 159.244 26.388 160.67 27.3471C162.105 28.2991 163.355 29.4853 164.442 30.7697C165.532 32.0453 166.437 33.3937 167.101 34.744C167.769 36.094 168.2 37.4415 168.453 38.689C168.707 39.9385 168.791 41.0831 168.821 42.0542C168.854 43.0248 168.81 43.826 168.784 44.399L168.72 45.4389C168.704 45.7886 168.699 46.1626 168.693 46.5093C168.686 47.1141 168.656 47.9581 168.694 49.1446C168.711 49.7348 168.755 50.4171 168.886 51.1989C169.02 51.9762 169.253 52.8834 169.791 53.7915C170.053 54.2472 170.391 54.6816 170.799 55.0868C171.204 55.5007 171.727 55.8667 172.326 56.1546C172.941 56.4245 173.637 56.5655 174.345 56.5693C175.051 56.5605 175.743 56.4082 176.418 56.1881C177.747 55.7099 178.979 54.9338 180.172 53.9974C180.767 53.5283 181.354 53.0136 181.936 52.4638C182.23 52.1929 182.508 51.9211 182.801 51.6419C182.857 51.5887 182.911 51.5337 182.968 51.4805L183.01 51.4391C183.026 51.4524 183.042 51.4657 183.06 51.481L183.076 51.4943L183.085 51.5019L183.154 51.5756C183.256 51.6801 183.36 51.7907 183.472 51.9047C183.91 52.3619 184.42 52.8906 184.982 53.4797C186.108 54.6578 187.46 56.0766 188.952 57.6405C189.633 58.3557 190.346 59.1059 191.082 59.8793C191.101 59.907 191.162 59.9353 191.113 59.9669L191.075 60.0121L190.913 60.1856C190.524 60.6075 190.105 61.0278 189.673 61.445C189.235 61.8649 188.793 62.2851 188.349 62.7117C187.9 63.1179 187.462 63.5461 186.997 63.9389C186.087 64.7501 185.126 65.5027 184.164 66.2239C181.541 68.1593 178.922 69.5424 176.438 70.3284C173.956 71.1228 171.629 71.2992 169.639 71.0479C168.643 70.9245 167.728 70.7079 166.902 70.427C166.08 70.1373 165.338 69.8072 164.678 69.449C163.359 68.7303 162.368 67.9392 161.596 67.2591C160.691 66.4521 159.878 65.572 159.161 64.6753C158.43 63.7861 157.823 62.8547 157.303 61.9115C156.265 60.0228 155.669 58.0497 155.387 56.0934C155.235 55.1162 155.172 54.1397 155.141 53.1751C155.104 52.2089 155.139 51.2533 155.147 50.279C155.152 49.3092 155.16 48.358 155.127 47.3873C155.092 46.4231 155.005 45.4381 154.757 44.4609C154.485 43.4059 153.996 42.6741 153.603 42.2822C153.412 42.0785 153.232 41.9619 153.1 41.8936C152.968 41.8253 152.879 41.812 152.832 41.8497L152.701 41.8442C152.697 41.8635 152.703 41.8692 152.722 41.8655L152.829 41.8436L152.808 41.8685C152.77 41.9138 152.772 42.008 152.817 42.1426C152.86 42.2752 152.946 42.4482 153.042 42.6791C153.244 43.1316 153.527 43.7785 153.718 44.7041C153.889 45.5705 153.936 46.4792 153.926 47.4054C153.92 48.3312 153.872 49.2838 153.833 50.2398C153.722 52.1482 153.636 54.1889 153.902 56.2935C154.151 58.3995 154.77 60.593 155.881 62.6747C156.437 63.7134 157.093 64.7371 157.873 65.7018C158.641 66.6759 159.501 67.6149 160.49 68.5006C161.26 69.1829 162.28 70.0177 163.649 70.8244C165.02 71.6183 166.762 72.3758 168.863 72.7476C170.959 73.1156 173.393 73.0683 175.922 72.44C178.453 71.8219 181.043 70.6301 183.565 69.0036C185.208 67.94 186.742 66.7265 188.162 65.4284C188.478 65.1492 188.784 64.8541 189.092 64.5567C189.402 64.2613 189.714 63.9636 190.011 63.665C190.619 63.0668 191.235 62.4573 191.845 61.8107L192.299 61.316C192.345 61.2617 192.523 61.0679 192.639 60.9257L193.021 60.4708L193.391 60.0086L193.486 59.8955C193.48 59.8561 193.425 59.821 193.399 59.7834L193.195 59.566C192.933 59.2761 192.65 58.988 192.374 58.7014C191.761 58.0705 191.146 57.4377 190.534 56.8068C189.331 55.5598 188.135 54.3226 186.969 53.1144C185.625 51.7139 184.318 50.348 183.066 49.0444C182.442 49.6398 181.829 50.2259 181.227 50.8048C181.016 51.0098 180.808 51.2062 180.602 51.3919C180.393 51.5799 180.196 51.7733 179.987 51.9488C179.164 52.6706 178.326 53.2951 177.498 53.7927C176.67 54.2863 175.836 54.6439 175.066 54.7841C174.293 54.9266 173.6 54.8461 173.042 54.5966C172.477 54.3497 172.045 53.936 171.712 53.5326C171.383 53.1289 171.169 52.7362 171.022 52.3965C170.949 52.2266 170.901 52.067 170.85 51.9351C170.811 51.7937 170.778 51.677 170.753 51.5826C170.724 51.4886 170.713 51.4098 170.7 51.3606C170.689 51.309 170.683 51.2844 170.683 51.2844C170.683 51.2844 170.655 51.1757 170.62 50.9647C170.602 50.8571 170.582 50.7245 170.558 50.5692C170.542 50.409 170.522 50.2261 170.5 50.0182C170.428 49.181 170.429 47.9304 170.475 46.3506C170.48 45.578 170.559 44.7172 170.575 43.7653C170.586 42.816 170.584 41.7985 170.473 40.7275C170.366 39.6562 170.183 38.5328 169.879 37.3967C169.563 36.2616 169.12 35.1208 168.563 34.0109C168.013 32.8919 167.297 31.8419 166.532 30.8276C166.332 30.5785 166.135 30.3312 165.933 30.0802C165.729 29.8356 165.508 29.603 165.296 29.3632C165.082 29.1258 164.871 28.886 164.637 28.6587C164.41 28.4287 164.184 28.1965 163.941 27.9846C162.045 26.2207 159.744 24.834 157.312 24.1068C154.881 23.3649 152.383 23.3003 150.19 23.631C147.983 23.9545 146.071 24.6532 144.51 25.353C142.165 26.4333 140.292 27.6636 138.737 28.8286C137.183 29.9978 135.935 31.0964 134.891 32.0807C133.859 33.0556 132.992 33.8798 132.263 34.6501C132.173 34.7481 132.085 34.8439 131.996 34.9355C131.87 35.0807 131.724 35.2361 131.601 35.3915C131.474 35.5473 131.351 35.6986 131.228 35.8498C131.165 35.9245 131.108 36.0008 131.048 36.0732C131.006 36.1461 130.87 36.225 130.986 36.2883C131.232 36.5607 131.465 36.8217 131.709 37.0734C131.889 37.2634 132.062 37.4477 132.23 37.624C133.778 39.2461 135.238 40.775 136.632 42.2363C137.33 42.9626 138.015 43.6733 138.681 44.3688C139.015 44.7154 139.345 45.0583 139.674 45.3969C139.865 45.5964 140.056 45.7918 140.245 45.9894L140.649 46.4098C140.784 46.5428 140.916 46.6615 141.049 46.7885L141.247 46.9748L141.299 47.0185L141.32 47.044C141.325 47.0478 141.329 47.0516 141.332 47.0535L141.343 47.0399L141.444 46.943L141.83 46.5529C142.085 46.3 142.335 46.0077 142.564 45.7213C142.888 45.3177 143.089 45.0967 143.437 44.779C143.751 44.4791 144.068 44.1851 144.395 43.9113C144.712 43.6257 145.047 43.3701 145.374 43.1088C146.043 42.6165 146.72 42.1424 147.435 41.8013C148.146 41.4564 148.886 41.2055 149.62 41.1503L149.643 41.1462Z" fill="#0055CC"/>
<path d="M80.321 9.381C80.4416 7.10655 79.4571 7.02823 79.1312 9.25752C78.8942 10.8392 78.6434 12.4555 78.3341 14.1966C78.018 15.932 77.6635 17.8049 77.0533 19.8029C76.9621 20.1318 76.8558 20.4327 76.7629 20.7177C76.7418 20.7888 76.7161 20.8561 76.6904 20.9233C76.6579 21.008 76.6295 21.0923 76.5966 21.1728C76.5069 21.4218 76.4055 21.6573 76.3015 21.8866C75.8871 22.7744 75.5595 23.4763 75.3454 23.9376C76.5743 23.808 77.6597 23.6698 78.5962 23.5572C79.1374 23.483 79.6268 23.4154 80.1059 23.3508C81.0599 23.2219 81.9734 23.1092 83.1533 22.9964C85.9529 22.7118 89.7215 22.3998 93.0728 22.1386C93.9107 22.0744 94.7237 22.0123 95.4885 21.9523C95.6782 21.938 95.8679 21.9236 96.0534 21.9097C96.3908 21.8804 96.7199 21.8519 97.0447 21.8237C97.2132 21.807 97.3821 21.7945 97.5465 21.7781L97.6089 21.7727C97.6204 21.7591 97.6182 21.7341 97.6228 21.7148L97.6419 21.5957L97.6801 21.3574C97.73 21.0362 97.7788 20.7257 97.826 20.4215C97.9332 19.7429 98.0279 19.1388 98.1097 18.6281C98.1809 18.1394 98.241 17.7418 98.2835 17.4569C98.332 17.1191 98.3699 16.7801 98.4014 16.4396C98.4496 15.9045 98.5308 14.9722 98.6212 13.7348C98.6626 13.1206 98.7101 12.4304 98.7605 11.6769C98.8248 10.9391 98.9042 10.1327 98.9956 9.27083C99.1893 7.55237 99.4495 5.63093 99.8761 3.6447C100.088 2.65271 100.35 1.64389 100.688 0.657733C100.777 0.415087 100.869 0.172091 100.959 -0.0728197L101.111 -0.432169L101.185 -0.612789C101.19 -0.632072 101.226 -0.698169 101.255 -0.755205L101.343 -0.924419L101.695 -1.60959C101.746 -1.72103 101.822 -1.84298 101.901 -1.96529L102.126 -2.32887C102.421 -2.80344 102.713 -3.27991 103.01 -3.75675C102.93 -3.75822 102.807 -3.74549 102.664 -3.73095C102.522 -3.71867 102.364 -3.70079 102.189 -3.68563C101.84 -3.65113 101.434 -3.60967 100.989 -3.56688C100.271 -3.49835 99.4285 -3.41482 98.594 -3.33619C92.1629 -2.6822 88.1819 -2.27836 86.104 -2.06678C84.8775 -1.93528 83.7301 -1.81063 82.6387 -1.69294C81.9634 -1.61553 81.3068 -1.54182 80.6649 -1.4673L80.3138 -1.42637L80.1393 -1.40705L80.054 -1.39756C80.054 -1.39756 80.0158 -1.40264 80.0195 -1.38408L80.0129 -1.33944C79.9849 -1.10411 79.9566 -0.872952 79.9306 -0.639888C79.9042 -0.410991 79.8778 -0.182091 79.8514 0.046808C79.8379 0.182264 79.824 0.313557 79.8105 0.449013C79.6178 2.44645 79.5162 4.28491 79.4719 6.10582C79.4328 8.10883 80.2926 8.15179 80.5363 6.1856C80.7678 4.39463 81.0108 2.59008 81.2991 0.630513C81.3163 0.51362 81.3335 0.396721 81.3507 0.279829L81.3736 0.156149L81.3968 0.0366324C81.4245 0.0174448 81.4801 0.0294168 81.5173 0.0220026L81.6426 0.0153272C81.7592 0.00521753 81.8758 -0.00488413 81.9924 -0.0149939C82.259 -0.0381019 82.5275 -0.0634723 82.8005 -0.0850388C83.891 -0.187965 85.0441 -0.296311 86.2698 -0.413054C88.1772 -0.605671 92.1765 -0.77399 97.792 -1.29854C98.2499 -1.34242 98.7073 -1.39046 99.1621 -1.44458L99.459 -1.4808C99.459 -1.4808 99.4628 -1.48532 99.4666 -1.48985C99.4723 -1.49664 99.4841 -1.50606 99.5061 -1.51846C99.5282 -1.53086 99.5786 -1.55412 99.6074 -1.56081C99.6134 -1.54035 99.619 -1.52404 99.5928 -1.43784L99.5732 -1.37321L99.4323 -1.01267C99.3335 -0.771204 99.2457 -0.524399 99.1662 -0.278311C98.8317 0.707485 98.5712 1.70154 98.3498 2.68592C97.9192 4.64943 97.6406 6.5515 97.4316 8.21463C97.2283 9.87097 97.0684 11.3011 96.9964 12.3145C96.9101 13.3082 96.8578 13.8939 96.8578 13.8939C96.8578 13.8939 96.7819 14.8384 96.6206 16.3484C96.541 17.1044 96.4359 18.0011 96.3094 18.9919C96.2578 19.3657 96.2075 19.7561 96.1523 20.1616C96.1696 20.265 96.0622 20.2366 95.9922 20.2511C95.7737 20.2721 95.5533 20.2954 95.3287 20.3191C90.738 20.782 85.3487 21.3268 82.1496 21.6503L79.3959 21.931L78.3394 22.0393L78.1542 22.0575L78.0607 22.0677L78.0148 22.0717C78.0148 22.0717 77.9678 22.0862 77.9869 22.0636C78.0476 21.9408 78.1061 21.8162 78.1578 21.6858L78.2605 21.4167C78.3084 21.2909 78.3479 21.1657 78.3917 21.0402C78.4791 20.7893 78.5624 20.5387 78.637 20.2846C79.2812 18.1452 79.6012 16.2123 79.8478 14.4263C80.088 12.6388 80.2266 10.9859 80.3206 9.37683L80.321 9.381Z" fill="#0055CC"/>
</g>
</g>
<defs>
<clipPath id="clip0_550_14457">
<rect width="419" height="16" fill="white"/>
</clipPath>
<clipPath id="clip1_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_550_14457">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 330) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $e48fba9cf5395297$export$d3a66d29d3f047ac = `data:image/svg+xml;base64,${$e48fba9cf5395297$require$Buffer.from($e48fba9cf5395297$var$courseBg).toString("base64")}`;



var $ea8e736e4eb06883$require$Buffer = $hgUW1$Buffer;
const $ea8e736e4eb06883$var$learningPathBg = `<svg width="420" height="32" viewBox="0 0 420 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_783_5660)">
<rect width="421" height="32" fill="#D3F1A7"/>
<g clipPath="url(#clip1_783_5660)">
<path d="M419.987 -18.535C419.996 -18.6008 420.003 -18.6685 420.014 -18.7325C420.032 -18.7948 420.048 -18.855 420.064 -18.9151C420.099 -19.0357 420.114 -19.1586 420.159 -19.2633C420.248 -19.4787 420.309 -19.6897 420.416 -19.8626C420.463 -19.9547 420.508 -20.0405 420.551 -20.1239C420.603 -20.204 420.653 -20.2776 420.702 -20.3489C420.75 -20.4203 420.79 -20.495 420.836 -20.56C420.888 -20.6211 420.931 -20.6814 420.974 -20.7377C421.14 -20.9766 421.288 -21.1425 421.37 -21.2818C421.452 -21.4212 421.479 -21.5221 421.443 -21.5798C421.407 -21.6375 421.307 -21.6519 421.142 -21.6125C420.978 -21.5731 420.733 -21.4931 420.458 -21.2993C420.387 -21.2511 420.313 -21.2007 420.234 -21.1477C420.159 -21.0908 420.086 -21.0173 420.006 -20.9454C419.928 -20.8715 419.847 -20.7931 419.762 -20.7102C419.686 -20.6197 419.613 -20.5189 419.533 -20.4155C419.364 -20.2141 419.244 -19.9561 419.102 -19.6815C419.032 -19.5432 418.992 -19.3908 418.936 -19.237C418.91 -19.1592 418.885 -19.0794 418.86 -18.9996C418.838 -18.918 418.826 -18.8351 418.809 -18.7496C418.615 -17.7845 418.69 -16.8132 418.876 -15.8956C419.059 -14.9694 419.392 -14.1023 419.756 -13.2441C419.947 -12.8201 420.142 -12.3942 420.364 -11.9834C420.574 -11.5631 420.81 -11.1597 421.049 -10.7503L421.231 -10.4387C421.302 -10.3211 421.379 -10.2102 421.453 -10.1055C421.527 -10.0007 421.606 -9.89626 421.681 -9.80207L421.834 -9.60345C421.861 -9.56587 421.887 -9.52828 421.909 -9.4945C421.917 -9.4763 421.939 -9.45727 421.93 -9.44179L421.87 -9.40722L421.756 -9.34487C421.555 -9.22042 421.349 -9.0956 421.146 -8.96889C420.732 -8.71475 420.314 -8.45608 419.889 -8.19478C419.043 -7.67029 418.178 -7.13793 417.292 -6.589C415.522 -5.48507 413.666 -4.32963 411.701 -3.10388C411.569 -3.02115 411.438 -2.93843 411.311 -2.85606L411.263 -2.82257C411.247 -2.8128 411.23 -2.79243 411.213 -2.79515L411.176 -2.83808L411.129 -2.89695C411.053 -2.99948 410.979 -3.10009 410.908 -3.19881C410.748 -3.42205 410.595 -3.64376 410.445 -3.86582C409.853 -4.75028 409.317 -5.59134 408.833 -6.35724C407.867 -7.87654 407.139 -9.19195 406.523 -10.4478C405.911 -11.7041 405.395 -12.8911 404.961 -14.1984C404.532 -15.502 404.156 -16.9192 403.941 -18.6296C403.764 -20.0725 403.734 -21.6583 403.948 -23.2903C404.067 -24.1022 404.224 -24.932 404.485 -25.7436C404.596 -26.1561 404.761 -26.5544 404.909 -26.9595C405.08 -27.3563 405.245 -27.7587 405.453 -28.1439C405.847 -28.9251 406.311 -29.6787 406.85 -30.3843C407.385 -31.0937 407.973 -31.7657 408.624 -32.3739C408.936 -32.6906 409.287 -32.9707 409.619 -33.2638C409.969 -33.5376 410.311 -33.8212 410.678 -34.0691C411.033 -34.3348 411.41 -34.5668 411.777 -34.8022C412.152 -35.0319 412.539 -35.2438 412.914 -35.4652C414.436 -36.3063 415.99 -36.9508 417.497 -37.3605C419.003 -37.7744 420.458 -37.953 421.776 -37.9728C423.096 -37.9949 424.276 -37.8643 425.269 -37.7091C426.262 -37.5581 427.07 -37.3658 427.646 -37.2332L428.69 -36.9733C429.045 -36.8908 429.419 -36.8161 429.771 -36.7439C430.378 -36.6244 431.227 -36.4357 432.428 -36.2524C433.028 -36.1617 433.721 -36.077 434.532 -36.0634C435.339 -36.0536 436.29 -36.115 437.298 -36.4731C437.804 -36.6386 438.302 -36.8958 438.794 -37.2049C439.033 -37.3788 439.288 -37.5352 439.516 -37.7606C439.63 -37.8691 439.756 -37.9682 439.863 -38.0907C439.969 -38.2175 440.076 -38.3442 440.183 -38.4709C440.585 -39.0094 440.922 -39.6534 441.087 -40.3602C441.245 -41.0621 441.295 -41.8007 441.211 -42.5237C441.061 -43.9794 440.534 -45.3837 439.853 -46.7871C439.509 -47.4895 439.114 -48.1854 438.684 -48.8867C438.47 -49.2438 438.255 -49.5756 438.036 -49.93C437.987 -50.0056 437.941 -50.0792 437.892 -50.1547L437.861 -50.2044C437.876 -50.2184 437.894 -50.2304 437.914 -50.2447C437.836 -50.1981 438.202 -50.4313 438.461 -50.5964C439.016 -50.9487 439.658 -51.3548 440.372 -51.8091C441.803 -52.7116 443.524 -53.7987 445.425 -54.9978C446.336 -55.572 447.291 -56.171 448.275 -56.7892L448.326 -56.823C448.342 -56.8286 448.363 -56.8577 448.374 -56.8292L448.412 -56.7821L448.504 -56.658C448.854 -56.1743 449.194 -55.6645 449.531 -55.1418C449.866 -54.6086 450.202 -54.0712 450.54 -53.5319C450.86 -52.9889 451.204 -52.4564 451.506 -51.9013C452.14 -50.8043 452.697 -49.6713 453.218 -48.5373C454.609 -45.4749 455.414 -42.519 455.622 -39.8408C455.835 -37.1588 455.451 -34.7734 454.708 -32.8332C453.969 -30.885 452.931 -29.3703 451.906 -28.2008C450.869 -27.0366 449.854 -26.1975 448.994 -25.5648C448.74 -25.377 448.489 -25.1937 448.225 -25.026C447.964 -24.8545 447.711 -24.6814 447.441 -24.53C447.177 -24.3729 446.912 -24.2176 446.652 -24.0609C446.391 -23.906 446.118 -23.7796 445.858 -23.6395C445.335 -23.3487 444.792 -23.1337 444.267 -22.891C444.001 -22.782 443.73 -22.6893 443.467 -22.5866L443.07 -22.4369L442.67 -22.314C441.607 -21.9638 440.54 -21.7559 439.49 -21.6188C438.439 -21.4752 437.397 -21.4584 436.377 -21.4937C435.354 -21.5267 434.349 -21.6453 433.361 -21.7967C432.866 -21.8692 432.377 -21.9632 431.889 -22.0531C431.396 -22.1509 430.914 -22.2581 430.418 -22.3473C429.434 -22.5327 428.468 -22.7238 427.477 -22.8687C426.491 -23.0141 425.476 -23.1065 424.439 -23.0397C423.318 -22.9551 422.489 -22.6084 422.02 -22.2886C421.775 -22.1352 421.62 -21.9792 421.526 -21.8618C421.431 -21.7445 421.396 -21.6576 421.422 -21.6053L421.393 -21.479C421.408 -21.4698 421.421 -21.475 421.419 -21.4959L421.417 -21.6091L421.441 -21.5817C421.478 -21.5346 421.572 -21.5217 421.717 -21.5385C421.86 -21.5572 422.053 -21.6117 422.306 -21.6651C422.804 -21.788 423.52 -21.9508 424.501 -21.9792C426.333 -22.0037 428.217 -21.4935 430.151 -21.0652C432.069 -20.5957 434.122 -20.1211 436.309 -19.998C437.401 -19.9333 438.53 -19.9304 439.679 -20.0657C440.824 -20.1922 441.997 -20.4072 443.155 -20.774L443.593 -20.9043L444.026 -21.0615C444.313 -21.1682 444.608 -21.2672 444.896 -21.3845C445.464 -21.6372 446.054 -21.871 446.616 -22.1756C446.899 -22.3239 447.191 -22.4605 447.471 -22.6232C447.751 -22.7859 448.03 -22.9528 448.316 -23.1182C448.602 -23.2794 448.877 -23.4648 449.157 -23.6507C449.44 -23.8304 449.714 -24.0284 449.988 -24.2305C450.841 -24.8583 451.905 -25.7017 453.021 -26.8958C453.309 -27.1872 453.571 -27.5226 453.863 -27.8606C454.004 -28.0322 454.137 -28.2179 454.276 -28.402C454.418 -28.5843 454.554 -28.7745 454.686 -28.9768C455.233 -29.7649 455.74 -30.6671 456.174 -31.674C457.054 -33.6807 457.614 -36.138 457.566 -38.828C457.534 -41.5172 456.936 -44.4071 455.846 -47.3131C455.131 -49.2087 454.232 -51.0192 453.22 -52.7276C453 -53.1093 452.768 -53.4858 452.531 -53.8597C452.294 -54.2399 452.058 -54.616 451.817 -54.9854C451.333 -55.7282 450.844 -56.4873 450.306 -57.2401C450.171 -57.4277 450.035 -57.6153 449.893 -57.8044C449.653 -58.1256 449.383 -58.4568 449.123 -58.7679L448.927 -59.0068L448.828 -59.1242L448.779 -59.185L448.713 -59.1436L448.187 -58.8211L447.222 -58.2108C446.463 -57.7211 445.702 -57.2334 444.944 -56.746C443.425 -55.775 441.918 -54.8134 440.448 -53.874C438.753 -52.7997 437.104 -51.7524 435.527 -50.7533C435.991 -50.0109 436.451 -49.2807 436.903 -48.5604C437.066 -48.3038 437.217 -48.0567 437.362 -47.8112C437.505 -47.5634 437.664 -47.3254 437.793 -47.0785C438.349 -46.1048 438.792 -45.1298 439.105 -44.1939C439.417 -43.2557 439.58 -42.3466 439.535 -41.5454C439.493 -40.7424 439.25 -40.0624 438.851 -39.5599C438.46 -39.0497 437.954 -38.6911 437.475 -38.4376C436.995 -38.1883 436.554 -38.0452 436.181 -37.9646C435.996 -37.9234 435.825 -37.9044 435.679 -37.877C435.529 -37.864 435.404 -37.8532 435.302 -37.8423C435.2 -37.8313 435.122 -37.8309 435.068 -37.8304C435.013 -37.8298 434.988 -37.8277 434.988 -37.8277C434.988 -37.8277 434.871 -37.8259 434.651 -37.8215C434.54 -37.8265 434.399 -37.829 434.237 -37.8338C434.073 -37.8406 433.88 -37.8596 433.667 -37.8767C432.801 -37.9591 431.531 -38.1931 429.936 -38.5374C429.151 -38.6876 428.292 -38.93 427.33 -39.1214C426.369 -39.3109 425.335 -39.5004 424.228 -39.5891C423.123 -39.6842 421.952 -39.7107 420.741 -39.6162C419.533 -39.5115 418.291 -39.2884 417.058 -38.9423C415.82 -38.6 414.613 -38.0967 413.43 -37.5305C412.848 -37.2282 412.256 -36.9336 411.697 -36.585C411.125 -36.2585 410.565 -35.8952 410.019 -35.5121C407.837 -33.978 405.925 -31.9889 404.62 -29.721C403.3 -27.4622 402.621 -24.9777 402.422 -22.6922C402.327 -21.5468 402.342 -20.4487 402.416 -19.4206C402.469 -18.909 402.508 -18.413 402.588 -17.9395C402.625 -17.7035 402.656 -17.4691 402.697 -17.2418C402.742 -17.0149 402.786 -16.7921 402.83 -16.5777C403.106 -15.2755 403.444 -14.0753 403.836 -12.9846C404.024 -12.4365 404.237 -11.9178 404.431 -11.4143C404.65 -10.9213 404.839 -10.4341 405.058 -9.9831C405.906 -8.16185 406.754 -6.66802 407.532 -5.40729C408.303 -4.16059 408.956 -3.11351 409.589 -2.2179C409.677 -2.09754 409.763 -1.97908 409.846 -1.86252C409.972 -1.69507 410.097 -1.53177 410.231 -1.3692C410.364 -1.2108 410.493 -1.05203 410.619 -0.899327C410.683 -0.822977 410.748 -0.74889 410.811 -0.672541C410.838 -0.607701 410.885 -0.664288 410.925 -0.684559L411.049 -0.758224C411.375 -0.948013 411.688 -1.14089 411.994 -1.3353C412.199 -1.46428 412.396 -1.58837 412.583 -1.70531C414.541 -2.94093 416.392 -4.10849 418.154 -5.2223C419.034 -5.7811 419.891 -6.3275 420.73 -6.86187C421.15 -7.13113 421.563 -7.39361 421.975 -7.65798C422.182 -7.78922 422.388 -7.92463 422.593 -8.0536L423.1 -8.37663L423.351 -8.53683L423.58 -8.6994L424.035 -9.02415L424.063 -9.04335L424.074 -9.05693C424.074 -9.05693 424.071 -9.06299 424.069 -9.06906L424.03 -9.12865L423.95 -9.24973L423.794 -9.48584C423.591 -9.79557 423.369 -10.1058 423.118 -10.4051L422.846 -10.7382L422.646 -10.9915C422.584 -11.0743 422.525 -11.1593 422.472 -11.2387L422.296 -11.5214C422.062 -11.9039 421.823 -12.282 421.616 -12.6689C421.392 -13.0503 421.203 -13.441 421.015 -13.8275C420.658 -14.6065 420.324 -15.3895 420.137 -16.1875C419.943 -16.9806 419.861 -17.7834 419.977 -18.5362L419.987 -18.535Z" fill="#6A9A23"/>
<path d="M375.063 24.9613C374.963 24.9469 374.87 24.934 374.776 24.9211C374.684 24.9207 374.594 24.9181 374.507 24.9151C374.335 24.9132 374.174 24.9167 374.025 24.9233C373.73 24.9258 373.486 24.9952 373.295 25.0474C372.911 25.1605 372.732 25.2998 372.737 25.4357C372.745 25.5735 372.937 25.7079 373.298 25.8109C373.477 25.8688 373.704 25.8932 373.964 25.9651C374.095 25.9937 374.236 26.0234 374.387 26.046C374.461 26.0584 374.54 26.0705 374.623 26.0822C374.702 26.1026 374.783 26.1207 374.867 26.1407C375.825 26.3325 376.729 26.7137 377.473 27.3312C378.22 27.9441 378.807 28.785 379.24 29.7755C379.678 30.7657 379.967 31.901 380.15 33.1252C380.208 33.4286 380.237 33.7429 380.273 34.0629C380.311 34.3807 380.35 34.7026 380.365 35.0327C380.388 35.3644 380.408 35.6983 380.431 36.0384C380.447 36.3874 380.465 36.7426 380.481 37.1C380.568 38.5486 380.642 39.8241 380.666 40.2417C381.225 40.2059 381.762 40.1741 382.279 40.1418C382.607 40.1197 382.919 40.0968 383.222 40.0768C383.739 40.0362 384.218 39.9989 384.668 39.964C385.568 39.8902 386.356 39.8262 387.106 39.7653C388.606 39.6437 389.965 39.5385 391.821 39.449C393.519 39.3668 395.452 39.2727 397.832 39.1566C397.789 38.0735 397.747 36.9566 397.702 35.8254C397.669 34.9323 397.636 34.0245 397.605 33.125C397.53 31.3039 397.376 29.4981 397.138 27.8338C396.902 26.1715 396.583 24.6549 396.247 23.4104C395.91 22.1659 395.554 21.1981 395.327 20.6092C395.161 20.1725 394.959 19.7431 394.754 19.3202C394.367 18.5733 393.65 17.1667 392.278 15.5734C391.593 14.7809 390.741 13.9525 389.693 13.2062C388.648 12.4595 387.41 11.801 386.039 11.3281C384.669 10.8447 383.165 10.5723 381.624 10.4666C380.079 10.3572 378.499 10.4312 376.908 10.6467C373.722 11.0467 370.51 12.3407 368.007 14.3579C366.235 15.781 364.937 17.3979 363.976 18.95C363.746 19.3434 363.514 19.7244 363.305 20.1013C363.11 20.4854 362.924 20.8582 362.739 21.2205C362.569 21.5877 362.42 21.9489 362.268 22.3C362.215 22.422 362.163 22.544 362.112 22.6638C362.01 22.8133 362.067 22.9888 362.062 23.1549C362.073 23.3492 362.081 23.5415 362.091 23.7274C362.225 26.4708 362.325 28.491 362.392 29.8763C362.478 31.4741 362.561 32.9734 362.623 34.1577L364.386 34.2336C364.674 32.0726 365.411 30.2357 366.575 28.8843C367.741 27.5432 369.26 26.6687 370.916 26.2336C371.517 26.0786 371.977 25.9401 372.284 25.8233C372.59 25.6982 372.75 25.5626 372.742 25.4437C372.74 25.3221 372.569 25.2173 372.224 25.1508C371.88 25.0778 371.359 25.0726 370.681 25.1943C368.823 25.5253 366.976 26.4093 365.521 27.937C364.067 29.4689 363.142 31.6116 362.786 34.0198L364.239 34.0827C364.187 32.8954 364.122 31.3966 364.054 29.7974C363.992 28.5249 363.955 26.5621 363.894 23.9844C363.891 23.8231 363.885 23.66 363.883 23.4923L363.878 23.2409L363.877 23.1781L363.878 23.1675L363.881 23.1505C363.881 23.1505 363.892 23.1327 363.903 23.1108C363.934 23.0409 363.966 22.971 364 22.903C364.071 22.75 364.141 22.5928 364.214 22.4376C364.35 22.1194 364.523 21.8086 364.694 21.4895C364.779 21.329 364.866 21.1662 364.953 21.0034C365.043 20.8403 365.147 20.6844 365.242 20.5209C366.022 19.2216 367.014 17.8998 368.295 16.6977C368.509 16.507 368.703 16.2951 368.929 16.1223L369.589 15.5804C369.811 15.3996 370.05 15.2488 370.278 15.0779L370.624 14.8277L370.986 14.6032C371.25 14.4461 371.505 14.2666 371.785 14.127C372.062 13.9854 372.345 13.8413 372.625 13.6975C373.21 13.4516 373.797 13.1846 374.426 13.0021C374.736 12.8997 375.044 12.7954 375.367 12.7275C375.686 12.6516 376.006 12.5651 376.327 12.4994C376.979 12.3905 377.629 12.2649 378.288 12.2204C380.921 11.946 383.526 12.209 385.614 12.968C386.66 13.3411 387.579 13.8238 388.345 14.3365C389.111 14.8534 389.716 15.401 390.206 15.8705C390.437 16.1191 390.649 16.3399 390.826 16.5386C390.997 16.7441 391.142 16.9203 391.259 17.0654C391.379 17.2083 391.454 17.3297 391.516 17.4083C391.573 17.4873 391.601 17.5268 391.601 17.5268C391.873 17.8747 392.103 18.2575 392.347 18.6288C392.569 19.0166 392.801 19.393 392.997 19.7977C393.412 20.5906 393.761 21.4207 394.07 22.2646C394.683 23.9614 395.133 25.7269 395.443 27.5254C395.758 29.3236 395.953 31.1448 396.065 32.9773C396.125 33.8891 396.162 34.828 396.208 35.7514L396.305 37.7845L390.608 38.0895L382.223 38.5415L382.147 37.0331C382.088 35.6115 381.988 34.1912 381.763 32.8742C381.542 31.5526 381.199 30.294 380.646 29.1459C380.101 28.0035 379.328 26.971 378.338 26.2428C377.353 25.5077 376.197 25.1148 375.079 24.9746L375.063 24.9613Z" fill="#6A9A23"/>
<path d="M402.801 24.9656C402.203 22.6548 401.239 22.8832 401.63 25.2097C401.897 26.8631 402.16 28.5525 402.386 30.3878C402.496 31.3035 402.599 32.2556 402.664 33.2487C402.731 34.2438 402.77 35.2853 402.721 36.368C402.716 36.4986 402.712 36.6269 402.706 36.7533C402.692 36.9308 402.68 37.106 402.667 37.2728C402.649 37.501 402.616 37.7284 402.587 37.947C402.549 38.1706 402.513 38.3836 402.478 38.5859C402.35 39.3629 402.251 39.9632 402.194 40.3059C402.264 40.2831 402.36 40.2328 402.447 40.1938C402.536 40.1525 402.622 40.1093 402.707 40.0684C402.88 39.9863 403.049 39.9045 403.212 39.8253C403.541 39.6688 403.857 39.5134 404.161 39.3675C404.461 39.2218 404.753 39.0811 405.035 38.9434C405.166 38.8796 405.295 38.8181 405.42 38.7569C405.494 38.719 405.569 38.681 405.641 38.6454C406.222 38.3495 406.739 38.0886 407.235 37.8379C408.23 37.334 409.152 36.8765 410.402 36.3086C413.075 35.0677 416.694 33.4635 419.925 32.0504C420.732 31.6972 421.514 31.3587 422.252 31.0366C422.623 30.8766 422.982 30.7195 423.328 30.5699C423.651 30.4244 423.969 30.2815 424.278 30.1435L424.51 30.0373L424.627 29.9852C424.643 29.9754 424.67 29.971 424.679 29.9555L424.669 29.8934C424.645 29.7298 424.621 29.5703 424.596 29.4109C424.469 28.5658 424.357 27.8075 424.263 27.1716C424.181 26.6584 424.115 26.2443 424.066 25.9443C424.009 25.5906 423.941 25.2398 423.864 24.8897C423.747 24.3627 423.548 23.4609 423.258 22.267C423.115 21.6751 422.945 20.9912 422.762 20.281C422.599 19.5649 422.429 18.7845 422.257 17.937C421.919 16.25 421.588 14.3419 421.404 12.3017C421.312 11.2815 421.271 10.2275 421.314 9.17048C421.331 8.90671 421.348 8.64295 421.367 8.37693L421.413 7.98269L421.436 7.78557L421.445 7.71975C421.453 7.66451 421.46 7.64713 421.465 7.60892L421.506 7.4081C421.68 6.38378 422.084 5.13595 422.384 4.06711C422.287 4.10077 422.129 4.17316 421.956 4.25533C421.78 4.3356 421.585 4.42601 421.371 4.52428C420.941 4.7231 420.436 4.95568 419.886 5.21114C419.131 5.55774 418.245 5.96396 417.367 6.3653C411.226 9.21824 407.424 10.9851 405.438 11.9042C404.269 12.4546 403.174 12.9712 402.136 13.462C401.618 13.7104 401.117 13.9532 400.623 14.1911C400.196 14.396 399.771 14.5986 399.352 14.7986C399.183 14.8195 399.29 14.9823 399.295 15.091L399.363 15.446C399.409 15.6812 399.454 15.9123 399.497 16.1457C399.555 16.4219 399.614 16.6958 399.671 16.9678C399.726 17.219 399.783 17.4679 399.838 17.715C399.952 18.2087 400.069 18.6937 400.19 19.17C400.43 20.1249 400.684 21.0492 400.954 21.9637C401.557 23.9739 402.388 23.7488 401.992 21.7122C401.823 20.7825 401.653 19.851 401.478 18.8926C401.397 18.415 401.313 17.9312 401.226 17.4373C401.149 16.9592 401.07 16.4752 400.989 15.9786L400.974 15.8456L400.966 15.7812C400.966 15.7623 400.949 15.7324 400.982 15.7295L401.11 15.6785L401.173 15.6542L401.28 15.6092C401.78 15.3876 402.289 15.1588 402.814 14.9244C403.86 14.4477 404.962 13.9451 406.136 13.4069C407.958 12.5628 411.855 11.0143 417.234 8.56739C417.672 8.36786 418.107 8.16225 418.54 7.95474L419.186 7.63645L419.508 7.47429C419.526 7.46225 419.52 7.46071 419.527 7.45166C419.541 7.43581 419.56 7.41318 419.589 7.38756L419.638 7.34764L419.667 7.32619C419.667 7.32619 419.691 7.30737 419.688 7.31606C419.694 7.34069 419.694 7.39103 419.696 7.4622L419.696 7.51671L419.663 7.87844C419.633 8.14329 419.62 8.40669 419.607 8.67009C419.56 9.72334 419.595 10.7652 419.667 11.7724C419.824 13.7898 420.128 15.6834 420.427 17.3172C420.573 18.1354 420.726 18.8859 420.861 19.5603C421 20.2365 421.126 20.8298 421.25 21.3122C421.469 22.2689 421.597 22.8286 421.597 22.8286C421.597 22.8286 421.823 23.7951 422.142 25.3537C422.301 26.133 422.48 27.0597 422.663 28.0908C422.702 28.3203 422.743 28.5559 422.785 28.7957L422.803 28.9075L422.812 28.9654C422.818 28.9859 422.785 28.9846 422.771 28.9963C422.384 29.1767 421.984 29.3624 421.575 29.5511C417.19 31.5824 412.042 33.9717 408.986 35.3886L405.982 36.7841L404.671 37.3929L404.467 37.4882L404.366 37.5347L404.316 37.558L404.289 37.5708C404.289 37.5708 404.28 37.5779 404.277 37.576L404.28 37.5631C404.303 37.4584 404.319 37.3521 404.328 37.2442L404.345 37.0687C404.365 36.8613 404.372 36.6551 404.381 36.4465C404.431 35.2672 404.374 34.1685 404.284 33.1272C404.194 32.0859 404.057 31.1094 403.903 30.1765C403.593 28.3087 403.216 26.6124 402.802 24.9739L402.801 24.9656Z" fill="#6A9A23"/>
<path d="M384.78 4.00329C387.938 3.20915 387.727 2.24341 384.526 2.83562C382.254 3.25496 379.932 3.70171 377.414 4.21162C376.157 4.47169 374.85 4.74026 373.477 5.02294C372.791 5.16845 372.086 5.31766 371.367 5.47022L371.218 5.49987C371.197 5.50168 371.166 5.52123 371.163 5.48791C371.092 5.31992 371.022 5.14967 370.951 4.97752C369.623 1.76695 368.946 -0.312486 368.381 -2.12043C367.842 -3.93698 367.411 -5.50059 367.051 -7.83194C366.893 -8.81488 366.773 -9.88927 366.688 -11.0192C366.622 -12.1486 366.576 -13.3343 366.64 -14.5359C366.704 -15.7374 366.819 -16.9581 367.064 -18.1396C367.308 -19.3211 367.637 -20.4742 368.076 -21.5383C368.18 -21.8055 368.312 -22.0581 368.428 -22.3158C368.488 -22.4427 368.547 -22.5716 368.605 -22.6962C368.676 -22.822 368.743 -22.9474 368.812 -23.0709C369.086 -23.5667 369.355 -24.0516 369.614 -24.5211C369.889 -24.9813 370.184 -25.4056 370.452 -25.8254C370.59 -26.0303 370.716 -26.2406 370.855 -26.4331C371 -26.6199 371.14 -26.804 371.278 -26.9817C371.556 -27.3352 371.803 -27.6798 372.06 -27.9811C372.327 -28.2707 372.576 -28.5441 372.802 -28.7903C373.238 -29.3044 373.671 -29.6399 373.952 -29.9097L374.459 -30.3796L375.001 -30.8127C375.161 -30.9441 375.356 -31.1015 375.579 -31.2845C375.688 -31.3821 375.817 -31.4709 375.954 -31.5604C376.091 -31.6541 376.237 -31.7508 376.39 -31.8542C376.986 -32.2878 377.767 -32.7206 378.666 -33.1972C380.483 -34.1268 382.926 -34.9701 385.749 -35.6869C386.452 -35.8717 387.182 -36.0462 387.929 -36.2179C388.673 -36.3957 389.442 -36.561 390.222 -36.7356C390.745 -36.8523 391.276 -36.9696 391.811 -37.0874C391.827 -37.0972 391.829 -37.0805 391.834 -37.0684L391.843 -37.0293L391.877 -36.8812C391.965 -36.4754 392.052 -36.0697 392.138 -35.6616C392.826 -32.3977 393.535 -29.0516 394.215 -25.8332C394.699 -23.5607 395.138 -21.5069 395.533 -19.6569C395.709 -18.8328 395.874 -18.0562 396.03 -17.3227L396.047 -17.2507C396.046 -17.2318 396.008 -17.2368 395.99 -17.229C395.759 -17.1838 395.532 -17.1389 395.315 -17.097C393.858 -16.8196 392.563 -16.5563 391.456 -16.2547C390.349 -15.9573 389.427 -15.6235 388.695 -15.281C387.829 -14.8808 387.014 -14.3841 386.312 -13.7652C385.606 -13.15 385.025 -12.4135 384.602 -11.6257C384.182 -10.8318 383.945 -10.0035 383.788 -9.19671C383.737 -8.79153 383.662 -8.39059 383.656 -7.99771C383.648 -7.79977 383.64 -7.606 383.631 -7.41223C383.631 -7.21918 383.643 -7.02722 383.649 -6.83679C383.805 -3.79316 384.714 -1.22823 385.709 1.20761C386.262 2.50259 386.762 3.06984 386.983 3.00452L386.993 2.90918C386.995 2.93001 387.006 2.93951 387.029 2.93545L387.023 2.98842C387.233 2.86741 387.157 2.12707 386.709 0.831387C385.907 -1.6044 385.185 -4.13523 385.149 -6.86608C385.149 -7.03604 385.145 -7.20563 385.149 -7.37595C385.164 -7.54509 385.174 -7.71387 385.187 -7.88491C385.199 -8.23008 385.278 -8.56211 385.326 -8.9041C385.476 -9.57384 385.682 -10.2422 386.022 -10.857C386.365 -11.468 386.82 -12.032 387.389 -12.5198C387.957 -13.0076 388.635 -13.4231 389.39 -13.7697C389.972 -14.0447 390.76 -14.3207 391.748 -14.5721C392.735 -14.8234 393.919 -15.0373 395.292 -15.2696C395.66 -15.3351 396.039 -15.3993 396.429 -15.4689C396.772 -15.5363 397.118 -15.6041 397.469 -15.6723C397.646 -15.7087 397.826 -15.7431 398.003 -15.7795L398.137 -15.8058L398.206 -15.818C398.206 -15.818 398.218 -15.8191 398.222 -15.8236L398.22 -15.8403L398.213 -15.8732L398.161 -16.1414C397.961 -17.148 397.754 -18.2065 397.532 -19.3161C397.2 -21.0058 396.833 -22.8477 396.421 -24.8325C396.152 -26.1248 395.86 -27.413 395.553 -28.6873C394.886 -31.4348 394.198 -34.3925 393.546 -37.286L393.341 -38.223L393.235 -38.7027L393.183 -38.9395L393.156 -39.0588C393.152 -39.0774 393.15 -39.1024 393.141 -39.1141L393.079 -39.1004C392.467 -38.9655 391.858 -38.8288 391.251 -38.6943C390.541 -38.5342 389.839 -38.3747 389.149 -38.2205C387.771 -37.908 386.435 -37.6013 385.194 -37.2776C382.705 -36.6506 380.584 -35.9232 379.116 -35.3029C378.753 -35.1371 378.426 -34.9871 378.141 -34.8596C377.997 -34.7947 377.866 -34.7351 377.745 -34.6784C377.627 -34.6157 377.521 -34.5582 377.422 -34.5056C377.038 -34.296 376.829 -34.1815 376.829 -34.1815C376.829 -34.1815 376.751 -34.139 376.605 -34.0571C376.459 -33.971 376.233 -33.8675 375.972 -33.6854C375.704 -33.509 375.379 -33.292 374.999 -33.043C374.904 -32.9802 374.807 -32.9151 374.705 -32.8496C374.611 -32.7743 374.511 -32.6964 374.413 -32.6165C374.213 -32.4565 373.998 -32.289 373.775 -32.1101C373.313 -31.7721 372.875 -31.325 372.39 -30.8675C371.887 -30.4253 371.447 -29.8604 370.947 -29.3072C370.689 -29.0331 370.468 -28.7244 370.238 -28.4086C370.006 -28.0969 369.77 -27.7742 369.529 -27.4512C369.295 -27.1225 369.093 -26.7672 368.869 -26.4183C368.652 -26.0638 368.416 -25.7139 368.211 -25.3457C368.012 -24.9718 367.81 -24.5934 367.61 -24.213C367.412 -23.8266 367.19 -23.4611 367.018 -23.0413C366.838 -22.6332 366.644 -22.2241 366.501 -21.7962L366.27 -21.1594C366.194 -20.9451 366.142 -20.7265 366.076 -20.511C365.569 -18.778 365.306 -16.9905 365.209 -15.272C365.017 -11.829 365.44 -8.67637 365.857 -6.37091C366.505 -2.89785 367.285 -0.399327 367.899 1.48832C368.53 3.37452 369.032 4.64658 369.43 5.61085C369.519 5.81714 369.604 6.0238 369.693 6.22593C369.821 6.52323 369.954 6.82018 370.092 7.1145L370.193 7.33446L370.219 7.39097C370.227 7.40918 370.255 7.38998 370.274 7.39044L370.391 7.36557L370.861 7.27026C371.154 7.20714 371.444 7.14212 371.732 7.07936C372.451 6.91847 373.155 6.76093 373.838 6.60936C375.206 6.29562 376.507 5.99825 377.757 5.70939C380.258 5.12332 382.558 4.56518 384.799 4.00376L384.78 4.00329Z" fill="#6A9A23"/>
<path d="M289.604 -5.95927C289.825 -7.16812 289.658 -7.81042 289.394 -7.85468C289.12 -7.90012 288.748 -7.36645 288.444 -6.25107C287.978 -4.67267 287.331 -3.1185 286.404 -1.58822C285.451 -0.0788647 284.202 1.41638 282.444 2.63884C282.187 2.81642 281.946 2.9884 281.706 3.1267C281.648 3.16317 281.588 3.19774 281.53 3.23421L281.447 3.28762C281.447 3.28762 281.409 3.30978 281.377 3.32517L281.29 3.36835C281.059 3.48283 280.835 3.59242 280.626 3.69867C280.424 3.80645 280.211 3.89829 280.009 3.98299C279.81 4.06733 279.626 4.14832 279.454 4.2199C279.131 4.36125 278.862 4.47897 278.656 4.5682C278.704 4.61647 278.78 4.66864 278.853 4.71892C278.925 4.77146 278.996 4.81983 279.068 4.87237C279.209 4.97138 279.347 5.07265 279.484 5.16786C279.754 5.36053 280.016 5.54559 280.268 5.72304C280.518 5.89859 280.76 6.0707 280.994 6.2371C281.17 6.35821 281.342 6.47968 281.508 6.59544C282.011 6.93785 282.46 7.2452 282.899 7.54495C283.773 8.1448 284.593 8.71793 285.64 9.49792C286.838 10.3781 288.231 11.4219 289.677 12.5177C290.398 13.0658 291.134 13.6272 291.868 14.1826C292.068 14.3352 292.27 14.4898 292.47 14.6424L292.955 15.0033L293.076 15.0935L293.136 15.1365L293.166 15.1612C293.166 15.1612 293.19 15.1507 293.202 15.1455L293.482 15.0373L294.04 14.8189L294.428 14.6468C294.65 14.5436 294.865 14.4306 295.078 14.3198C295.921 13.8585 296.673 13.3087 297.317 12.722C297.483 12.5796 297.641 12.4338 297.785 12.2807C297.933 12.1314 298.078 11.9825 298.221 11.84C298.484 11.5361 298.742 11.243 298.969 10.9548C299.883 9.79918 300.394 8.76454 300.697 8.20105C300.87 7.86299 301.007 7.51115 301.151 7.16086C301.27 6.89033 301.388 6.50663 301.543 6.03374C301.71 5.56394 301.847 4.99179 302.013 4.33953C302.105 4.01476 302.163 3.66562 302.234 3.29648C302.303 2.93376 302.376 2.55402 302.45 2.15726C302.521 1.78395 302.597 1.39552 302.673 0.992327C302.769 0.593762 302.883 0.187326 302.989 -0.237315C303.46 -1.91903 304.268 -3.72008 305.478 -5.37976C306.096 -6.19706 306.82 -6.9753 307.642 -7.65926C308.05 -8.00731 308.494 -8.31432 308.949 -8.61183L309.48 -8.92643C309.722 -9.05865 309.971 -9.18934 310.24 -9.31123C310.758 -9.55548 311.278 -9.80199 311.8 -10.0466C311.202 -10.492 309.695 -11.6078 308.218 -12.703C305.465 -14.7241 303.236 -16.3585 301.476 -17.6495C300.595 -18.2971 299.83 -18.8559 299.173 -19.3383C298.846 -19.5785 298.546 -19.8001 298.271 -20.0007C298.038 -20.1694 297.818 -20.3308 297.61 -20.4827C297.494 -20.565 297.378 -20.6472 297.27 -20.726C297.244 -20.7594 297.213 -20.7357 297.182 -20.7226L297.092 -20.6791C297.033 -20.6509 296.971 -20.6224 296.914 -20.5965C296.644 -20.4641 296.349 -20.3377 296.113 -20.204C295.961 -20.1194 295.804 -20.0429 295.661 -19.9466C295.516 -19.8563 295.37 -19.7661 295.229 -19.6762C295.09 -19.5803 294.954 -19.4824 294.82 -19.3869C294.549 -19.1934 294.3 -18.9851 294.054 -18.7791C293.819 -18.5594 293.574 -18.3598 293.365 -18.1298C292.493 -17.2443 291.803 -16.2907 291.244 -15.3315C290.158 -13.3931 289.552 -11.4542 289.197 -9.52671C288.87 -7.38335 289.73 -7.29835 290.238 -9.28538C290.758 -11.0888 291.464 -12.8475 292.528 -14.5574C293.072 -15.4019 293.716 -16.2236 294.498 -16.9838C294.687 -17.1806 294.905 -17.3485 295.111 -17.5384C295.329 -17.7105 295.547 -17.8909 295.782 -18.0519C295.901 -18.1335 296.018 -18.2129 296.139 -18.2968C296.263 -18.3705 296.386 -18.4483 296.512 -18.5243C296.637 -18.6044 296.768 -18.6682 296.898 -18.7403C296.958 -18.7749 296.982 -18.7854 297.027 -18.806C297.043 -18.8116 297.059 -18.8214 297.075 -18.827C297.089 -18.8156 297.105 -18.8023 297.118 -18.7909C297.157 -18.7585 297.195 -18.7262 297.236 -18.692C297.49 -18.4937 297.769 -18.2786 298.075 -18.0408C298.684 -17.5628 299.393 -17.0053 300.204 -16.3705C301.821 -15.1028 303.83 -13.5417 306.218 -11.7617C306.608 -11.4723 307 -11.1853 307.395 -10.9069L307.991 -10.4907L308.141 -10.3882C308.141 -10.3882 308.145 -10.3886 308.149 -10.389C308.156 -10.3874 308.164 -10.3881 308.172 -10.3889C308.198 -10.3869 308.247 -10.3723 308.287 -10.3505C308.274 -10.3264 308.253 -10.3015 308.185 -10.2431L308.026 -10.1412L307.856 -10.0215L307.515 -9.7822C307.288 -9.6219 307.077 -9.44412 306.856 -9.27395C305.994 -8.57388 305.217 -7.77012 304.539 -6.92241C303.169 -5.22782 302.263 -3.31968 301.676 -1.61952C301.604 -1.40558 301.532 -1.1958 301.461 -0.992448C301.389 -0.786833 301.346 -0.579579 301.287 -0.381476C301.185 0.0197139 301.063 0.395451 300.994 0.762334C300.848 1.4779 300.721 2.10572 300.615 2.62689C300.509 3.12497 300.445 3.52707 300.363 3.79018C300.29 4.05674 300.25 4.20078 300.25 4.20078C300.25 4.20078 300.188 4.43483 300.074 4.86019C300.018 5.07269 299.922 5.32023 299.824 5.6162C299.724 5.91027 299.618 6.24672 299.46 6.60036C299.308 6.95554 299.158 7.35463 298.943 7.75307C298.84 7.95289 298.734 8.1614 298.625 8.37859C298.502 8.58437 298.376 8.79468 298.248 9.01141C297.713 9.8635 297.042 10.7483 296.207 11.5257C296.102 11.623 295.997 11.7202 295.892 11.8174C295.785 11.9127 295.666 11.9985 295.555 12.09C295.334 12.2791 295.092 12.4386 294.853 12.6083C294.734 12.6941 294.604 12.7621 294.482 12.8418C294.359 12.9197 294.233 12.9956 294.101 13.0617C293.97 13.1296 293.844 13.2056 293.709 13.2614L293.533 13.3417C293.509 13.3522 293.493 13.3619 293.472 13.3679C293.433 13.3734 293.389 13.4255 293.358 13.3799L293.237 13.2897C292.982 13.102 292.724 12.9124 292.469 12.7247C291.958 12.3494 291.452 11.9778 290.954 11.6139C288.967 10.1558 287.13 8.80428 285.762 7.80036L283.266 5.96879L282.16 5.15826L281.992 5.03643L281.909 4.97438L281.868 4.94015C281.868 4.94015 281.82 4.91912 281.851 4.91433C281.973 4.86601 282.09 4.80973 282.204 4.74737L282.226 4.73497L282.264 4.71279L282.428 4.61469L282.757 4.42037C282.977 4.29221 283.184 4.13788 283.397 3.99986C285.383 2.6065 286.754 0.888816 287.729 -0.813492C288.682 -2.53899 289.266 -4.26186 289.612 -5.96416L289.604 -5.95927Z" fill="#6A9A23"/>
<path d="M335.18 -24.8556C335.367 -27.0896 334.385 -27.2164 333.994 -25.0108C333.717 -23.4468 333.449 -21.8414 333.182 -20.0956C333.054 -19.2221 332.92 -18.3146 332.78 -17.3583C332.644 -16.3603 332.501 -15.3135 332.351 -14.2073C332.315 -13.902 332.279 -13.6073 332.272 -13.5479C332.586 -13.2373 332.882 -12.942 333.169 -12.6584C333.357 -12.4774 333.536 -12.2999 333.707 -12.1364C334.053 -11.8034 334.368 -11.5034 334.661 -11.2224C335.252 -10.6673 335.75 -10.1985 336.218 -9.76272C337.155 -8.88931 337.961 -8.13454 339.071 -6.99696C339.768 -6.28315 340.543 -5.4922 341.538 -4.47471C342.213 -4.57105 342.912 -4.67145 343.62 -4.77484C344.209 -4.85527 344.811 -4.93678 345.41 -5.02019C346.613 -5.17905 347.818 -5.34016 348.949 -5.49061C351.408 -5.80659 353.549 -6.08036 354.718 -6.22989C354.939 -6.58062 355.125 -6.88001 355.282 -7.13069C355.375 -7.27301 355.451 -7.3908 355.515 -7.49084C355.643 -7.68865 355.727 -7.81548 355.797 -7.92231C355.981 -8.20051 356.158 -8.48443 356.33 -8.77214C356.622 -9.26111 357.152 -10.1443 358.014 -11.5787C358.936 -13.098 360.217 -15.2044 361.956 -18.0724C361.796 -18.5474 361.552 -19.2816 361.244 -20.2012C360.997 -20.9457 360.704 -21.8414 360.38 -22.8288C359.735 -24.8082 358.978 -27.1597 358.266 -29.4229L357.826 -30.7822L346.487 -34.4322C346.071 -34.566 345.657 -34.698 345.367 -34.7904C344.773 -34.3822 344.196 -33.9902 343.636 -33.6038C343.197 -33.2972 342.767 -33.0018 342.351 -32.7098C341.523 -32.1239 340.738 -31.567 339.98 -31.0334C338.475 -29.9545 337.106 -28.942 335.757 -27.9207C334.187 -26.7334 334.67 -26.0221 336.355 -27.0389C337.803 -27.9114 339.251 -28.8111 340.81 -29.8065C341.585 -30.3101 342.392 -30.8333 343.246 -31.3858C343.996 -31.883 344.784 -32.4066 345.626 -32.9622C345.717 -32.9323 345.846 -32.889 345.978 -32.8479C346.88 -32.5568 348.252 -32.0525 350.06 -31.4015C350.964 -31.0812 351.977 -30.72 353.094 -30.3258C354.069 -29.9928 355.133 -29.6276 356.281 -29.234L356.327 -29.0953L356.539 -28.457C356.685 -28.0332 356.834 -27.6097 356.99 -27.1931C357.543 -25.6967 358.111 -24.0988 358.656 -22.52C359.156 -21.0526 359.648 -19.6076 360.1 -18.2892L360.045 -18.1921C359.979 -18.0815 359.913 -17.975 359.847 -17.8644C359.702 -17.6273 359.56 -17.3947 359.422 -17.1666C359.143 -16.7102 358.876 -16.2737 358.625 -15.8595C358.115 -15.0327 357.658 -14.2923 357.279 -13.6761C356.512 -12.4473 356.05 -11.7043 356.05 -11.7043L353.657 -7.82492L342.05 -6.02149L339.492 -8.60924L334.019 -14.1379L334.03 -14.2332C334.157 -15.2577 334.277 -16.227 334.393 -17.1498C334.503 -18.1077 334.607 -19.0211 334.706 -19.8962C334.896 -21.6521 335.05 -23.2727 335.182 -24.8537L335.18 -24.8556Z" fill="#6A9A23"/>
<path d="M334.463 4.5503C336.378 5.19843 337.423 5.25884 337.511 5.0037C337.601 4.73987 336.74 4.16619 334.878 3.42744C332.352 2.41678 329.793 1.3314 327.049 0.0858865C325.677 -0.538004 324.262 -1.20221 322.786 -1.92192C322.048 -2.2797 321.294 -2.65496 320.524 -3.04353C320.14 -3.23894 319.751 -3.43817 319.356 -3.63893C318.73 -3.96444 318.098 -4.29148 317.454 -4.62388C317.2 -4.26194 316.851 -3.76375 316.498 -3.26103C311.509 3.94451 310.444 5.82245 307.026 10.6635C306.168 11.8814 305.22 13.2246 304.201 14.6705C303.026 16.325 301.771 18.0935 300.448 19.9518C301.609 20.5877 302.784 21.2286 303.958 21.8717C304.893 22.3719 305.832 22.8675 306.756 23.3476C308.612 24.3051 310.431 25.2049 312.103 26.0042C315.451 27.6024 318.222 28.8037 319.543 29.3585C320.099 29.5978 320.659 29.8219 321.228 30.0371C323.093 30.7482 327.879 32.5742 334.242 34.4546C337.42 35.4002 340.99 36.3581 344.761 37.2377C346.647 37.6764 348.582 38.0983 350.545 38.4926C351.525 38.6909 352.513 38.8801 353.502 39.0629L354.99 39.3326L357.469 39.7598C357.512 39.0699 357.618 37.378 357.721 35.7072C358.398 24.2426 358.818 17.1477 359.038 13.4421C359.115 12.082 359.191 10.7661 359.248 9.7981C358.525 9.66145 357.813 9.53015 357.113 9.39776C356.669 9.31034 356.23 9.22673 355.799 9.14241C354.934 8.97185 354.095 8.79914 353.278 8.62651C351.643 8.27935 350.096 7.92461 348.607 7.56898C345.63 6.8513 342.892 6.12137 340.191 5.33367C338.504 4.84208 337.595 4.76975 337.515 5.00334C337.437 5.22408 338.192 5.75453 339.861 6.35052C342.533 7.30237 345.259 8.1655 348.242 8.98542C349.733 9.39329 351.289 9.78932 352.935 10.1691C353.757 10.3622 354.602 10.547 355.474 10.7316C356.136 10.8673 356.819 11.0053 357.52 11.1501C357.485 11.7344 357.434 12.5299 357.383 13.3484C357.181 16.7483 356.524 23.8217 355.888 33.8224C355.843 34.63 355.797 35.4334 355.753 36.2387L355.697 37.4437C355.695 37.5153 355.695 37.488 355.696 37.4963L355.7 37.5001L355.703 37.5145L355.713 37.5494C355.713 37.5494 355.699 37.5569 355.686 37.558C355.653 37.5567 355.753 37.5795 355.443 37.5309C355.007 37.4616 354.566 37.3928 354.124 37.3221C353.241 37.1783 352.344 37.0273 351.449 36.8615C349.654 36.5387 347.844 36.1753 346.062 35.7821C342.497 35.0063 339.05 34.1049 336.046 33.2323C333.043 32.3574 330.487 31.5173 328.681 30.8912C327.778 30.5729 327.064 30.3201 326.573 30.1465C326.083 29.9666 325.818 29.8678 325.818 29.8678C321.699 28.3743 317.646 26.705 313.653 24.9004C311.657 23.995 309.679 23.0544 307.719 22.0745C306.741 21.5843 305.762 21.0859 304.793 20.5802L303.34 19.8144L302.638 19.4367L309.085 10.2353C314.014 3.19229 316.386 -0.198457 317.845 -2.28256C317.896 -2.35617 317.946 -2.42977 317.981 -2.4811C318.602 -2.16773 319.205 -1.86541 319.791 -1.56997C320.573 -1.18248 321.337 -0.814374 322.09 -0.459944C323.592 0.247014 325.035 0.89203 326.437 1.48387C329.24 2.67399 331.869 3.6673 334.463 4.55447L334.463 4.5503Z" fill="#6A9A23"/>
<path d="M266.148 11.4377C265.904 11.241 261.607 11.6973 262.767 12.4218C263.152 12.7388 263.531 12.734 263.685 12.313C263.756 13.154 264.635 12.1 265.004 12.3981C264.83 12.9694 266.069 11.8383 265.807 12.4271C270.358 13.3709 279.961 8.3733 268.469 10.9842C269.573 11.3222 268.502 11.4793 268.006 11.3163C268.775 10.6232 266.63 11.1226 266.225 11.3524C266.878 11.3826 265.768 11.8565 266.15 11.4398L266.148 11.4377Z" fill="#101214"/>
<path d="M273.986 19.0467C273.385 19.0418 270.602 22.9468 270.26 23.3131C269.677 24.2322 271.049 24.4039 271.328 23.6053C271.45 23.4739 271.918 22.3416 272.164 22.8577C273.353 22.6833 273.656 20.6225 274.654 20.5627C274.514 20.2788 274.886 19.9778 274.819 19.7896C275.111 19.8418 275.301 19.4589 275.233 19.4186C276.559 18.4848 275.082 17.1701 274.308 18.5903C274.261 18.5239 273.902 18.7589 273.986 19.0428L273.986 19.0467Z" fill="#101214"/>
<path d="M288.709 27.7641C289.293 27.125 289.207 27.8367 288.919 28.1456C288.477 27.5052 288.381 28.9221 288.518 29.2965C288.558 29.1514 288.815 29.1459 288.75 29.4489C288.158 29.1232 287.385 32.9628 288.995 31.3767C289.003 31.3103 288.513 31.1909 288.68 31.1416C289.409 31.4079 288.987 30.7058 288.958 30.5243C289.347 30.5991 289.013 30.3704 289.181 30.3567C289.67 30.6613 288.959 29.5148 289.438 29.8463C290.383 29.1065 289.625 27.1642 290.464 26.62C289.666 25.994 291.452 23.4009 289.594 24.1887C289.01 25.3404 288.629 26.3014 288.709 27.7641Z" fill="#101214"/>
<path d="M278.52 33.4874C279.672 34.0122 279.857 31.3062 280.471 30.6733C281.323 29.9268 285.341 20.9746 282.563 22.9852C281.37 25.7048 279.916 27.7259 278.886 31.2063C278.677 31.7594 277.666 33.4114 278.52 33.4874Z" fill="#101214"/>
<path d="M272.605 3.22304C273.458 2.36044 274.245 3.76255 275.035 3.06901C276.28 1.6898 267.453 -0.415104 267.475 1.23084C267.685 2.64358 272.067 2.52653 272.605 3.22304Z" fill="#101214"/>
<path d="M353.904 0.605135C351.888 -0.0406305 348.015 0.187959 346.143 -0.686571C344.414 -0.564747 342.931 -1.0713 341.224 -1.48882C341.674 -1.91768 342.883 -2.42509 342.976 -2.90903C346.063 -5.01434 340.805 -2.8555 339.877 -1.40738L339.89 -1.40739C339.89 -1.40739 339.691 -1.15637 339.673 -1.19408C339.802 -0.692643 340.458 -0.0652969 340.454 0.283156C343.482 2.73881 344.616 3.1592 341.381 -0.567943C342.528 -0.296267 343.241 0.288849 344.364 0.147743C344.642 0.54692 350.562 1.43902 348.42 0.717936C348.941 0.404403 350.793 1.07698 349.514 1.05847C350.098 1.25533 359.729 2.18758 358.787 0.832591C358.387 0.926263 357.763 0.58519 357.477 0.747534C357.422 0.905176 357.407 1.02061 357.253 0.965295C357.28 0.632353 356.933 0.630529 356.556 0.701981C356.088 0.866753 355.08 0.903412 355.236 0.665757C355.306 0.46149 353.472 0.982932 353.904 0.607357L353.904 0.605135Z" fill="#101214"/>
</g>
<g clipPath="url(#clip2_783_5660)">
<path d="M13.0459 23.9464C13.2244 23.8029 13.375 23.6514 13.5135 23.5051C13.6519 23.3588 13.7767 23.2242 13.8912 23.0925C14.1165 22.8338 14.2962 22.6063 14.4242 22.4127C14.6826 22.0273 14.7534 21.7777 14.657 21.6812C14.5605 21.5846 14.2987 21.6388 13.898 21.8582C13.6977 21.9679 13.4612 22.1206 13.1927 22.3159C13.0586 22.4156 12.9146 22.5225 12.7657 22.6446C12.6168 22.7666 12.4583 22.8999 12.2783 23.0267C11.7797 23.3994 11.2791 23.7743 10.7705 24.1541C10.2398 24.4959 9.70493 24.8382 9.16244 25.1894C8.60947 25.5164 8.02636 25.8104 7.44957 26.1289C7.15404 26.2784 6.84575 26.4016 6.5389 26.5415C6.23133 26.6731 5.92782 26.8274 5.60858 26.9453C5.28898 27.059 4.96332 27.1754 4.63765 27.2917C4.47464 27.3478 4.31044 27.4145 4.1448 27.4645C3.97464 27.5108 3.80449 27.557 3.63433 27.6032C3.29175 27.6937 2.94835 27.799 2.59636 27.8778C2.24139 27.9463 1.88225 28.0152 1.51931 28.0887C0.0606176 28.3263 -1.49813 28.4258 -3.12925 28.2944C-3.56103 28.2752 -3.97141 28.2121 -4.35537 28.1636C-4.54794 28.1446 -4.73171 28.106 -4.90643 28.075C-4.9938 28.0595 -5.08116 28.0439 -5.16436 28.0281C-5.22411 28.0165 -5.28576 28.0071 -5.34551 27.9955C-5.43287 27.98 -5.5081 27.9593 -5.58713 27.943C-6.21656 27.7731 -6.77491 27.6242 -7.25162 27.4977C-7.70977 27.3675 -8.08591 27.2637 -8.36563 27.183C-8.05452 28.2597 -7.73595 29.277 -7.45896 30.2014C-7.28585 30.7487 -7.12621 31.2616 -6.97515 31.7478C-6.68674 32.6587 -6.42815 33.4671 -6.18005 34.2514C-5.68384 35.8198 -5.22994 37.287 -4.66961 39.2338C-4.04204 41.3763 -3.32537 43.895 -2.58721 46.5167C-2.22004 47.8299 -1.84428 49.1695 -1.4715 50.499C-1.25363 51.2732 -1.04029 52.0436 -0.825398 52.8077C-0.802628 52.877 -0.789367 52.9577 -0.758627 53.0222L-0.551516 53.0882L-0.137285 53.2201L0.276945 53.3521L0.53893 53.4217C0.71283 53.4675 0.884474 53.5113 1.05837 53.5571C1.23346 53.5923 1.40628 53.6256 1.57946 53.663C4.36235 54.2065 7.04848 53.896 9.14027 53.3601C9.66062 53.2143 10.1485 53.0566 10.6086 52.9181C11.0609 52.7614 11.4697 52.5875 11.8496 52.4433C12.2341 52.303 12.5622 52.1424 12.8562 51.9994C13.1502 51.8564 13.4062 51.7356 13.6198 51.6331C13.8785 51.5184 14.1157 51.374 14.3552 51.2316L15.0752 50.7978C15.254 50.6816 15.4828 50.561 15.7156 50.3898C15.9507 50.2204 16.2176 50.0315 16.5119 49.8192C16.8017 49.6032 17.1399 49.3892 17.4667 49.1154C17.7957 48.8435 18.1502 48.5505 18.5283 48.2387C18.716 48.0797 18.9169 47.928 19.1073 47.752C19.2955 47.5741 19.4897 47.3936 19.6897 47.2064C20.0835 46.8344 20.499 46.4459 20.9358 46.0366C21.3513 45.6481 21.7823 45.2457 22.2305 44.8228C22.6881 44.4118 23.1922 44.0282 23.6952 43.609C23.943 43.3924 24.219 43.2111 24.4958 43.015C24.7708 42.8212 25.0517 42.6248 25.3346 42.4262C25.4725 42.3219 25.6221 42.2313 25.772 42.1449C25.9215 42.0543 26.0733 41.9656 26.2248 41.8727C26.5303 41.693 26.8325 41.499 27.1493 41.3288C28.4302 40.6597 29.8119 40.0405 31.3018 39.605C32.7947 39.1798 34.3762 38.9063 36.0024 38.8598C36.8156 38.8249 37.6359 38.8734 38.4607 38.9488L39.0913 39.0347L39.4056 39.0788L40.0042 39.2074C40.8225 39.3777 41.6365 39.5716 42.4509 39.7695C42.1544 38.7398 41.401 36.1362 40.667 33.5875C37.7264 23.5317 35.9053 17.3068 34.9535 14.0573C34.9552 13.7613 34.6651 13.8032 34.4682 13.7342C34.2584 13.6853 34.0485 13.6363 33.8387 13.5874L33.6803 13.5507C33.6311 13.5403 33.6141 13.5376 33.5778 13.5303L33.3902 13.4962L33.0173 13.4299C32.7696 13.38 32.5206 13.3638 32.2744 13.3306L31.9055 13.287L31.5408 13.2662C30.5668 13.1891 29.6218 13.2521 28.7074 13.3293C26.8858 13.5438 25.2051 14.0042 23.6927 14.641C23.3041 14.7817 22.9496 14.9782 22.5817 15.1402C22.4004 15.2272 22.2187 15.3101 22.0393 15.3949C21.8648 15.4877 21.6929 15.5865 21.5206 15.6812C21.1787 15.8766 20.8406 16.0675 20.5024 16.2583C20.1809 16.4708 19.8612 16.6811 19.5415 16.8914C19.3828 16.9974 19.226 17.1013 19.0692 17.2051C18.9128 17.3131 18.7677 17.4305 18.618 17.5442C18.321 17.7735 18.0236 17.9986 17.7304 18.2234C17.4281 18.4405 17.165 18.6983 16.8834 18.9367C16.6064 19.179 16.3335 19.4208 16.0565 19.6631C14.9003 20.7809 14.4954 21.5106 14.6627 21.6744C14.8371 21.8481 15.5686 21.4742 16.7575 20.4689C17.0367 20.2516 17.3182 20.0363 17.6015 19.8187C17.8853 19.6053 18.1547 19.3721 18.455 19.1803C18.7503 18.9805 19.0435 18.7789 19.3427 18.5746C19.4915 18.4757 19.6354 18.3688 19.7888 18.2736C19.9425 18.1827 20.0981 18.0895 20.256 17.9982C20.5672 17.8117 20.8807 17.6272 21.1938 17.4384C21.5194 17.2717 21.8468 17.1028 22.1765 16.9357C22.3434 16.852 22.5062 16.7687 22.675 16.6827C22.8449 16.6092 23.0189 16.5354 23.193 16.4615C23.5419 16.3222 23.8814 16.148 24.2446 16.0284C25.6722 15.4787 27.2231 15.0945 28.8787 14.9259C29.7068 14.8688 30.5609 14.822 31.436 14.8972L31.7652 14.919L32.0939 14.9598C32.3148 14.991 32.5385 15.0052 32.7585 15.0512C32.959 15.0883 33.1636 15.1252 33.3663 15.1642L33.4906 15.1954C33.5296 15.2088 33.5901 15.2057 33.5831 15.2462C33.7626 15.8915 33.9886 16.7112 34.2604 17.6969C34.563 18.8205 34.9173 20.1306 35.3166 21.6214C36.1212 24.6004 37.1258 28.2922 38.3635 32.5933C38.7677 33.9956 39.1924 35.3918 39.6324 36.77L39.7103 37.0171L39.7503 37.1396C39.7503 37.1396 39.7548 37.1434 39.757 37.1453C39.7661 37.1529 39.7713 37.165 39.7789 37.179C39.7935 37.203 39.816 37.2451 39.8321 37.2856C39.8094 37.2897 39.7776 37.2862 39.7337 37.2879L39.7 37.2866L39.6811 37.2861L39.5858 37.2755L39.0005 37.2045C38.6159 37.1477 38.1999 37.1418 37.8004 37.1071C37.3951 37.0793 36.9912 37.0913 36.5855 37.0824C34.9651 37.099 33.3478 37.3232 31.8071 37.7043C28.7091 38.445 25.9889 39.9166 23.8329 41.4107C23.5617 41.6 23.2986 41.7843 23.0374 41.9664C22.7852 42.1562 22.5484 42.355 22.3129 42.5433C22.0774 42.7316 21.8479 42.9172 21.6222 43.0984C21.5105 43.1899 21.3985 43.2772 21.2906 43.3642C21.1876 43.4592 21.0865 43.5519 20.9873 43.6423C20.2001 44.3673 19.5102 45.0041 18.937 45.5343C18.6591 45.7913 18.4082 46.0207 18.1904 46.2201C18.0817 46.3218 17.9806 46.4145 17.8871 46.4981C17.7891 46.578 17.6987 46.6488 17.6204 46.7143C17.3005 46.9707 17.13 47.1093 17.13 47.1093C17.13 47.1093 16.8416 47.342 16.3261 47.7623C16.0647 47.9675 15.7272 48.1898 15.3418 48.4645C15.15 48.6007 14.9442 48.7445 14.7266 48.8976C14.509 49.0508 14.2624 49.1833 14.0092 49.3375C13.758 49.4894 13.4926 49.6487 13.2175 49.8153C12.9446 49.9837 12.637 50.1153 12.3319 50.276C12.0216 50.4246 11.7142 50.6065 11.3733 50.741C11.037 50.8792 10.6885 51.0228 10.3339 51.1689C8.89465 51.7049 7.25528 52.1345 5.51244 52.2646C4.64192 52.34 3.74838 52.3189 2.85551 52.2326L2.18746 52.1499L1.52224 52.0271C1.30062 51.9876 1.08518 51.9223 0.864745 51.8722L0.70406 51.8337L0.64585 51.8157L0.529429 51.7796C0.476824 51.7779 0.495606 51.728 0.478692 51.7022L0.439583 51.565L0.23949 50.8752C0.105343 50.4147 -0.0284482 49.9584 -0.162235 49.5021C-0.429811 48.5895 -0.692493 47.6848 -0.951844 46.7946C-1.99079 43.24 -2.95224 39.9515 -3.66507 37.5017L-5.03013 32.8424L-5.71171 30.5116L-5.92228 29.7975L-5.96736 29.6399L-5.99086 29.5622L-6.00278 29.5213C-6.00278 29.5213 -6.02077 29.4829 -6.00077 29.4959C-5.91685 29.5201 -5.83258 29.5485 -5.74485 29.5681L-5.6163 29.599L-5.29637 29.6594C-5.12807 29.6888 -4.95906 29.7266 -4.78886 29.7539L-4.27933 29.823L-3.7698 29.8921L-3.25864 29.9317C-1.47352 30.0729 0.223859 29.9509 1.8069 29.671C2.20054 29.5886 2.59002 29.5066 2.97117 29.4253C3.3535 29.3334 3.71855 29.2115 4.08731 29.1082C4.27151 29.0545 4.45344 28.9988 4.63347 28.9455C4.81315 28.8879 4.98721 28.8141 5.162 28.7486C5.51122 28.6134 5.85438 28.4808 6.19753 28.3483C6.53616 28.2119 6.85488 28.0395 7.17958 27.8876C7.49939 27.7277 7.82481 27.584 8.13331 27.4146C8.73565 27.0519 9.34051 26.7183 9.90882 26.3501C10.4625 25.958 11.0127 25.5746 11.5478 25.1862C12.0546 24.7625 12.5558 24.3455 13.0547 23.9267L13.0459 23.9464Z" fill="#6A9A23"/>
<path d="M114.495 48.3233C112.222 47.5594 111.865 48.4842 114.065 49.4412C115.623 50.1181 117.228 50.7952 118.977 51.5123C119.855 51.8642 120.766 52.2322 121.724 52.617C122.269 52.8321 122.83 53.0521 123.405 53.2771C123.642 53.3719 123.882 53.4581 124.118 53.5446L124.298 53.6109L124.387 53.6431L124.432 53.658C124.448 53.6672 124.451 53.6354 124.461 53.6282L124.677 53.3074C124.82 53.0915 124.962 52.8714 125.107 52.6532C125.214 52.4803 125.323 52.3051 125.431 52.1299C126.78 49.8413 127.434 48.3201 127.986 46.9923C128.522 45.6576 128.956 44.5121 129.531 42.8088C130.002 41.3663 130.481 39.6442 130.752 37.7826C131.029 35.9289 131.072 33.9297 130.72 32.0614C130.685 31.8273 130.618 31.6003 130.566 31.3718L130.485 31.0327C130.452 30.9243 130.42 30.8201 130.388 30.7117C130.257 30.2887 130.129 29.8759 130.004 29.4734C129.871 29.0758 129.708 28.6954 129.569 28.3277C129.497 28.143 129.427 27.9644 129.357 27.79C129.273 27.619 129.194 27.4517 129.115 27.2886C128.956 26.9624 128.812 26.6518 128.666 26.3665C128.501 26.0891 128.349 25.8296 128.209 25.592C127.945 25.1071 127.656 24.7566 127.474 24.4912L127.134 24.0276L126.744 23.5997C126.627 23.4736 126.483 23.3223 126.319 23.1456C126.159 22.9644 125.94 22.7924 125.717 22.5851C125.273 22.162 124.688 21.7197 124.013 21.241C122.649 20.2913 120.829 19.3789 118.787 18.5467C117.766 18.1211 116.69 17.7191 115.586 17.3008C115.27 17.1814 114.951 17.06 114.628 16.9391C114.367 16.8399 114.105 16.7389 113.84 16.6401L113.446 16.4897L113.246 16.4147L113.146 16.3772L113.096 16.3584C113.096 16.3584 113.082 16.389 113.075 16.4064C112.755 17.2378 112.429 18.0802 112.103 18.9267C111.218 21.2191 110.304 23.5645 109.412 25.8156C108.794 27.4093 108.234 28.851 107.732 30.1514C107.421 30.9526 107.128 31.7103 106.85 32.4268C106.745 32.6982 106.644 32.965 106.543 33.2276L106.506 33.3274C106.489 33.3478 106.52 33.3471 106.533 33.3544L106.583 33.3731L106.78 33.4463C106.91 33.4938 107.038 33.5435 107.168 33.591C107.634 33.7625 108.085 33.9291 108.525 34.0903C109.559 34.458 110.424 34.7754 111.129 35.0899C111.836 35.4021 112.382 35.7072 112.788 35.9826C113.763 36.6283 114.417 37.4256 114.721 38.3225C115.031 39.2209 115.01 40.211 114.85 41.1627C114.514 43.0782 113.723 44.8274 112.888 46.5008C112.427 47.3926 112.339 47.952 112.53 48.0971L112.524 48.1921C112.543 48.1967 112.555 48.1914 112.562 48.174L112.566 48.1192C112.77 48.2253 113.25 47.9025 113.813 47.0312C114.839 45.3874 115.819 43.6386 116.32 41.4445C116.554 40.3541 116.654 39.1054 116.251 37.8205C116.047 37.1856 115.719 36.5657 115.278 36.0207C114.838 35.4734 114.298 35.004 113.712 34.6079C113.257 34.2948 112.658 33.946 111.931 33.5894C111.201 33.2309 110.34 32.8775 109.378 32.5014C109.259 32.4551 109.137 32.4069 109.015 32.3587L108.972 32.3415L108.965 32.3358L108.952 32.3285L108.932 32.3114L108.894 32.2874C108.885 32.2798 108.864 32.2774 108.883 32.2548C108.905 32.2235 108.922 32.1989 108.937 32.1767C109.05 31.9046 109.164 31.6303 109.285 31.345C109.769 30.1721 110.29 28.891 110.842 27.5045C111.2 26.6006 111.535 25.6882 111.85 24.7754C112.189 23.7893 112.548 22.774 112.917 21.7433C113.278 20.7489 113.644 19.7394 114.005 18.745L114.061 18.5681C114.061 18.5681 114.066 18.5489 114.07 18.5485L114.092 18.555L114.135 18.5681L114.223 18.5961L114.268 18.611L114.292 18.6194L114.381 18.6516L114.756 18.7891C115.003 18.881 115.248 18.9709 115.491 19.0632C115.976 19.2435 116.451 19.4227 116.91 19.6032C117.372 19.7793 117.813 19.9613 118.238 20.1365C119.943 20.8405 121.328 21.5682 122.259 22.1505C122.71 22.4597 123.088 22.685 123.314 22.8752C123.546 23.0587 123.675 23.1587 123.675 23.1587C123.675 23.1587 123.72 23.1968 123.812 23.2665C123.898 23.3387 124.044 23.4309 124.196 23.5815C124.355 23.7271 124.549 23.9055 124.772 24.1127C124.829 24.1644 124.886 24.2161 124.948 24.2717C125.001 24.3321 125.059 24.3921 125.117 24.4563C125.233 24.5848 125.355 24.7189 125.483 24.861C126.504 25.9978 127.669 27.8 128.462 30.0309C128.555 30.3103 128.651 30.5957 128.747 30.8812C128.839 31.167 128.95 31.4574 129.012 31.7415C129.087 32.0288 129.164 32.3138 129.211 32.6119L129.291 33.0539C129.312 33.2032 129.325 33.3531 129.347 33.5023C129.488 34.7029 129.464 35.9345 129.335 37.1165C129.074 39.485 128.427 41.6372 127.869 43.2046C127.024 45.5691 126.192 47.2486 125.546 48.5173C124.889 49.7808 124.393 50.6273 124.007 51.2609C123.939 51.3738 123.871 51.4825 123.805 51.589L123.775 51.6377C123.775 51.6377 123.741 51.6281 123.724 51.6254L123.618 51.5863C123.167 51.4156 122.729 51.2521 122.3 51.0921C121.329 50.7356 120.408 50.3979 119.52 50.072C117.742 49.4309 116.096 48.8581 114.486 48.3157L114.495 48.3233Z" fill="#6A9A23"/>
<path d="M63.2213 11.0802C64.3036 11.4417 64.931 11.4901 65.0627 11.2416C65.1871 11.0063 64.7809 10.4561 63.6473 9.96267C62.8457 9.6209 62.0109 9.33237 61.1289 9.10458C60.2473 8.88095 59.3135 8.7101 58.3289 8.65487C57.8413 8.59642 57.3321 8.62798 56.8151 8.61824C56.558 8.63003 56.296 8.65694 56.0313 8.67778C55.898 8.68934 55.7647 8.70089 55.6314 8.71245C55.497 8.7346 55.3648 8.75864 55.2303 8.78079C54.1508 8.93941 53.0339 9.27124 51.9327 9.78634C51.7776 9.86063 51.624 9.9285 51.4775 10.0062C51.3356 10.0878 51.1978 10.169 51.0597 10.246C50.7857 10.4019 50.528 10.5523 50.2994 10.7231C50.0662 10.8902 49.8377 11.038 49.6378 11.2022C49.4383 11.3706 49.2487 11.5318 49.0667 11.684C48.7053 11.9944 48.4124 12.3198 48.1181 12.6055C47.8555 12.9178 47.5991 13.2044 47.3722 13.4927C46.4759 14.6552 45.8317 15.7244 45.0325 17.3317C44.3767 18.7042 43.7657 20.377 43.3437 22.174C42.9124 23.9592 42.6876 25.9258 42.8109 27.7679C42.9178 29.6155 43.3565 31.3442 43.9484 32.684C44.5304 34.031 45.2423 34.9618 45.621 35.485C45.8706 35.776 46.1183 36.0692 46.3915 36.3414C46.8871 36.8083 47.8267 37.6795 49.2654 38.4989C49.6286 38.6962 50.0023 38.9177 50.4196 39.1102C50.8332 39.3072 51.2794 39.4931 51.7434 39.6669C52.6774 40.0119 53.698 40.3137 54.8094 40.5258C57.0183 40.9575 59.6288 40.962 62.1114 40.1404C63.3524 39.7391 64.5396 39.1263 65.6002 38.3608C66.6654 37.5991 67.6064 36.6867 68.4118 35.7104C69.54 34.318 70.3115 32.8999 70.9125 31.5972C71.4954 30.2794 71.8779 29.0712 72.1641 27.9868C72.4458 26.8986 72.6224 25.9307 72.7077 25.0945C72.8141 24.2606 72.8305 23.5521 72.8419 22.9783C72.8528 20.2602 72.1712 17.8559 71.051 15.9366C70.4777 14.9834 69.8234 14.1357 69.0796 13.4176C68.3284 12.7126 67.5418 12.0821 66.6795 11.5966C66.2508 11.3211 65.8679 11.2117 65.5987 11.1553C65.3256 11.1034 65.1518 11.1311 65.0821 11.2231L65.145 11.3687C65.1232 11.335 65.0952 11.3269 65.0588 11.3426L65.0431 11.3062C65.0108 11.4181 65.0816 11.582 65.2604 11.7826C65.4355 11.9877 65.7286 12.1994 66.0982 12.4947C66.8482 13.0172 67.5077 13.6566 68.1348 14.3346C68.7505 15.0261 69.282 15.813 69.7486 16.6727C70.2113 17.5369 70.5551 18.5059 70.8114 19.5559C71.0594 20.6065 71.2063 21.7499 71.1886 22.9789C71.1966 23.2174 71.1654 23.4887 71.1497 23.7922C71.1381 24.0954 71.0911 24.4268 71.0364 24.7903C70.948 25.5156 70.767 26.3601 70.5057 27.2954C69.9645 29.1699 69.1073 31.4663 67.5012 33.7163L67.3088 33.9911L67.1005 34.2525L66.6908 34.7811C66.3873 35.1054 66.1203 35.4642 65.8002 35.7668C65.6299 35.9327 65.4716 36.1164 65.2858 36.273C65.1023 36.4316 64.9187 36.5902 64.7333 36.7511C64.3409 37.0432 63.9478 37.35 63.5114 37.5935C62.6552 38.102 61.7221 38.5228 60.7441 38.7629C58.7947 39.2718 56.7658 39.2231 55.0396 38.865C53.3077 38.5136 51.8735 37.9413 50.9288 37.4483C50.4595 37.1889 50.0869 36.9799 49.8427 36.8249C49.602 36.6611 49.4726 36.5716 49.4726 36.5716C49.4726 36.5716 49.4235 36.5381 49.3322 36.4768C49.2405 36.4113 49.0971 36.3293 48.9364 36.1942C48.772 36.0637 48.5714 35.9027 48.3372 35.7174C48.1201 35.5117 47.8736 35.2813 47.5996 35.0239C47.0988 34.4714 46.5061 33.8031 46.0168 32.9475C45.52 32.1009 45.0877 31.1039 44.7938 30.0068C44.1804 27.8107 44.2512 25.251 44.7058 22.956C45.1626 20.6398 45.9616 18.5919 46.736 17.184C47.8904 15.0487 49.1258 13.7309 50.1581 12.8798C51.1942 12.0241 52.0123 11.5839 52.6484 11.2959C53.6061 10.8457 54.5704 10.5439 55.5178 10.3862C55.6356 10.3655 55.753 10.3406 55.8686 10.318C55.9871 10.3057 56.1034 10.2914 56.2219 10.279C56.4548 10.2546 56.6851 10.2242 56.9142 10.2043C57.3752 10.1979 57.8243 10.1506 58.2681 10.1877C60.0484 10.2243 61.691 10.5855 63.2383 11.0829L63.2213 11.0802Z" fill="#6A9A23"/>
<path d="M149.643 57.1462C149.707 57.1386 149.772 57.135 149.834 57.1296C149.897 57.1284 149.958 57.1335 150.017 57.1368C150.136 57.1434 150.255 57.1393 150.367 57.1485C150.584 57.1884 150.799 57.195 150.983 57.2609C151.077 57.2863 151.167 57.3078 151.257 57.3294C151.342 57.3619 151.422 57.3948 151.5 57.4216C151.58 57.4504 151.654 57.4776 151.725 57.5028C151.793 57.5368 151.859 57.5689 151.92 57.5972C152.179 57.7027 152.367 57.8102 152.516 57.8582C152.665 57.9103 152.768 57.9119 152.818 57.8655C152.869 57.8192 152.863 57.7211 152.795 57.5675C152.727 57.4139 152.604 57.2022 152.364 56.9733C152.304 56.9155 152.242 56.8517 152.176 56.7882C152.104 56.7315 152.021 56.6736 151.936 56.6138C151.851 56.554 151.758 56.4908 151.66 56.4279C151.555 56.3783 151.444 56.3271 151.328 56.2721C151.099 56.1534 150.826 56.0974 150.536 56.0197C150.391 55.9903 150.237 55.9806 150.078 55.9629C149.999 55.955 149.919 55.9452 149.837 55.9418C149.757 55.9445 149.674 55.9476 149.59 55.9506C148.636 55.9788 147.736 56.254 146.905 56.6177C146.068 56.9798 145.315 57.471 144.572 57.9823C144.209 58.2488 143.842 58.5115 143.498 58.8057C143.142 59.0862 142.801 59.3864 142.46 59.695L142.203 59.9229C142.117 59.9975 142.015 60.1008 141.928 60.1902C141.84 60.2818 141.755 60.373 141.675 60.4639L141.463 60.7068L141.37 60.8029C141.341 60.8285 141.308 60.8776 141.28 60.8192L141.196 60.7216L141.177 60.698L141.059 60.5718L140.819 60.3157C140.497 59.9722 140.173 59.6226 139.843 59.2714C139.187 58.5688 138.512 57.8509 137.823 57.1133C136.438 55.6471 134.985 54.105 133.447 52.4758C133.366 52.3925 133.286 52.3093 133.205 52.2261L133.16 52.188C133.113 52.1606 133.152 52.1278 133.173 52.0987L133.224 52.0376C133.316 51.9373 133.407 51.8393 133.497 51.7413C133.679 51.5471 133.86 51.3593 134.04 51.1738C134.763 50.4418 135.456 49.7649 136.09 49.1581C137.34 47.9418 138.448 46.9918 139.511 46.1548C140.576 45.3197 141.597 44.587 142.741 43.9067C143.884 43.2263 145.144 42.5737 146.712 41.9993C147.041 41.8701 147.387 41.775 147.733 41.6568C148.083 41.5489 148.444 41.4588 148.809 41.36C149.549 41.1973 150.314 41.0408 151.105 40.9722C152.687 40.8036 154.367 40.8909 156.008 41.2858C157.649 41.6806 159.244 42.388 160.67 43.3471C162.105 44.2991 163.355 45.4853 164.442 46.7697C165.532 48.0453 166.437 49.3937 167.101 50.744C167.769 52.094 168.2 53.4415 168.453 54.689C168.707 55.9385 168.791 57.0831 168.821 58.0542C168.854 59.0248 168.81 59.826 168.784 60.399L168.72 61.4389C168.704 61.7886 168.699 62.1626 168.693 62.5093C168.686 63.1141 168.656 63.9581 168.694 65.1446C168.711 65.7348 168.755 66.4171 168.886 67.1989C169.02 67.9762 169.253 68.8834 169.791 69.7915C170.053 70.2472 170.391 70.6816 170.799 71.0868C171.204 71.5007 171.727 71.8667 172.326 72.1546C172.941 72.4245 173.637 72.5655 174.345 72.5693C175.051 72.5605 175.743 72.4082 176.418 72.1881C177.747 71.7099 178.979 70.9338 180.172 69.9974C180.767 69.5283 181.354 69.0136 181.936 68.4638C182.23 68.1929 182.508 67.9211 182.801 67.6419C182.857 67.5887 182.911 67.5337 182.968 67.4805L183.01 67.4391C183.026 67.4524 183.042 67.4657 183.06 67.481L183.076 67.4943L183.085 67.5019L183.154 67.5756C183.256 67.6801 183.36 67.7907 183.472 67.9047C183.91 68.3619 184.42 68.8906 184.982 69.4797C186.108 70.6578 187.46 72.0766 188.952 73.6405C189.633 74.3557 190.346 75.1059 191.082 75.8793C191.101 75.907 191.162 75.9353 191.113 75.9669L191.075 76.0121L190.913 76.1856C190.524 76.6075 190.105 77.0278 189.673 77.445C189.235 77.8649 188.793 78.2851 188.349 78.7117C187.9 79.1179 187.462 79.5461 186.997 79.9389C186.087 80.7501 185.126 81.5027 184.164 82.2239C181.541 84.1593 178.922 85.5424 176.438 86.3284C173.956 87.1228 171.629 87.2992 169.639 87.0479C168.643 86.9245 167.728 86.7079 166.902 86.427C166.08 86.1373 165.338 85.8072 164.678 85.449C163.359 84.7303 162.368 83.9392 161.596 83.2591C160.691 82.4521 159.878 81.572 159.161 80.6753C158.43 79.7861 157.823 78.8547 157.303 77.9115C156.265 76.0228 155.669 74.0497 155.387 72.0934C155.235 71.1162 155.172 70.1397 155.141 69.1751C155.104 68.2089 155.139 67.2533 155.147 66.279C155.152 65.3092 155.16 64.358 155.127 63.3873C155.092 62.4231 155.005 61.4381 154.757 60.4609C154.485 59.4059 153.996 58.6741 153.603 58.2822C153.412 58.0785 153.232 57.9619 153.1 57.8936C152.968 57.8253 152.879 57.812 152.832 57.8497L152.701 57.8442C152.697 57.8635 152.703 57.8692 152.722 57.8655L152.829 57.8436L152.808 57.8685C152.77 57.9138 152.772 58.008 152.817 58.1426C152.86 58.2752 152.946 58.4482 153.042 58.6791C153.244 59.1316 153.527 59.7785 153.718 60.7041C153.889 61.5705 153.936 62.4792 153.926 63.4054C153.92 64.3312 153.872 65.2838 153.833 66.2398C153.722 68.1482 153.636 70.1889 153.902 72.2935C154.151 74.3995 154.77 76.593 155.881 78.6747C156.437 79.7134 157.093 80.7371 157.873 81.7018C158.641 82.6759 159.501 83.6149 160.49 84.5006C161.26 85.1829 162.28 86.0177 163.649 86.8244C165.02 87.6183 166.762 88.3758 168.863 88.7476C170.959 89.1156 173.393 89.0683 175.922 88.44C178.453 87.8219 181.043 86.6301 183.565 85.0036C185.208 83.94 186.742 82.7265 188.162 81.4284C188.478 81.1492 188.784 80.8541 189.092 80.5567C189.402 80.2613 189.714 79.9636 190.011 79.665C190.619 79.0668 191.235 78.4573 191.845 77.8107L192.299 77.316C192.345 77.2617 192.523 77.0679 192.639 76.9257L193.021 76.4708L193.391 76.0086L193.486 75.8955C193.48 75.8561 193.425 75.821 193.399 75.7834L193.195 75.566C192.933 75.2761 192.65 74.988 192.374 74.7014C191.761 74.0705 191.146 73.4377 190.534 72.8068C189.331 71.5598 188.135 70.3226 186.969 69.1144C185.625 67.7139 184.318 66.348 183.066 65.0444C182.442 65.6398 181.829 66.2259 181.227 66.8048C181.016 67.0098 180.808 67.2062 180.602 67.3919C180.393 67.5799 180.196 67.7733 179.987 67.9488C179.164 68.6706 178.326 69.2951 177.498 69.7927C176.67 70.2863 175.836 70.6439 175.066 70.7841C174.293 70.9266 173.6 70.8461 173.042 70.5966C172.477 70.3497 172.045 69.936 171.712 69.5326C171.383 69.1289 171.169 68.7362 171.022 68.3965C170.949 68.2266 170.901 68.067 170.85 67.9351C170.811 67.7937 170.778 67.677 170.753 67.5826C170.724 67.4886 170.713 67.4098 170.7 67.3606C170.689 67.309 170.683 67.2844 170.683 67.2844C170.683 67.2844 170.655 67.1757 170.62 66.9647C170.602 66.8571 170.582 66.7245 170.558 66.5692C170.542 66.409 170.522 66.2261 170.5 66.0182C170.428 65.181 170.429 63.9304 170.475 62.3506C170.48 61.578 170.559 60.7172 170.575 59.7653C170.586 58.816 170.584 57.7985 170.473 56.7275C170.366 55.6562 170.183 54.5328 169.879 53.3967C169.563 52.2616 169.12 51.1208 168.563 50.0109C168.013 48.8919 167.297 47.8419 166.532 46.8276C166.332 46.5785 166.135 46.3312 165.933 46.0802C165.729 45.8356 165.508 45.603 165.296 45.3632C165.082 45.1258 164.871 44.886 164.637 44.6587C164.41 44.4287 164.184 44.1965 163.941 43.9846C162.045 42.2207 159.744 40.834 157.312 40.1068C154.881 39.3649 152.383 39.3003 150.19 39.631C147.983 39.9545 146.071 40.6532 144.51 41.353C142.165 42.4333 140.292 43.6636 138.737 44.8286C137.183 45.9978 135.935 47.0964 134.891 48.0807C133.859 49.0556 132.992 49.8798 132.263 50.6501C132.173 50.7481 132.085 50.8439 131.996 50.9355C131.87 51.0807 131.724 51.2361 131.601 51.3915C131.474 51.5473 131.351 51.6986 131.228 51.8498C131.165 51.9245 131.108 52.0008 131.048 52.0732C131.006 52.1461 130.87 52.225 130.986 52.2883C131.232 52.5607 131.465 52.8217 131.709 53.0734C131.889 53.2634 132.062 53.4477 132.23 53.624C133.778 55.2461 135.238 56.775 136.632 58.2363C137.33 58.9626 138.015 59.6733 138.681 60.3688C139.015 60.7154 139.345 61.0583 139.674 61.3969C139.865 61.5964 140.056 61.7918 140.245 61.9894L140.649 62.4098C140.784 62.5428 140.916 62.6615 141.049 62.7885L141.247 62.9748L141.299 63.0185L141.32 63.044C141.325 63.0478 141.329 63.0516 141.332 63.0535L141.343 63.0399L141.444 62.943L141.83 62.5529C142.085 62.3 142.335 62.0077 142.564 61.7213C142.888 61.3177 143.089 61.0967 143.437 60.779C143.751 60.4791 144.068 60.1851 144.395 59.9113C144.712 59.6257 145.047 59.3701 145.374 59.1088C146.043 58.6165 146.72 58.1424 147.435 57.8013C148.146 57.4564 148.886 57.2055 149.62 57.1503L149.643 57.1462Z" fill="#6A9A23"/>
<path d="M80.321 25.3809C80.4416 23.1064 79.4571 23.0281 79.1312 25.2574C78.8942 26.839 78.6434 28.4554 78.3341 30.1965C78.018 31.9318 77.6635 33.8048 77.0533 35.8028C76.9621 36.1317 76.8558 36.4326 76.7629 36.7176C76.7418 36.7887 76.7161 36.8559 76.6904 36.9232C76.6579 37.0079 76.6295 37.0922 76.5966 37.1726C76.5069 37.4217 76.4055 37.6571 76.3015 37.8865C75.8871 38.7743 75.5595 39.4762 75.3454 39.9375C76.5743 39.8079 77.6597 39.6697 78.5962 39.5571C79.1374 39.4829 79.6268 39.4153 80.1059 39.3507C81.0599 39.2218 81.9734 39.109 83.1533 38.9963C85.9529 38.7116 89.7215 38.3996 93.0728 38.1385C93.9107 38.0743 94.7237 38.0122 95.4885 37.9522C95.6782 37.9379 95.8679 37.9235 96.0534 37.9095C96.3908 37.8803 96.7199 37.8518 97.0447 37.8236C97.2132 37.8069 97.3821 37.7943 97.5465 37.778L97.6089 37.7726C97.6204 37.759 97.6182 37.734 97.6228 37.7147L97.6419 37.5956L97.6801 37.3573C97.73 37.0361 97.7788 36.7255 97.826 36.4214C97.9332 35.7428 98.0279 35.1387 98.1097 34.628C98.1809 34.1392 98.241 33.7417 98.2835 33.4568C98.332 33.119 98.3699 32.78 98.4014 32.4394C98.4496 31.9044 98.5308 30.972 98.6212 29.7346C98.6626 29.1205 98.7101 28.4302 98.7605 27.6768C98.8248 26.9389 98.9042 26.1326 98.9956 25.2707C99.1893 23.5523 99.4495 21.6308 99.8761 19.6446C100.088 18.6526 100.35 17.6438 100.688 16.6576C100.777 16.415 100.869 16.172 100.959 15.9271L101.111 15.5677L101.185 15.3871C101.19 15.3678 101.226 15.3017 101.255 15.2447L101.343 15.0755L101.695 14.3903C101.746 14.2788 101.822 14.1569 101.901 14.0346L102.126 13.671C102.421 13.1964 102.713 12.72 103.01 12.2431C102.93 12.2417 102.807 12.2544 102.664 12.2689C102.522 12.2812 102.364 12.2991 102.189 12.3143C101.84 12.3487 101.434 12.3902 100.989 12.433C100.271 12.5015 99.4285 12.5851 98.594 12.6637C92.1629 13.3177 88.1819 13.7215 86.104 13.9331C84.8775 14.0646 83.7301 14.1892 82.6387 14.3069C81.9634 14.3843 81.3068 14.4581 80.6649 14.5326L80.3138 14.5735L80.1393 14.5928L80.054 14.6023C80.054 14.6023 80.0158 14.5972 80.0195 14.6158L80.0129 14.6604C79.9849 14.8958 79.9566 15.1269 79.9306 15.36C79.9042 15.5889 79.8778 15.8178 79.8514 16.0467C79.8379 16.1821 79.824 16.3134 79.8105 16.4489C79.6178 18.4463 79.5162 20.2848 79.4719 22.1057C79.4328 24.1087 80.2926 24.1517 80.5363 22.1855C80.7678 20.3945 81.0108 18.59 81.2991 16.6304C81.3163 16.5135 81.3335 16.3966 81.3507 16.2797L81.3736 16.156L81.3968 16.0365C81.4245 16.0173 81.4801 16.0293 81.5173 16.0219L81.6426 16.0152C81.7592 16.0051 81.8758 15.995 81.9924 15.9849C82.259 15.9618 82.5275 15.9364 82.8005 15.9148C83.891 15.8119 85.0441 15.7036 86.2698 15.5868C88.1772 15.3942 92.1765 15.2259 97.792 14.7013C98.2499 14.6575 98.7073 14.6094 99.1621 14.5553L99.459 14.5191C99.459 14.5191 99.4628 14.5146 99.4666 14.51C99.4723 14.5032 99.4841 14.4938 99.5061 14.4814C99.5282 14.469 99.5786 14.4458 99.6074 14.4391C99.6134 14.4595 99.619 14.4758 99.5928 14.562L99.5732 14.6267L99.4323 14.9872C99.3335 15.2287 99.2457 15.4755 99.1662 15.7216C98.8317 16.7074 98.5712 17.7014 98.3498 18.6858C97.9192 20.6493 97.6406 22.5514 97.4316 24.2145C97.2283 25.8708 97.0684 27.301 96.9964 28.3144C96.9101 29.3081 96.8578 29.8938 96.8578 29.8938C96.8578 29.8938 96.7819 30.8383 96.6206 32.3483C96.541 33.1043 96.4359 34.0009 96.3094 34.9918C96.2578 35.3655 96.2075 35.756 96.1523 36.1615C96.1696 36.2649 96.0622 36.2365 95.9922 36.2509C95.7737 36.272 95.5533 36.2953 95.3287 36.3189C90.738 36.7819 85.3487 37.3267 82.1496 37.6502L79.3959 37.9309L78.3394 38.0392L78.1542 38.0574L78.0607 38.0676L78.0148 38.0716C78.0148 38.0716 77.9678 38.0861 77.9869 38.0635C78.0476 37.9407 78.1061 37.8161 78.1578 37.6857L78.2605 37.4166C78.3084 37.2907 78.3479 37.1656 78.3917 37.0401C78.4791 36.7891 78.5624 36.5385 78.637 36.2845C79.2812 34.1451 79.6012 32.2122 79.8478 30.4262C80.088 28.6386 80.2266 26.9858 80.3206 25.3767L80.321 25.3809Z" fill="#6A9A23"/>
</g>
</g>
<defs>
<clipPath id="clip0_783_5660">
<rect width="421" height="32" fill="white"/>
</clipPath>
<clipPath id="clip1_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(268.681 74.498) rotate(-105)"/>
</clipPath>
<clipPath id="clip2_783_5660">
<rect width="304" height="304.679" fill="white" transform="translate(-42.3188 346) rotate(-105)"/>
</clipPath>
</defs>
</svg>
`;
const $ea8e736e4eb06883$export$3c6f6c6a4ab84ea6 = `data:image/svg+xml;base64,${$ea8e736e4eb06883$require$Buffer.from($ea8e736e4eb06883$var$learningPathBg).toString("base64")}`;



const $0dbf0b63949b5d22$export$8b251419efc915eb = ({ isCourse: isCourse , courseImgUrl: courseImgUrl , title: title , completedItems: completedItems , progress: progress , learningPathSlug: learningPathSlug , courseSlug: courseSlug , navigate: navigate  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "sidebar-header",
        css: $0dbf0b63949b5d22$var$headerStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                css: $0dbf0b63949b5d22$var$headerImageStyles,
                src: isCourse ? (0, $e48fba9cf5395297$export$d3a66d29d3f047ac) : (0, $ea8e736e4eb06883$export$3c6f6c6a4ab84ea6),
                alt: title
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: [
                    $0dbf0b63949b5d22$var$headerContentStyles,
                    isCourse && $0dbf0b63949b5d22$var$courseHeaderContentStyles
                ],
                children: [
                    isCourse && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: $0dbf0b63949b5d22$var$courseImageContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                            css: $0dbf0b63949b5d22$var$courseImageStyles,
                            src: courseImgUrl,
                            alt: title,
                            "data-testid": "course-image"
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: [
                            $0dbf0b63949b5d22$var$containerStyles,
                            isCourse && (0, $hgUW1$css)({
                                marginLeft: (0, $hgUW1$token)("space.150")
                            })
                        ],
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                css: $0dbf0b63949b5d22$var$typeStyles,
                                children: isCourse ? "Course" : "Learning Path"
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                css: $0dbf0b63949b5d22$var$titleStyles,
                                "data-testid": "sidebar-title",
                                onClick: ()=>learningPathSlug ? navigate(`/path/${learningPathSlug}`) : navigate(`/course/${courseSlug}`),
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        "data-testid": "course-progress-circle",
                        css: $0dbf0b63949b5d22$var$progressCircleContainerStyles,
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$CircularProgressbarWithChildren), {
                            strokeWidth: 8,
                            value: progress,
                            styles: (0, $hgUW1$buildStyles)({
                                pathColor: (0, $hgUW1$token)("color.border.success"),
                                trailColor: "rgba(9, 30, 66, 0.14)"
                            }),
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                css: [
                                    $0dbf0b63949b5d22$var$progressStyles,
                                    isCourse && (0, $hgUW1$css)({
                                        fontSize: "14px"
                                    })
                                ],
                                "data-testid": "progress-text",
                                children: completedItems
                            })
                        })
                    })
                ]
            })
        ]
    });
const $0dbf0b63949b5d22$var$headerStyles = (0, $hgUW1$css)({
    width: "100%",
    marginBottom: (0, $hgUW1$token)("space.200")
});
const $0dbf0b63949b5d22$var$headerImageStyles = (0, $hgUW1$css)({
    [(0, $hgUW1$media).below.xs]: {
        width: "100%"
    }
});
const $0dbf0b63949b5d22$var$headerContentStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: (0, $hgUW1$token)("space.250"),
    paddingLeft: (0, $hgUW1$token)("space.200"),
    paddingRight: (0, $hgUW1$token)("space.100")
});
const $0dbf0b63949b5d22$var$courseHeaderContentStyles = (0, $hgUW1$css)({
    paddingLeft: (0, $hgUW1$token)("space.150"),
    paddingRight: (0, $hgUW1$token)("space.150")
});
const $0dbf0b63949b5d22$var$progressCircleContainerStyles = (0, $hgUW1$css)({
    maxWidth: "48px",
    marginLeft: (0, $hgUW1$token)("space.150")
});
const $0dbf0b63949b5d22$var$progressStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px"
});
const $0dbf0b63949b5d22$var$courseImageContainerStyles = (0, $hgUW1$css)({
    width: "32px",
    minWidth: "32px",
    minHeight: "32px"
});
const $0dbf0b63949b5d22$var$courseImageStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "100%",
    objectFit: "cover"
});
const $0dbf0b63949b5d22$var$containerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto"
});
const $0dbf0b63949b5d22$var$typeStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtle"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: 600,
    textTransform: "uppercase",
    marginBottom: (0, $hgUW1$token)("space.050")
});
const $0dbf0b63949b5d22$var$titleStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "28px",
    marginTop: 0,
    transition: "color 0.5s ease",
    [(0, $hgUW1$media).below.xs]: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    "&:hover": {
        cursor: "pointer",
        color: (0, $hgUW1$token)("color.text.selected")
    }
});










const $dc9bbc4e728e99ac$export$792ece11a7230884 = 89;
const $dc9bbc4e728e99ac$export$1239cfcb7eeed80e = 8;
const $dc9bbc4e728e99ac$export$686a18f490557de2 = 16;
const $dc9bbc4e728e99ac$export$6a021f56d50c6f44 = 250;
const $dc9bbc4e728e99ac$export$789f21e35b72f907 = 68;
const $dc9bbc4e728e99ac$export$4ac0ef1183ae81e8 = (positionData)=>{
    const height = positionData.height > $dc9bbc4e728e99ac$export$792ece11a7230884 ? $dc9bbc4e728e99ac$export$792ece11a7230884 : positionData.height;
    const subnavbarPosition = document.getElementById("subnavbar")?.getBoundingClientRect();
    const offset = subnavbarPosition && subnavbarPosition.y < $dc9bbc4e728e99ac$export$789f21e35b72f907 ? $dc9bbc4e728e99ac$export$789f21e35b72f907 - subnavbarPosition.y : 0;
    return {
        top: positionData.top - ($dc9bbc4e728e99ac$export$6a021f56d50c6f44 / 2 - height / 2) + offset - $dc9bbc4e728e99ac$export$686a18f490557de2,
        left: (0, $035f8a623e403361$export$780035d9fe48eb32) - $dc9bbc4e728e99ac$export$686a18f490557de2
    };
};


const $f50e6e435b887166$export$1671b398b5e36be4 = ({ courses: courses , renderPopup: renderPopup  })=>{
    const popupRef = (0, $hgUW1$useRef)(null);
    const { hoverInfo: hoverInfo , setHoverInfo: setHoverInfo  } = (0, $32c02b5652036d7a$export$861cd542ff836f0d)();
    const courseToShowInPopup = (0, $hgUW1$useMemo)(()=>courses.find(({ sys: sys  })=>sys.id === hoverInfo?.courseId), [
        hoverInfo?.courseId,
        courses
    ]);
    const handlePopupLeave = (e)=>{
        const popupId = popupRef.current?.children[0].id;
        const isMovedToOutside = e.target.closest(`#${popupId}`);
        if (isMovedToOutside) setHoverInfo(null);
    };
    if (!hoverInfo) return null;
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        "data-testid": "sidebar-hover-popup",
        ref: popupRef,
        onMouseEnter: ()=>{
            setHoverInfo(hoverInfo);
        },
        onMouseLeave: handlePopupLeave,
        css: [
            $f50e6e435b887166$var$popupStyles,
            (0, $hgUW1$css)((0, $dc9bbc4e728e99ac$export$4ac0ef1183ae81e8)(hoverInfo.courseCardPosition))
        ],
        children: renderPopup(courseToShowInPopup)
    });
};
const $f50e6e435b887166$var$popupStyles = (0, $hgUW1$css)({
    position: "absolute",
    zIndex: 100,
    transform: "translateY(-50%)",
    paddingLeft: `${(0, $dc9bbc4e728e99ac$export$686a18f490557de2) + (0, $dc9bbc4e728e99ac$export$1239cfcb7eeed80e)}px`,
    [(0, $hgUW1$media).below.sm]: {
        display: "none"
    }
});




const $3d76652bb6362040$export$4ff69a78d3a65d6f = ({ isVisible: isVisible = true , isLoading: isLoading , learningPath: learningPath , progressForLessons: progressForLessons , progressForCourses: progressForCourses , expandedCourseIds: expandedCourseIds = [] , expandedLessonIds: expandedLessonIds = [] , selectedSectionId: selectedSectionId , currentLessonSlug: currentLessonSlug , onSelect: onSelect , navigate: navigate = ()=>{} , renderPopup: renderPopup , onToggleVisibility: onToggleVisibility  })=>{
    const [showCurrentLessonButton, setShowCurrentLessonButton] = (0, $hgUW1$useState)(false);
    const scrollContainerRef = (0, $hgUW1$useRef)(null);
    const selectedLessonRef = (0, $hgUW1$useRef)(null);
    const courses = learningPath?.coursesCollection.items || [];
    const lessons = courses.flatMap((course)=>course.lessonsCollection.items);
    const numberOfCompletedLessons = lessons.filter(({ sys: { id: id  }  })=>progressForLessons?.lessons.find((lesson)=>lesson.lessonId === id)?.status === (0, $035f8a623e403361$export$23d03d0b3065d061).COMPLETED).length;
    const numberOfCompletedCourses = courses.filter(({ sys: { id: id  }  })=>progressForCourses?.courses.find((course)=>course.courseId === id)?.status === (0, $035f8a623e403361$export$23d03d0b3065d061).COMPLETED).length;
    const selectedCourse = courses.find(({ slug: slug  })=>(0, $48630d5962798e4a$export$15379570ba48f04d)(slug));
    const isCourse = !learningPath?.title;
    const calculateProgress = ()=>isCourse ? numberOfCompletedLessons / lessons.length * 100 : numberOfCompletedCourses / courses.length * 100;
    const completedEntities = isCourse ? numberOfCompletedLessons : numberOfCompletedCourses;
    const totalEntities = isCourse ? lessons.length : courses.length;
    // Find the selected lesson in either the main lessons array or inside course cards
    const selectedLessonId = (0, $hgUW1$useMemo)(()=>isCourse ? lessons.find(({ slug: slug  })=>(0, $48630d5962798e4a$export$15379570ba48f04d)("", slug)) : courses.reduce((found, course)=>{
            if (found) return found;
            const selectedLesson = course.lessonsCollection.items.find(({ slug: slug  })=>(0, $48630d5962798e4a$export$15379570ba48f04d)("", slug));
            return selectedLesson ? selectedLesson.sys.id : undefined;
        }, undefined), [
        isCourse,
        lessons,
        courses
    ]);
    // Handle scroll event to check if selected lesson is visible
    const handleScroll = (0, $hgUW1$useCallback)(()=>{
        if (!scrollContainerRef.current || !selectedLessonRef.current || !selectedLessonId) return;
        const container = scrollContainerRef.current;
        const selectedLessonElement = selectedLessonRef.current;
        const containerRect = container.getBoundingClientRect();
        const lessonRect = selectedLessonElement.getBoundingClientRect();
        // Check if the selected lesson is above the visible area
        const isLessonAboveViewport = lessonRect.top < containerRect.top;
        setShowCurrentLessonButton(isLessonAboveViewport);
    }, [
        selectedLessonId
    ]);
    const scrollToSelectedLesson = (0, $hgUW1$useCallback)(()=>{
        if (selectedLessonRef.current && scrollContainerRef.current) selectedLessonRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, [
        selectedLessonId
    ]);
    (0, $hgUW1$useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);
            handleScroll();
            return ()=>{
                scrollContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        selectedLessonId
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("aside", {
        "data-testid": "sidebar",
        css: [
            $3d76652bb6362040$var$sidebarStyles,
            !isVisible && $3d76652bb6362040$var$sidebarClosedStyles
        ],
        children: [
            isVisible && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $3d76652bb6362040$var$closeButtonContainerStyles,
                onClick: onToggleVisibility,
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
                    "data-testid": "sidebar-mobile-close-button",
                    css: $3d76652bb6362040$var$closeButtonStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "cross",
                            color: (0, $hgUW1$token)("color.icon")
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                            css: $3d76652bb6362040$var$closeButtonTextStyles,
                            children: "Close"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                "data-testid": "sidebar-toggle-button",
                css: [
                    $3d76652bb6362040$var$sidebarButton,
                    isCourse && $3d76652bb6362040$var$sidebarButtonForCourseStyles
                ],
                onClick: onToggleVisibility,
                "aria-label": isVisible ? "Collapse sidebar" : "Expand sidebar",
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                    type: isVisible ? "sidebar-collapse" : "sidebar-expand"
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0dbf0b63949b5d22$export$8b251419efc915eb), {
                isCourse: isCourse,
                learningPathSlug: learningPath?.slug,
                courseSlug: courses[0]?.slug,
                title: isCourse ? selectedCourse?.title || "" : learningPath?.title || "",
                completedItems: `${completedEntities}/${totalEntities}`,
                progress: calculateProgress(),
                courseImgUrl: courses[0]?.reward?.badgeCdnUrl || courses[0]?.reward?.badge?.[0]?.cdn_url || (0, $ef44b01e6346ac17$export$44f5f766f3f98994),
                navigate: navigate
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $32c02b5652036d7a$export$d8355e8edbcacbe8), {
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        "data-testid": "sidebar-cards-container",
                        css: $3d76652bb6362040$var$cardsContainerStyles,
                        children: [
                            showCurrentLessonButton && selectedLessonId && /*#__PURE__*/ (0, $hgUW1$jsxs)("button", {
                                css: $3d76652bb6362040$var$currentLessonStyles,
                                onClick: scrollToSelectedLesson,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: "arrow-up",
                                        color: (0, $hgUW1$token)("color.icon")
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                        css: $3d76652bb6362040$var$buttonTextStyles,
                                        children: "Current lesson"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $3d76652bb6362040$var$cardsScrollableContainerStyles,
                                ref: scrollContainerRef,
                                children: isCourse ? /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    "data-testid": "sidebar-lesson-container",
                                    css: $3d76652bb6362040$var$lessonContainerStyles,
                                    children: lessons.map((lesson)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                            ref: (0, $48630d5962798e4a$export$15379570ba48f04d)("", lesson.slug) ? selectedLessonRef : null,
                                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0ca1c0d89e77a13d$export$951debaed2d5c034), {
                                                courseSlug: selectedCourse?.slug,
                                                lesson: lesson,
                                                progressForLesson: progressForLessons?.lessons.find((lessonProgress)=>lessonProgress.lessonId === lesson.sys.id),
                                                onSelect: onSelect,
                                                expandedLessonIds: expandedLessonIds,
                                                isLoading: isLoading,
                                                selectedSectionId: selectedSectionId,
                                                currentLessonSlug: currentLessonSlug
                                            })
                                        }, lesson.sys.id))
                                }) : courses.map((course)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $aefb4e9d0a694068$export$bb61bd2f4f2a772c), {
                                        course: course,
                                        progressForLessons: progressForLessons,
                                        status: (0, $48630d5962798e4a$export$272e7ef3ea22070d)(progressForCourses?.courses.find((courseProgress)=>courseProgress.courseId === course.sys.id)?.status),
                                        onSelect: onSelect,
                                        isLoading: isLoading,
                                        selectedLessonRef: selectedLessonRef,
                                        expandedLessonIds: expandedLessonIds,
                                        expandedCourseIds: expandedCourseIds,
                                        selectedSectionId: selectedSectionId,
                                        currentLessonSlug: currentLessonSlug
                                    }, course.sys.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $f50e6e435b887166$export$1671b398b5e36be4), {
                        courses: courses,
                        renderPopup: renderPopup
                    })
                ]
            })
        ]
    });
};
const $3d76652bb6362040$var$sidebarStyles = (0, $hgUW1$css)({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    height: "100%",
    width: `${(0, $035f8a623e403361$export$780035d9fe48eb32)}px`,
    borderRight: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    transition: "transform 0.3s ease",
    [(0, $hgUW1$media).below.xs]: {
        width: "100%"
    }
});
const $3d76652bb6362040$var$sidebarClosedStyles = (0, $hgUW1$css)({
    transform: "translateX(-412px)",
    [(0, $hgUW1$media).below.xs]: {
        transform: "translateX(-100%)"
    }
});
const $3d76652bb6362040$var$closeButtonContainerStyles = (0, $hgUW1$css)({
    padding: `${(0, $hgUW1$token)("space.150")} ${(0, $hgUW1$token)("space.200")}`,
    [(0, $hgUW1$media).above.xs]: {
        display: "none"
    }
});
const $3d76652bb6362040$var$closeButtonStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    border: "none",
    cursor: "pointer"
});
const $3d76652bb6362040$var$closeButtonTextStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 400,
    color: (0, $hgUW1$token)("color.text"),
    marginLeft: (0, $hgUW1$token)("space.100")
});
const $3d76652bb6362040$var$sidebarButton = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "32px",
    height: "32px",
    top: "84px",
    right: "calc(-32px - 16px)",
    backgroundColor: "#FFFFFF",
    borderRadius: "3px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)",
    padding: 0,
    border: "none",
    cursor: "pointer",
    zIndex: 100,
    "&:hover": {
        backgroundColor: (0, $hgUW1$token)("elevation.surface.hovered")
    },
    "&:active": {
        backgroundColor: (0, $hgUW1$token)("elevation.surface.pressed")
    },
    svg: {
        width: "24px",
        height: "24px"
    },
    [(0, $hgUW1$media).below.xs]: {
        display: "none"
    }
});
const $3d76652bb6362040$var$sidebarButtonForCourseStyles = (0, $hgUW1$css)({
    top: (0, $hgUW1$token)("space.200")
});
const $3d76652bb6362040$var$cardsContainerStyles = (0, $hgUW1$css)({
    position: "relative",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    minHeight: 0
});
const $3d76652bb6362040$var$currentLessonStyles = (0, $hgUW1$css)({
    position: "absolute",
    zIndex: 100,
    top: (0, $hgUW1$token)("space.100"),
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    padding: `${(0, $hgUW1$token)("space.100")} ${(0, $hgUW1$token)("space.200")}`,
    cursor: "pointer",
    width: "fit-content",
    borderRadius: "100px",
    boxShadow: "0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 8px 12px 0px rgba(9, 30, 66, 0.15), 0px 0px 0px 1px rgba(188, 214, 240, 0.00) inset"
});
const $3d76652bb6362040$var$buttonTextStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    marginLeft: (0, $hgUW1$token)("space.050"),
    color: (0, $hgUW1$token)("color.text")
});
const $3d76652bb6362040$var$lessonContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $hgUW1$token)("space.100")
});
const $3d76652bb6362040$var$cardsScrollableContainerStyles = (0, $hgUW1$css)({
    flex: 1,
    overflowY: "auto",
    minHeight: 0
});


var $764442aba3de2fce$exports = {};

$parcel$export($764442aba3de2fce$exports, "Video", () => $764442aba3de2fce$export$ae01dedf5c052bb);







const $764442aba3de2fce$var$MOBILE_SCREEN_WIDTH = 480;
const $764442aba3de2fce$export$ae01dedf5c052bb = ({ brandfolderUrl: brandfolderUrl , orangeUrl: orangeUrl , vimeoUrl: vimeoUrl , youtubeUrl: youtubeUrl , captions: captions , chapters: chapters , controls: controls , width: width , height: height , videoId: videoId , name: name , poster: poster = "" , onControlClick: onControlClick , onProgressUpdate: onProgressUpdate , onError: onError  })=>{
    const videoRef = (0, $hgUW1$useRef)(null);
    const deviceSize = (0, $3ced3ef7e9864bf1$export$4616d33c54ae5baf)();
    const videoSrc = (0, $hgUW1$useMemo)(()=>orangeUrl || brandfolderUrl || vimeoUrl || youtubeUrl, [
        orangeUrl,
        brandfolderUrl,
        vimeoUrl,
        youtubeUrl
    ]);
    const playerSource = {
        type: "video",
        sources: [
            {
                src: videoSrc
            }
        ],
        tracks: [
            {
                kind: "captions",
                label: "English",
                srcLang: "en",
                src: captions,
                default: true
            }
        ]
    };
    const playerOptions = {
        invertTime: false,
        tooltips: {
            controls: true,
            seek: true
        },
        controls: [
            "play-large",
            "play",
            "progress",
            "current-time",
            "captions",
            "rewind",
            "fast-forward",
            "mute",
            "volume",
            "settings",
            "pip",
            "fullscreen",
            "seektime"
        ],
        quality: {
            default: 1080,
            options: [
                1080,
                720,
                576,
                480,
                360,
                240
            ]
        },
        markers: {
            enabled: true,
            points: chapters
        }
    };
    const playerOptionsMobile = {
        invertTime: false,
        tooltips: {
            controls: true,
            seek: true
        },
        controls: [
            "play-small",
            "play",
            "progress",
            "current-time",
            "rewind",
            "fast-forward",
            "mute",
            "volume",
            "settings",
            "fullscreen",
            "seektime"
        ],
        quality: {
            default: 1080,
            options: [
                1080,
                720,
                576,
                480,
                360,
                240
            ]
        },
        markers: {
            enabled: true,
            points: chapters
        }
    };
    const addEvents = (0, $hgUW1$useCallback)((instance)=>{
        instance.once("loadeddata", ()=>{
            addEvent(instance, "play");
            addEvent(instance, "pause");
            addEvent(instance, "captionsenabled");
            addEvent(instance, "captionsdisabled");
        });
        instance.on("timeupdate", ()=>{
            const currentTime = instance.currentTime;
            const duration = instance.duration;
            const percentage = currentTime / duration * 100;
            onProgressUpdate && onProgressUpdate(+percentage.toFixed(2), name, videoId);
        });
        if (onError) instance.on("error", onError);
    }, [
        onControlClick,
        onError
    ]);
    const addEvent = (0, $hgUW1$useCallback)((instance, event)=>instance.on(event, ()=>onControlClick && onControlClick(event)), []);
    (0, $hgUW1$useEffect)(()=>{
        const isMobileSize = deviceSize <= $764442aba3de2fce$var$MOBILE_SCREEN_WIDTH;
        const player = new (0, $hgUW1$plyrdistplyr)(videoRef.current, isMobileSize ? playerOptionsMobile : playerOptions);
        player.source = playerSource;
        player.poster = poster;
        addEvents(player);
        const plyrVideoContainers = document.getElementsByClassName("plyr--video");
        if (plyrVideoContainers.length) Array.from(plyrVideoContainers).forEach((el)=>el.role = "presentation");
    }, []);
    if (videoSrc === vimeoUrl) return /*#__PURE__*/ (0, $hgUW1$jsx)("iframe", {
        role: "document",
        title: "video",
        tabIndex: 0,
        css: (0, $hgUW1$css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
            }
        }),
        src: vimeoUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    else if (videoSrc === youtubeUrl) return /*#__PURE__*/ (0, $hgUW1$jsx)("iframe", {
        role: "document",
        title: "video",
        tabIndex: 0,
        css: (0, $hgUW1$css)({
            backgroundColor: "transparent",
            width: "100%",
            aspectRatio: "16 / 9",
            ":focus-visible": {
                border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
            }
        }),
        src: youtubeUrl,
        allowFullScreen: true,
        allow: "autoplay"
    });
    else return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $764442aba3de2fce$var$videoPlayerStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("video", {
            tabIndex: 0,
            ref: videoRef,
            width: width,
            height: height,
            controls: controls,
            crossOrigin: "anonymous",
            title: "video",
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)("source", {
                    src: videoSrc,
                    type: "video/mp4"
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)("track", {
                    src: captions,
                    kind: "captions",
                    label: "captions",
                    srcLang: "en",
                    default: true
                })
            ]
        })
    });
};
const $764442aba3de2fce$var$videoPlayerStyles = (0, $hgUW1$css)({
    ".plyr__time": {
        fontSize: "12px !important",
        fontWeight: "600 !important"
    },
    "--plyr-color-main": "#1D7AFC",
    "--plyr-badge-background": (0, $hgUW1$N800),
    "--plyr-audio-control-color": (0, $hgUW1$N800),
    "--plyr-menu-color": (0, $hgUW1$N800),
    "--plyr-menu-item-arrow-color": "#758195",
    "--plyr-menu-border-color": "#DCDFE4",
    "--plyr-tooltip-color": (0, $hgUW1$N800),
    ":focus-visible": {
        border: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});



var $77282b3961d82199$exports = {};

$parcel$export($77282b3961d82199$exports, "Columns", () => $77282b3961d82199$export$f02cc02ad0e0bba3);
$parcel$export($77282b3961d82199$exports, "LessonColumns", () => $77282b3961d82199$export$2dde675552f76fc5);



let $77282b3961d82199$export$f02cc02ad0e0bba3;
(function(Columns) {
    Columns["TWO"] = "two";
    Columns["THREE"] = "three";
    Columns["FOUR"] = "four";
})($77282b3961d82199$export$f02cc02ad0e0bba3 || ($77282b3961d82199$export$f02cc02ad0e0bba3 = {}));
const $77282b3961d82199$export$2dde675552f76fc5 = ({ columns: columns = $77282b3961d82199$export$f02cc02ad0e0bba3.TWO , children: children  })=>/*#__PURE__*/ (0, $hgUW1$jsx)("section", {
        css: $77282b3961d82199$var$sectionStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            "data-testid": "lesson-columns",
            css: [
                $77282b3961d82199$var$lessonColumnsStyles,
                $77282b3961d82199$var$lessonColumnsMDStyles[columns]
            ],
            children: children
        })
    });
const $77282b3961d82199$var$sectionStyles = (0, $hgUW1$css)({
    textOverflow: "ellipsis",
    [(0, $hgUW1$media1).above.lg]: {
        textOverflow: "clip"
    }
});
const $77282b3961d82199$var$lessonColumnsStyles = (0, $hgUW1$css)({
    display: "grid",
    columnGap: "0.5rem",
    gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
    fontSize: "16px",
    [(0, $hgUW1$media1).above.xs]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
    }
});
const $77282b3961d82199$var$lessonColumnsMDStyles = {
    [$77282b3961d82199$export$f02cc02ad0e0bba3.TWO]: (0, $hgUW1$css)({
        [(0, $hgUW1$media1).above.sm]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        }
    }),
    [$77282b3961d82199$export$f02cc02ad0e0bba3.THREE]: (0, $hgUW1$css)({
        [(0, $hgUW1$media1).above.sm]: {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
        }
    }),
    [$77282b3961d82199$export$f02cc02ad0e0bba3.FOUR]: (0, $hgUW1$css)({
        [(0, $hgUW1$media1).above.sm]: {
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))"
        }
    })
};



var $4c35f7fd4ad5f13f$exports = {};

$parcel$export($4c35f7fd4ad5f13f$exports, "LearningCourseCard", () => $4c35f7fd4ad5f13f$export$5ae3342de8088f07);









const $4c35f7fd4ad5f13f$export$5ae3342de8088f07 = ({ inspectMode: inspectMode , title: title , imageUrl: imageUrl , onClick: onClick , link: link , minHeight: minHeight = 153 , learningProgress: learningProgress , onGeneratePdf: onGeneratePdf , shouldDisplayShareButton: shouldDisplayShareButton , shouldDisplayBookmark: shouldDisplayBookmark  })=>{
    const onClickHandler = (0, $hgUW1$useCallback)(()=>{
        onClick && onClick();
    }, [
        onClick,
        link
    ]);
    const onKeyDown = (0, $hgUW1$useCallback)((0, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f)(onClickHandler), [
        onClickHandler
    ]);
    const handleSave = (event)=>{
        if (learningProgress) {
            event.stopPropagation();
            event.preventDefault();
            learningProgress.onSave(!learningProgress.isSaved);
        }
    };
    const isSaved = learningProgress?.completedResources === learningProgress?.resourceCount || learningProgress?.isSaved;
    return /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
        href: link,
        css: $4c35f7fd4ad5f13f$var$linkContainerStyles,
        rel: "noopener noreferrer",
        onClick: (e)=>e.preventDefault(),
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles,
            onClick: onClickHandler,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            "data-testid": "learning-course-card",
            style: {
                minHeight: `${minHeight}px`
            },
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $4c35f7fd4ad5f13f$var$bodyContainerStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $4c35f7fd4ad5f13f$var$imageContainerStyles,
                            children: imageUrl ? /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                                css: [
                                    $4c35f7fd4ad5f13f$var$imageStyles
                                ],
                                "data-testid": "learning-course-card-image",
                                src: imageUrl,
                                alt: "course-img"
                            }) : /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                "data-testid": "learning-course-card-no-image",
                                css: $4c35f7fd4ad5f13f$var$noImageStyles
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles,
                            children: title && /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                                "data-testid": "title",
                                ...(0, $fde9406d76ec24a9$export$1784ac302bd8ebad)("title", inspectMode),
                                css: $4c35f7fd4ad5f13f$var$titleStyles,
                                children: title
                            })
                        })
                    ]
                }),
                learningProgress && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles,
                    "data-testid": "learning-course-card-progress-content",
                    children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d8ee29df49af8811$export$184a993f673fc83f), {
                                completedResources: learningProgress.completedResources,
                                resourceCount: learningProgress.resourceCount,
                                completionDate: learningProgress.completionDate,
                                contentType: (0, $ed20910b93d89c3f$export$e2e108cbe2e4f865).COURSE
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles,
                                children: [
                                    shouldDisplayShareButton && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $2cfa64583f556289$export$477c64ffaba52edf), {
                                        urlToShare: link,
                                        alignToLeft: true,
                                        shareOnFb: false,
                                        shareOnLinkedin: false,
                                        showCopyLink: false,
                                        shareOnPdf: true,
                                        onGeneratePdf: onGeneratePdf
                                    }),
                                    shouldDisplayBookmark && /*#__PURE__*/ (0, $hgUW1$jsx)("button", {
                                        "data-testid": "save-content",
                                        css: $4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles,
                                        onClick: handleSave,
                                        children: isSaved ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "bookmark-filled"
                                        }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                            type: "bookmark"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $4c35f7fd4ad5f13f$var$learningCourseCardContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    backgroundColor: (0, $hgUW1$token)("color.background.input"),
    borderRadius: "8px",
    border: `1px solid ${(0, $hgUW1$token)("color.border")}`,
    boxShadow: (0, $hgUW1$token)("elevation.shadow.raised"),
    transition: "box-shadow 0.3s ease-in-out",
    cursor: "pointer",
    width: "100%",
    height: "153px",
    "&:hover": {
        boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay")
    },
    "&:active": {
        outline: `1px solid ${(0, $hgUW1$token)("color.border.focused")}`,
        border: `1px solid ${(0, $hgUW1$token)("color.border.focused")}`
    }
});
const $4c35f7fd4ad5f13f$var$bodyContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: `${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.300")} ${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.075")}`,
    gap: (0, $hgUW1$token)("space.200"),
    minHeight: "96px",
    justifyContent: "flex-end",
    "@media (max-width: 1279px)": {
        justifyContent: "flex-start",
        padding: `${(0, $hgUW1$token)("space.050")} ${(0, $hgUW1$token)("space.050")} ${(0, $hgUW1$token)("space.050")} ${(0, $hgUW1$token)("space.200")}`
    }
});
const $4c35f7fd4ad5f13f$var$linkContainerStyles = (0, $hgUW1$css)({
    textDecoration: "none",
    "&:hover": {
        textDecoration: "none"
    }
});
const $4c35f7fd4ad5f13f$var$imageContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    width: "64px",
    height: "64px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0
});
const $4c35f7fd4ad5f13f$var$imageStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%"
});
const $4c35f7fd4ad5f13f$var$noImageStyles = (0, $hgUW1$css)({
    background: (0, $hgUW1$token)("color.background.accent.gray.subtlest"),
    width: "64px",
    height: "64px",
    borderRadius: "50%"
});
const $4c35f7fd4ad5f13f$var$titleAndDetailsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "275px",
    "@media (max-width: 1279px)": {
        width: "232px",
        flexGrow: 1,
        padding: `${(0, $hgUW1$token)("space.300")} ${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.300")} ${(0, $hgUW1$token)("space.0")}`
    }
});
const $4c35f7fd4ad5f13f$var$learningCourseCardProgressContainerStyles = (0, $hgUW1$css)({
    borderTop: `1px solid ${(0, $hgUW1$token)("color.border")}`
});
const $4c35f7fd4ad5f13f$var$learningCourseCardProgressItemsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "space-between",
    padding: `${(0, $hgUW1$token)("space.200")} ${(0, $hgUW1$token)("space.300")}`
});
const $4c35f7fd4ad5f13f$var$learningCourseCardIconsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    gap: (0, $hgUW1$token)("space.300")
});
const $4c35f7fd4ad5f13f$var$learningCourseCardBookmarkContainerStyles = (0, $hgUW1$css)({
    height: "24px",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none",
    "&:focus-visible": {
        outline: `2px solid ${(0, $hgUW1$token)("color.border.selected")}`
    }
});
const $4c35f7fd4ad5f13f$var$titleStyles = (0, $hgUW1$css)({
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginTop: "20px",
    marginBottom: 0,
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "24px",
    color: (0, $hgUW1$token)("color.text")
});



var $27d686e47ff412fd$exports = {};

$parcel$export($27d686e47ff412fd$exports, "FeedbackHeader", () => $27d686e47ff412fd$export$41cd510048068b0c);





const $27d686e47ff412fd$export$41cd510048068b0c = ({ heading: heading , duration: duration , description: description  })=>/*#__PURE__*/ (0, $hgUW1$jsxs)("section", {
        "aria-labelledby": "feedback-header",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $27d686e47ff412fd$var$headingWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("h1", {
                    css: $27d686e47ff412fd$var$headingStyles,
                    id: "feedback-header",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $27d686e47ff412fd$var$metadataStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                    css: $27d686e47ff412fd$var$flexContainerStyles,
                    children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: (0, $hgUW1$css)({
                            display: "flex"
                        }),
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $27d686e47ff412fd$var$tagStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                                    label: duration
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $27d686e47ff412fd$var$tagStyles,
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5cf70e33bfc6ce73$export$3288d34c523a1192), {
                                    label: "survey"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $27d686e47ff412fd$var$lineWrapperStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                    color: (0, $hgUW1$token)("color.border")
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $27d686e47ff412fd$var$descriptionStyles,
                children: description
            })
        ]
    });
const $27d686e47ff412fd$var$metadataStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $27d686e47ff412fd$var$flexContainerStyles = (0, $hgUW1$css)({
    display: "flex"
});
const $27d686e47ff412fd$var$tagStyles = (0, $hgUW1$css)({
    marginRight: (0, $hgUW1$token)("space.100")
});
const $27d686e47ff412fd$var$lineWrapperStyles = (0, $hgUW1$css)({
    padding: `${(0, $hgUW1$token)("space.300")} 0 ${(0, $hgUW1$token)("space.500")} 0`
});
const $27d686e47ff412fd$var$headingWrapperStyles = (0, $hgUW1$css)({
    padding: `${(0, $hgUW1$token)("space.1000")} 0 ${(0, $hgUW1$token)("space.300")} 0`
});
const $27d686e47ff412fd$var$headingStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text"),
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "61.333px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "81.778px"
});
const $27d686e47ff412fd$var$descriptionStyles = (0, $hgUW1$css)({
    paddingBottom: (0, $hgUW1$token)("space.1000"),
    fontFamily: "Inter, sans-serif",
    fontSize: "20px",
    lineHeight: "32px",
    color: (0, $hgUW1$token)("color.text"),
    p: {
        margin: 0
    }
});


var $a4deb03146bf3bfc$exports = {};

$parcel$export($a4deb03146bf3bfc$exports, "ReportIssueModal", () => $a4deb03146bf3bfc$export$448811829c5d1992);











let $a4deb03146bf3bfc$var$DialogWidth;
(function(DialogWidth) {
    DialogWidth["SMALL"] = "small";
    DialogWidth["MEDIUM"] = "medium";
    DialogWidth["LARGE"] = "large";
    DialogWidth["XLARGE"] = "x-large";
})($a4deb03146bf3bfc$var$DialogWidth || ($a4deb03146bf3bfc$var$DialogWidth = {}));
const $a4deb03146bf3bfc$export$448811829c5d1992 = ({ isParticipatingInResearch: isParticipatingInResearch , consentToContact: consentToContact , selectValue: selectValue , textAreaValues: textAreaValues , heading: heading , width: width = $a4deb03146bf3bfc$var$DialogWidth.LARGE , options: options , isDisabled: isDisabled , closeModal: closeModal , submit: submit , onSelectChange: onSelectChange , onTextChange: onTextChange , onParticipatingInResearch: onParticipatingInResearch , onConsentToContact: onConsentToContact  })=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitmodaldialog), {
        onClose: closeModal,
        width: width,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            css: $a4deb03146bf3bfc$var$modalContainerStyles,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                    css: $a4deb03146bf3bfc$var$modalBodyStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("p", {
                            "data-testid": "modal-heading",
                            css: $a4deb03146bf3bfc$var$modalHeadingContainerStyles,
                            children: heading
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)("p", {
                            css: $a4deb03146bf3bfc$var$requiredFieldsStyles,
                            children: [
                                "Required fields are marked with an asterisk",
                                " ",
                                /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                    css: [
                                        $a4deb03146bf3bfc$var$requiredFieldsStyles,
                                        (0, $hgUW1$css)({
                                            color: (0, $hgUW1$token)("color.text.accent.red")
                                        })
                                    ],
                                    children: "*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: (0, $hgUW1$css)({
                                marginBottom: (0, $hgUW1$token)("space.050")
                            }),
                            children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Label), {
                                htmlFor: "problem-to-report",
                                children: [
                                    "What problem would you like to report? ",
                                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                        css: (0, $hgUW1$css)({
                                            color: (0, $hgUW1$token)("color.text.accent.red")
                                        }),
                                        children: "*"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $a4deb03146bf3bfc$var$selectContainerStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitselect), {
                                inputId: "problem-to-report",
                                options: options,
                                value: selectValue,
                                onChange: (e)=>onSelectChange(e),
                                placeholder: "Select problem"
                            })
                        }),
                        selectValue && /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: (0, $hgUW1$css)({
                                        marginBottom: (0, $hgUW1$token)("space.050")
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Label), {
                                        htmlFor: "problem-to-report",
                                        children: [
                                            "Provide any other details ",
                                            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                                                css: (0, $hgUW1$css)({
                                                    color: (0, $hgUW1$token)("color.text.accent.red")
                                                }),
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $a4deb03146bf3bfc$var$detailsStyles,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskittextarea), {
                                        maxHeight: "156px",
                                        placeholder: "Start typing...",
                                        onChange: onTextChange,
                                        value: textAreaValues
                                    })
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: (0, $hgUW1$css)({
                                        marginBottom: (0, $hgUW1$token)("space.100")
                                    }),
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d501466973a9f0a6$export$48513f6b9f8ce62d), {
                                        label: "I'd like to participate in product research",
                                        onChange: onParticipatingInResearch,
                                        isChecked: isParticipatingInResearch
                                    })
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                    css: $a4deb03146bf3bfc$var$policyContainerStyles,
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d501466973a9f0a6$export$48513f6b9f8ce62d), {
                                        label: /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
                                            children: [
                                                "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy",
                                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a), {
                                                    label: "Atlassian Privacy Policy.",
                                                    target: "_blank",
                                                    link: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                    onClick: ()=>{
                                                        window.open("https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers", "_blank", "noopener");
                                                    }
                                                })
                                            ]
                                        }),
                                        onChange: onConsentToContact,
                                        isChecked: consentToContact
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hgUW1$jsxs)("span", {
                    css: $a4deb03146bf3bfc$var$modalCloseButtonStyles,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                            css: $a4deb03146bf3bfc$var$customButtonWrapperStyles,
                            children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitbuttonnew), {
                                appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).SUBTLE,
                                onClick: closeModal,
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                            label: "Submit",
                            appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                            disabled: isDisabled,
                            onClick: submit
                        })
                    ]
                })
            ]
        })
    });
const $a4deb03146bf3bfc$var$modalContainerStyles = (0, $hgUW1$css)({
    padding: (0, $hgUW1$token)("space.300"),
    [(0, $hgUW1$media1).below.sm]: {
        padding: (0, $hgUW1$token)("space.200")
    }
});
const $a4deb03146bf3bfc$var$modalHeadingContainerStyles = (0, $hgUW1$css)({
    fontFamily: "Charlie Display, sans-serif",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "32px"
});
const $a4deb03146bf3bfc$var$requiredFieldsStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    marginBottom: (0, $hgUW1$token)("space.300")
});
const $a4deb03146bf3bfc$var$selectContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    maxWidth: "420px",
    marginBottom: (0, $hgUW1$token)("space.300")
});
const $a4deb03146bf3bfc$var$detailsStyles = (0, $hgUW1$css)({
    width: "100%",
    marginBottom: (0, $hgUW1$token)("space.300")
});
const $a4deb03146bf3bfc$var$modalCloseButtonStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "flex-end",
    [(0, $hgUW1$media1).below.sm]: {
        padding: (0, $hgUW1$token)("space.100")
    }
});
const $a4deb03146bf3bfc$var$modalBodyStyles = (0, $hgUW1$css)({
    maxWidth: "640px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: `${(0, $hgUW1$token)("space.200")} auto 0`,
    [(0, $hgUW1$media1).below.sm]: {
        marginTop: 0
    }
});
const $a4deb03146bf3bfc$var$customButtonWrapperStyles = (0, $hgUW1$css)({
    marginRight: (0, $hgUW1$token)("space.100"),
    button: {
        height: "100%",
        color: (0, $hgUW1$token)("color.text"),
        fontSize: "16px",
        lineHeight: "20px",
        padding: `10px ${(0, $hgUW1$token)("space.150")}`,
        fontWeight: 600
    }
});
const $a4deb03146bf3bfc$var$policyContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    a: {
        marginLeft: "5px"
    }
});


var $0ae392c3008c8a3e$exports = {};

$parcel$export($0ae392c3008c8a3e$exports, "FlatContentCardStyle", () => $0ae392c3008c8a3e$export$f2adaabc3a0295ef);
$parcel$export($0ae392c3008c8a3e$exports, "FlatContentCardType", () => $0ae392c3008c8a3e$export$8023ea0baf29b8db);
$parcel$export($0ae392c3008c8a3e$exports, "FlatContentCard", () => $0ae392c3008c8a3e$export$bc8a9d98c2eabbb7);






let $0ae392c3008c8a3e$export$f2adaabc3a0295ef;
(function(FlatContentCardStyle) {
    FlatContentCardStyle["TALL"] = "tall";
    FlatContentCardStyle["FULL"] = "full";
})($0ae392c3008c8a3e$export$f2adaabc3a0295ef || ($0ae392c3008c8a3e$export$f2adaabc3a0295ef = {}));
let $0ae392c3008c8a3e$export$8023ea0baf29b8db;
(function(FlatContentCardType) {
    FlatContentCardType["ROUND"] = "round";
    FlatContentCardType["SQUARE"] = "square";
    FlatContentCardType["RECTANGLE"] = "rectangle";
})($0ae392c3008c8a3e$export$8023ea0baf29b8db || ($0ae392c3008c8a3e$export$8023ea0baf29b8db = {}));
const $0ae392c3008c8a3e$export$bc8a9d98c2eabbb7 = ({ image: image , title: title , text: text , link: link , linkLabel: linkLabel = "Learn more" , style: style = $0ae392c3008c8a3e$export$f2adaabc3a0295ef.TALL , type: type = $0ae392c3008c8a3e$export$8023ea0baf29b8db.ROUND , headingLevel: headingLevel , bgColor: bgColor = "initial" , onClick: onClick , target: target = "_self" , maxWidth: maxWidth  })=>{
    const isSquareOrRectangle = type === $0ae392c3008c8a3e$export$8023ea0baf29b8db.SQUARE || type === $0ae392c3008c8a3e$export$8023ea0baf29b8db.RECTANGLE;
    const roundStyles = image ? $0ae392c3008c8a3e$var$variantStyles[style].container.withImage : $0ae392c3008c8a3e$var$variantStyles[style].container.withoutImage;
    const additionalContainerStyles = isSquareOrRectangle ? $0ae392c3008c8a3e$var$squareTypeStyles.container : roundStyles;
    const defaultHeadingLevel = isSquareOrRectangle ? 3 : 4;
    const rectangleStyles = type === $0ae392c3008c8a3e$export$8023ea0baf29b8db.RECTANGLE && $0ae392c3008c8a3e$var$variantStyles[$0ae392c3008c8a3e$export$f2adaabc3a0295ef.TALL].container.withImage;
    const handleClick = (title)=>{
        onClick && onClick(title);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: [
            $0ae392c3008c8a3e$var$containerStyles,
            additionalContainerStyles,
            rectangleStyles,
            (0, $hgUW1$css)({
                backgroundColor: bgColor
            }),
            maxWidth && (0, $hgUW1$css)({
                maxWidth: maxWidth
            })
        ],
        "data-testid": "learn-more-card",
        children: [
            image && /*#__PURE__*/ (0, $hgUW1$jsx)("img", {
                src: image.src,
                alt: image.alt,
                css: [
                    $0ae392c3008c8a3e$var$imageBaseStyles,
                    isSquareOrRectangle && $0ae392c3008c8a3e$var$imageSquareStyles,
                    style === $0ae392c3008c8a3e$export$f2adaabc3a0295ef.FULL && $0ae392c3008c8a3e$var$fullStyleImageStyles
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: [
                    $0ae392c3008c8a3e$var$contentContainerStyles,
                    isSquareOrRectangle && $0ae392c3008c8a3e$var$contentContainerSquareStyles
                ],
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: (0, $hgUW1$css)([
                            $0ae392c3008c8a3e$var$textStyles,
                            type === $0ae392c3008c8a3e$export$8023ea0baf29b8db.ROUND && $0ae392c3008c8a3e$var$variantStyles[style].heading,
                            isSquareOrRectangle && $0ae392c3008c8a3e$var$squareTypeStyles.heading
                        ]),
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                            level: headingLevel || defaultHeadingLevel,
                            children: title,
                            fontWeight: 600
                        })
                    }),
                    type === $0ae392c3008c8a3e$export$8023ea0baf29b8db.ROUND && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        css: [
                            (0, $hgUW1$css)([
                                $0ae392c3008c8a3e$var$textStyles,
                                $0ae392c3008c8a3e$var$variantStyles[style].text,
                                $0ae392c3008c8a3e$var$textContainerStyles
                            ])
                        ],
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a), {
                        label: linkLabel,
                        link: link,
                        onClick: ()=>handleClick(title),
                        icon: "arrow-right",
                        fontColor: (0, $hgUW1$token)("color.text.brand"),
                        style: (0, $4fce8dfc4ce8f546$export$2b77966d73aefa77).SEMIBOLD,
                        size: (0, $4fce8dfc4ce8f546$export$be4c932f76c19adf).LARGE,
                        target: target
                    })
                ]
            })
        ]
    });
};
const $0ae392c3008c8a3e$var$containerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    padding: `${(0, $hgUW1$token)("space.400")} 0`,
    [(0, $hgUW1$media).below.sm]: {
        padding: `${(0, $hgUW1$token)("space.300")} 0`
    }
});
const $0ae392c3008c8a3e$var$textStyles = (0, $hgUW1$css)({
    [(0, $hgUW1$media).above.md]: {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }
});
const $0ae392c3008c8a3e$var$imageBaseStyles = (0, $hgUW1$css)({
    height: "80px",
    width: "80px",
    objectFit: "contain",
    borderRadius: "50%",
    marginBottom: (0, $hgUW1$token)("space.200"),
    maxWidth: "100%"
});
const $0ae392c3008c8a3e$var$imageSquareStyles = (0, $hgUW1$css)({
    borderRadius: 0,
    marginBottom: (0, $hgUW1$token)("space.300")
});
const $0ae392c3008c8a3e$var$fullStyleImageStyles = (0, $hgUW1$css)({
    width: "100%",
    height: "auto",
    maxHeight: "260px",
    marginBottom: (0, $hgUW1$token)("space.500"),
    borderRadius: "initial"
});
const $0ae392c3008c8a3e$var$variantStyles = {
    [$0ae392c3008c8a3e$export$f2adaabc3a0295ef.TALL]: {
        container: {
            withImage: (0, $hgUW1$css)({
                [(0, $hgUW1$media).above.md]: {
                    height: "352px !important"
                }
            }),
            withoutImage: (0, $hgUW1$css)({
                [(0, $hgUW1$media).above.md]: {
                    height: "264px !important"
                }
            })
        },
        heading: (0, $hgUW1$css)({
            [(0, $hgUW1$media).above.md]: {
                WebkitLineClamp: "2"
            }
        }),
        text: (0, $hgUW1$css)({
            [(0, $hgUW1$media).above.md]: {
                WebkitLineClamp: "3"
            }
        })
    },
    [$0ae392c3008c8a3e$export$f2adaabc3a0295ef.FULL]: {
        container: {
            withImage: (0, $hgUW1$css)({
                [(0, $hgUW1$media).above.md]: {
                    height: "auto !important"
                }
            }),
            withoutImage: (0, $hgUW1$css)({
                [(0, $hgUW1$media).above.md]: {
                    height: "auto !important"
                }
            })
        },
        heading: (0, $hgUW1$css)({
            [(0, $hgUW1$media).above.md]: {
                WebkitLineClamp: "none"
            }
        }),
        text: (0, $hgUW1$css)({
            [(0, $hgUW1$media).above.md]: {
                WebkitLineClamp: "none"
            }
        })
    }
};
const $0ae392c3008c8a3e$var$squareTypeStyles = {
    container: (0, $hgUW1$css)({
        backgroundColor: (0, $hgUW1$token)("color.background.input"),
        padding: (0, $hgUW1$token)("space.300"),
        height: "320px",
        width: "324px",
        borderRadius: "8px",
        [(0, $hgUW1$media).below.md]: {
            minHeight: "360px",
            maxWidth: "unset",
            height: "100%"
        },
        [(0, $hgUW1$media).below.sm]: {
            minHeight: "264px",
            padding: (0, $hgUW1$token)("space.300")
        }
    }),
    heading: (0, $hgUW1$css)({
        marginBottom: (0, $hgUW1$token)("space.300")
    })
};
const $0ae392c3008c8a3e$var$contentContainerStyles = (0, $hgUW1$css)({
    marginBottom: (0, $hgUW1$token)("space.025"),
    flex: 1,
    display: "flex",
    flexDirection: "column"
});
const $0ae392c3008c8a3e$var$contentContainerSquareStyles = (0, $hgUW1$css)({
    justifyContent: "space-between",
    a: {
        fontSize: "20px",
        lineHeight: "24px"
    }
});
const $0ae392c3008c8a3e$var$textContainerStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.100"),
    marginBottom: (0, $hgUW1$token)("space.400"),
    [(0, $hgUW1$media).below.sm]: {
        marginBottom: (0, $hgUW1$token)("space.300")
    }
});


var $3c691af970e2b3d8$exports = {};

$parcel$export($3c691af970e2b3d8$exports, "ThumbType", () => $3c691af970e2b3d8$export$e1c6e381de15460b);
$parcel$export($3c691af970e2b3d8$exports, "FeedbackButtonType", () => $3c691af970e2b3d8$export$8eec558e14651de4);
$parcel$export($3c691af970e2b3d8$exports, "THUMBS_UP_FEEDBACK_OPTIONS", () => $3c691af970e2b3d8$export$3e6d4d99e8c08756);
$parcel$export($3c691af970e2b3d8$exports, "THUMBS_DOWN_FEEDBACK_OPTIONS", () => $3c691af970e2b3d8$export$592a942fdddb4b1a);
$parcel$export($3c691af970e2b3d8$exports, "QuickFeedback", () => $3c691af970e2b3d8$export$c6f2bf448101d429);







let $3c691af970e2b3d8$export$e1c6e381de15460b;
(function(ThumbType) {
    ThumbType["THUMB_UP"] = "thumb-up";
    ThumbType["THUMB_DOWN"] = "thumb-down";
})($3c691af970e2b3d8$export$e1c6e381de15460b || ($3c691af970e2b3d8$export$e1c6e381de15460b = {}));
let $3c691af970e2b3d8$export$8eec558e14651de4;
(function(FeedbackButtonType) {
    FeedbackButtonType["DISMISS"] = "dismiss";
    FeedbackButtonType["SUBMIT"] = "submit";
})($3c691af970e2b3d8$export$8eec558e14651de4 || ($3c691af970e2b3d8$export$8eec558e14651de4 = {}));
const $3c691af970e2b3d8$export$3e6d4d99e8c08756 = [
    "It was easy to understand",
    "I learned something useful",
    "It was engaging",
    "It improved my confidence in the subject",
    "Other"
];
const $3c691af970e2b3d8$export$592a942fdddb4b1a = [
    "It wasn’t clear",
    "It wasn’t accurate",
    "I didn’t learn what I wanted to know",
    "Other"
];
const $3c691af970e2b3d8$export$c6f2bf448101d429 = ({ onSubmitFeedback: onSubmitFeedback , onChangeThoughts: onChangeThoughts , onChangeOption: onChangeOption , onThumbClick: onThumbClick , shouldShowDivider: shouldShowDivider = true  })=>{
    const [isPopupOpened, setIsPopupOpened] = (0, $hgUW1$react).useState({
        isOpen: false,
        thumbType: null
    });
    const [selectedOption, setSelectedOption] = (0, $hgUW1$react).useState("");
    const [selectedThumb, setSelectedThumb] = (0, $hgUW1$react).useState(null);
    const handleThumbClick = (thumbType)=>{
        setIsPopupOpened({
            isOpen: true,
            thumbType: thumbType
        });
        setSelectedThumb(thumbType);
        onThumbClick(thumbType);
    };
    const toggleAnswer = (option)=>{
        setSelectedOption(option);
        onChangeOption(option);
    };
    const getOptionStatus = (option)=>selectedOption === option;
    const handleChangeThoughts = (0, $hgUW1$useCallback)((e)=>{
        e.preventDefault();
        if (onChangeThoughts) onChangeThoughts(e);
    }, [
        onChangeThoughts
    ]);
    const handleSubmitFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        onSubmitFeedback($3c691af970e2b3d8$export$8eec558e14651de4.SUBMIT);
    };
    const handleDismissFeedback = ()=>{
        setIsPopupOpened({
            isOpen: false,
            thumbType: null
        });
        setSelectedOption("");
        onChangeThoughts({
            target: {
                value: ""
            }
        });
        onChangeOption("");
        onSubmitFeedback($3c691af970e2b3d8$export$8eec558e14651de4.DISMISS);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        "data-testid": "quick-feedback-component",
        css: $3c691af970e2b3d8$var$quickFeedbackStyles,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $3c691af970e2b3d8$var$feedbackContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $3c691af970e2b3d8$var$thumbsContainerStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                "data-testid": "thumb-down-container",
                                css: [
                                    $3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $3c691af970e2b3d8$export$e1c6e381de15460b.THUMB_DOWN && {
                                        backgroundColor: (0, $hgUW1$token)("color.background.selected")
                                    }
                                ],
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    tooltip: "Needs improvement",
                                    iconType: "thumb-down",
                                    label: "",
                                    iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: "thumb-down"
                                    }),
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                    onClick: ()=>handleThumbClick($3c691af970e2b3d8$export$e1c6e381de15460b.THUMB_DOWN)
                                })
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: [
                                    $3c691af970e2b3d8$var$thumbButtonContainerStyles,
                                    selectedThumb === $3c691af970e2b3d8$export$e1c6e381de15460b.THUMB_UP && {
                                        backgroundColor: (0, $hgUW1$token)("color.background.selected")
                                    }
                                ],
                                "data-testid": "thumb-up-container",
                                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                    tooltip: "Good",
                                    iconType: "thumb-up",
                                    label: "",
                                    iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                                        type: "thumb-up"
                                    }),
                                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON,
                                    onClick: ()=>handleThumbClick($3c691af970e2b3d8$export$e1c6e381de15460b.THUMB_UP)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                        "data-testid": "quick-feedback-text",
                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $582583ec420fce57$export$a8a3e93435678ff9), {
                            level: 6,
                            color: (0, $hgUW1$token)("color.text.subtle"),
                            children: selectedThumb ? "Thanks for your feedback!" : "How was this lesson?"
                        })
                    })
                ]
            }),
            shouldShowDivider && /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                css: $3c691af970e2b3d8$var$dividerStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $0903e93de01b205a$export$2e0a83ec2e27ecbb), {
                    color: (0, $hgUW1$token)("color.border"),
                    height: 2
                })
            }),
            isPopupOpened.isOpen && /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                "data-testid": "popup",
                css: $3c691af970e2b3d8$var$popupStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                                size: "small",
                                fontWeight: "semibold",
                                children: "Why did you choose this response?"
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                css: $3c691af970e2b3d8$var$optionsContentStyles,
                                children: isPopupOpened.thumbType === $3c691af970e2b3d8$export$e1c6e381de15460b.THUMB_UP ? $3c691af970e2b3d8$export$3e6d4d99e8c08756.map((option)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $3c691af970e2b3d8$var$radioContainerStyles,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3fbcb32390ca7008$export$d7b12c4107be0d61), {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-up"
                                        })
                                    }, option)) : $3c691af970e2b3d8$export$592a942fdddb4b1a.map((option)=>/*#__PURE__*/ (0, $hgUW1$jsx)("div", {
                                        css: $3c691af970e2b3d8$var$radioContainerStyles,
                                        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3fbcb32390ca7008$export$d7b12c4107be0d61), {
                                            setIsChecked: ()=>toggleAnswer(option),
                                            isChecked: getOptionStatus(option),
                                            label: option,
                                            name: "thumb-down"
                                        })
                                    }, option))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                        css: $3c691af970e2b3d8$var$feedbackFormStyles,
                        children: [
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $3c691af970e2b3d8$var$inputContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8b54d37779d052e8$export$5f1af8db9871e1d6), {
                                        size: "small",
                                        fontWeight: "semibold",
                                        children: "Share your thoughts"
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $1ca64a7075ab6eae$export$2c73285ae9390cec), {
                                        placeholder: "Start typing...",
                                        onChange: handleChangeThoughts
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                                css: $3c691af970e2b3d8$var$buttonsContainerStyles,
                                children: [
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Dismiss",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).LINK,
                                        onClick: handleDismissFeedback
                                    }),
                                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                                        label: "Submit",
                                        appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).PRIMARY,
                                        onClick: handleSubmitFeedback
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $3c691af970e2b3d8$var$quickFeedbackStyles = (0, $hgUW1$css)({
    position: "relative",
    maxWidth: "720px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center"
});
const $3c691af970e2b3d8$var$feedbackContainerStyles = (0, $hgUW1$css)({
    width: "100%",
    display: "flex",
    gap: (0, $hgUW1$token)("space.150"),
    alignItems: "center"
});
const $3c691af970e2b3d8$var$thumbsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    gap: (0, $hgUW1$token)("space.100")
});
const $3c691af970e2b3d8$var$thumbButtonContainerStyles = (0, $hgUW1$css)({
    backgroundColor: (0, $hgUW1$token)("color.background.disabled"),
    borderRadius: "3px"
});
const $3c691af970e2b3d8$var$dividerStyles = (0, $hgUW1$css)({
    width: "100%",
    margin: `${(0, $hgUW1$token)("space.400")} 0`
});
const $3c691af970e2b3d8$var$popupStyles = (0, $hgUW1$css)({
    position: "absolute",
    bottom: "100px",
    maxWidth: "476px",
    width: "100%",
    padding: (0, $hgUW1$token)("space.200"),
    borderRadius: "8px",
    background: (0, $hgUW1$token)("color.background.input"),
    boxShadow: `0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25)`,
    [(0, $hgUW1$media).below.sm]: {
        position: "relative",
        bottom: "60px"
    }
});
const $3c691af970e2b3d8$var$optionsContentStyles = (0, $hgUW1$css)({
    margin: `${(0, $hgUW1$token)("space.100")} 0 ${(0, $hgUW1$token)("space.150")}`
});
const $3c691af970e2b3d8$var$radioContainerStyles = (0, $hgUW1$css)({
    marginTop: (0, $hgUW1$token)("space.050")
});
const $3c691af970e2b3d8$var$feedbackFormStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $hgUW1$token)("space.150")
});
const $3c691af970e2b3d8$var$inputContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    flexDirection: "column",
    gap: (0, $hgUW1$token)("space.050")
});
const $3c691af970e2b3d8$var$buttonsContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "flex-end",
    gap: (0, $hgUW1$token)("space.100")
});


var $5f9280667c666470$exports = {};

$parcel$export($5f9280667c666470$exports, "Searchbar", () => $5f9280667c666470$export$b9f6e7a4c54af1f6);
















const $9c9ed7a3b666cf11$export$b36c0aa7a63a3911 = ({ item: item , onRemove: onRemove , onSelect: onSelect  })=>{
    const deviceSize = (0, $3ced3ef7e9864bf1$export$4616d33c54ae5baf)();
    const handleRemoveButton = (e)=>{
        e.stopPropagation();
        onRemove(item);
    };
    const handleItemClick = ()=>{
        onSelect(item);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $9c9ed7a3b666cf11$var$historyItemContainerStyles,
        onClick: handleItemClick,
        "data-testid": "history-item",
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: $9c9ed7a3b666cf11$var$historyItemStyles,
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: "emoji-frequent",
                        color: (0, $hgUW1$token)("color.icon.subtle")
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                        css: $9c9ed7a3b666cf11$var$itemTextStyles,
                        children: item
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
                css: [
                    $9c9ed7a3b666cf11$var$removeContainerStyles,
                    deviceSize < (0, $3ced3ef7e9864bf1$export$27ed77542911fb0e) && (0, $hgUW1$css)({
                        opacity: 1
                    })
                ],
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                        onClick: handleRemoveButton,
                        label: "",
                        iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                            type: "dropdown-cross",
                            color: (0, $hgUW1$token)("color.icon")
                        })
                    }),
                    deviceSize < (0, $3ced3ef7e9864bf1$export$27ed77542911fb0e) && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                        css: $9c9ed7a3b666cf11$var$clearButtonStyles,
                        onClick: handleRemoveButton,
                        children: "Clear"
                    })
                ]
            })
        ]
    });
};
const $9c9ed7a3b666cf11$var$removeContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    button: {
        span: {
            margin: "0px !important"
        }
    }
});
const $9c9ed7a3b666cf11$var$historyItemContainerStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: (0, $hgUW1$token)("space.050"),
    cursor: "pointer",
    button: {
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        outline: "none",
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    "&:hover": {
        backgroundColor: (0, $hgUW1$token)("color.background.accent.gray.subtlest")
    },
    "&:hover > div:last-child": {
        opacity: 1
    }
});
const $9c9ed7a3b666cf11$var$historyItemStyles = (0, $hgUW1$css)({
    display: "flex",
    alignItems: "center",
    gap: "4px"
});
const $9c9ed7a3b666cf11$var$itemTextStyles = (0, $hgUW1$css)({
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: `${(0, $hgUW1$token)("color.text")}`
});
const $9c9ed7a3b666cf11$var$clearButtonStyles = (0, $hgUW1$css)({
    color: (0, $hgUW1$token)("color.text.subtlest"),
    fontFamily: "Inter, sans-serif",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px"
});



const $2f046e897b352baf$export$ed4de3239e2fb964 = ({ items: items , onRemove: onRemove , onSelect: onSelect  })=>{
    if (!items.length) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Fragment), {});
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $2f046e897b352baf$var$historyStyles,
        "data-testid": "history-container",
        children: items.slice(-5).reverse().map((item)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $9c9ed7a3b666cf11$export$b36c0aa7a63a3911), {
                item: item,
                onRemove: onRemove,
                onSelect: onSelect
            }, item))
    });
};
const $2f046e897b352baf$var$historyStyles = (0, $hgUW1$css)({
    position: "absolute",
    display: "flex",
    width: "279px",
    borderRadius: "3px",
    padding: `${(0, $hgUW1$token)("space.075")} ${(0, $hgUW1$token)("space.050")}`,
    marginTop: (0, $hgUW1$token)("space.075"),
    flexDirection: "column",
    alignItems: "flex-start",
    background: (0, $hgUW1$token)("elevation.surface.overlay"),
    boxShadow: (0, $hgUW1$token)("elevation.shadow.overlay"),
    zIndex: 1,
    [(0, $hgUW1$media1).below.md]: {
        width: "327px"
    }
});








const $5f9280667c666470$export$b9f6e7a4c54af1f6 = ({ value: value , onChange: onChange , isLoading: isLoading  })=>{
    const [isHistoryVisible, setIsHistoryVisible] = (0, $hgUW1$useState)(false);
    const [history, setHistory] = (0, $hgUW1$useState)((0, $fde9406d76ec24a9$export$7765f5b61937bda1)());
    const searchRef = (0, $hgUW1$useRef)(null);
    const deviceSize = (0, $3ced3ef7e9864bf1$export$4616d33c54ae5baf)();
    const isRemoveIconVisible = !!value.length && (deviceSize >= (0, $3ced3ef7e9864bf1$export$27ed77542911fb0e) || !isLoading);
    (0, $hgUW1$useEffect)(()=>{
        const searchElement = searchRef.current;
        if (!searchElement) return;
        const inputElement = searchElement.querySelector("input");
        if (!inputElement) return;
        const handleFocus = ()=>{
            setTimeout(()=>{
                setIsHistoryVisible(true);
            }, 500);
        };
        const handleClickOutside = (event)=>{
            if (searchRef.current && !searchRef.current.contains(event.target)) setIsHistoryVisible(false);
        };
        inputElement.addEventListener("focus", handleFocus);
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            inputElement.removeEventListener("focus", handleFocus);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleRemoveItem = (itemToRemove)=>{
        const newHistory = history.filter((item)=>item !== itemToRemove);
        setHistory(newHistory);
        (0, $fde9406d76ec24a9$export$cec0922aa1b64670)(newHistory);
    };
    const handleSelectItem = (selectedItem)=>{
        onChange(selectedItem);
        setIsHistoryVisible(false);
    };
    const onKeyDown = (event)=>{
        if (event.key === "Enter" && value.trim()) {
            if (!history.includes(value.trim()) && searchRef.current) {
                const newHistory = [
                    ...history,
                    value.trim()
                ];
                (0, $fde9406d76ec24a9$export$cec0922aa1b64670)(newHistory);
                const inputElement = searchRef.current.querySelector("input");
                if (inputElement) inputElement.blur();
                setTimeout(()=>{
                    setHistory(newHistory);
                }, 500);
            }
        }
    };
    const filteredItems = history.filter((item)=>item.toLowerCase().includes(value.toLowerCase()));
    const handleOnChange = (event)=>{
        if (event.target instanceof HTMLInputElement) onChange(event.target.value);
    };
    const onClearSearchClick = ()=>{
        onChange("");
        setIsHistoryVisible(false);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        css: $5f9280667c666470$var$searchStyles,
        onKeyDown: onKeyDown,
        tabIndex: 0,
        ref: searchRef,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: $5f9280667c666470$var$searchBeforeIconStyles,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskiticonglyphsearch), {
                    primaryColor: (0, $hgUW1$token)("color.text.subtlest"),
                    size: "medium",
                    label: "search icon"
                })
            }),
            !!value.length && isLoading && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                "data-testid": "search-loader",
                css: [
                    $5f9280667c666470$var$searchAfterIconStyles,
                    deviceSize < (0, $3ced3ef7e9864bf1$export$27ed77542911fb0e) && (0, $hgUW1$css)({
                        right: (0, $hgUW1$token)("space.100"),
                        top: 0
                    }),
                    deviceSize >= (0, $3ced3ef7e9864bf1$export$27ed77542911fb0e) && (0, $hgUW1$css)({
                        right: `-${(0, $hgUW1$token)("space.300")}`
                    })
                ],
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitspinner), {
                    size: "small"
                })
            }),
            isRemoveIconVisible && /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
                css: $5f9280667c666470$var$searchAfterIconStyles,
                onClick: onClearSearchClick,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $fec02fc26c7e145d$export$353f5b6fc5456de1), {
                    label: "",
                    size: "large",
                    iconBefore: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a02a6f7de308273b$export$f04a61298a47a40f), {
                        type: "cross",
                        alt: "cross icon"
                    }),
                    appearance: (0, $fec02fc26c7e145d$export$261c9483fc4a455a).ICON
                })
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)("input", {
                placeholder: deviceSize < (0, $3ced3ef7e9864bf1$export$27ed77542911fb0e) ? "Search" : "Search catalog",
                value: value,
                onChange: handleOnChange
            }),
            isHistoryVisible && history.length > 0 && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $2f046e897b352baf$export$ed4de3239e2fb964), {
                items: filteredItems,
                onRemove: handleRemoveItem,
                onSelect: handleSelectItem
            })
        ]
    });
};
const $5f9280667c666470$var$searchStyles = (0, $hgUW1$css)({
    position: "relative",
    width: "100%",
    maxWidth: "240px",
    [(0, $hgUW1$media1).below.md]: {
        maxWidth: "275px"
    },
    [(0, $hgUW1$media1).below.xs]: {
        maxWidth: "100%"
    },
    input: {
        width: "100%",
        height: "32px",
        border: `1px solid ${(0, $hgUW1$token)("color.border.input")}`,
        borderRadius: "5px !important",
        padding: `0 ${(0, $hgUW1$token)("space.100")} 0 ${(0, $hgUW1$token)("space.500")}`,
        color: `${(0, $hgUW1$token)("color.text")} !important`,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        outline: "none",
        "&::placeholder": {
            color: (0, $hgUW1$token)("color.text.subtlest"),
            fontFamily: "SF Pro, sans-serif"
        },
        "&:focus": {
            border: `2px solid ${(0, $hgUW1$token)("color.border.focused")} !important`
        },
        [(0, $hgUW1$media1).below.md]: {
            height: "40px",
            padding: `10px ${(0, $hgUW1$token)("space.100")} 10px ${(0, $hgUW1$token)("space.500")}`
        }
    }
});
const $5f9280667c666470$var$searchBeforeIconStyles = (0, $hgUW1$css)({
    position: "absolute",
    left: "10px",
    top: "6px",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    }
});
const $5f9280667c666470$var$searchAfterIconStyles = (0, $hgUW1$css)({
    position: "absolute",
    right: (0, $hgUW1$token)("space.100"),
    top: (0, $hgUW1$token)("space.050"),
    cursor: "pointer",
    "[role='img']": {
        width: "20px !important",
        height: "20px !important"
    },
    [(0, $hgUW1$media1).below.md]: {
        top: (0, $hgUW1$token)("space.100")
    }
});



$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $83fc18f8199a12ff$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $389dbaf1c04dd698$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $c18917e553fd2737$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $3ca3d702a74367ba$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $e018ab7ed2648ae8$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $81dd635d83decaee$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $8d99d7c025746ac9$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $1f7c4876f10b107b$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $c5616d3f1657fc84$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $eb6f767c51421421$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $7fe7e19d380f3d34$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $915f5687b3b07750$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $579f9ef2424e0bd8$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $d559b1cc82536c49$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $fa53e9c0a1746730$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $9225344cd5d1f99b$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $3b9afd8fe4435353$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $65703ff0bcd12648$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $dbb9d5792c296a49$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $2cfa64583f556289$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $44303f6c3c81eeac$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $9c3f769544bb2079$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $3d76652bb6362040$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $764442aba3de2fce$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $77282b3961d82199$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $4c35f7fd4ad5f13f$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $d8ee29df49af8811$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $27d686e47ff412fd$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $a4deb03146bf3bfc$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $0ae392c3008c8a3e$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $3c691af970e2b3d8$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $5f9280667c666470$exports);
$parcel$exportWildcard($6e379ec2eca3d7d3$exports, $ed20910b93d89c3f$exports);



var $0cf4554ad00467b5$exports = {};
var $a3d28c94a229f94e$exports = {};

$parcel$export($a3d28c94a229f94e$exports, "CommunityLogo", () => $a3d28c94a229f94e$export$311e5e9ca09eea69);
$parcel$export($a3d28c94a229f94e$exports, "CommunityNavigation", () => $a3d28c94a229f94e$export$901cb8c9de2be2aa);
$parcel$export($a3d28c94a229f94e$exports, "AnalyticsActivityType", () => $1ff01338112cd7fe$export$d778a884eb401313);
$parcel$export($a3d28c94a229f94e$exports, "EventType", () => $1ff01338112cd7fe$export$3d7865934588d77e);
$parcel$export($a3d28c94a229f94e$exports, "CommunityApp", () => $1ff01338112cd7fe$export$93d048dc21eb282a);
$parcel$export($a3d28c94a229f94e$exports, "MenuItemWithAnalytics", () => $e297024529b24fb0$export$92905cc84b82619c);
$parcel$export($a3d28c94a229f94e$exports, "NavBarLinkItem", () => $e297024529b24fb0$export$b18dbc162161ec9c);
$parcel$export($a3d28c94a229f94e$exports, "APP_BUTTONS", () => $1ff01338112cd7fe$export$208c68d48dfc9a12);
$parcel$export($a3d28c94a229f94e$exports, "getAppButtons", () => $1ff01338112cd7fe$export$67e61a6fa639f224);



/**
 * This file contains the sub-components that are wrapped with the OnClickWrapper component to send analytics events
 * with the relevant payload attributes.
 */ 


/**
 * This is a wrapper component that allows passing in an onClick handler to a div. It can be used to wrap components
 * that are meant to be clicked (e.g. buttons and links), for additional click handling.
 */ 

const $d153af7a71e64fa7$export$9c92f94f6e99bc1a = ({ children: children , onClick: onClick  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)("span", {
        onClick: onClick,
        children: children
    });
};














const $3e3d20b49785004a$export$29d11c0fe2fc51d8 = ({ link: link , shouldRedirect: shouldRedirect , isSelected: isSelected  })=>{
    const { text: text , href: href , onClick: onClick , target: target  } = link;
    return /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
        css: [
            $3e3d20b49785004a$var$linkStyles.default,
            isSelected && $3e3d20b49785004a$var$linkStyles.selected
        ],
        href: shouldRedirect ? href : undefined,
        onClick: onClick,
        target: target || "_self",
        children: text
    });
};
const $3e3d20b49785004a$export$e76239e22e3abad = ({ isSelected: isSelected = false , link: link , expandableBodyContent: expandableBodyContent , isNested: isNested = false  })=>{
    const isBreakpoint = (0, $6e8a4d5d78071ed7$export$32d5543ab307c01)(`(max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`);
    if (isBreakpoint) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3b7e032fd37ae5a5$export$1229978ae51a03a8), {
        headerContent: /*#__PURE__*/ (0, $hgUW1$jsx)($3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: !expandableBodyContent
        }),
        bodyContent: expandableBodyContent,
        isNested: isNested
    });
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        css: $3e3d20b49785004a$var$buttonDivStyles,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)($3e3d20b49785004a$export$29d11c0fe2fc51d8, {
            link: link,
            isSelected: isSelected,
            shouldRedirect: true
        })
    });
};
const $3e3d20b49785004a$var$buttonDivStyles = (0, $hgUW1$css)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 12px"
});
const $3e3d20b49785004a$var$linkStyles = {
    default: (0, $hgUW1$css)({
        color: (0, $hgUW1$token)("color.text"),
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: "20px",
        "&:hover": {
            color: (0, $hgUW1$token)("color.text.selected"),
            textDecoration: "none"
        },
        "&:active": {
            color: (0, $hgUW1$token)("color.text.information")
        },
        [`@media (max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`]: {
            "&:hover, &:active": {
                color: (0, $hgUW1$token)("color.text.brand"),
                textDecoration: "none"
            }
        }
    }),
    selected: (0, $hgUW1$css)({
        [`@media (min-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).DESKTOP.MIN_WIDTH}px)`]: {
            color: (0, $hgUW1$token)("color.text.selected")
        }
    })
};


const $d97d6cd9a58d7e95$export$bb065923b9250b7b = ({ ...rest })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3e3d20b49785004a$export$e76239e22e3abad), {
        ...rest
    });
};






const $e297024529b24fb0$export$68280dacbbcb94bd = (payload, analyticsInfo)=>{
    payload.source = "communityNavigation";
    payload.attributes = {
        ...payload.attributes || {},
        currentApp: analyticsInfo.currentApp,
        isLoggedIn: analyticsInfo.isLoggedIn,
        isNavMobileOrTablet: analyticsInfo.isMobileOrTablet
    };
    return payload;
};
const $e297024529b24fb0$export$5aa64ab1f07d6e00 = ({ analyticsInfo: analyticsInfo , subtitleHref: subtitleHref , ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "logo",
                actionSubjectId: "communityNavigationHome",
                attributes: {
                    href: subtitleHref,
                    destinationApp: (0, $1ff01338112cd7fe$export$93d048dc21eb282a).HOME
                }
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).NAV_LOGO_CLICK);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d153af7a71e64fa7$export$9c92f94f6e99bc1a), {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $90d3cbebafca1fdb$export$6ce3be5638d8e2a), {
            subtitleHref: subtitleHref,
            ...rest
        })
    });
};
const $e297024529b24fb0$export$b18dbc162161ec9c = ({ analyticsInfo: analyticsInfo , destinationApp: destinationApp , link: link , ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "communityNavigationLink",
                attributes: {
                    href: link.href,
                    label: link.text,
                    destinationApp: destinationApp
                }
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).NAV_ITEM_CLICK);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d153af7a71e64fa7$export$9c92f94f6e99bc1a), {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d97d6cd9a58d7e95$export$bb065923b9250b7b), {
            link: link,
            destinationApp: destinationApp,
            ...rest
        })
    });
};
const $e297024529b24fb0$var$loginSignupWrapperStyles = (isMobile)=>isMobile ? (0, $hgUW1$css)({
        padding: "0 24px"
    }) : undefined;
const $e297024529b24fb0$var$loginButtonStyles = (isMobile)=>isMobile ? (0, $hgUW1$css)({
        button: {
            width: "100%",
            borderRadius: "0.25rem",
            borderStyle: "solid",
            borderWidth: "1px",
            fontSize: "1rem",
            fontWeight: 600,
            fontFamily: "Charlie Text",
            color: (0, $hgUW1$token)("color.text.brand"),
            borderColor: (0, $hgUW1$token)("color.border.brand"),
            "&:active": {
                backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.pressed"),
                borderColor: (0, $hgUW1$token)("color.border.selected"),
                color: (0, $hgUW1$token)("color.text.inverse")
            },
            "&:hover": {
                backgroundColor: (0, $hgUW1$token)("color.background.selected.bold.hovered"),
                borderColor: (0, $hgUW1$token)("color.border.selected"),
                color: (0, $hgUW1$token)("color.text.inverse"),
                textDecoration: "none"
            }
        }
    }) : (0, $hgUW1$css)({
        button: {
            fontWeight: 650,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            color: (0, $hgUW1$token)("color.text"),
            width: "auto",
            "&:hover": {
                backgroundColor: "transparent",
                color: (0, $hgUW1$token)("color.text.brand"),
                textDecoration: "none"
            }
        }
    });
const $e297024529b24fb0$var$signupButtonStyles = (isMobile)=>(0, $hgUW1$css)({
        button: {
            fontWeight: 550,
            fontFamily: "Charlie Text",
            fontSize: "1rem",
            width: isMobile ? "100%" : "auto"
        }
    });
const $e297024529b24fb0$export$c421b2a9819014e7 = ({ href: href , analyticsInfo: analyticsInfo , isMobile: isMobile = false  })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationLogin",
                attributes: {
                    href: href
                }
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).LOG_IN_CLICK);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d153af7a71e64fa7$export$9c92f94f6e99bc1a), {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $e297024529b24fb0$var$loginSignupWrapperStyles(isMobile),
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                css: $e297024529b24fb0$var$loginButtonStyles(isMobile),
                href: href,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitbuttonnew), {
                    appearance: "subtle",
                    children: (0, $1ff01338112cd7fe$export$46dbfbdf99745111)
                })
            })
        })
    });
};
const $e297024529b24fb0$export$5f193ccad31822c4 = ({ href: href , analyticsInfo: analyticsInfo , isMobile: isMobile = false  })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationSignup",
                attributes: {
                    href: href
                }
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).SIGN_UP_CLICK);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d153af7a71e64fa7$export$9c92f94f6e99bc1a), {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
            css: $e297024529b24fb0$var$loginSignupWrapperStyles(isMobile),
            children: /*#__PURE__*/ (0, $hgUW1$jsx)("a", {
                css: $e297024529b24fb0$var$signupButtonStyles(isMobile),
                href: href,
                children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$atlaskitbuttonnew), {
                    appearance: "primary",
                    children: (0, $1ff01338112cd7fe$export$4fe37309c24221ae)
                })
            })
        })
    });
};
const $e297024529b24fb0$export$55b351f575b2f75b = ({ analyticsInfo: analyticsInfo , ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationProfileMenuOpen" : "communityNavigationProfileMenuClose"
            }, analyticsInfo), !isMenuOpen ? (0, $1ff01338112cd7fe$export$d778a884eb401313).PROFILE_MENU_OPEN : (0, $1ff01338112cd7fe$export$d778a884eb401313).PROFILE_MENU_CLOSE);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $397a78fff494027c$export$1cba3806e1f1b01d), {
        onProfileMenuClick: analyticsInfo && getSendEventFn(analyticsInfo),
        ...rest
    });
};
const $e297024529b24fb0$export$92905cc84b82619c = ({ analyticsInfo: analyticsInfo , link: link , type: type , ...rest })=>{
    const getSendEventFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "communityNavigationMenuItem",
                attributes: {
                    href: link.href,
                    label: link.text,
                    menuItemId: link.id
                }
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).PROFILE_MENU_ITEM_CLICK);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d153af7a71e64fa7$export$9c92f94f6e99bc1a), {
        onClick: analyticsInfo && getSendEventFn(analyticsInfo),
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $3539883ac1727dfc$export$2ce376c2cc3355c8), {
            type: type,
            link: link,
            ...rest
        })
    });
};
const $e297024529b24fb0$export$86a131c9ca6f534a = ({ analyticsInfo: analyticsInfo , ...rest })=>{
    // event when clicking on the menu toggle button in mobile/tablet view
    const getSendEventMenuToggleFn = (analyticsInfo)=>(isMenuOpen)=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: !isMenuOpen ? "communityNavigationMobileMenuOpen" : "communityNavigationMobileMenuClose"
            }, analyticsInfo), // TODO: Fix bug with outside click handler in NavigationBar (currently, it doesn't register toggling the menu closed)
            !isMenuOpen ? (0, $1ff01338112cd7fe$export$d778a884eb401313).MOBILE_MENU_OPEN : (0, $1ff01338112cd7fe$export$d778a884eb401313).MOBILE_MENU_CLOSE);
        };
    // event when clicking outside of the menu in mobile/tablet view, which closes the menu
    const getSendEventOutsideClickFn = (analyticsInfo)=>()=>{
            analyticsInfo.onAnalyticsSendEvent((0, $1ff01338112cd7fe$export$3d7865934588d77e).UI, $e297024529b24fb0$export$68280dacbbcb94bd({
                action: "clicked",
                actionSubject: "component",
                actionSubjectId: "communityNavigationMobileMenuClose"
            }, analyticsInfo), (0, $1ff01338112cd7fe$export$d778a884eb401313).MOBILE_MENU_CLOSE);
        };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $25cbe9fdb2d8d071$export$214ae410b202e65a), {
        onMenuToggleClick: analyticsInfo && getSendEventMenuToggleFn(analyticsInfo),
        onMenuOutsideClick: analyticsInfo && getSendEventOutsideClickFn(analyticsInfo),
        ...rest
    });
};





const $a3d28c94a229f94e$export$311e5e9ca09eea69 = ({ subtitleHref: subtitleHref , analyticsInfo: analyticsInfo  })=>{
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$5aa64ab1f07d6e00), {
        subtitleHref: subtitleHref,
        label: "Community homepage",
        logoSubtitle: "Community",
        analyticsInfo: analyticsInfo
    });
};
const $a3d28c94a229f94e$var$renderAppButtons = (currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email)=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    return (0, $1ff01338112cd7fe$export$67e61a6fa639f224)(email).map((button)=>{
        if (button.app === (0, $1ff01338112cd7fe$export$93d048dc21eb282a).FORUMS && isLoggedIn && forumsLoggedInRedirectHref) button.href[loginState] += forumsLoggedInRedirectHref;
        return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$b18dbc162161ec9c), {
            isSelected: button.app === currentApp,
            link: {
                text: button.label,
                href: button.href[loginState],
                target: button.target
            },
            expandableBodyContent: subMenuContentByApp?.[button.app],
            destinationApp: button.app,
            analyticsInfo: analyticsInfo
        }, button.app);
    });
};
const $a3d28c94a229f94e$var$getUserDisplayMenuContent = (logoutHref, type, profileHref, settingsHref, analyticsInfo)=>{
    const subMenuItems = [
        {
            ...(0, $1ff01338112cd7fe$export$668d072b293d5f38).PROFILE,
            href: profileHref
        },
        {
            ...(0, $1ff01338112cd7fe$export$668d072b293d5f38).SETTINGS,
            href: settingsHref
        },
        {
            ...(0, $1ff01338112cd7fe$export$668d072b293d5f38).LOG_OUT,
            href: logoutHref
        }
    ];
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Fragment), {
        children: subMenuItems.map((item, index)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$92905cc84b82619c), {
                link: item,
                type: type,
                analyticsInfo: analyticsInfo
            }, `${item.text}-${index}`))
    });
};
const $a3d28c94a229f94e$export$901cb8c9de2be2aa = ({ currentApp: currentApp , isLoggedIn: isLoggedIn , user: user , loginHref: loginHref , signupHref: signupHref , logoutHref: logoutHref , subMenuContentByApp: subMenuContentByApp , onAnalyticsSendEvent: onAnalyticsSendEvent , forumsLoggedInRedirectHref: forumsLoggedInRedirectHref , isSticky: isSticky = true , showChampions: showChampions = false , email: email  })=>{
    const loginState = isLoggedIn ? "loggedIn" : "loggedOut";
    const homeHref = (0, $hgUW1$useMemo)(()=>(0, $1ff01338112cd7fe$export$d349399b473d7299)[loginState], [
        loginState
    ]);
    const profileHref = (0, $hgUW1$useMemo)(()=>(0, $1ff01338112cd7fe$export$132b2bf91782e62b)[loginState], [
        loginState
    ]);
    const settingsHref = (0, $hgUW1$useMemo)(()=>(0, $1ff01338112cd7fe$export$b9cc8022ec117e91)[loginState], [
        loginState
    ]);
    const isMobileOrTablet = (0, $6e8a4d5d78071ed7$export$32d5543ab307c01)(`(max-width: ${(0, $f0285f05d4d9f8a0$export$426e07cd0772984d).TABLET.MAX_WIDTH}px)`);
    const analyticsInfo = onAnalyticsSendEvent ? {
        currentApp: currentApp,
        isLoggedIn: isLoggedIn,
        isMobileOrTablet: isMobileOrTablet,
        onAnalyticsSendEvent: onAnalyticsSendEvent
    } : undefined;
    let leftItems = [
        ...$a3d28c94a229f94e$var$renderAppButtons(currentApp, subMenuContentByApp, isLoggedIn, analyticsInfo, forumsLoggedInRedirectHref, email)
    ];
    if (!showChampions) leftItems = leftItems.filter((item)=>item.key !== (0, $1ff01338112cd7fe$export$93d048dc21eb282a).CHAMPIONS);
    const rightItems = [
        isLoggedIn && user ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$55b351f575b2f75b), {
            user: user,
            expandableMenuContent: $a3d28c94a229f94e$var$getUserDisplayMenuContent(logoutHref, "subMenu", profileHref, settingsHref, analyticsInfo),
            profileMenuContent: $a3d28c94a229f94e$var$getUserDisplayMenuContent(logoutHref, "profile", profileHref, settingsHref, analyticsInfo),
            analyticsInfo: analyticsInfo
        }) : isMobileOrTablet ? /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Stack), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$c421b2a9819014e7), {
                    href: loginHref,
                    analyticsInfo: analyticsInfo,
                    isMobile: isMobileOrTablet
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$5f193ccad31822c4), {
                    href: signupHref,
                    analyticsInfo: analyticsInfo,
                    isMobile: isMobileOrTablet
                })
            ]
        }) : /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Inline), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$c421b2a9819014e7), {
                    href: loginHref,
                    analyticsInfo: analyticsInfo
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$5f193ccad31822c4), {
                    href: signupHref,
                    analyticsInfo: analyticsInfo
                })
            ]
        })
    ];
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e297024529b24fb0$export$86a131c9ca6f534a), {
        logoItem: /*#__PURE__*/ (0, $hgUW1$jsx)($a3d28c94a229f94e$export$311e5e9ca09eea69, {
            subtitleHref: homeHref,
            analyticsInfo: analyticsInfo
        }, "community-logo"),
        leftItems: leftItems,
        rightItems: rightItems,
        analyticsInfo: analyticsInfo,
        isSticky: isSticky
    });
};


$parcel$exportWildcard($0cf4554ad00467b5$exports, $a3d28c94a229f94e$exports);


$parcel$exportWildcard($a69491ea5a126553$exports, $5d4509b60606b6df$exports);
$parcel$exportWildcard($a69491ea5a126553$exports, $6e379ec2eca3d7d3$exports);
$parcel$exportWildcard($a69491ea5a126553$exports, $a6a41c835fd01d00$exports);
$parcel$exportWildcard($a69491ea5a126553$exports, $0cf4554ad00467b5$exports);






export {$660bd1c6cb41002a$export$29a7a275fe11687 as Blockquote, $660bd1c6cb41002a$export$7a77f8e9665fa6b2 as blockquoteStyles, $fec02fc26c7e145d$export$5dd2748b7940a2a0 as ButtonSize, $fec02fc26c7e145d$export$261c9483fc4a455a as ButtonAppearance, $fec02fc26c7e145d$export$353f5b6fc5456de1 as Button, $d501466973a9f0a6$export$138e17770a0a93a6 as CheckboxType, $d501466973a9f0a6$export$5e435bc8b081a399 as CheckboxSize, $d501466973a9f0a6$export$48513f6b9f8ce62d as Checkbox, $c4979bfceee73878$export$8577c1390d697bac as CommonModal, $0903e93de01b205a$export$2e0a83ec2e27ecbb as Divider, $a950778dc3003c4a$export$71f050e2efa708bb as Eyebrow, $582583ec420fce57$export$a8a3e93435678ff9 as Heading, $a02a6f7de308273b$export$df03f54e09e486fa as icons, $a02a6f7de308273b$export$ff775019b5b6e7df as IconSize, $a02a6f7de308273b$export$b3241a99d3e47e02 as IconRotation, $a02a6f7de308273b$export$f04a61298a47a40f as Icon, $1298c86a7e6a9fc7$export$3e431a229df88919 as Image, $4fce8dfc4ce8f546$export$2b77966d73aefa77 as LinkStyle, $4fce8dfc4ce8f546$export$be4c932f76c19adf as LinkSize, $4fce8dfc4ce8f546$export$a6c7ac8248d6e38a as Link, $800df40a54823a3f$export$54c2e3dc7acea9f5 as List, $800df40a54823a3f$export$6427468642e6e9fe as variantsListStyles, $25cbe9fdb2d8d071$export$214ae410b202e65a as NavigationBar, $397a78fff494027c$export$1cba3806e1f1b01d as NavBarProfileItem, $90d3cbebafca1fdb$export$6ce3be5638d8e2a as AtlassianNavLogo, $3539883ac1727dfc$export$2ce376c2cc3355c8 as MenuItem, $3b7e032fd37ae5a5$export$1229978ae51a03a8 as NavBarExpandableItem, $3fbcb32390ca7008$export$f5eff9f4cffe1e46 as RadioType, $3fbcb32390ca7008$export$4da24539a3bb7d98 as RadioSize, $3fbcb32390ca7008$export$d7b12c4107be0d61 as Radio, $731a4fd527bab680$export$ddadc1228c8dcfa as TabsSize, $731a4fd527bab680$export$3e41faf802a29e71 as Tab, $5cf70e33bfc6ce73$export$3288d34c523a1192 as Tag, $5cf70e33bfc6ce73$export$f40d73b6f7f951e9 as tagListStyles, $8b54d37779d052e8$export$5f1af8db9871e1d6 as Text, $9cfa05d02afa3952$export$8f89d78db9c8c41f as AccordionSize, $9cfa05d02afa3952$export$a766cd26d0d69044 as Accordion, $7d458ed59bb9c6a8$export$7f1bf47c7f50a6aa as InlineCode, $a467abe0c2c1750b$export$a31cbe1bf5463979 as Lozenge, $52124b9ae1d78e04$export$710836885d72543c as SectionMessageAppearance, $52124b9ae1d78e04$export$a36903bd214cec06 as SectionMessage, $6e2eae4c8556b5b9$export$2393c31da95977ae as DropdownMenuCheckbox, $4366d2b05f9f8f6b$export$e52b3c28ffecde23 as GreetingCard, $be203e745bcefb12$export$edf27be85e5f6da0 as Error, $a0eced43682c2d75$export$bd0c6e28f5d6b66e as LicenseModal, $1db60c687807de63$export$5620dbefc1cb6f80 as SUCCESS_MESSAGE, $1db60c687807de63$export$3f27bc10068ef877 as ERROR_MESSAGE, $1db60c687807de63$export$21041608e6399292 as NewsletterSignup, $83fc18f8199a12ff$export$832cc5475f11d8b4 as AudioPlayer, $389dbaf1c04dd698$export$22da447a4012011 as BadgeCard, $c18917e553fd2737$export$c572aa3e2aa38d2 as CertificateCard, $3ca3d702a74367ba$export$84c408eab3fc01b3 as ContentOverviewCardState, $3ca3d702a74367ba$export$cb86f63bb5e77777 as ContentOverviewCard, $e018ab7ed2648ae8$export$fddf379e22a74b00 as EmptyState, $81dd635d83decaee$export$f9292ef28b7b429a as InlineFeedbackMessageAppearance, $81dd635d83decaee$export$f23c56ac9ab316f as InlineFeedbackMessage, $8d99d7c025746ac9$export$c01be50dd5c433fe as LearningContentCard, $1f7c4876f10b107b$export$2b77a92f1a5ad772 as Modal, $c5616d3f1657fc84$export$415b2bdf1346d2d4 as LessonsTabContentSize, $c5616d3f1657fc84$export$ce96f190f5d3ee14 as LessonsTabContent, $eb6f767c51421421$export$e7adebdc1ebd2fed as Metadata, $7fe7e19d380f3d34$export$2d4c84fdfce6f2a9 as ArrowPosition, $7fe7e19d380f3d34$export$129a32eedafa97c5 as Popup, $915f5687b3b07750$export$c17561cb55d4db30 as ProgressBar, $579f9ef2424e0bd8$export$fad76899145ca0c7 as ProgressStatus, $579f9ef2424e0bd8$export$aa03ab7e1a208875 as defineProgressStatus, $579f9ef2424e0bd8$export$86f07cccb119409d as LearningHeader, $d559b1cc82536c49$export$a06f1c675e846f6f as Footer, $fa53e9c0a1746730$export$12b5e3eab33f219b as LabelledGraphic, $9225344cd5d1f99b$export$7bee7638d150bc04 as LessonHeader, $3b9afd8fe4435353$export$962a95c44e73eb25 as LessonList, $65703ff0bcd12648$export$c2bf8d11366d1eb0 as LessonSidebar, $dbb9d5792c296a49$export$f6dc54b55657f29f as SubmitFeedback, $2cfa64583f556289$export$477c64ffaba52edf as PopupShare, $44303f6c3c81eeac$export$51940fbbacba35d4 as QuestionType, $44303f6c3c81eeac$export$bf1c1ed72daa392b as QuizStatus, $44303f6c3c81eeac$export$602daccbd963b20 as QuestionStatus, $44303f6c3c81eeac$export$85e3e62cc743c830 as MatchingAnswerStatus, $44303f6c3c81eeac$export$cb9c858407602327 as ActionDescription, $44303f6c3c81eeac$export$76709845c4fea6cd as Quiz, $9c3f769544bb2079$export$1ba59dacbcbf90fe as Sidebar, $3d76652bb6362040$export$4ff69a78d3a65d6f as LearningSidebar, $764442aba3de2fce$export$ae01dedf5c052bb as Video, $77282b3961d82199$export$f02cc02ad0e0bba3 as Columns, $77282b3961d82199$export$2dde675552f76fc5 as LessonColumns, $4c35f7fd4ad5f13f$export$5ae3342de8088f07 as LearningCourseCard, $d8ee29df49af8811$export$184a993f673fc83f as LearningProgressBar, $27d686e47ff412fd$export$41cd510048068b0c as FeedbackHeader, $a4deb03146bf3bfc$export$448811829c5d1992 as ReportIssueModal, $0ae392c3008c8a3e$export$f2adaabc3a0295ef as FlatContentCardStyle, $0ae392c3008c8a3e$export$8023ea0baf29b8db as FlatContentCardType, $0ae392c3008c8a3e$export$bc8a9d98c2eabbb7 as FlatContentCard, $3c691af970e2b3d8$export$e1c6e381de15460b as ThumbType, $3c691af970e2b3d8$export$8eec558e14651de4 as FeedbackButtonType, $3c691af970e2b3d8$export$3e6d4d99e8c08756 as THUMBS_UP_FEEDBACK_OPTIONS, $3c691af970e2b3d8$export$592a942fdddb4b1a as THUMBS_DOWN_FEEDBACK_OPTIONS, $3c691af970e2b3d8$export$c6f2bf448101d429 as QuickFeedback, $5f9280667c666470$export$b9f6e7a4c54af1f6 as Searchbar, $ed20910b93d89c3f$export$e2e108cbe2e4f865 as ContentType, $1ca64a7075ab6eae$export$2c73285ae9390cec as TextField, $60ab015507144a2b$export$9144c5f9beecc4b7 as TextFieldMessage, $57b1d5df6b5425d4$export$76375b2580d1f8ac as TextFieldLabel, $4be7278e65b71184$export$c031b829a2452999 as UnifiedAccountCardContent, $db9d361cdef36cb6$export$c9d2f1697787ae74 as UnifiedAccountContainerCard, $e6da040d2ca2c72a$export$fc13faf098015d3a as UnifiedAccountLinkAccountCard, $9c7edcd33b2e220b$export$b27c6704e245f018 as UnifiedAccountTagContainer, $3ec1f71319ba0295$export$8bee5cfdbbc2fc0c as UnifiedAccountTagLoggedIn, $7cbc56ac0bc2e1de$export$be7f7dedc3a0e1ad as UnifiedAccountTagPrimary, $01ef21c48d795edb$export$446c53c437a3d14a as UnifiedAccountTagLinked, $80cd39a44f20f361$export$7a92b4adf6bd95bb as SharedFooter, $fff41b96fcd62262$export$9d12d42929c3fcf as WelcomeModal, $a3d28c94a229f94e$export$311e5e9ca09eea69 as CommunityLogo, $a3d28c94a229f94e$export$901cb8c9de2be2aa as CommunityNavigation, $1ff01338112cd7fe$export$d778a884eb401313 as AnalyticsActivityType, $1ff01338112cd7fe$export$3d7865934588d77e as EventType, $1ff01338112cd7fe$export$93d048dc21eb282a as CommunityApp, $e297024529b24fb0$export$92905cc84b82619c as MenuItemWithAnalytics, $e297024529b24fb0$export$b18dbc162161ec9c as NavBarLinkItemWithAnalytics, $1ff01338112cd7fe$export$208c68d48dfc9a12 as APP_BUTTONS, $1ff01338112cd7fe$export$67e61a6fa639f224 as getAppButtons, $fde9406d76ec24a9$export$8a8918d045227e35 as objectValuesToControls, $fde9406d76ec24a9$export$1456ddd9fbfc0a1f as withFocusInteraction, $fde9406d76ec24a9$export$1784ac302bd8ebad as inspectorProps, $fde9406d76ec24a9$export$30c35cbf580cab77 as formatMinutes, $fde9406d76ec24a9$export$93832c3affb240d3 as getRedirectUrl, $fde9406d76ec24a9$export$6e67b290ed5690f6 as calculateLearningProgress, $fde9406d76ec24a9$export$1059c3e9f228d9b as SEARCHBAR_HISTORY_STORAGE_KEY, $fde9406d76ec24a9$export$7765f5b61937bda1 as getLocalStorageHistory, $fde9406d76ec24a9$export$cec0922aa1b64670 as setLocalStorageItems, $3ced3ef7e9864bf1$export$27ed77542911fb0e as DESKTOP_SCREEN_WIDTH, $3ced3ef7e9864bf1$export$4616d33c54ae5baf as useDeviceSize, $965a3cfbe886b380$export$aa79b0abe3dfeaba as useOutsideClickHandler, $6e8a4d5d78071ed7$export$32d5543ab307c01 as useMediaQuery, $cbd57b1b072c1da3$export$ea96d97e8873ca7f as usePostNewsletterSignup};
//# sourceMappingURL=index.es.js.map
